export const ShreeDevi = [
  [
    { id: 1, value: "69" },
    { id: 2, value: "61" },
    { id: 3, value: "27" },
    { id: 4, value: "06" },
    { id: 5, value: "02" },
    { id: 6, value: "61" },
    { id: 7, value: "83" },
  ],
  [
    { id: 8, value: "06" },
    { id: 9, value: "25" },
    { id: 10, value: "57" },
    { id: 11, value: "03" },
    { id: 12, value: "87" },
    { id: 13, value: "59" },
    { id: 14, value: "66" },
  ],
  [
    { id: 15, value: "64" },
    { id: 16, value: "79" },
    { id: 17, value: "57" },
    { id: 18, value: "75" },
    { id: 19, value: "38" },
    { id: 20, value: "80" },
    { id: 21, value: "82" },
  ],
  [
    { id: 22, value: "69" },
    { id: 23, value: "21" },
    { id: 24, value: "83" },
    { id: 25, value: "13" },
    { id: 26, value: "**" },
    { id: 27, value: "73" },
    { id: 28, value: "13" },
  ],
  [
    { id: 29, value: "74" },
    { id: 30, value: "00" },
    { id: 31, value: "89" },
    { id: 32, value: "79" },
    { id: 33, value: "17" },
    { id: 34, value: "14" },
    { id: 35, value: "58" },
  ],
  [
    { id: 36, value: "22" },
    { id: 37, value: "00" },
    { id: 38, value: "95" },
    { id: 39, value: "04" },
    { id: 40, value: "73" },
    { id: 41, value: "74" },
    { id: 42, value: "71" },
  ],
  [
    { id: 43, value: "01" },
    { id: 44, value: "54" },
    { id: 45, value: "42" },
    { id: 46, value: "13" },
    { id: 47, value: "09" },
    { id: 48, value: "69" },
    { id: 49, value: "56" },
  ],
  [
    { id: 50, value: "62" },
    { id: 51, value: "03" },
    { id: 52, value: "13" },
    { id: 53, value: "58" },
    { id: 54, value: "84" },
    { id: 55, value: "49" },
    { id: 56, value: "98" },
  ],
  [
    { id: 57, value: "28" },
    { id: 58, value: "49" },
    { id: 59, value: "11" },
    { id: 60, value: "04" },
    { id: 61, value: "50" },
    { id: 62, value: "70" },
    { id: 63, value: "84" },
  ],
  [
    { id: 64, value: "63" },
    { id: 65, value: "71" },
    { id: 66, value: "19" },
    { id: 67, value: "89" },
    { id: 68, value: "86" },
    { id: 69, value: "68" },
    { id: 70, value: "54" },
  ],
  [
    { id: 71, value: "70" },
    { id: 72, value: "55" },
    { id: 73, value: "19" },
    { id: 74, value: "55" },
    { id: 75, value: "93" },
    { id: 76, value: "90" },
    { id: 77, value: "66" },
  ],
  [
    { id: 78, value: "16" },
    { id: 79, value: "82" },
    { id: 80, value: "67" },
    { id: 81, value: "29" },
    { id: 82, value: "86" },
    { id: 83, value: "64" },
    { id: 84, value: "43" },
  ],
  [
    { id: 85, value: "**" },
    { id: 86, value: "48" },
    { id: 87, value: "64" },
    { id: 88, value: "12" },
    { id: 89, value: "88" },
    { id: 90, value: "74" },
    { id: 91, value: "19" },
  ],
  [
    { id: 92, value: "73" },
    { id: 93, value: "72" },
    { id: 94, value: "23" },
    { id: 95, value: "26" },
    { id: 96, value: "63" },
    { id: 97, value: "70" },
    { id: 98, value: "81" },
  ],
  [
    { id: 99, value: "98" },
    { id: 100, value: "81" },
    { id: 101, value: "61" },
    { id: 102, value: "67" },
    { id: 103, value: "00" },
    { id: 104, value: "52" },
    { id: 105, value: "56" },
  ],
  [
    { id: 106, value: "52" },
    { id: 107, value: "04" },
    { id: 108, value: "63" },
    { id: 109, value: "87" },
    { id: 110, value: "42" },
    { id: 111, value: "76" },
    { id: 112, value: "89" },
  ],
  [
    { id: 113, value: "00" },
    { id: 114, value: "08" },
    { id: 115, value: "62" },
    { id: 116, value: "60" },
    { id: 117, value: "68" },
    { id: 118, value: "98" },
    { id: 119, value: "09" },
  ],
  [
    { id: 120, value: "59" },
    { id: 121, value: "57" },
    { id: 122, value: "48" },
    { id: 123, value: "48" },
    { id: 124, value: "18" },
    { id: 125, value: "03" },
    { id: 126, value: "92" },
  ],
  [
    { id: 127, value: "65" },
    { id: 128, value: "42" },
    { id: 129, value: "46" },
    { id: 130, value: "57" },
    { id: 131, value: "17" },
    { id: 132, value: "53" },
    { id: 133, value: "95" },
  ],
  [
    { id: 134, value: "64" },
    { id: 135, value: "29" },
    { id: 136, value: "95" },
    { id: 137, value: "70" },
    { id: 138, value: "37" },
    { id: 139, value: "19" },
    { id: 140, value: "78" },
  ],
  [
    { id: 141, value: "05" },
    { id: 142, value: "68" },
    { id: 143, value: "13" },
    { id: 144, value: "53" },
    { id: 145, value: "05" },
    { id: 146, value: "13" },
    { id: 147, value: "72" },
  ],
  [
    { id: 148, value: "23" },
    { id: 149, value: "25" },
    { id: 150, value: "59" },
    { id: 151, value: "16" },
    { id: 152, value: "10" },
    { id: 153, value: "28" },
    { id: 154, value: "76" },
  ],
  [
    { id: 155, value: "29" },
    { id: 156, value: "16" },
    { id: 157, value: "73" },
    { id: 158, value: "15" },
    { id: 159, value: "51" },
    { id: 160, value: "19" },
    { id: 161, value: "32" },
  ],
  [
    { id: 162, value: "24" },
    { id: 163, value: "01" },
    { id: 164, value: "02" },
    { id: 165, value: "29" },
    { id: 166, value: "48" },
    { id: 167, value: "84" },
    { id: 168, value: "47" },
  ],
  [
    { id: 169, value: "51" },
    { id: 170, value: "08" },
    { id: 171, value: "32" },
    { id: 172, value: "01" },
    { id: 173, value: "45" },
    { id: 174, value: "42" },
    { id: 175, value: "45" },
  ],
  [
    { id: 176, value: "12" },
    { id: 177, value: "18" },
    { id: 178, value: "28" },
    { id: 179, value: "23" },
    { id: 180, value: "73" },
    { id: 181, value: "76" },
    { id: 182, value: "84" },
  ],
  [
    { id: 183, value: "51" },
    { id: 184, value: "50" },
    { id: 185, value: "54" },
    { id: 186, value: "21" },
    { id: 187, value: "49" },
    { id: 188, value: "76" },
    { id: 189, value: "57" },
  ],
  [
    { id: 190, value: "77" },
    { id: 191, value: "88" },
    { id: 192, value: "73" },
    { id: 193, value: "88" },
    { id: 194, value: "91" },
    { id: 195, value: "60" },
    { id: 196, value: "53" },
  ],
  [
    { id: 197, value: "97" },
    { id: 198, value: "00" },
    { id: 199, value: "81" },
    { id: 200, value: "69" },
    { id: 201, value: "97" },
    { id: 202, value: "57" },
    { id: 203, value: "71" },
  ],
  [
    { id: 204, value: "51" },
    { id: 205, value: "53" },
    { id: 206, value: "09" },
    { id: 207, value: "83" },
    { id: 208, value: "08" },
    { id: 209, value: "82" },
    { id: 210, value: "48" },
  ],
  [
    { id: 211, value: "47" },
    { id: 212, value: "77" },
    { id: 213, value: "55" },
    { id: 214, value: "63" },
    { id: 215, value: "62" },
    { id: 216, value: "85" },
    { id: 217, value: "59" },
  ],
  [
    { id: 218, value: "13" },
    { id: 219, value: "59" },
    { id: 220, value: "14" },
    { id: 221, value: "62" },
    { id: 222, value: "60" },
    { id: 223, value: "87" },
    { id: 224, value: "06" },
  ],
  [
    { id: 225, value: "84" },
    { id: 226, value: "08" },
    { id: 227, value: "24" },
    { id: 228, value: "**" },
    { id: 229, value: "08" },
    { id: 230, value: "54" },
    { id: 231, value: "97" },
  ],
  [
    { id: 232, value: "63" },
    { id: 233, value: "99" },
    { id: 234, value: "42" },
    { id: 235, value: "89" },
    { id: 236, value: "50" },
    { id: 237, value: "16" },
    { id: 238, value: "16" },
  ],
  [
    { id: 239, value: "19" },
    { id: 240, value: "52" },
    { id: 241, value: "82" },
    { id: 242, value: "96" },
    { id: 243, value: "08" },
    { id: 244, value: "28" },
    { id: 245, value: "70" },
  ],
  [
    { id: 246, value: "23" },
    { id: 247, value: "76" },
    { id: 248, value: "76" },
    { id: 249, value: "41" },
    { id: 250, value: "42" },
    { id: 251, value: "19" },
    { id: 252, value: "13" },
  ],
  [
    { id: 253, value: "87" },
    { id: 254, value: "23" },
    { id: 255, value: "29" },
    { id: 256, value: "41" },
    { id: 257, value: "63" },
    { id: 258, value: "76" },
    { id: 259, value: "62" },
  ],
  [
    { id: 260, value: "09" },
    { id: 261, value: "52" },
    { id: 262, value: "75" },
    { id: 263, value: "43" },
    { id: 264, value: "43" },
    { id: 265, value: "81" },
    { id: 266, value: "40" },
  ],
  [
    { id: 267, value: "13" },
    { id: 268, value: "06" },
    { id: 269, value: "69" },
    { id: 270, value: "67" },
    { id: 271, value: "02" },
    { id: 272, value: "53" },
    { id: 273, value: "56" },
  ],
  [
    { id: 274, value: "88" },
    { id: 275, value: "43" },
    { id: 276, value: "60" },
    { id: 277, value: "55" },
    { id: 278, value: "79" },
    { id: 279, value: "81" },
    { id: 280, value: "59" },
  ],
  [
    { id: 281, value: "45" },
    { id: 282, value: "77" },
    { id: 283, value: "11" },
    { id: 284, value: "59" },
    { id: 285, value: "21" },
    { id: 286, value: "29" },
    { id: 287, value: "72" },
  ],
  [
    { id: 288, value: "21" },
    { id: 289, value: "54" },
    { id: 290, value: "45" },
    { id: 291, value: "89" },
    { id: 292, value: "85" },
    { id: 293, value: "55" },
    { id: 294, value: "80" },
  ],
  [
    { id: 295, value: "38" },
    { id: 296, value: "69" },
    { id: 297, value: "72" },
    { id: 298, value: "42" },
    { id: 299, value: "09" },
    { id: 300, value: "49" },
    { id: 301, value: "47" },
  ],
  [
    { id: 302, value: "75" },
    { id: 303, value: "32" },
    { id: 304, value: "74" },
    { id: 305, value: "98" },
    { id: 306, value: "84" },
    { id: 307, value: "06" },
    { id: 308, value: "83" },
  ],
  [
    { id: 309, value: "74" },
    { id: 310, value: "81" },
    { id: 311, value: "66" },
    { id: 312, value: "66" },
    { id: 313, value: "70" },
    { id: 314, value: "02" },
    { id: 315, value: "63" },
  ],
  [
    { id: 316, value: "09" },
    { id: 317, value: "82" },
    { id: 318, value: "69" },
    { id: 319, value: "88" },
    { id: 320, value: "66" },
    { id: 321, value: "19" },
    { id: 322, value: "49" },
  ],
  [
    { id: 323, value: "78" },
    { id: 324, value: "16" },
    { id: 325, value: "03" },
    { id: 326, value: "95" },
    { id: 327, value: "40" },
    { id: 328, value: "29" },
    { id: 329, value: "65" },
  ],
  [
    { id: 330, value: "18" },
    { id: 331, value: "96" },
    { id: 332, value: "21" },
    { id: 333, value: "41" },
    { id: 334, value: "28" },
    { id: 335, value: "23" },
    { id: 336, value: "53" },
  ],
  [
    { id: 337, value: "55" },
    { id: 338, value: "26" },
    { id: 339, value: "29" },
    { id: 340, value: "08" },
    { id: 341, value: "38" },
    { id: 342, value: "23" },
    { id: 343, value: "96" },
  ],
  [
    { id: 344, value: "48" },
    { id: 345, value: "08" },
    { id: 346, value: "50" },
    { id: 347, value: "52" },
    { id: 348, value: "81" },
    { id: 349, value: "08" },
    { id: 350, value: "76" },
  ],
  [
    { id: 351, value: "11" },
    { id: 352, value: "04" },
    { id: 353, value: "81" },
    { id: 354, value: "22" },
    { id: 355, value: "37" },
    { id: 356, value: "98" },
    { id: 357, value: "26" },
  ],
  [
    { id: 358, value: "15" },
    { id: 359, value: "88" },
    { id: 360, value: "26" },
    { id: 361, value: "86" },
    { id: 362, value: "26" },
    { id: 363, value: "58" },
    { id: 364, value: "54" },
  ],
  [
    { id: 365, value: "04" },
    { id: 366, value: "57" },
    { id: 367, value: "57" },
    { id: 368, value: "64" },
    { id: 369, value: "96" },
    { id: 370, value: "93" },
    { id: 371, value: "96" },
  ],
  [
    { id: 372, value: "70" },
    { id: 373, value: "89" },
    { id: 374, value: "81" },
    { id: 375, value: "29" },
    { id: 376, value: "54" },
    { id: 377, value: "26" },
    { id: 378, value: "17" },
  ],
  [
    { id: 379, value: "65" },
    { id: 380, value: "97" },
    { id: 381, value: "98" },
    { id: 382, value: "81" },
    { id: 383, value: "97" },
    { id: 384, value: "87" },
    { id: 385, value: "35" },
  ],
  [
    { id: 386, value: "93" },
    { id: 387, value: "18" },
    { id: 388, value: "63" },
    { id: 389, value: "56" },
    { id: 390, value: "30" },
    { id: 391, value: "34" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "59" },
    { id: 394, value: "29" },
    { id: 395, value: "23" },
    { id: 396, value: "29" },
    { id: 397, value: "87" },
    { id: 398, value: "49" },
    { id: 399, value: "80" },
  ],
  [
    { id: 400, value: "97" },
    { id: 401, value: "96" },
    { id: 402, value: "16" },
    { id: 403, value: "61" },
    { id: 404, value: "12" },
    { id: 405, value: "61" },
    { id: 406, value: "28" },
  ],
  [
    { id: 407, value: "94" },
    { id: 408, value: "22" },
    { id: 409, value: "70" },
    { id: 410, value: "23" },
    { id: 411, value: "76" },
    { id: 412, value: "57" },
    { id: 413, value: "01" },
  ],
  [
    { id: 414, value: "61" },
    { id: 415, value: "63" },
    { id: 416, value: "53" },
    { id: 417, value: "04" },
    { id: 418, value: "72" },
    { id: 419, value: "55" },
    { id: 420, value: "97" },
  ],
  [
    { id: 421, value: "80" },
    { id: 422, value: "78" },
    { id: 423, value: "34" },
    { id: 424, value: "39" },
    { id: 425, value: "21" },
    { id: 426, value: "70" },
    { id: 427, value: "34" },
  ],
  [
    { id: 428, value: "77" },
    { id: 429, value: "04" },
    { id: 430, value: "04" },
    { id: 431, value: "06" },
    { id: 432, value: "89" },
    { id: 433, value: "28" },
    { id: 434, value: "83" },
  ],
  [
    { id: 435, value: "71" },
    { id: 436, value: "62" },
    { id: 437, value: "84" },
    { id: 438, value: "90" },
    { id: 439, value: "60" },
    { id: 440, value: "02" },
    { id: 441, value: "28" },
  ],
  [
    { id: 442, value: "58" },
    { id: 443, value: "60" },
    { id: 444, value: "99" },
    { id: 445, value: "77" },
    { id: 446, value: "91" },
    { id: 447, value: "95" },
    { id: 448, value: "60" },
  ],
  [
    { id: 449, value: "42" },
    { id: 450, value: "62" },
    { id: 451, value: "98" },
    { id: 452, value: "35" },
    { id: 453, value: "32" },
    { id: 454, value: "48" },
    { id: 455, value: "14" },
  ],
  [
    { id: 456, value: "14" },
    { id: 457, value: "67" },
    { id: 458, value: "14" },
    { id: 459, value: "14" },
    { id: 460, value: "08" },
    { id: 461, value: "50" },
    { id: 462, value: "37" },
  ],
  [
    { id: 463, value: "99" },
    { id: 464, value: "17" },
    { id: 465, value: "51" },
    { id: 466, value: "85" },
    { id: 467, value: "56" },
    { id: 468, value: "53" },
    { id: 469, value: "97" },
  ],
  [
    { id: 470, value: "17" },
    { id: 471, value: "05" },
    { id: 472, value: "59" },
    { id: 473, value: "54" },
    { id: 474, value: "11" },
    { id: 475, value: "17" },
    { id: 476, value: "79" },
  ],
  [
    { id: 477, value: "44" },
    { id: 478, value: "90" },
    { id: 479, value: "49" },
    { id: 480, value: "98" },
    { id: 481, value: "29" },
    { id: 482, value: "78" },
    { id: 483, value: "92" },
  ],
  [
    { id: 484, value: "47" },
    { id: 485, value: "26" },
    { id: 486, value: "01" },
    { id: 487, value: "70" },
    { id: 488, value: "99" },
    { id: 489, value: "11" },
    { id: 490, value: "62" },
  ],
  [
    { id: 491, value: "68" },
    { id: 492, value: "27" },
    { id: 493, value: "26" },
    { id: 494, value: "99" },
    { id: 495, value: "84" },
    { id: 496, value: "91" },
    { id: 497, value: "65" },
  ],
  [
    { id: 498, value: "68" },
    { id: 499, value: "56" },
    { id: 500, value: "58" },
    { id: 501, value: "28" },
    { id: 502, value: "65" },
    { id: 503, value: "45" },
    { id: 504, value: "29" },
  ],
  [
    { id: 505, value: "88" },
    { id: 506, value: "30" },
    { id: 507, value: "08" },
    { id: 508, value: "03" },
    { id: 509, value: "38" },
    { id: 510, value: "43" },
    { id: 511, value: "59" },
  ],
  [
    { id: 512, value: "67" },
    { id: 513, value: "96" },
    { id: 514, value: "53" },
    { id: 515, value: "46" },
    { id: 516, value: "40" },
    { id: 517, value: "88" },
    { id: 518, value: "57" },
  ],
  [
    { id: 519, value: "63" },
    { id: 520, value: "58" },
    { id: 521, value: "23" },
    { id: 522, value: "71" },
    { id: 523, value: "96" },
    { id: 524, value: "43" },
    { id: 525, value: "84" },
  ],
  [
    { id: 526, value: "29" },
    { id: 527, value: "51" },
    { id: 528, value: "83" },
    { id: 529, value: "75" },
    { id: 530, value: "39" },
    { id: 531, value: "51" },
    { id: 532, value: "31" },
  ],
  [
    { id: 533, value: "90" },
    { id: 534, value: "46" },
    { id: 535, value: "96" },
    { id: 536, value: "12" },
    { id: 537, value: "42" },
    { id: 538, value: "51" },
    { id: 539, value: "90" },
  ],
  [
    { id: 540, value: "79" },
    { id: 541, value: "90" },
    { id: 542, value: "77" },
    { id: 543, value: "84" },
    { id: 544, value: "70" },
    { id: 545, value: "70" },
    { id: 546, value: "87" },
  ],
  [
    { id: 547, value: "62" },
    { id: 548, value: "83" },
    { id: 549, value: "70" },
    { id: 550, value: "79" },
    { id: 551, value: "55" },
    { id: 552, value: "14" },
    { id: 553, value: "84" },
  ],
  [
    { id: 554, value: "75" },
    { id: 555, value: "77" },
    { id: 556, value: "57" },
    { id: 557, value: "84" },
    { id: 558, value: "19" },
    { id: 559, value: "67" },
    { id: 560, value: "46" },
  ],
  [
    { id: 561, value: "11" },
    { id: 562, value: "51" },
    { id: 563, value: "35" },
    { id: 564, value: "59" },
    { id: 565, value: "56" },
    { id: 566, value: "32" },
    { id: 567, value: "93" },
  ],
  [
    { id: 568, value: "45" },
    { id: 569, value: "21" },
    { id: 570, value: "99" },
    { id: 571, value: "37" },
    { id: 572, value: "82" },
    { id: 573, value: "32" },
    { id: 574, value: "36" },
  ],
  [
    { id: 575, value: "04" },
    { id: 576, value: "97" },
    { id: 577, value: "82" },
    { id: 578, value: "89" },
    { id: 579, value: "70" },
    { id: 580, value: "79" },
    { id: 581, value: "74" },
  ],
  [
    { id: 582, value: "95" },
    { id: 583, value: "90" },
    { id: 584, value: "53" },
    { id: 585, value: "60" },
    { id: 586, value: "85" },
    { id: 587, value: "45" },
    { id: 588, value: "71" },
  ],
  [
    { id: 589, value: "35" },
    { id: 590, value: "17" },
    { id: 591, value: "67" },
    { id: 592, value: "49" },
    { id: 593, value: "**" },
    { id: 594, value: "92" },
    { id: 595, value: "60" },
  ],
  [
    { id: 596, value: "65" },
    { id: 597, value: "63" },
    { id: 598, value: "07" },
    { id: 599, value: "75" },
    { id: 600, value: "04" },
    { id: 601, value: "60" },
    { id: 602, value: "94" },
  ],
  [
    { id: 603, value: "30" },
    { id: 604, value: "20" },
    { id: 605, value: "26" },
    { id: 606, value: "86" },
    { id: 607, value: "20" },
    { id: 608, value: "33" },
    { id: 609, value: "37" },
  ],
  [
    { id: 610, value: "88" },
    { id: 611, value: "62" },
    { id: 612, value: "00" },
    { id: 613, value: "94" },
    { id: 614, value: "47" },
    { id: 615, value: "71" },
    { id: 616, value: "43" },
  ],
  [
    { id: 617, value: "24" },
    { id: 618, value: "42" },
    { id: 619, value: "49" },
    { id: 620, value: "97" },
    { id: 621, value: "50" },
    { id: 622, value: "93" },
    { id: 623, value: "75" },
  ],
  [
    { id: 624, value: "93" },
    { id: 625, value: "00" },
    { id: 626, value: "46" },
    { id: 627, value: "72" },
    { id: 628, value: "51" },
    { id: 629, value: "95" },
    { id: 630, value: "52" },
  ],
  [
    { id: 631, value: "73" },
    { id: 632, value: "74" },
    { id: 633, value: "86" },
    { id: 634, value: "74" },
    { id: 635, value: "43" },
    { id: 636, value: "01" },
    { id: 637, value: "81" },
  ],
  [
    { id: 638, value: "88" },
    { id: 639, value: "74" },
    { id: 640, value: "80" },
    { id: 641, value: "27" },
    { id: 642, value: "81" },
    { id: 643, value: "75" },
    { id: 644, value: "45" },
  ],
  [
    { id: 645, value: "37" },
    { id: 646, value: "94" },
    { id: 647, value: "02" },
    { id: 648, value: "51" },
    { id: 649, value: "07" },
    { id: 650, value: "38" },
    { id: 651, value: "97" },
  ],
  [
    { id: 652, value: "54" },
    { id: 653, value: "38" },
    { id: 654, value: "39" },
    { id: 655, value: "91" },
    { id: 656, value: "87" },
    { id: 657, value: "**" },
    { id: 658, value: "23" },
  ],
  [
    { id: 659, value: "38" },
    { id: 660, value: "71" },
    { id: 661, value: "78" },
    { id: 662, value: "73" },
    { id: 663, value: "86" },
    { id: 664, value: "61" },
    { id: 665, value: "84" },
  ],
  [
    { id: 666, value: "85" },
    { id: 667, value: "33" },
    { id: 668, value: "17" },
    { id: 669, value: "42" },
    { id: 670, value: "99" },
    { id: 671, value: "49" },
    { id: 672, value: "68" },
  ],
  [
    { id: 673, value: "99" },
    { id: 674, value: "22" },
    { id: 675, value: "47" },
    { id: 676, value: "39" },
    { id: 677, value: "31" },
    { id: 678, value: "91" },
    { id: 679, value: "12" },
  ],
  [
    { id: 680, value: "87" },
    { id: 681, value: "22" },
    { id: 682, value: "21" },
    { id: 683, value: "17" },
    { id: 684, value: "77" },
    { id: 685, value: "91" },
    { id: 686, value: "72" },
  ],
  [
    { id: 687, value: "81" },
    { id: 688, value: "47" },
    { id: 689, value: "45" },
    { id: 690, value: "42" },
    { id: 691, value: "35" },
    { id: 692, value: "81" },
    { id: 693, value: "89" },
  ],
  [
    { id: 694, value: "22" },
    { id: 695, value: "01" },
    { id: 696, value: "50" },
    { id: 697, value: "22" },
    { id: 698, value: "59" },
    { id: 699, value: "78" },
    { id: 700, value: "52" },
  ],
  [
    { id: 701, value: "79" },
    { id: 702, value: "11" },
    { id: 703, value: "22" },
    { id: 704, value: "19" },
    { id: 705, value: "84" },
    { id: 706, value: "30" },
    { id: 707, value: "14" },
  ],
  [
    { id: 708, value: "30" },
    { id: 709, value: "79" },
    { id: 710, value: "34" },
    { id: 711, value: "13" },
    { id: 712, value: "46" },
    { id: 713, value: "04" },
    { id: 714, value: "92" },
  ],
  [
    { id: 715, value: "08" },
    { id: 716, value: "37" },
    { id: 717, value: "40" },
    { id: 718, value: "60" },
    { id: 719, value: "37" },
    { id: 720, value: "47" },
    { id: 721, value: "98" },
  ],
  [
    { id: 722, value: "05" },
    { id: 723, value: "83" },
    { id: 724, value: "09" },
    { id: 725, value: "28" },
    { id: 726, value: "66" },
    { id: 727, value: "23" },
    { id: 728, value: "62" },
  ],
  [
    { id: 729, value: "09" },
    { id: 730, value: "92" },
    { id: 731, value: "83" },
    { id: 732, value: "14" },
    { id: 733, value: "00" },
    { id: 734, value: "78" },
    { id: 735, value: "89" },
  ],
  [
    { id: 736, value: "89" },
    { id: 737, value: "66" },
    { id: 738, value: "08" },
    { id: 739, value: "67" },
    { id: 740, value: "70" },
    { id: 741, value: "46" },
    { id: 742, value: "85" },
  ],
  [
    { id: 743, value: "31" },
    { id: 744, value: "60" },
    { id: 745, value: "48" },
    { id: 746, value: "01" },
    { id: 747, value: "48" },
    { id: 748, value: "30" },
    { id: 749, value: "57" },
  ],
  [
    { id: 750, value: "71" },
    { id: 751, value: "45" },
    { id: 752, value: "11" },
    { id: 753, value: "61" },
    { id: 754, value: "61" },
    { id: 755, value: "43" },
    { id: 756, value: "48" },
  ],
  [
    { id: 757, value: "**" },
    { id: 758, value: "85" },
    { id: 759, value: "36" },
    { id: 760, value: "43" },
    { id: 761, value: "45" },
    { id: 762, value: "90" },
    { id: 763, value: "96" },
  ],
  [
    { id: 764, value: "88" },
    { id: 765, value: "45" },
    { id: 766, value: "66" },
    { id: 767, value: "90" },
    { id: 768, value: "41" },
    { id: 769, value: "83" },
    { id: 770, value: "63" },
  ],
  [
    { id: 771, value: "63" },
    { id: 772, value: "14" },
    { id: 773, value: "73" },
    { id: 774, value: "21" },
    { id: 775, value: "91" },
    { id: 776, value: "21" },
    { id: 777, value: "58" },
  ],
  [
    { id: 778, value: "74" },
    { id: 779, value: "07" },
    { id: 780, value: "09" },
    { id: 781, value: "25" },
    { id: 782, value: "92" },
    { id: 783, value: "87" },
    { id: 784, value: "42" },
  ],
  [
    { id: 785, value: "72" },
    { id: 786, value: "13" },
    { id: 787, value: "04" },
    { id: 788, value: "58" },
    { id: 789, value: "99" },
    { id: 790, value: "07" },
    { id: 791, value: "56" },
  ],
  [
    { id: 792, value: "49" },
    { id: 793, value: "84" },
    { id: 794, value: "**" },
    { id: 795, value: "65" },
    { id: 796, value: "08" },
    { id: 797, value: "62" },
    { id: 798, value: "42" },
  ],
  [
    { id: 799, value: "60" },
    { id: 800, value: "90" },
    { id: 801, value: "89" },
    { id: 802, value: "24" },
    { id: 803, value: "88" },
    { id: 804, value: "89" },
    { id: 805, value: "62" },
  ],
  [
    { id: 806, value: "23" },
    { id: 807, value: "25" },
    { id: 808, value: "56" },
    { id: 809, value: "59" },
    { id: 810, value: "71" },
    { id: 811, value: "04" },
    { id: 812, value: "09" },
  ],
];

//  time bazar
export const TimeBazar = [
  [
    { id: 1, value: "13" },
    { id: 2, value: "36" },
    { id: 3, value: "35" },
    { id: 4, value: "59" },
    { id: 5, value: "17" },
    { id: 6, value: "04" },
  ],
  [
    { id: 7, value: "35" },
    { id: 8, value: "06" },
    { id: 9, value: "47" },
    { id: 10, value: "61" },
    { id: 11, value: "23" },
    { id: 12, value: "40" },
  ],
  [
    { id: 13, value: "83" },
    { id: 14, value: "76" },
    { id: 15, value: "00" },
    { id: 16, value: "56" },
    { id: 17, value: "11" },
    { id: 18, value: "44" },
  ],
  [
    { id: 19, value: "17" },
    { id: 20, value: "85" },
    { id: 21, value: "08" },
    { id: 22, value: "03" },
    { id: 23, value: "**" },
    { id: 24, value: "33" },
  ],
  [
    { id: 25, value: "14" },
    { id: 26, value: "32" },
    { id: 27, value: "44" },
    { id: 28, value: "86" },
    { id: 29, value: "37" },
    { id: 30, value: "13" },
  ],
  [
    { id: 31, value: "97" },
    { id: 32, value: "73" },
    { id: 33, value: "16" },
    { id: 34, value: "79" },
    { id: 35, value: "05" },
    { id: 36, value: "08" },
  ],
  [
    { id: 37, value: "07" },
    { id: 38, value: "54" },
    { id: 39, value: "68" },
    { id: 40, value: "67" },
    { id: 41, value: "42" },
    { id: 42, value: "46" },
  ],
  [
    { id: 43, value: "80" },
    { id: 44, value: "71" },
    { id: 45, value: "34" },
    { id: 46, value: "94" },
    { id: 47, value: "16" },
    { id: 48, value: "65" },
  ],
  [
    { id: 49, value: "65" },
    { id: 50, value: "10" },
    { id: 51, value: "43" },
    { id: 52, value: "24" },
    { id: 53, value: "84" },
    { id: 54, value: "03" },
  ],
  [
    { id: 55, value: "94" },
    { id: 56, value: "59" },
    { id: 57, value: "72" },
    { id: 58, value: "71" },
    { id: 59, value: "80" },
    { id: 60, value: "30" },
  ],
  [
    { id: 61, value: "96" },
    { id: 62, value: "50" },
    { id: 63, value: "89" },
    { id: 64, value: "79" },
    { id: 65, value: "71" },
    { id: 66, value: "74" },
  ],
  [
    { id: 67, value: "80" },
    { id: 68, value: "61" },
    { id: 69, value: "40" },
    { id: 70, value: "12" },
    { id: 71, value: "07" },
    { id: 72, value: "59" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "71" },
    { id: 75, value: "74" },
    { id: 76, value: "37" },
    { id: 77, value: "33" },
    { id: 78, value: "49" },
  ],
  [
    { id: 79, value: "24" },
    { id: 80, value: "34" },
    { id: 81, value: "53" },
    { id: 82, value: "12" },
    { id: 83, value: "29" },
    { id: 84, value: "17" },
  ],
  [
    { id: 85, value: "15" },
    { id: 86, value: "38" },
    { id: 87, value: "19" },
    { id: 88, value: "27" },
    { id: 89, value: "95" },
    { id: 90, value: "70" },
  ],
  [
    { id: 91, value: "40" },
    { id: 92, value: "77" },
    { id: 93, value: "96" },
    { id: 94, value: "24" },
    { id: 95, value: "77" },
    { id: 96, value: "55" },
  ],
  [
    { id: 97, value: "70" },
    { id: 98, value: "30" },
    { id: 99, value: "28" },
    { id: 100, value: "12" },
    { id: 101, value: "13" },
    { id: 102, value: "69" },
  ],
  [
    { id: 103, value: "30" },
    { id: 104, value: "85" },
    { id: 105, value: "89" },
    { id: 106, value: "12" },
    { id: 107, value: "64" },
    { id: 108, value: "63" },
  ],
  [
    { id: 109, value: "30" },
    { id: 110, value: "91" },
    { id: 111, value: "25" },
    { id: 112, value: "14" },
    { id: 113, value: "72" },
    { id: 114, value: "04" },
  ],
  [
    { id: 115, value: "95" },
    { id: 116, value: "64" },
    { id: 117, value: "87" },
    { id: 118, value: "17" },
    { id: 119, value: "77" },
    { id: 120, value: "17" },
  ],
  [
    { id: 121, value: "99" },
    { id: 122, value: "59" },
    { id: 123, value: "68" },
    { id: 124, value: "84" },
    { id: 125, value: "31" },
    { id: 126, value: "14" },
  ],
  [
    { id: 127, value: "30" },
    { id: 128, value: "35" },
    { id: 129, value: "02" },
    { id: 130, value: "22" },
    { id: 131, value: "60" },
    { id: 132, value: "73" },
  ],
  [
    { id: 133, value: "18" },
    { id: 134, value: "00" },
    { id: 135, value: "07" },
    { id: 136, value: "61" },
    { id: 137, value: "77" },
    { id: 138, value: "76" },
  ],
  [
    { id: 139, value: "14" },
    { id: 140, value: "89" },
    { id: 141, value: "77" },
    { id: 142, value: "20" },
    { id: 143, value: "26" },
    { id: 144, value: "91" },
  ],
  [
    { id: 145, value: "71" },
    { id: 146, value: "22" },
    { id: 147, value: "73" },
    { id: 148, value: "90" },
    { id: 149, value: "38" },
    { id: 150, value: "73" },
  ],
  [
    { id: 151, value: "69" },
    { id: 152, value: "10" },
    { id: 153, value: "78" },
    { id: 154, value: "45" },
    { id: 155, value: "49" },
    { id: 156, value: "31" },
  ],
  [
    { id: 157, value: "71" },
    { id: 158, value: "31" },
    { id: 159, value: "63" },
    { id: 160, value: "78" },
    { id: 161, value: "49" },
    { id: 162, value: "82" },
  ],
  [
    { id: 163, value: "91" },
    { id: 164, value: "24" },
    { id: 165, value: "30" },
    { id: 166, value: "53" },
    { id: 167, value: "36" },
    { id: 168, value: "12" },
  ],
  [
    { id: 169, value: "20" },
    { id: 170, value: "92" },
    { id: 171, value: "62" },
    { id: 172, value: "95" },
    { id: 173, value: "52" },
    { id: 174, value: "56" },
  ],
  [
    { id: 175, value: "06" },
    { id: 176, value: "43" },
    { id: 177, value: "05" },
    { id: 178, value: "92" },
    { id: 179, value: "34" },
    { id: 180, value: "84" },
  ],
  [
    { id: 181, value: "50" },
    { id: 182, value: "52" },
    { id: 183, value: "32" },
    { id: 184, value: "00" },
    { id: 185, value: "45" },
    { id: 186, value: "16" },
  ],
  [
    { id: 187, value: "25" },
    { id: 188, value: "93" },
    { id: 189, value: "39" },
    { id: 190, value: "03" },
    { id: 191, value: "02" },
    { id: 192, value: "09" },
  ],
  [
    { id: 193, value: "86" },
    { id: 194, value: "33" },
    { id: 195, value: "67" },
    { id: 196, value: "**" },
    { id: 197, value: "34" },
    { id: 198, value: "82" },
  ],
  [
    { id: 199, value: "83" },
    { id: 200, value: "56" },
    { id: 201, value: "51" },
    { id: 202, value: "81" },
    { id: 203, value: "82" },
    { id: 204, value: "79" },
  ],
  [
    { id: 205, value: "55" },
    { id: 206, value: "21" },
    { id: 207, value: "08" },
    { id: 208, value: "35" },
    { id: 209, value: "69" },
    { id: 210, value: "31" },
  ],
  [
    { id: 211, value: "27" },
    { id: 212, value: "51" },
    { id: 213, value: "86" },
    { id: 214, value: "11" },
    { id: 215, value: "02" },
    { id: 216, value: "**" },
  ],
  [
    { id: 217, value: "05" },
    { id: 218, value: "72" },
    { id: 219, value: "98" },
    { id: 220, value: "02" },
    { id: 221, value: "91" },
    { id: 222, value: "86" },
  ],
  [
    { id: 223, value: "88" },
    { id: 224, value: "80" },
    { id: 225, value: "75" },
    { id: 226, value: "00" },
    { id: 227, value: "19" },
    { id: 228, value: "61" },
  ],
  [
    { id: 229, value: "82" },
    { id: 230, value: "05" },
    { id: 231, value: "71" },
    { id: 232, value: "89" },
    { id: 233, value: "09" },
    { id: 234, value: "35" },
  ],
  [
    { id: 235, value: "21" },
    { id: 236, value: "27" },
    { id: 237, value: "41" },
    { id: 238, value: "53" },
    { id: 239, value: "58" },
    { id: 240, value: "56" },
  ],
  [
    { id: 241, value: "86" },
    { id: 242, value: "39" },
    { id: 243, value: "48" },
    { id: 244, value: "10" },
    { id: 245, value: "57" },
    { id: 246, value: "37" },
  ],
  [
    { id: 247, value: "05" },
    { id: 248, value: "31" },
    { id: 249, value: "13" },
    { id: 250, value: "19" },
    { id: 251, value: "52" },
    { id: 252, value: "13" },
  ],
  [
    { id: 253, value: "65" },
    { id: 254, value: "04" },
    { id: 255, value: "15" },
    { id: 256, value: "77" },
    { id: 257, value: "38" },
    { id: 258, value: "41" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "51" },
    { id: 268, value: "30" },
    { id: 269, value: "47" },
    { id: 270, value: "67" },
  ],
  [
    { id: 271, value: "56" },
    { id: 272, value: "88" },
    { id: 273, value: "51" },
    { id: 274, value: "08" },
    { id: 275, value: "07" },
    { id: 276, value: "92" },
  ],
  [
    { id: 277, value: "57" },
    { id: 278, value: "01" },
    { id: 279, value: "48" },
    { id: 280, value: "35" },
    { id: 281, value: "15" },
    { id: 282, value: "05" },
  ],
  [
    { id: 283, value: "63" },
    { id: 284, value: "12" },
    { id: 285, value: "69" },
    { id: 286, value: "21" },
    { id: 287, value: "62" },
    { id: 288, value: "96" },
  ],
  [
    { id: 289, value: "57" },
    { id: 290, value: "86" },
    { id: 291, value: "24" },
    { id: 292, value: "57" },
    { id: 293, value: "98" },
    { id: 294, value: "07" },
  ],
  [
    { id: 295, value: "89" },
    { id: 296, value: "37" },
    { id: 297, value: "02" },
    { id: 298, value: "80" },
    { id: 299, value: "24" },
    { id: 300, value: "92" },
  ],
  [
    { id: 301, value: "64" },
    { id: 302, value: "16" },
    { id: 303, value: "05" },
    { id: 304, value: "16" },
    { id: 305, value: "51" },
    { id: 306, value: "12" },
  ],
  [
    { id: 307, value: "91" },
    { id: 308, value: "06" },
    { id: 309, value: "49" },
    { id: 310, value: "33" },
    { id: 311, value: "48" },
    { id: 312, value: "16" },
  ],
  [
    { id: 313, value: "41" },
    { id: 314, value: "28" },
    { id: 315, value: "08" },
    { id: 316, value: "69" },
    { id: 317, value: "25" },
    { id: 318, value: "52" },
  ],
  [
    { id: 319, value: "97" },
    { id: 320, value: "44" },
    { id: 321, value: "44" },
    { id: 322, value: "04" },
    { id: 323, value: "62" },
    { id: 324, value: "88" },
  ],
  [
    { id: 325, value: "33" },
    { id: 326, value: "51" },
    { id: 327, value: "05" },
    { id: 328, value: "26" },
    { id: 329, value: "83" },
    { id: 330, value: "64" },
  ],
  [
    { id: 331, value: "92" },
    { id: 332, value: "67" },
    { id: 333, value: "00" },
    { id: 334, value: "46" },
    { id: 335, value: "18" },
    { id: 336, value: "21" },
    { id: 337, value: "**" },
  ],
  [
    { id: 338, value: "67" },
    { id: 339, value: "82" },
    { id: 340, value: "56" },
    { id: 341, value: "43" },
    { id: 342, value: "58" },
    { id: 343, value: "89" },
    { id: 344, value: "**" },
  ],
  [
    { id: 345, value: "89" },
    { id: 346, value: "52" },
    { id: 347, value: "19" },
    { id: 348, value: "43" },
    { id: 349, value: "10" },
    { id: 350, value: "64" },
    { id: 351, value: "**" },
  ],
  [
    { id: 352, value: "26" },
    { id: 353, value: "09" },
    { id: 354, value: "01" },
    { id: 355, value: "85" },
    { id: 356, value: "06" },
    { id: 357, value: "42" },
    { id: 358, value: "**" },
  ],
  [
    { id: 359, value: "24" },
    { id: 360, value: "79" },
    { id: 361, value: "75" },
    { id: 362, value: "68" },
    { id: 363, value: "54" },
    { id: 364, value: "90" },
    { id: 365, value: "**" },
  ],
  [
    { id: 366, value: "41" },
    { id: 367, value: "53" },
    { id: 368, value: "63" },
    { id: 369, value: "10" },
    { id: 370, value: "03" },
    { id: 371, value: "10" },
    { id: 372, value: "**" },
  ],
  [
    { id: 373, value: "39" },
    { id: 374, value: "90" },
    { id: 375, value: "48" },
    { id: 376, value: "71" },
    { id: 377, value: "19" },
    { id: 378, value: "36" },
    { id: 379, value: "**" },
  ],
  [
    { id: 380, value: "93" },
    { id: 381, value: "38" },
    { id: 382, value: "46" },
    { id: 383, value: "82" },
    { id: 384, value: "90" },
    { id: 385, value: "41" },
    { id: 386, value: "**" },
  ],
  [
    { id: 387, value: "13" },
    { id: 388, value: "17" },
    { id: 389, value: "61" },
    { id: 390, value: "06" },
    { id: 391, value: "17" },
    { id: 392, value: "66" },
    { id: 393, value: "**" },
  ],
  [
    { id: 394, value: "43" },
    { id: 395, value: "80" },
    { id: 396, value: "49" },
    { id: 397, value: "03" },
    { id: 398, value: "45" },
    { id: 399, value: "75" },
    { id: 400, value: "**" },
  ],
  [
    { id: 401, value: "48" },
    { id: 402, value: "28" },
    { id: 403, value: "15" },
    { id: 404, value: "65" },
    { id: 405, value: "17" },
    { id: 406, value: "85" },
    { id: 407, value: "**" },
  ],
  [
    { id: 408, value: "09" },
    { id: 409, value: "45" },
    { id: 410, value: "67" },
    { id: 411, value: "68" },
    { id: 412, value: "74" },
    { id: 413, value: "23" },
    { id: 414, value: "**" },
  ],
  [
    { id: 415, value: "11" },
    { id: 416, value: "27" },
    { id: 417, value: "07" },
    { id: 418, value: "27" },
    { id: 419, value: "39" },
    { id: 420, value: "13" },
    { id: 421, value: "**" },
  ],
  [
    { id: 422, value: "32" },
    { id: 423, value: "30" },
    { id: 424, value: "85" },
    { id: 425, value: "00" },
    { id: 426, value: "99" },
    { id: 427, value: "85" },
    { id: 428, value: "**" },
  ],
  [
    { id: 429, value: "14" },
    { id: 430, value: "08" },
    { id: 431, value: "91" },
    { id: 432, value: "82" },
    { id: 433, value: "08" },
    { id: 434, value: "44" },
    { id: 435, value: "**" },
  ],
  [
    { id: 436, value: "20" },
    { id: 437, value: "02" },
    { id: 438, value: "97" },
    { id: 439, value: "80" },
    { id: 440, value: "90" },
    { id: 441, value: "58" },
    { id: 442, value: "**" },
  ],
  [
    { id: 443, value: "10" },
    { id: 444, value: "09" },
    { id: 445, value: "36" },
    { id: 446, value: "53" },
    { id: 447, value: "88" },
    { id: 448, value: "47" },
    { id: 449, value: "**" },
  ],
  [
    { id: 450, value: "05" },
    { id: 451, value: "67" },
    { id: 452, value: "92" },
    { id: 453, value: "21" },
    { id: 454, value: "52" },
    { id: 455, value: "54" },
    { id: 456, value: "**" },
  ],
  [
    { id: 457, value: "80" },
    { id: 458, value: "27" },
    { id: 459, value: "79" },
    { id: 460, value: "02" },
    { id: 461, value: "45" },
    { id: 462, value: "42" },
    { id: 463, value: "**" },
  ],
  [
    { id: 464, value: "86" },
    { id: 465, value: "85" },
    { id: 466, value: "02" },
    { id: 467, value: "91" },
    { id: 468, value: "66" },
    { id: 469, value: "87" },
    { id: 470, value: "**" },
  ],
  [
    { id: 471, value: "77" },
    { id: 472, value: "51" },
    { id: 473, value: "62" },
    { id: 474, value: "92" },
    { id: 475, value: "48" },
    { id: 476, value: "22" },
    { id: 477, value: "**" },
  ],
  [
    { id: 478, value: "49" },
    { id: 479, value: "37" },
    { id: 480, value: "68" },
    { id: 481, value: "65" },
    { id: 482, value: "01" },
    { id: 483, value: "08" },
    { id: 484, value: "**" },
  ],
  [
    { id: 485, value: "81" },
    { id: 486, value: "33" },
    { id: 487, value: "64" },
    { id: 488, value: "03" },
    { id: 489, value: "53" },
    { id: 490, value: "72" },
    { id: 491, value: "**" },
  ],
  [
    { id: 492, value: "82" },
    { id: 493, value: "86" },
    { id: 494, value: "50" },
    { id: 495, value: "25" },
    { id: 496, value: "26" },
    { id: 497, value: "77" },
    { id: 498, value: "**" },
  ],
  [
    { id: 499, value: "02" },
    { id: 500, value: "03" },
    { id: 501, value: "79" },
    { id: 502, value: "15" },
    { id: 503, value: "75" },
    { id: 504, value: "64" },
    { id: 505, value: "**" },
  ],
  [
    { id: 506, value: "46" },
    { id: 507, value: "04" },
    { id: 508, value: "55" },
    { id: 509, value: "61" },
    { id: 510, value: "61" },
    { id: 511, value: "55" },
    { id: 512, value: "**" },
  ],
  [
    { id: 513, value: "43" },
    { id: 514, value: "44" },
    { id: 515, value: "61" },
    { id: 516, value: "10" },
    { id: 517, value: "74" },
    { id: 518, value: "34" },
    { id: 519, value: "**" },
  ],
  [
    { id: 520, value: "36" },
    { id: 521, value: "55" },
    { id: 522, value: "43" },
    { id: 523, value: "72" },
    { id: 524, value: "67" },
    { id: 525, value: "98" },
    { id: 526, value: "**" },
  ],
  [
    { id: 527, value: "49" },
    { id: 528, value: "39" },
    { id: 529, value: "61" },
    { id: 530, value: "91" },
    { id: 531, value: "03" },
    { id: 532, value: "06" },
    { id: 533, value: "**" },
  ],
  [
    { id: 534, value: "73" },
    { id: 535, value: "74" },
    { id: 536, value: "38" },
    { id: 537, value: "29" },
    { id: 538, value: "**" },
    { id: 539, value: "99" },
    { id: 540, value: "**" },
  ],
  [
    { id: 541, value: "67" },
    { id: 542, value: "32" },
    { id: 543, value: "14" },
    { id: 544, value: "03" },
    { id: 545, value: "75" },
    { id: 546, value: "35" },
    { id: 547, value: "**" },
  ],
  [
    { id: 548, value: "81" },
    { id: 549, value: "09" },
    { id: 550, value: "**" },
    { id: 551, value: "82" },
    { id: 552, value: "34" },
    { id: 553, value: "41" },
    { id: 554, value: "**" },
  ],
  [
    { id: 555, value: "44" },
    { id: 556, value: "38" },
    { id: 557, value: "46" },
    { id: 558, value: "22" },
    { id: 559, value: "51" },
    { id: 560, value: "52" },
    { id: 561, value: "**" },
  ],
  [
    { id: 562, value: "41" },
    { id: 563, value: "15" },
    { id: 564, value: "20" },
    { id: 565, value: "96" },
    { id: 566, value: "46" },
    { id: 567, value: "86" },
    { id: 568, value: "**" },
  ],
  [
    { id: 569, value: "63" },
    { id: 570, value: "18" },
    { id: 571, value: "89" },
    { id: 572, value: "59" },
    { id: 573, value: "57" },
    { id: 574, value: "44" },
    { id: 575, value: "**" },
  ],
  [
    { id: 576, value: "00" },
    { id: 577, value: "11" },
    { id: 578, value: "56" },
    { id: 579, value: "92" },
    { id: 580, value: "73" },
    { id: 581, value: "00" },
    { id: 582, value: "**" },
  ],
  [
    { id: 583, value: "45" },
    { id: 584, value: "05" },
    { id: 585, value: "62" },
    { id: 586, value: "86" },
    { id: 587, value: "30" },
    { id: 588, value: "84" },
    { id: 589, value: "**" },
  ],
  [
    { id: 590, value: "69" },
    { id: 591, value: "39" },
    { id: 592, value: "91" },
    { id: 593, value: "50" },
    { id: 594, value: "87" },
    { id: 595, value: "67" },
    { id: 596, value: "**" },
  ],
  [
    { id: 597, value: "75" },
    { id: 598, value: "18" },
    { id: 599, value: "13" },
    { id: 600, value: "93" },
    { id: 601, value: "62" },
    { id: 602, value: "**" },
    { id: 603, value: "**" },
  ],
  [
    { id: 604, value: "09" },
    { id: 605, value: "65" },
    { id: 606, value: "54" },
    { id: 607, value: "41" },
    { id: 608, value: "62" },
    { id: 609, value: "23" },
    { id: 610, value: "**" },
  ],
  [
    { id: 611, value: "07" },
    { id: 612, value: "74" },
    { id: 613, value: "35" },
    { id: 614, value: "81" },
    { id: 615, value: "78" },
    { id: 616, value: "23" },
    { id: 617, value: "**" },
  ],
  [
    { id: 618, value: "43" },
    { id: 619, value: "62" },
    { id: 620, value: "75" },
    { id: 621, value: "46" },
    { id: 622, value: "11" },
    { id: 623, value: "77" },
    { id: 624, value: "**" },
  ],
  [
    { id: 625, value: "03" },
    { id: 626, value: "33" },
    { id: 627, value: "21" },
    { id: 628, value: "80" },
    { id: 629, value: "65" },
    { id: 630, value: "35" },
    { id: 631, value: "**" },
  ],
  [
    { id: 632, value: "62" },
    { id: 633, value: "89" },
    { id: 634, value: "33" },
    { id: 635, value: "20" },
    { id: 636, value: "86" },
    { id: 637, value: "28" },
    { id: 638, value: "**" },
  ],
  [
    { id: 639, value: "59" },
    { id: 640, value: "15" },
    { id: 641, value: "44" },
    { id: 642, value: "73" },
    { id: 643, value: "44" },
    { id: 644, value: "44" },
    { id: 645, value: "**" },
  ],
  [
    { id: 646, value: "47" },
    { id: 647, value: "55" },
    { id: 648, value: "14" },
    { id: 649, value: "29" },
    { id: 650, value: "96" },
    { id: 651, value: "89" },
    { id: 652, value: "**" },
  ],
  [
    { id: 653, value: "62" },
    { id: 654, value: "90" },
    { id: 655, value: "89" },
    { id: 656, value: "81" },
    { id: 657, value: "17" },
    { id: 658, value: "97" },
    { id: 659, value: "**" },
  ],
  [
    { id: 660, value: "19" },
    { id: 661, value: "28" },
    { id: 662, value: "72" },
    { id: 663, value: "38" },
    { id: 664, value: "12" },
    { id: 665, value: "05" },
    { id: 666, value: "**" },
  ],
  [
    { id: 667, value: "19" },
    { id: 668, value: "27" },
    { id: 669, value: "50" },
    { id: 670, value: "36" },
    { id: 671, value: "24" },
    { id: 672, value: "08" },
    { id: 673, value: "**" },
  ],
  [
    { id: 674, value: "67" },
    { id: 675, value: "57" },
    { id: 676, value: "65" },
    { id: 677, value: "61" },
    { id: 678, value: "28" },
    { id: 679, value: "53" },
    { id: 680, value: "**" },
  ],
  [
    { id: 681, value: "41" },
    { id: 682, value: "59" },
    { id: 683, value: "04" },
    { id: 684, value: "87" },
    { id: 685, value: "40" },
    { id: 686, value: "90" },
    { id: 687, value: "**" },
  ],
  [
    { id: 688, value: "19" },
    { id: 689, value: "43" },
    { id: 690, value: "64" },
    { id: 691, value: "31" },
    { id: 692, value: "08" },
    { id: 693, value: "51" },
    { id: 694, value: "**" },
  ],
  [
    { id: 695, value: "**" },
    { id: 696, value: "95" },
    { id: 697, value: "11" },
    { id: 698, value: "09" },
    { id: 699, value: "80" },
    { id: 700, value: "77" },
    { id: 701, value: "**" },
  ],
  [
    { id: 702, value: "53" },
    { id: 703, value: "58" },
    { id: 704, value: "86" },
    { id: 705, value: "27" },
    { id: 706, value: "75" },
    { id: 707, value: "79" },
    { id: 708, value: "**" },
  ],
  [
    { id: 709, value: "85" },
    { id: 710, value: "14" },
    { id: 711, value: "78" },
    { id: 712, value: "83" },
    { id: 713, value: "83" },
    { id: 714, value: "11" },
    { id: 715, value: "**" },
  ],
  [
    { id: 716, value: "15" },
    { id: 717, value: "04" },
    { id: 718, value: "16" },
    { id: 719, value: "89" },
    { id: 720, value: "10" },
    { id: 721, value: "41" },
    { id: 722, value: "**" },
  ],
  [
    { id: 723, value: "35" },
    { id: 724, value: "33" },
    { id: 725, value: "92" },
    { id: 726, value: "67" },
    { id: 727, value: "48" },
    { id: 728, value: "04" },
    { id: 729, value: "**" },
  ],
  [
    { id: 730, value: "14" },
    { id: 731, value: "31" },
    { id: 732, value: "**" },
    { id: 733, value: "46" },
    { id: 734, value: "62" },
    { id: 735, value: "00" },
    { id: 736, value: "**" },
  ],
  [
    { id: 737, value: "29" },
    { id: 738, value: "50" },
    { id: 739, value: "97" },
    { id: 740, value: "44" },
    { id: 741, value: "92" },
    { id: 742, value: "66" },
    { id: 743, value: "**" },
  ],
  [
    { id: 744, value: "96" },
    { id: 745, value: "83" },
    { id: 746, value: "00" },
    { id: 747, value: "03" },
    { id: 748, value: "18" },
    { id: 749, value: "23" },
    { id: 750, value: "**" },
  ],
];

//  Madhur Day

export const MadhurDay = [
  [
    { id: 1, value: "93" },
    { id: 2, value: "82" },
    { id: 3, value: "44" },
    { id: 4, value: "69" },
    { id: 5, value: "60" },
    { id: 6, value: "29" },
    { id: 7, value: "64" },
  ],
  [
    { id: 8, value: "75" },
    { id: 9, value: "73" },
    { id: 10, value: "88" },
    { id: 11, value: "95" },
    { id: 12, value: "01" },
    { id: 13, value: "21" },
    { id: 14, value: "76" },
  ],
  [
    { id: 15, value: "12" },
    { id: 16, value: "85" },
    { id: 17, value: "16" },
    { id: 18, value: "23" },
    { id: 19, value: "42" },
    { id: 20, value: "01" },
    { id: 21, value: "38" },
  ],
  [
    { id: 22, value: "01" },
    { id: 23, value: "30" },
    { id: 24, value: "91" },
    { id: 25, value: "97" },
    { id: 26, value: "**" },
    { id: 27, value: "40" },
    { id: 28, value: "48" },
  ],
  [
    { id: 29, value: "14" },
    { id: 30, value: "32" },
    { id: 31, value: "14" },
    { id: 32, value: "47" },
    { id: 33, value: "66" },
    { id: 34, value: "83" },
    { id: 35, value: "10" },
  ],
  [
    { id: 36, value: "88" },
    { id: 37, value: "27" },
    { id: 38, value: "21" },
    { id: 39, value: "24" },
    { id: 40, value: "59" },
    { id: 41, value: "09" },
    { id: 42, value: "27" },
  ],
  [
    { id: 43, value: "72" },
    { id: 44, value: "63" },
    { id: 45, value: "10" },
    { id: 46, value: "08" },
    { id: 47, value: "24" },
    { id: 48, value: "81" },
    { id: 49, value: "35" },
  ],
  [
    { id: 50, value: "31" },
    { id: 51, value: "80" },
    { id: 52, value: "17" },
    { id: 53, value: "49" },
    { id: 54, value: "42" },
    { id: 55, value: "88" },
    { id: 56, value: "86" },
  ],
  [
    { id: 57, value: "34" },
    { id: 58, value: "44" },
    { id: 59, value: "30" },
    { id: 60, value: "05" },
    { id: 61, value: "88" },
    { id: 62, value: "02" },
    { id: 63, value: "64" },
  ],
  [
    { id: 64, value: "34" },
    { id: 65, value: "10" },
    { id: 66, value: "62" },
    { id: 67, value: "59" },
    { id: 68, value: "19" },
    { id: 69, value: "98" },
    { id: 70, value: "66" },
  ],
  [
    { id: 71, value: "80" },
    { id: 72, value: "16" },
    { id: 73, value: "69" },
    { id: 74, value: "32" },
    { id: 75, value: "94" },
    { id: 76, value: "56" },
    { id: 77, value: "44" },
  ],
  [
    { id: 78, value: "11" },
    { id: 79, value: "65" },
    { id: 80, value: "80" },
    { id: 81, value: "16" },
    { id: 82, value: "13" },
    { id: 83, value: "73" },
    { id: 84, value: "54" },
  ],
  [
    { id: 85, value: "**" },
    { id: 86, value: "91" },
    { id: 87, value: "41" },
    { id: 88, value: "03" },
    { id: 89, value: "09" },
    { id: 90, value: "93" },
    { id: 91, value: "07" },
  ],
  [
    { id: 92, value: "50" },
    { id: 93, value: "71" },
    { id: 94, value: "77" },
    { id: 95, value: "94" },
    { id: 96, value: "87" },
    { id: 97, value: "77" },
    { id: 98, value: "80" },
  ],
  [
    { id: 99, value: "13" },
    { id: 100, value: "52" },
    { id: 101, value: "47" },
    { id: 102, value: "23" },
    { id: 103, value: "32" },
    { id: 104, value: "68" },
    { id: 105, value: "64" },
  ],
  [
    { id: 106, value: "94" },
    { id: 107, value: "19" },
    { id: 108, value: "10" },
    { id: 109, value: "23" },
    { id: 110, value: "92" },
    { id: 111, value: "86" },
    { id: 112, value: "39" },
  ],
  [
    { id: 113, value: "02" },
    { id: 114, value: "25" },
    { id: 115, value: "68" },
    { id: 116, value: "16" },
    { id: 117, value: "00" },
    { id: 118, value: "24" },
    { id: 119, value: "74" },
  ],
  [
    { id: 120, value: "94" },
    { id: 121, value: "45" },
    { id: 122, value: "38" },
    { id: 123, value: "42" },
    { id: 124, value: "87" },
    { id: 125, value: "19" },
    { id: 126, value: "51" },
  ],
  [
    { id: 127, value: "71" },
    { id: 128, value: "21" },
    { id: 129, value: "08" },
    { id: 130, value: "97" },
    { id: 131, value: "46" },
    { id: 132, value: "44" },
    { id: 133, value: "08" },
  ],
  [
    { id: 134, value: "72" },
    { id: 135, value: "47" },
    { id: 136, value: "09" },
    { id: 137, value: "86" },
    { id: 138, value: "67" },
    { id: 139, value: "65" },
    { id: 140, value: "07" },
  ],
  [
    { id: 141, value: "65" },
    { id: 142, value: "79" },
    { id: 143, value: "12" },
    { id: 144, value: "21" },
    { id: 145, value: "06" },
    { id: 146, value: "77" },
    { id: 147, value: "51" },
  ],
  [
    { id: 148, value: "11" },
    { id: 149, value: "31" },
    { id: 150, value: "82" },
    { id: 151, value: "82" },
    { id: 152, value: "51" },
    { id: 153, value: "46" },
    { id: 154, value: "85" },
  ],
  [
    { id: 155, value: "87" },
    { id: 156, value: "82" },
    { id: 157, value: "12" },
    { id: 158, value: "32" },
    { id: 159, value: "91" },
    { id: 160, value: "42" },
    { id: 161, value: "14" },
  ],
  [
    { id: 162, value: "35" },
    { id: 163, value: "34" },
    { id: 164, value: "99" },
    { id: 165, value: "73" },
    { id: 166, value: "21" },
    { id: 167, value: "32" },
    { id: 168, value: "71" },
  ],
  [
    { id: 169, value: "19" },
    { id: 170, value: "01" },
    { id: 171, value: "02" },
    { id: 172, value: "76" },
    { id: 173, value: "04" },
    { id: 174, value: "60" },
    { id: 175, value: "48" },
  ],
  [
    { id: 176, value: "90" },
    { id: 177, value: "70" },
    { id: 178, value: "69" },
    { id: 179, value: "08" },
    { id: 180, value: "82" },
    { id: 181, value: "81" },
    { id: 182, value: "62" },
  ],
  [
    { id: 183, value: "27" },
    { id: 184, value: "23" },
    { id: 185, value: "42" },
    { id: 186, value: "99" },
    { id: 187, value: "68" },
    { id: 188, value: "97" },
    { id: 189, value: "79" },
  ],
  [
    { id: 190, value: "00" },
    { id: 191, value: "36" },
    { id: 192, value: "26" },
    { id: 193, value: "48" },
    { id: 194, value: "05" },
    { id: 195, value: "08" },
    { id: 196, value: "27" },
  ],
  [
    { id: 197, value: "42" },
    { id: 198, value: "10" },
    { id: 199, value: "51" },
    { id: 200, value: "30" },
    { id: 201, value: "60" },
    { id: 202, value: "93" },
    { id: 203, value: "24" },
  ],
  [
    { id: 204, value: "53" },
    { id: 205, value: "58" },
    { id: 206, value: "03" },
    { id: 207, value: "81" },
    { id: 208, value: "81" },
    { id: 209, value: "63" },
    { id: 210, value: "80" },
  ],
  [
    { id: 211, value: "10" },
    { id: 212, value: "65" },
    { id: 213, value: "04" },
    { id: 214, value: "23" },
    { id: 215, value: "73" },
    { id: 216, value: "28" },
    { id: 217, value: "23" },
  ],
  [
    { id: 218, value: "38" },
    { id: 219, value: "26" },
    { id: 220, value: "04" },
    { id: 221, value: "97" },
    { id: 222, value: "41" },
    { id: 223, value: "38" },
    { id: 224, value: "06" },
  ],
  [
    { id: 225, value: "60" },
    { id: 226, value: "84" },
    { id: 227, value: "48" },
    { id: 228, value: "**" },
    { id: 229, value: "48" },
    { id: 230, value: "97" },
    { id: 231, value: "71" },
  ],
  [
    { id: 232, value: "24" },
    { id: 233, value: "05" },
    { id: 234, value: "91" },
    { id: 235, value: "71" },
    { id: 236, value: "32" },
    { id: 237, value: "74" },
    { id: 238, value: "99" },
  ],
  [
    { id: 239, value: "75" },
    { id: 240, value: "66" },
    { id: 241, value: "93" },
    { id: 242, value: "57" },
    { id: 243, value: "40" },
    { id: 244, value: "32" },
    { id: 245, value: "04" },
  ],
  [
    { id: 246, value: "49" },
    { id: 247, value: "92" },
    { id: 248, value: "20" },
    { id: 249, value: "77" },
    { id: 250, value: "70" },
    { id: 251, value: "52" },
    { id: 252, value: "22" },
  ],
  [
    { id: 253, value: "51" },
    { id: 254, value: "40" },
    { id: 255, value: "15" },
    { id: 256, value: "73" },
    { id: 257, value: "99" },
    { id: 258, value: "96" },
    { id: 259, value: "36" },
  ],
  [
    { id: 260, value: "22" },
    { id: 261, value: "73" },
    { id: 262, value: "77" },
    { id: 263, value: "01" },
    { id: 264, value: "50" },
    { id: 265, value: "80" },
    { id: 266, value: "62" },
  ],
  [
    { id: 267, value: "08" },
    { id: 268, value: "13" },
    { id: 269, value: "00" },
    { id: 270, value: "86" },
    { id: 271, value: "05" },
    { id: 272, value: "04" },
    { id: 273, value: "89" },
  ],
  [
    { id: 274, value: "69" },
    { id: 275, value: "83" },
    { id: 276, value: "31" },
    { id: 277, value: "58" },
    { id: 278, value: "28" },
    { id: 279, value: "74" },
    { id: 280, value: "81" },
  ],
  [
    { id: 281, value: "81" },
    { id: 282, value: "90" },
    { id: 283, value: "67" },
    { id: 284, value: "69" },
    { id: 285, value: "53" },
    { id: 286, value: "77" },
    { id: 287, value: "57" },
  ],
  [
    { id: 288, value: "37" },
    { id: 289, value: "09" },
    { id: 290, value: "94" },
    { id: 291, value: "93" },
    { id: 292, value: "55" },
    { id: 293, value: "62" },
    { id: 294, value: "90" },
  ],
  [
    { id: 295, value: "59" },
    { id: 296, value: "37" },
    { id: 297, value: "32" },
    { id: 298, value: "99" },
    { id: 299, value: "69" },
    { id: 300, value: "62" },
    { id: 301, value: "**" },
  ],
  [
    { id: 302, value: "**" },
    { id: 303, value: "**" },
    { id: 304, value: "**" },
    { id: 305, value: "**" },
    { id: 306, value: "**" },
    { id: 307, value: "**" },
    { id: 308, value: "**" },
  ],
  [
    { id: 309, value: "**" },
    { id: 310, value: "**" },
    { id: 311, value: "31" },
    { id: 312, value: "47" },
    { id: 313, value: "38" },
    { id: 314, value: "57" },
    { id: 315, value: "83" },
  ],
  [
    { id: 316, value: "90" },
    { id: 317, value: "16" },
    { id: 318, value: "83" },
    { id: 319, value: "78" },
    { id: 320, value: "61" },
    { id: 321, value: "16" },
    { id: 322, value: "02" },
  ],
  [
    { id: 323, value: "89" },
    { id: 324, value: "34" },
    { id: 325, value: "82" },
    { id: 326, value: "94" },
    { id: 327, value: "36" },
    { id: 328, value: "44" },
    { id: 329, value: "43" },
  ],
  [
    { id: 330, value: "13" },
    { id: 331, value: "12" },
    { id: 332, value: "60" },
    { id: 333, value: "97" },
    { id: 334, value: "32" },
    { id: 335, value: "94" },
    { id: 336, value: "61" },
  ],
  [
    { id: 337, value: "70" },
    { id: 338, value: "61" },
    { id: 339, value: "46" },
    { id: 340, value: "64" },
    { id: 341, value: "21" },
    { id: 342, value: "02" },
    { id: 343, value: "71" },
  ],
  [
    { id: 344, value: "64" },
    { id: 345, value: "49" },
    { id: 346, value: "97" },
    { id: 347, value: "10" },
    { id: 348, value: "87" },
    { id: 349, value: "97" },
    { id: 350, value: "29" },
  ],
  [
    { id: 351, value: "89" },
    { id: 352, value: "86" },
    { id: 353, value: "12" },
    { id: 354, value: "90" },
    { id: 355, value: "69" },
    { id: 356, value: "38" },
    { id: 357, value: "97" },
  ],
  [
    { id: 358, value: "60" },
    { id: 359, value: "65" },
    { id: 360, value: "17" },
    { id: 361, value: "06" },
    { id: 362, value: "12" },
    { id: 363, value: "23" },
    { id: 364, value: "00" },
  ],
  [
    { id: 365, value: "64" },
    { id: 366, value: "93" },
    { id: 367, value: "32" },
    { id: 368, value: "57" },
    { id: 369, value: "94" },
    { id: 370, value: "41" },
    { id: 371, value: "61" },
  ],
  [
    { id: 372, value: "76" },
    { id: 373, value: "01" },
    { id: 374, value: "76" },
    { id: 375, value: "55" },
    { id: 376, value: "44" },
    { id: 377, value: "93" },
    { id: 378, value: "55" },
  ],
  [
    { id: 379, value: "21" },
    { id: 380, value: "83" },
    { id: 381, value: "33" },
    { id: 382, value: "14" },
    { id: 383, value: "09" },
    { id: 384, value: "00" },
    { id: 385, value: "37" },
  ],
  [
    { id: 386, value: "63" },
    { id: 387, value: "67" },
    { id: 388, value: "21" },
    { id: 389, value: "21" },
    { id: 390, value: "03" },
    { id: 391, value: "28" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "63" },
    { id: 394, value: "53" },
    { id: 395, value: "21" },
    { id: 396, value: "21" },
    { id: 397, value: "03" },
    { id: 398, value: "28" },
    { id: 399, value: "72" },
  ],
  [
    { id: 400, value: "39" },
    { id: 401, value: "29" },
    { id: 402, value: "26" },
    { id: 403, value: "54" },
    { id: 404, value: "17" },
    { id: 405, value: "71" },
    { id: 406, value: "80" },
  ],
  [
    { id: 407, value: "92" },
    { id: 408, value: "74" },
    { id: 409, value: "74" },
    { id: 410, value: "15" },
    { id: 411, value: "57" },
    { id: 412, value: "00" },
    { id: 413, value: "83" },
  ],
  [
    { id: 414, value: "95" },
    { id: 415, value: "84" },
    { id: 416, value: "89" },
    { id: 417, value: "89" },
    { id: 418, value: "71" },
    { id: 419, value: "12" },
    { id: 420, value: "59" },
  ],
  [
    { id: 421, value: "19" },
    { id: 422, value: "05" },
    { id: 423, value: "29" },
    { id: 424, value: "26" },
    { id: 425, value: "61" },
    { id: 426, value: "38" },
    { id: 427, value: "75" },
  ],
  [
    { id: 428, value: "92" },
    { id: 429, value: "59" },
    { id: 430, value: "66" },
    { id: 431, value: "25" },
    { id: 432, value: "64" },
    { id: 433, value: "00" },
    { id: 434, value: "72" },
  ],
  [
    { id: 435, value: "91" },
    { id: 436, value: "46" },
    { id: 437, value: "72" },
    { id: 438, value: "42" },
    { id: 439, value: "17" },
    { id: 440, value: "29" },
    { id: 441, value: "77" },
  ],
  [
    { id: 442, value: "17" },
    { id: 443, value: "29" },
    { id: 444, value: "60" },
    { id: 445, value: "48" },
    { id: 446, value: "72" },
    { id: 447, value: "66" },
    { id: 448, value: "99" },
  ],
  [
    { id: 449, value: "94" },
    { id: 450, value: "38" },
    { id: 451, value: "71" },
    { id: 452, value: "39" },
    { id: 453, value: "40" },
    { id: 454, value: "12" },
    { id: 455, value: "19" },
  ],
  [
    { id: 456, value: "49" },
    { id: 457, value: "61" },
    { id: 458, value: "01" },
    { id: 459, value: "49" },
    { id: 460, value: "74" },
    { id: 461, value: "94" },
    { id: 462, value: "10" },
  ],
  [
    { id: 463, value: "84" },
    { id: 464, value: "22" },
    { id: 465, value: "94" },
    { id: 466, value: "13" },
    { id: 467, value: "26" },
    { id: 468, value: "38" },
    { id: 469, value: "08" },
  ],
  [
    { id: 470, value: "36" },
    { id: 471, value: "30" },
    { id: 472, value: "87" },
    { id: 473, value: "40" },
    { id: 474, value: "50" },
    { id: 475, value: "52" },
    { id: 476, value: "66" },
  ],
  [
    { id: 477, value: "11" },
    { id: 478, value: "00" },
    { id: 479, value: "42" },
    { id: 480, value: "60" },
    { id: 481, value: "58" },
    { id: 482, value: "13" },
    { id: 483, value: "37" },
  ],
  [
    { id: 484, value: "91" },
    { id: 485, value: "88" },
    { id: 486, value: "21" },
    { id: 487, value: "78" },
    { id: 488, value: "60" },
    { id: 489, value: "82" },
    { id: 490, value: "37" },
  ],
  [
    { id: 491, value: "33" },
    { id: 492, value: "46" },
    { id: 493, value: "94" },
    { id: 494, value: "27" },
    { id: 495, value: "67" },
    { id: 496, value: "19" },
    { id: 497, value: "43" },
  ],
  [
    { id: 498, value: "17" },
    { id: 499, value: "40" },
    { id: 500, value: "95" },
    { id: 501, value: "57" },
    { id: 502, value: "72" },
    { id: 503, value: "16" },
    { id: 504, value: "87" },
  ],
  [
    { id: 505, value: "41" },
    { id: 506, value: "41" },
    { id: 507, value: "82" },
    { id: 508, value: "90" },
    { id: 509, value: "11" },
    { id: 510, value: "48" },
    { id: 511, value: "37" },
  ],
  [
    { id: 512, value: "91" },
    { id: 513, value: "03" },
    { id: 514, value: "83" },
    { id: 515, value: "90" },
    { id: 516, value: "75" },
    { id: 517, value: "48" },
    { id: 518, value: "47" },
  ],
  [
    { id: 519, value: "82" },
    { id: 520, value: "64" },
    { id: 521, value: "20" },
    { id: 522, value: "01" },
    { id: 523, value: "09" },
    { id: 524, value: "12" },
    { id: 525, value: "06" },
  ],
  [
    { id: 526, value: "13" },
    { id: 527, value: "41" },
    { id: 528, value: "11" },
    { id: 529, value: "55" },
    { id: 530, value: "78" },
    { id: 531, value: "69" },
    { id: 532, value: "41" },
  ],
  [
    { id: 533, value: "89" },
    { id: 534, value: "37" },
    { id: 535, value: "37" },
    { id: 536, value: "61" },
    { id: 537, value: "55" },
    { id: 538, value: "10" },
    { id: 539, value: "45" },
  ],
  [
    { id: 540, value: "25" },
    { id: 541, value: "45" },
    { id: 542, value: "20" },
    { id: 543, value: "30" },
    { id: 544, value: "99" },
    { id: 545, value: "12" },
    { id: 546, value: "71" },
  ],
  [
    { id: 547, value: "58" },
    { id: 548, value: "08" },
    { id: 549, value: "83" },
    { id: 550, value: "75" },
    { id: 551, value: "08" },
    { id: 552, value: "22" },
    { id: 553, value: "84" },
  ],
  [
    { id: 554, value: "61" },
    { id: 555, value: "78" },
    { id: 556, value: "33" },
    { id: 557, value: "59" },
    { id: 558, value: "73" },
    { id: 559, value: "98" },
    { id: 560, value: "38" },
  ],
  [
    { id: 561, value: "16" },
    { id: 562, value: "10" },
    { id: 563, value: "05" },
    { id: 564, value: "62" },
    { id: 565, value: "89" },
    { id: 566, value: "44" },
    { id: 567, value: "63" },
  ],
  [
    { id: 568, value: "54" },
    { id: 569, value: "01" },
    { id: 570, value: "44" },
    { id: 571, value: "45" },
    { id: 572, value: "81" },
    { id: 573, value: "02" },
    { id: 574, value: "88" },
  ],
  [
    { id: 575, value: "64" },
    { id: 576, value: "40" },
    { id: 577, value: "48" },
    { id: 578, value: "08" },
    { id: 579, value: "21" },
    { id: 580, value: "03" },
    { id: 581, value: "06" },
  ],
  [
    { id: 582, value: "41" },
    { id: 583, value: "75" },
    { id: 584, value: "87" },
    { id: 585, value: "51" },
    { id: 586, value: "40" },
    { id: 587, value: "93" },
    { id: 588, value: "86" },
  ],
  [
    { id: 589, value: "52" },
    { id: 590, value: "37" },
    { id: 591, value: "87" },
    { id: 592, value: "89" },
    { id: 593, value: "79" },
    { id: 594, value: "34" },
    { id: 595, value: "02" },
  ],
  [
    { id: 596, value: "05" },
    { id: 597, value: "77" },
    { id: 598, value: "58" },
    { id: 599, value: "74" },
    { id: 600, value: "**" },
    { id: 601, value: "79" },
    { id: 602, value: "70" },
  ],
  [
    { id: 603, value: "96" },
    { id: 604, value: "72" },
    { id: 605, value: "10" },
    { id: 606, value: "58" },
    { id: 607, value: "64" },
    { id: 608, value: "90" },
    { id: 609, value: "10" },
  ],
  [
    { id: 610, value: "57" },
    { id: 611, value: "08" },
    { id: 612, value: "13" },
    { id: 613, value: "82" },
    { id: 614, value: "77" },
    { id: 615, value: "23" },
    { id: 616, value: "69" },
  ],
  [
    { id: 617, value: "21" },
    { id: 618, value: "92" },
    { id: 619, value: "06" },
    { id: 620, value: "69" },
    { id: 621, value: "04" },
    { id: 622, value: "62" },
    { id: 623, value: "41" },
  ],
  [
    { id: 624, value: "84" },
    { id: 625, value: "58" },
    { id: 626, value: "36" },
    { id: 627, value: "88" },
    { id: 628, value: "64" },
    { id: 629, value: "80" },
    { id: 630, value: "25" },
  ],
  [
    { id: 631, value: "06" },
    { id: 632, value: "69" },
    { id: 633, value: "62" },
    { id: 634, value: "13" },
    { id: 635, value: "01" },
    { id: 636, value: "39" },
    { id: 637, value: "91" },
  ],
  [
    { id: 638, value: "86" },
    { id: 639, value: "12" },
    { id: 640, value: "15" },
    { id: 641, value: "99" },
    { id: 642, value: "07" },
    { id: 643, value: "75" },
    { id: 644, value: "77" },
  ],
  [
    { id: 645, value: "90" },
    { id: 646, value: "94" },
    { id: 647, value: "57" },
    { id: 648, value: "38" },
    { id: 649, value: "40" },
    { id: 650, value: "31" },
    { id: 651, value: "66" },
  ],
  [
    { id: 652, value: "93" },
    { id: 653, value: "78" },
    { id: 654, value: "32" },
    { id: 655, value: "55" },
    { id: 656, value: "70" },
    { id: 657, value: "22" },
    { id: 658, value: "30" },
  ],
  [
    { id: 659, value: "77" },
    { id: 660, value: "90" },
    { id: 661, value: "82" },
    { id: 662, value: "43" },
    { id: 663, value: "29" },
    { id: 664, value: "**" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "76" },
    { id: 667, value: "24" },
    { id: 668, value: "90" },
    { id: 669, value: "12" },
    { id: 670, value: "94" },
    { id: 671, value: "21" },
    { id: 672, value: "40" },
  ],
  [
    { id: 673, value: "17" },
    { id: 674, value: "09" },
    { id: 675, value: "18" },
    { id: 676, value: "87" },
    { id: 677, value: "80" },
    { id: 678, value: "24" },
    { id: 679, value: "69" },
  ],
  [
    { id: 680, value: "40" },
    { id: 681, value: "29" },
    { id: 682, value: "22" },
    { id: 683, value: "71" },
    { id: 684, value: "60" },
    { id: 685, value: "56" },
    { id: 686, value: "59" },
  ],
  [
    { id: 687, value: "69" },
    { id: 688, value: "34" },
    { id: 689, value: "10" },
    { id: 690, value: "77" },
    { id: 691, value: "28" },
    { id: 692, value: "24" },
    { id: 693, value: "20" },
  ],
  [
    { id: 694, value: "20" },
    { id: 695, value: "71" },
    { id: 696, value: "06" },
    { id: 697, value: "53" },
    { id: 698, value: "06" },
    { id: 699, value: "74" },
    { id: 700, value: "05" },
  ],
  [
    { id: 701, value: "60" },
    { id: 702, value: "12" },
    { id: 703, value: "77" },
    { id: 704, value: "53" },
    { id: 705, value: "77" },
    { id: 706, value: "43" },
    { id: 707, value: "46" },
  ],
  [
    { id: 708, value: "31" },
    { id: 709, value: "49" },
    { id: 710, value: "84" },
    { id: 711, value: "20" },
    { id: 712, value: "53" },
    { id: 713, value: "53" },
    { id: 714, value: "98" },
  ],
  [
    { id: 715, value: "00" },
    { id: 716, value: "61" },
    { id: 717, value: "40" },
    { id: 718, value: "32" },
    { id: 719, value: "45" },
    { id: 720, value: "10" },
    { id: 721, value: "14" },
  ],
  [
    { id: 722, value: "94" },
    { id: 723, value: "10" },
    { id: 724, value: "28" },
    { id: 725, value: "76" },
    { id: 726, value: "74" },
    { id: 727, value: "05" },
    { id: 728, value: "03" },
  ],
  [
    { id: 729, value: "89" },
    { id: 730, value: "22" },
    { id: 731, value: "86" },
    { id: 732, value: "34" },
    { id: 733, value: "31" },
    { id: 734, value: "70" },
    { id: 735, value: "45" },
  ],
  [
    { id: 736, value: "66" },
    { id: 737, value: "09" },
    { id: 738, value: "70" },
    { id: 739, value: "04" },
    { id: 740, value: "97" },
    { id: 741, value: "91" },
    { id: 742, value: "85" },
  ],
  [
    { id: 743, value: "61" },
    { id: 744, value: "50" },
    { id: 745, value: "10" },
    { id: 746, value: "13" },
    { id: 747, value: "00" },
    { id: 748, value: "77" },
    { id: 749, value: "17" },
  ],
  [
    { id: 750, value: "31" },
    { id: 751, value: "93" },
    { id: 752, value: "98" },
    { id: 753, value: "28" },
    { id: 754, value: "10" },
    { id: 755, value: "23" },
    { id: 756, value: "68" },
  ],
  [
    { id: 757, value: "**" },
    { id: 758, value: "66" },
    { id: 759, value: "78" },
    { id: 760, value: "12" },
    { id: 761, value: "28" },
    { id: 762, value: "17" },
    { id: 763, value: "08" },
  ],
  [
    { id: 764, value: "94" },
    { id: 765, value: "82" },
    { id: 766, value: "99" },
    { id: 767, value: "66" },
    { id: 768, value: "89" },
    { id: 769, value: "58" },
    { id: 770, value: "96" },
  ],
  [
    { id: 771, value: "77" },
    { id: 772, value: "11" },
    { id: 773, value: "08" },
    { id: 774, value: "79" },
    { id: 775, value: "74" },
    { id: 776, value: "62" },
    { id: 777, value: "79" },
  ],
  [
    { id: 778, value: "53" },
    { id: 779, value: "21" },
    { id: 780, value: "38" },
    { id: 781, value: "25" },
    { id: 782, value: "44" },
    { id: 783, value: "99" },
    { id: 784, value: "59" },
  ],
  [
    { id: 785, value: "88" },
    { id: 786, value: "02" },
    { id: 787, value: "95" },
    { id: 788, value: "64" },
    { id: 789, value: "43" },
    { id: 790, value: "98" },
    { id: 791, value: "41" },
  ],
  [
    { id: 792, value: "56" },
    { id: 793, value: "33" },
    { id: 794, value: "**" },
    { id: 795, value: "88" },
    { id: 796, value: "21" },
    { id: 797, value: "86" },
    { id: 798, value: "98" },
  ],
  [
    { id: 799, value: "03" },
    { id: 800, value: "98" },
    { id: 801, value: "16" },
    { id: 802, value: "25" },
    { id: 803, value: "00" },
    { id: 804, value: "31" },
    { id: 805, value: "35" },
  ],
  [
    { id: 806, value: "80" },
    { id: 807, value: "03" },
    { id: 808, value: "61" },
    { id: 809, value: "69" },
    { id: 810, value: "22" },
    { id: 811, value: "17" },
    { id: 812, value: "33" },
  ],
];

export const MadhurNight = [
  [
    { id: 1, value: "75" },
    { id: 2, value: "54" },
    { id: 3, value: "50" },
    { id: 4, value: "69" },
    { id: 5, value: "56" },
    { id: 6, value: "62" },
  ],
  [
    { id: 7, value: "23" },
    { id: 8, value: "15" },
    { id: 9, value: "98" },
    { id: 10, value: "26" },
    { id: 11, value: "55" },
    { id: 12, value: "05" },
  ],
  [
    { id: 13, value: "89" },
    { id: 14, value: "60" },
    { id: 15, value: "12" },
    { id: 16, value: "31" },
    { id: 17, value: "74" },
    { id: 18, value: "39" },
  ],
  [
    { id: 19, value: "76" },
    { id: 20, value: "16" },
    { id: 21, value: "80" },
    { id: 22, value: "92" },
    { id: 23, value: "**" },
    { id: 24, value: "31" },
  ],
  [
    { id: 25, value: "23" },
    { id: 26, value: "25" },
    { id: 27, value: "67" },
    { id: 28, value: "88" },
    { id: 29, value: "58" },
    { id: 30, value: "36" },
  ],
  [
    { id: 31, value: "72" },
    { id: 32, value: "20" },
    { id: 33, value: "61" },
    { id: 34, value: "19" },
    { id: 35, value: "13" },
    { id: 36, value: "86" },
  ],
  [
    { id: 37, value: "46" },
    { id: 38, value: "37" },
    { id: 39, value: "72" },
    { id: 40, value: "08" },
    { id: 41, value: "37" },
    { id: 42, value: "35" },
  ],
  [
    { id: 43, value: "20" },
    { id: 44, value: "63" },
    { id: 45, value: "01" },
    { id: 46, value: "02" },
    { id: 47, value: "06" },
    { id: 48, value: "56" },
  ],
  [
    { id: 49, value: "27" },
    { id: 50, value: "94" },
    { id: 51, value: "21" },
    { id: 52, value: "83" },
    { id: 53, value: "44" },
    { id: 54, value: "21" },
  ],
  [
    { id: 55, value: "60" },
    { id: 56, value: "73" },
    { id: 57, value: "09" },
    { id: 58, value: "70" },
    { id: 59, value: "75" },
    { id: 60, value: "37" },
  ],
  [
    { id: 61, value: "59" },
    { id: 62, value: "88" },
    { id: 63, value: "45" },
    { id: 64, value: "87" },
    { id: 65, value: "59" },
    { id: 66, value: "23" },
  ],
  [
    { id: 67, value: "65" },
    { id: 68, value: "84" },
    { id: 69, value: "94" },
    { id: 70, value: "55" },
    { id: 71, value: "71" },
    { id: 72, value: "77" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "27" },
    { id: 75, value: "78" },
    { id: 76, value: "28" },
    { id: 77, value: "62" },
    { id: 78, value: "10" },
  ],
  [
    { id: 79, value: "14" },
    { id: 80, value: "73" },
    { id: 81, value: "86" },
    { id: 82, value: "08" },
    { id: 83, value: "69" },
    { id: 84, value: "83" },
  ],
  [
    { id: 85, value: "28" },
    { id: 86, value: "31" },
    { id: 87, value: "96" },
    { id: 88, value: "14" },
    { id: 89, value: "90" },
    { id: 90, value: "53" },
  ],
  [
    { id: 91, value: "20" },
    { id: 92, value: "39" },
    { id: 93, value: "24" },
    { id: 94, value: "70" },
    { id: 95, value: "55" },
    { id: 96, value: "67" },
  ],
  [
    { id: 97, value: "45" },
    { id: 98, value: "44" },
    { id: 99, value: "12" },
    { id: 100, value: "52" },
    { id: 101, value: "73" },
    { id: 102, value: "15" },
  ],
  [
    { id: 103, value: "26" },
    { id: 104, value: "60" },
    { id: 105, value: "10" },
    { id: 106, value: "94" },
    { id: 107, value: "12" },
    { id: 108, value: "21" },
  ],
  [
    { id: 109, value: "53" },
    { id: 110, value: "72" },
    { id: 111, value: "93" },
    { id: 112, value: "75" },
    { id: 113, value: "90" },
    { id: 114, value: "81" },
  ],
  [
    { id: 115, value: "81" },
    { id: 116, value: "77" },
    { id: 117, value: "29" },
    { id: 118, value: "22" },
    { id: 119, value: "11" },
    { id: 120, value: "94" },
  ],
  [
    { id: 121, value: "71" },
    { id: 122, value: "03" },
    { id: 123, value: "50" },
    { id: 124, value: "56" },
    { id: 125, value: "31" },
    { id: 126, value: "18" },
  ],
  [
    { id: 127, value: "63" },
    { id: 128, value: "02" },
    { id: 129, value: "91" },
    { id: 130, value: "58" },
    { id: 131, value: "30" },
    { id: 132, value: "77" },
  ],
  [
    { id: 133, value: "36" },
    { id: 134, value: "87" },
    { id: 135, value: "63" },
    { id: 136, value: "00" },
    { id: 137, value: "25" },
    { id: 138, value: "31" },
  ],
  [
    { id: 139, value: "38" },
    { id: 140, value: "14" },
    { id: 141, value: "36" },
    { id: 142, value: "12" },
    { id: 143, value: "28" },
    { id: 144, value: "98" },
  ],
  [
    { id: 145, value: "08" },
    { id: 146, value: "07" },
    { id: 147, value: "82" },
    { id: 148, value: "24" },
    { id: 149, value: "61" },
    { id: 150, value: "59" },
  ],
  [
    { id: 151, value: "88" },
    { id: 152, value: "52" },
    { id: 153, value: "75" },
    { id: 154, value: "07" },
    { id: 155, value: "28" },
    { id: 156, value: "58" },
  ],
  [
    { id: 157, value: "43" },
    { id: 158, value: "87" },
    { id: 159, value: "10" },
    { id: 160, value: "62" },
    { id: 161, value: "01" },
    { id: 162, value: "04" },
  ],
  [
    { id: 163, value: "59" },
    { id: 164, value: "26" },
    { id: 165, value: "07" },
    { id: 166, value: "60" },
    { id: 167, value: "27" },
    { id: 168, value: "94" },
  ],
  [
    { id: 169, value: "08" },
    { id: 170, value: "94" },
    { id: 171, value: "65" },
    { id: 172, value: "01" },
    { id: 173, value: "42" },
    { id: 174, value: "50" },
  ],
  [
    { id: 175, value: "74" },
    { id: 176, value: "71" },
    { id: 177, value: "18" },
    { id: 178, value: "05" },
    { id: 179, value: "43" },
    { id: 180, value: "66" },
  ],
  [
    { id: 181, value: "32" },
    { id: 182, value: "61" },
    { id: 183, value: "54" },
    { id: 184, value: "20" },
    { id: 185, value: "81" },
    { id: 186, value: "60" },
  ],
  [
    { id: 187, value: "98" },
    { id: 188, value: "30" },
    { id: 189, value: "86" },
    { id: 190, value: "64" },
    { id: 191, value: "41" },
    { id: 192, value: "94" },
  ],
  [
    { id: 193, value: "55" },
    { id: 194, value: "73" },
    { id: 195, value: "89" },
    { id: 196, value: "**" },
    { id: 197, value: "61" },
    { id: 198, value: "71" },
  ],
  [
    { id: 199, value: "67" },
    { id: 200, value: "19" },
    { id: 201, value: "14" },
    { id: 202, value: "04" },
    { id: 203, value: "15" },
    { id: 204, value: "76" },
  ],
  [
    { id: 205, value: "20" },
    { id: 206, value: "65" },
    { id: 207, value: "63" },
    { id: 208, value: "42" },
    { id: 209, value: "34" },
    { id: 210, value: "30" },
  ],
  [
    { id: 211, value: "91" },
    { id: 212, value: "16" },
    { id: 213, value: "18" },
    { id: 214, value: "84" },
    { id: 215, value: "16" },
    { id: 216, value: "55" },
  ],
  [
    { id: 217, value: "27" },
    { id: 218, value: "28" },
    { id: 219, value: "54" },
    { id: 220, value: "46" },
    { id: 221, value: "10" },
    { id: 222, value: "69" },
  ],
  [
    { id: 223, value: "24" },
    { id: 224, value: "59" },
    { id: 225, value: "30" },
    { id: 226, value: "30" },
    { id: 227, value: "71" },
    { id: 228, value: "37" },
  ],
  [
    { id: 229, value: "57" },
    { id: 230, value: "29" },
    { id: 231, value: "49" },
    { id: 232, value: "70" },
    { id: 233, value: "97" },
    { id: 234, value: "84" },
  ],
  [
    { id: 235, value: "32" },
    { id: 236, value: "23" },
    { id: 237, value: "64" },
    { id: 238, value: "65" },
    { id: 239, value: "44" },
    { id: 240, value: "00" },
  ],
  [
    { id: 241, value: "36" },
    { id: 242, value: "09" },
    { id: 243, value: "16" },
    { id: 244, value: "25" },
    { id: 245, value: "31" },
    { id: 246, value: "85" },
  ],
  [
    { id: 247, value: "34" },
    { id: 248, value: "13" },
    { id: 249, value: "00" },
    { id: 250, value: "94" },
    { id: 251, value: "60" },
    { id: 252, value: "51" },
  ],
  [
    { id: 253, value: "32" },
    { id: 254, value: "44" },
    { id: 255, value: "82" },
    { id: 256, value: "20" },
    { id: 257, value: "92" },
    { id: 258, value: "31" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "15" },
    { id: 268, value: "52" },
    { id: 269, value: "12" },
    { id: 270, value: "31" },
  ],
  [
    { id: 271, value: "55" },
    { id: 272, value: "19" },
    { id: 273, value: "88" },
    { id: 274, value: "42" },
    { id: 275, value: "13" },
    { id: 276, value: "68" },
  ],
  [
    { id: 277, value: "25" },
    { id: 278, value: "78" },
    { id: 279, value: "01" },
    { id: 280, value: "66" },
    { id: 281, value: "92" },
    { id: 282, value: "24" },
  ],
  [
    { id: 283, value: "26" },
    { id: 284, value: "98" },
    { id: 285, value: "98" },
    { id: 286, value: "92" },
    { id: 287, value: "04" },
    { id: 288, value: "58" },
  ],
  [
    { id: 289, value: "21" },
    { id: 290, value: "55" },
    { id: 291, value: "94" },
    { id: 292, value: "87" },
    { id: 293, value: "26" },
    { id: 294, value: "19" },
  ],
  [
    { id: 295, value: "69" },
    { id: 296, value: "03" },
    { id: 297, value: "85" },
    { id: 298, value: "11" },
    { id: 299, value: "18" },
    { id: 300, value: "21" },
  ],
  [
    { id: 301, value: "50" },
    { id: 302, value: "50" },
    { id: 303, value: "39" },
    { id: 304, value: "61" },
    { id: 305, value: "96" },
    { id: 306, value: "48" },
  ],
  [
    { id: 307, value: "04" },
    { id: 308, value: "75" },
    { id: 309, value: "18" },
    { id: 310, value: "98" },
    { id: 311, value: "33" },
    { id: 312, value: "87" },
  ],
  [
    { id: 313, value: "21" },
    { id: 314, value: "44" },
    { id: 315, value: "45" },
    { id: 316, value: "43" },
    { id: 317, value: "16" },
    { id: 318, value: "81" },
  ],
  [
    { id: 319, value: "77" },
    { id: 320, value: "36" },
    { id: 321, value: "09" },
    { id: 322, value: "04" },
    { id: 323, value: "72" },
    { id: 324, value: "16" },
  ],
  [
    { id: 325, value: "15" },
    { id: 326, value: "10" },
    { id: 327, value: "95" },
    { id: 328, value: "87" },
    { id: 329, value: "88" },
    { id: 330, value: "64" },
  ],
  [
    { id: 331, value: "99" },
    { id: 332, value: "84" },
    { id: 333, value: "07" },
    { id: 334, value: "52" },
    { id: 335, value: "26" },
    { id: 336, value: "53" },
  ],
  [
    { id: 337, value: "88" },
    { id: 338, value: "43" },
    { id: 339, value: "33" },
    { id: 340, value: "51" },
    { id: 341, value: "64" },
    { id: 342, value: "01" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "88" },
    { id: 345, value: "48" },
    { id: 346, value: "87" },
    { id: 347, value: "52" },
    { id: 348, value: "43" },
    { id: 349, value: "91" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "38" },
    { id: 352, value: "63" },
    { id: 353, value: "01" },
    { id: 354, value: "06" },
    { id: 355, value: "37" },
    { id: 356, value: "57" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "17" },
    { id: 359, value: "29" },
    { id: 360, value: "23" },
    { id: 361, value: "64" },
    { id: 362, value: "60" },
    { id: 363, value: "13" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "05" },
    { id: 366, value: "61" },
    { id: 367, value: "56" },
    { id: 368, value: "35" },
    { id: 369, value: "12" },
    { id: 370, value: "46" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "02" },
    { id: 373, value: "68" },
    { id: 374, value: "97" },
    { id: 375, value: "78" },
    { id: 376, value: "93" },
    { id: 377, value: "84" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "77" },
    { id: 380, value: "31" },
    { id: 381, value: "96" },
    { id: 382, value: "98" },
    { id: 383, value: "83" },
    { id: 384, value: "44" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "33" },
    { id: 387, value: "74" },
    { id: 388, value: "63" },
    { id: 389, value: "18" },
    { id: 390, value: "07" },
    { id: 391, value: "74" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "73" },
    { id: 394, value: "10" },
    { id: 395, value: "48" },
    { id: 396, value: "28" },
    { id: 397, value: "44" },
    { id: 398, value: "60" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "61" },
    { id: 401, value: "78" },
    { id: 402, value: "05" },
    { id: 403, value: "79" },
    { id: 404, value: "41" },
    { id: 405, value: "39" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "43" },
    { id: 408, value: "68" },
    { id: 409, value: "64" },
    { id: 410, value: "45" },
    { id: 411, value: "01" },
    { id: 412, value: "01" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "28" },
    { id: 415, value: "43" },
    { id: 416, value: "80" },
    { id: 417, value: "67" },
    { id: 418, value: "91" },
    { id: 419, value: "20" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "97" },
    { id: 422, value: "27" },
    { id: 423, value: "80" },
    { id: 424, value: "64" },
    { id: 425, value: "66" },
    { id: 426, value: "41" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "13" },
    { id: 429, value: "26" },
    { id: 430, value: "97" },
    { id: 431, value: "55" },
    { id: 432, value: "**" },
    { id: 433, value: "67" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "22" },
    { id: 436, value: "50" },
    { id: 437, value: "84" },
    { id: 438, value: "38" },
    { id: 439, value: "38" },
    { id: 440, value: "53" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "11" },
    { id: 443, value: "45" },
    { id: 444, value: "96" },
    { id: 445, value: "32" },
    { id: 446, value: "59" },
    { id: 447, value: "09" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "51" },
    { id: 450, value: "22" },
    { id: 451, value: "20" },
    { id: 452, value: "59" },
    { id: 453, value: "44" },
    { id: 454, value: "57" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "66" },
    { id: 457, value: "85" },
    { id: 458, value: "03" },
    { id: 459, value: "33" },
    { id: 460, value: "48" },
    { id: 461, value: "99" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "84" },
    { id: 464, value: "72" },
    { id: 465, value: "74" },
    { id: 466, value: "64" },
    { id: 467, value: "26" },
    { id: 468, value: "62" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "47" },
    { id: 471, value: "43" },
    { id: 472, value: "15" },
    { id: 473, value: "91" },
    { id: 474, value: "82" },
    { id: 475, value: "94" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "00" },
    { id: 478, value: "54" },
    { id: 479, value: "93" },
    { id: 480, value: "79" },
    { id: 481, value: "12" },
    { id: 482, value: "78" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "39" },
    { id: 485, value: "47" },
    { id: 486, value: "99" },
    { id: 487, value: "11" },
    { id: 488, value: "42" },
    { id: 489, value: "04" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "43" },
    { id: 492, value: "59" },
    { id: 493, value: "00" },
    { id: 494, value: "06" },
    { id: 495, value: "81" },
    { id: 496, value: "**" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "72" },
    { id: 499, value: "26" },
    { id: 500, value: "21" },
    { id: 501, value: "51" },
    { id: 502, value: "45" },
    { id: 503, value: "36" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "66" },
    { id: 506, value: "80" },
    { id: 507, value: "18" },
    { id: 508, value: "54" },
    { id: 509, value: "21" },
    { id: 510, value: "01" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "54" },
    { id: 513, value: "78" },
    { id: 514, value: "32" },
    { id: 515, value: "10" },
    { id: 516, value: "32" },
    { id: 517, value: "05" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "04" },
    { id: 520, value: "30" },
    { id: 521, value: "38" },
    { id: 522, value: "60" },
    { id: 523, value: "80" },
    { id: 524, value: "63" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "09" },
    { id: 527, value: "46" },
    { id: 528, value: "83" },
    { id: 529, value: "30" },
    { id: 530, value: "53" },
    { id: 531, value: "69" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "32" },
    { id: 534, value: "61" },
    { id: 535, value: "59" },
    { id: 536, value: "02" },
    { id: 537, value: "86" },
    { id: 538, value: "62" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "35" },
    { id: 541, value: "64" },
    { id: 542, value: "72" },
    { id: 543, value: "89" },
    { id: 544, value: "44" },
    { id: 545, value: "33" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "40" },
    { id: 548, value: "10" },
    { id: 549, value: "65" },
    { id: 550, value: "02" },
    { id: 551, value: "73" },
    { id: 552, value: "17" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "48" },
    { id: 555, value: "84" },
    { id: 556, value: "37" },
    { id: 557, value: "69" },
    { id: 558, value: "17" },
    { id: 559, value: "47" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "13" },
    { id: 562, value: "96" },
    { id: 563, value: "17" },
    { id: 564, value: "67" },
    { id: 565, value: "53" },
    { id: 566, value: "16" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "87" },
    { id: 569, value: "70" },
    { id: 570, value: "33" },
    { id: 571, value: "76" },
    { id: 572, value: "24" },
    { id: 573, value: "66" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "42" },
    { id: 576, value: "35" },
    { id: 577, value: "76" },
    { id: 578, value: "68" },
    { id: 579, value: "00" },
    { id: 580, value: "39" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "01" },
    { id: 583, value: "87" },
    { id: 584, value: "73" },
    { id: 585, value: "18" },
    { id: 586, value: "48" },
    { id: 587, value: "70" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "**" },
    { id: 590, value: "35" },
    { id: 591, value: "62" },
    { id: 592, value: "99" },
    { id: 593, value: "14" },
    { id: 594, value: "11" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "79" },
    { id: 597, value: "03" },
    { id: 598, value: "67" },
    { id: 599, value: "57" },
    { id: 600, value: "21" },
    { id: 601, value: "29" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "25" },
    { id: 604, value: "14" },
    { id: 605, value: "26" },
    { id: 606, value: "21" },
    { id: 607, value: "54" },
    { id: 608, value: "65" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "48" },
    { id: 611, value: "25" },
    { id: 612, value: "20" },
    { id: 613, value: "81" },
    { id: 614, value: "62" },
    { id: 615, value: "29" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "04" },
    { id: 618, value: "19" },
    { id: 619, value: "45" },
    { id: 620, value: "20" },
    { id: 621, value: "23" },
    { id: 622, value: "96" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "69" },
    { id: 625, value: "85" },
    { id: 626, value: "**" },
    { id: 627, value: "53" },
    { id: 628, value: "36" },
    { id: 629, value: "91" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "82" },
    { id: 632, value: "11" },
    { id: 633, value: "82" },
    { id: 634, value: "90" },
    { id: 635, value: "24" },
    { id: 636, value: "00" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "60" },
    { id: 639, value: "95" },
    { id: 640, value: "95" },
    { id: 641, value: "41" },
    { id: 642, value: "50" },
    { id: 643, value: "34" },
    { id: 644, value: "**" },
  ],
];
// rajdhaniday

export const RajdhaniDay = [
  [
    { id: 1, value: "23" },
    { id: 2, value: "99" },
    { id: 3, value: "70" },
    { id: 4, value: "05" },
    { id: 5, value: "21" },
    { id: 6, value: "99" },
  ],
  [
    { id: 7, value: "26" },
    { id: 8, value: "64" },
    { id: 9, value: "08" },
    { id: 10, value: "50" },
    { id: 11, value: "99" },
    { id: 12, value: "50" },
  ],
  [
    { id: 13, value: "16" },
    { id: 14, value: "17" },
    { id: 15, value: "70" },
    { id: 16, value: "83" },
    { id: 17, value: "40" },
    { id: 18, value: "91" },
  ],
  [
    { id: 19, value: "63" },
    { id: 20, value: "45" },
    { id: 21, value: "62" },
    { id: 22, value: "95" },
    { id: 23, value: "**" },
    { id: 24, value: "21" },
  ],
  [
    { id: 25, value: "33" },
    { id: 26, value: "46" },
    { id: 27, value: "44" },
    { id: 28, value: "60" },
    { id: 29, value: "02" },
    { id: 30, value: "62" },
  ],
  [
    { id: 31, value: "96" },
    { id: 32, value: "67" },
    { id: 33, value: "88" },
    { id: 34, value: "81" },
    { id: 35, value: "02" },
    { id: 36, value: "31" },
  ],
  [
    { id: 37, value: "44" },
    { id: 38, value: "23" },
    { id: 39, value: "47" },
    { id: 40, value: "64" },
    { id: 41, value: "31" },
    { id: 42, value: "70" },
  ],
  [
    { id: 43, value: "08" },
    { id: 44, value: "66" },
    { id: 45, value: "78" },
    { id: 46, value: "03" },
    { id: 47, value: "93" },
    { id: 48, value: "00" },
  ],
  [
    { id: 49, value: "93" },
    { id: 50, value: "57" },
    { id: 51, value: "19" },
    { id: 52, value: "13" },
    { id: 53, value: "96" },
    { id: 54, value: "28" },
  ],
  [
    { id: 55, value: "34" },
    { id: 56, value: "73" },
    { id: 57, value: "23" },
    { id: 58, value: "28" },
    { id: 59, value: "41" },
    { id: 60, value: "84" },
  ],
  [
    { id: 61, value: "71" },
    { id: 62, value: "77" },
    { id: 63, value: "28" },
    { id: 64, value: "42" },
    { id: 65, value: "76" },
    { id: 66, value: "89" },
  ],
  [
    { id: 67, value: "95" },
    { id: 68, value: "66" },
    { id: 69, value: "61" },
    { id: 70, value: "80" },
    { id: 71, value: "05" },
    { id: 72, value: "83" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "45" },
    { id: 75, value: "58" },
    { id: 76, value: "13" },
    { id: 77, value: "10" },
    { id: 78, value: "07" },
  ],
  [
    { id: 79, value: "41" },
    { id: 80, value: "33" },
    { id: 81, value: "09" },
    { id: 82, value: "41" },
    { id: 83, value: "03" },
    { id: 84, value: "38" },
  ],
  [
    { id: 85, value: "99" },
    { id: 86, value: "08" },
    { id: 87, value: "37" },
    { id: 88, value: "68" },
    { id: 89, value: "81" },
    { id: 90, value: "11" },
  ],
  [
    { id: 91, value: "63" },
    { id: 92, value: "37" },
    { id: 93, value: "82" },
    { id: 94, value: "06" },
    { id: 95, value: "15" },
    { id: 96, value: "16" },
  ],
  [
    { id: 97, value: "75" },
    { id: 98, value: "72" },
    { id: 99, value: "53" },
    { id: 100, value: "84" },
    { id: 101, value: "05" },
    { id: 102, value: "33" },
  ],
  [
    { id: 103, value: "56" },
    { id: 104, value: "02" },
    { id: 105, value: "88" },
    { id: 106, value: "59" },
    { id: 107, value: "22" },
    { id: 108, value: "24" },
  ],
  [
    { id: 109, value: "12" },
    { id: 110, value: "05" },
    { id: 111, value: "14" },
    { id: 112, value: "61" },
    { id: 113, value: "80" },
    { id: 114, value: "80" },
  ],
  [
    { id: 115, value: "19" },
    { id: 116, value: "65" },
    { id: 117, value: "40" },
    { id: 118, value: "14" },
    { id: 119, value: "67" },
    { id: 120, value: "80" },
  ],
  [
    { id: 121, value: "16" },
    { id: 122, value: "83" },
    { id: 123, value: "71" },
    { id: 124, value: "74" },
    { id: 125, value: "84" },
    { id: 126, value: "22" },
  ],
  [
    { id: 127, value: "15" },
    { id: 128, value: "63" },
    { id: 129, value: "97" },
    { id: 130, value: "33" },
    { id: 131, value: "95" },
    { id: 132, value: "54" },
  ],
  [
    { id: 133, value: "31" },
    { id: 134, value: "18" },
    { id: 135, value: "22" },
    { id: 136, value: "28" },
    { id: 137, value: "87" },
    { id: 138, value: "76" },
  ],
  [
    { id: 139, value: "30" },
    { id: 140, value: "48" },
    { id: 141, value: "51" },
    { id: 142, value: "82" },
    { id: 143, value: "15" },
    { id: 144, value: "16" },
  ],
  [
    { id: 145, value: "71" },
    { id: 146, value: "79" },
    { id: 147, value: "55" },
    { id: 148, value: "81" },
    { id: 149, value: "83" },
    { id: 150, value: "84" },
  ],
  [
    { id: 151, value: "33" },
    { id: 152, value: "46" },
    { id: 153, value: "64" },
    { id: 154, value: "63" },
    { id: 155, value: "08" },
    { id: 156, value: "29" },
  ],
  [
    { id: 157, value: "19" },
    { id: 158, value: "13" },
    { id: 159, value: "29" },
    { id: 160, value: "56" },
    { id: 161, value: "75" },
    { id: 162, value: "79" },
  ],
  [
    { id: 163, value: "68" },
    { id: 164, value: "53" },
    { id: 165, value: "57" },
    { id: 166, value: "14" },
    { id: 167, value: "81" },
    { id: 168, value: "26" },
  ],
  [
    { id: 169, value: "30" },
    { id: 170, value: "14" },
    { id: 171, value: "54" },
    { id: 172, value: "12" },
    { id: 173, value: "40" },
    { id: 174, value: "82" },
  ],
  [
    { id: 175, value: "70" },
    { id: 176, value: "54" },
    { id: 177, value: "85" },
    { id: 178, value: "41" },
    { id: 179, value: "74" },
    { id: 180, value: "29" },
  ],
  [
    { id: 181, value: "63" },
    { id: 182, value: "79" },
    { id: 183, value: "88" },
    { id: 184, value: "44" },
    { id: 185, value: "02" },
    { id: 186, value: "57" },
  ],
  [
    { id: 187, value: "26" },
    { id: 188, value: "18" },
    { id: 189, value: "89" },
    { id: 190, value: "38" },
    { id: 191, value: "07" },
    { id: 192, value: "77" },
  ],
  [
    { id: 193, value: "10" },
    { id: 194, value: "18" },
    { id: 195, value: "04" },
    { id: 196, value: "**" },
    { id: 197, value: "01" },
    { id: 198, value: "69" },
  ],
  [
    { id: 199, value: "40" },
    { id: 200, value: "82" },
    { id: 201, value: "05" },
    { id: 202, value: "25" },
    { id: 203, value: "86" },
    { id: 204, value: "19" },
  ],
  [
    { id: 205, value: "11" },
    { id: 206, value: "49" },
    { id: 207, value: "97" },
    { id: 208, value: "77" },
    { id: 209, value: "64" },
    { id: 210, value: "71" },
  ],
  [
    { id: 211, value: "69" },
    { id: 212, value: "51" },
    { id: 213, value: "61" },
    { id: 214, value: "70" },
    { id: 215, value: "91" },
    { id: 216, value: "18" },
  ],
  [
    { id: 217, value: "59" },
    { id: 218, value: "04" },
    { id: 219, value: "41" },
    { id: 220, value: "52" },
    { id: 221, value: "88" },
    { id: 222, value: "94" },
  ],
  [
    { id: 223, value: "42" },
    { id: 224, value: "96" },
    { id: 225, value: "51" },
    { id: 226, value: "23" },
    { id: 227, value: "09" },
    { id: 228, value: "58" },
  ],
  [
    { id: 229, value: "69" },
    { id: 230, value: "05" },
    { id: 231, value: "05" },
    { id: 232, value: "40" },
    { id: 233, value: "61" },
    { id: 234, value: "25" },
  ],
  [
    { id: 235, value: "91" },
    { id: 236, value: "03" },
    { id: 237, value: "82" },
    { id: 238, value: "29" },
    { id: 239, value: "37" },
    { id: 240, value: "21" },
  ],
  [
    { id: 241, value: "81" },
    { id: 242, value: "77" },
    { id: 243, value: "10" },
    { id: 244, value: "52" },
    { id: 245, value: "10" },
    { id: 246, value: "74" },
  ],
  [
    { id: 247, value: "42" },
    { id: 248, value: "16" },
    { id: 249, value: "99" },
    { id: 250, value: "42" },
    { id: 251, value: "51" },
    { id: 252, value: "54" },
  ],
  [
    { id: 253, value: "62" },
    { id: 254, value: "06" },
    { id: 255, value: "30" },
    { id: 256, value: "32" },
    { id: 257, value: "80" },
    { id: 258, value: "91" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "79" },
    { id: 268, value: "98" },
    { id: 269, value: "73" },
    { id: 270, value: "92" },
  ],
  [
    { id: 271, value: "06" },
    { id: 272, value: "10" },
    { id: 273, value: "74" },
    { id: 274, value: "48" },
    { id: 275, value: "66" },
    { id: 276, value: "38" },
  ],
  [
    { id: 277, value: "43" },
    { id: 278, value: "19" },
    { id: 279, value: "78" },
    { id: 280, value: "15" },
    { id: 281, value: "93" },
    { id: 282, value: "48" },
  ],
  [
    { id: 283, value: "77" },
    { id: 284, value: "38" },
    { id: 285, value: "32" },
    { id: 286, value: "63" },
    { id: 287, value: "24" },
    { id: 288, value: "13" },
  ],
  [
    { id: 289, value: "05" },
    { id: 290, value: "85" },
    { id: 291, value: "44" },
    { id: 292, value: "07" },
    { id: 293, value: "60" },
    { id: 294, value: "42" },
  ],
  [
    { id: 295, value: "91" },
    { id: 296, value: "37" },
    { id: 297, value: "31" },
    { id: 298, value: "26" },
    { id: 299, value: "25" },
    { id: 300, value: "81" },
  ],
  [
    { id: 301, value: "10" },
    { id: 302, value: "64" },
    { id: 303, value: "10" },
    { id: 304, value: "76" },
    { id: 305, value: "92" },
    { id: 306, value: "40" },
  ],
  [
    { id: 307, value: "66" },
    { id: 308, value: "09" },
    { id: 309, value: "94" },
    { id: 310, value: "95" },
    { id: 311, value: "90" },
    { id: 312, value: "75" },
  ],
  [
    { id: 313, value: "11" },
    { id: 314, value: "40" },
    { id: 315, value: "52" },
    { id: 316, value: "39" },
    { id: 317, value: "10" },
    { id: 318, value: "45" },
  ],
  [
    { id: 319, value: "59" },
    { id: 320, value: "05" },
    { id: 321, value: "14" },
    { id: 322, value: "41" },
    { id: 323, value: "35" },
    { id: 324, value: "66" },
  ],
  [
    { id: 325, value: "19" },
    { id: 326, value: "38" },
    { id: 327, value: "29" },
    { id: 328, value: "42" },
    { id: 329, value: "78" },
    { id: 330, value: "05" },
  ],
  [
    { id: 331, value: "39" },
    { id: 332, value: "66" },
    { id: 333, value: "64" },
    { id: 334, value: "20" },
    { id: 335, value: "86" },
    { id: 336, value: "53" },
  ],
  [
    { id: 337, value: "37" },
    { id: 338, value: "59" },
    { id: 339, value: "64" },
    { id: 340, value: "20" },
    { id: 341, value: "86" },
    { id: 342, value: "53" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "63" },
    { id: 345, value: "11" },
    { id: 346, value: "50" },
    { id: 347, value: "82" },
    { id: 348, value: "82" },
    { id: 349, value: "25" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "63" },
    { id: 352, value: "00" },
    { id: 353, value: "14" },
    { id: 354, value: "70" },
    { id: 355, value: "91" },
    { id: 356, value: "40" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "87" },
    { id: 359, value: "09" },
    { id: 360, value: "54" },
    { id: 361, value: "83" },
    { id: 362, value: "51" },
    { id: 363, value: "05" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "67" },
    { id: 366, value: "12" },
    { id: 367, value: "87" },
    { id: 368, value: "69" },
    { id: 369, value: "87" },
    { id: 370, value: "50" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "65" },
    { id: 373, value: "33" },
    { id: 374, value: "50" },
    { id: 375, value: "99" },
    { id: 376, value: "75" },
    { id: 377, value: "12" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "52" },
    { id: 380, value: "97" },
    { id: 381, value: "35" },
    { id: 382, value: "08" },
    { id: 383, value: "46" },
    { id: 384, value: "33" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "83" },
    { id: 387, value: "05" },
    { id: 388, value: "22" },
    { id: 389, value: "78" },
    { id: 390, value: "47" },
    { id: 391, value: "71" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "65" },
    { id: 394, value: "13" },
    { id: 395, value: "29" },
    { id: 396, value: "17" },
    { id: 397, value: "98" },
    { id: 398, value: "35" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "96" },
    { id: 401, value: "52" },
    { id: 402, value: "90" },
    { id: 403, value: "64" },
    { id: 404, value: "51" },
    { id: 405, value: "29" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "40" },
    { id: 408, value: "27" },
    { id: 409, value: "15" },
    { id: 410, value: "46" },
    { id: 411, value: "99" },
    { id: 412, value: "60" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "73" },
    { id: 415, value: "49" },
    { id: 416, value: "33" },
    { id: 417, value: "49" },
    { id: 418, value: "83" },
    { id: 419, value: "96" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "05" },
    { id: 422, value: "97" },
    { id: 423, value: "02" },
    { id: 424, value: "74" },
    { id: 425, value: "40" },
    { id: 426, value: "81" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "37" },
    { id: 429, value: "50" },
    { id: 430, value: "08" },
    { id: 431, value: "55" },
    { id: 432, value: "31" },
    { id: 433, value: "02" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "96" },
    { id: 436, value: "65" },
    { id: 437, value: "32" },
    { id: 438, value: "15" },
    { id: 439, value: "33" },
    { id: 440, value: "12" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "30" },
    { id: 443, value: "94" },
    { id: 444, value: "52" },
    { id: 445, value: "60" },
    { id: 446, value: "16" },
    { id: 447, value: "91" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "80" },
    { id: 450, value: "59" },
    { id: 451, value: "37" },
    { id: 452, value: "72" },
    { id: 453, value: "34" },
    { id: 454, value: "13" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "90" },
    { id: 457, value: "37" },
    { id: 458, value: "50" },
    { id: 459, value: "46" },
    { id: 460, value: "50" },
    { id: 461, value: "94" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "40" },
    { id: 464, value: "54" },
    { id: 465, value: "39" },
    { id: 466, value: "42" },
    { id: 467, value: "66" },
    { id: 468, value: "76" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "14" },
    { id: 471, value: "36" },
    { id: 472, value: "17" },
    { id: 473, value: "63" },
    { id: 474, value: "41" },
    { id: 475, value: "22" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "07" },
    { id: 478, value: "27" },
    { id: 479, value: "18" },
    { id: 480, value: "36" },
    { id: 481, value: "78" },
    { id: 482, value: "39" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "20" },
    { id: 485, value: "41" },
    { id: 486, value: "08" },
    { id: 487, value: "20" },
    { id: 488, value: "98" },
    { id: 489, value: "33" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "41" },
    { id: 492, value: "83" },
    { id: 493, value: "27" },
    { id: 494, value: "97" },
    { id: 495, value: "91" },
    { id: 496, value: "47" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "40" },
    { id: 499, value: "77" },
    { id: 500, value: "23" },
    { id: 501, value: "46" },
    { id: 502, value: "30" },
    { id: 503, value: "24" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "20" },
    { id: 506, value: "37" },
    { id: 507, value: "95" },
    { id: 508, value: "89" },
    { id: 509, value: "12" },
    { id: 510, value: "39" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "45" },
    { id: 513, value: "21" },
    { id: 514, value: "32" },
    { id: 515, value: "78" },
    { id: 516, value: "51" },
    { id: 517, value: "65" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "74" },
    { id: 520, value: "66" },
    { id: 521, value: "28" },
    { id: 522, value: "43" },
    { id: 523, value: "39" },
    { id: 524, value: "13" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "87" },
    { id: 527, value: "81" },
    { id: 528, value: "77" },
    { id: 529, value: "54" },
    { id: 530, value: "20" },
    { id: 531, value: "11" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "35" },
    { id: 534, value: "79" },
    { id: 535, value: "82" },
    { id: 536, value: "85" },
    { id: 537, value: "62" },
    { id: 538, value: "71" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "90" },
    { id: 541, value: "68" },
    { id: 542, value: "95" },
    { id: 543, value: "67" },
    { id: 544, value: "96" },
    { id: 545, value: "86" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "08" },
    { id: 548, value: "82" },
    { id: 549, value: "65" },
    { id: 550, value: "21" },
    { id: 551, value: "43" },
    { id: 552, value: "19" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "84" },
    { id: 555, value: "37" },
    { id: 556, value: "05" },
    { id: 557, value: "80" },
    { id: 558, value: "11" },
    { id: 559, value: "85" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "94" },
    { id: 562, value: "73" },
    { id: 563, value: "74" },
    { id: 564, value: "11" },
    { id: 565, value: "14" },
    { id: 566, value: "42" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "29" },
    { id: 569, value: "97" },
    { id: 570, value: "19" },
    { id: 571, value: "61" },
    { id: 572, value: "98" },
    { id: 573, value: "57" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "26" },
    { id: 576, value: "04" },
    { id: 577, value: "10" },
    { id: 578, value: "48" },
    { id: 579, value: "56" },
    { id: 580, value: "00" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "67" },
    { id: 583, value: "61" },
    { id: 584, value: "73" },
    { id: 585, value: "75" },
    { id: 586, value: "41" },
    { id: 587, value: "94" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "83" },
    { id: 590, value: "21" },
    { id: 591, value: "23" },
    { id: 592, value: "67" },
    { id: 593, value: "70" },
    { id: 594, value: "30" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "66" },
    { id: 597, value: "27" },
    { id: 598, value: "06" },
    { id: 599, value: "95" },
    { id: 600, value: "67" },
    { id: 601, value: "90" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "08" },
    { id: 604, value: "69" },
    { id: 605, value: "06" },
    { id: 606, value: "24" },
    { id: 607, value: "71" },
    { id: 608, value: "**" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "81" },
    { id: 611, value: "67" },
    { id: 612, value: "05" },
    { id: 613, value: "78" },
    { id: 614, value: "22" },
    { id: 615, value: "64" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "44" },
    { id: 618, value: "86" },
    { id: 619, value: "22" },
    { id: 620, value: "70" },
    { id: 621, value: "09" },
    { id: 622, value: "93" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "08" },
    { id: 625, value: "27" },
    { id: 626, value: "22" },
    { id: 627, value: "14" },
    { id: 628, value: "63" },
    { id: 629, value: "05" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "34" },
    { id: 632, value: "72" },
    { id: 633, value: "26" },
    { id: 634, value: "14" },
    { id: 635, value: "97" },
    { id: 636, value: "97" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "20" },
    { id: 639, value: "49" },
    { id: 640, value: "27" },
    { id: 641, value: "50" },
    { id: 642, value: "20" },
    { id: 643, value: "96" },
    { id: 644, value: "**" },
  ],
  [
    { id: 645, value: "84" },
    { id: 646, value: "44" },
    { id: 647, value: "15" },
    { id: 648, value: "22" },
    { id: 649, value: "67" },
    { id: 650, value: "75" },
    { id: 651, value: "**" },
  ],
  [
    { id: 652, value: "70" },
    { id: 653, value: "29" },
    { id: 654, value: "91" },
    { id: 655, value: "57" },
    { id: 656, value: "52" },
    { id: 657, value: "17" },
    { id: 658, value: "**" },
  ],
  [
    { id: 659, value: "70" },
    { id: 660, value: "68" },
    { id: 661, value: "24" },
    { id: 662, value: "31" },
    { id: 663, value: "84" },
    { id: 664, value: "77" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "75" },
    { id: 667, value: "44" },
    { id: 668, value: "16" },
    { id: 669, value: "92" },
    { id: 670, value: "60" },
    { id: 671, value: "69" },
    { id: 672, value: "**" },
  ],
  [
    { id: 673, value: "01" },
    { id: 674, value: "06" },
    { id: 675, value: "25" },
    { id: 676, value: "80" },
    { id: 677, value: "23" },
    { id: 678, value: "01" },
    { id: 679, value: "**" },
  ],
  [
    { id: 680, value: "99" },
    { id: 681, value: "79" },
    { id: 682, value: "48" },
    { id: 683, value: "00" },
    { id: 684, value: "64" },
    { id: 685, value: "20" },
    { id: 686, value: "**" },
  ],
  [
    { id: 687, value: "94" },
    { id: 688, value: "87" },
    { id: 689, value: "26" },
    { id: 690, value: "88" },
    { id: 691, value: "47" },
    { id: 692, value: "08" },
    { id: 693, value: "**" },
  ],
  [
    { id: 694, value: "60" },
    { id: 695, value: "98" },
    { id: 696, value: "82" },
    { id: 697, value: "23" },
    { id: 698, value: "01" },
    { id: 699, value: "58" },
    { id: 700, value: "**" },
  ],
  [
    { id: 701, value: "**" },
    { id: 702, value: "99" },
    { id: 703, value: "81" },
    { id: 704, value: "13" },
    { id: 705, value: "55" },
    { id: 706, value: "12" },
    { id: 707, value: "**" },
  ],
  [
    { id: 708, value: "00" },
    { id: 709, value: "15" },
    { id: 710, value: "84" },
    { id: 711, value: "40" },
    { id: 712, value: "59" },
    { id: 713, value: "43" },
    { id: 714, value: "**" },
  ],
  [
    { id: 715, value: "95" },
    { id: 716, value: "57" },
    { id: 717, value: "92" },
    { id: 718, value: "75" },
    { id: 719, value: "03" },
    { id: 720, value: "82" },
    { id: 721, value: "**" },
  ],
  [
    { id: 722, value: "79" },
    { id: 723, value: "44" },
    { id: 724, value: "60" },
    { id: 725, value: "01" },
    { id: 726, value: "19" },
    { id: 727, value: "30" },
    { id: 728, value: "**" },
  ],
  [
    { id: 729, value: "14" },
    { id: 730, value: "60" },
    { id: 731, value: "53" },
    { id: 732, value: "10" },
    { id: 733, value: "01" },
    { id: 734, value: "48" },
    { id: 735, value: "**" },
  ],
  [
    { id: 736, value: "38" },
    { id: 737, value: "61" },
    { id: 738, value: "**" },
    { id: 739, value: "17" },
    { id: 740, value: "57" },
    { id: 741, value: "53" },
    { id: 742, value: "**" },
  ],
  [
    { id: 743, value: "04" },
    { id: 744, value: "42" },
    { id: 745, value: "49" },
    { id: 746, value: "38" },
    { id: 747, value: "32" },
    { id: 748, value: "10" },
    { id: 749, value: "**" },
  ],
  [
    { id: 750, value: "42" },
    { id: 751, value: "51" },
    { id: 752, value: "28" },
    { id: 753, value: "92" },
    { id: 754, value: "73" },
    { id: 755, value: "73" },
    { id: 756, value: "**" },
  ],
];

// milanday

export const MilanDay = [
  [
    { id: 1, value: "15" },
    { id: 2, value: "72" },
    { id: 3, value: "26" },
    { id: 4, value: "96" },
    { id: 5, value: "16" },
    { id: 6, value: "55" },
  ],
  [
    { id: 7, value: "76" },
    { id: 8, value: "74" },
    { id: 9, value: "88" },
    { id: 10, value: "76" },
    { id: 11, value: "93" },
    { id: 12, value: "98" },
  ],
  [
    { id: 13, value: "19" },
    { id: 14, value: "56" },
    { id: 15, value: "81" },
    { id: 16, value: "17" },
    { id: 17, value: "02" },
    { id: 18, value: "96" },
  ],
  [
    { id: 19, value: "39" },
    { id: 20, value: "87" },
    { id: 21, value: "52" },
    { id: 22, value: "65" },
    { id: 23, value: "**" },
    { id: 24, value: "02" },
  ],
  [
    { id: 25, value: "17" },
    { id: 26, value: "64" },
    { id: 27, value: "07" },
    { id: 28, value: "26" },
    { id: 29, value: "91" },
    { id: 30, value: "98" },
  ],
  [
    { id: 31, value: "98" },
    { id: 32, value: "30" },
    { id: 33, value: "62" },
    { id: 34, value: "13" },
    { id: 35, value: "17" },
    { id: 36, value: "01" },
  ],
  [
    { id: 37, value: "06" },
    { id: 38, value: "80" },
    { id: 39, value: "95" },
    { id: 40, value: "43" },
    { id: 41, value: "55" },
    { id: 42, value: "78" },
  ],
  [
    { id: 43, value: "63" },
    { id: 44, value: "51" },
    { id: 45, value: "15" },
    { id: 46, value: "41" },
    { id: 47, value: "71" },
    { id: 48, value: "40" },
  ],
  [
    { id: 49, value: "97" },
    { id: 50, value: "08" },
    { id: 51, value: "09" },
    { id: 52, value: "26" },
    { id: 53, value: "27" },
    { id: 54, value: "76" },
  ],
  [
    { id: 55, value: "76" },
    { id: 56, value: "73" },
    { id: 57, value: "78" },
    { id: 58, value: "99" },
    { id: 59, value: "71" },
    { id: 60, value: "71" },
  ],
  [
    { id: 61, value: "83" },
    { id: 62, value: "16" },
    { id: 63, value: "59" },
    { id: 64, value: "08" },
    { id: 65, value: "54" },
    { id: 66, value: "65" },
  ],
  [
    { id: 67, value: "77" },
    { id: 68, value: "75" },
    { id: 69, value: "11" },
    { id: 70, value: "98" },
    { id: 71, value: "70" },
    { id: 72, value: "01" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "94" },
    { id: 75, value: "83" },
    { id: 76, value: "04" },
    { id: 77, value: "49" },
    { id: 78, value: "79" },
  ],
  [
    { id: 79, value: "10" },
    { id: 80, value: "92" },
    { id: 81, value: "91" },
    { id: 82, value: "03" },
    { id: 83, value: "18" },
    { id: 84, value: "63" },
  ],
  [
    { id: 85, value: "25" },
    { id: 86, value: "60" },
    { id: 87, value: "56" },
    { id: 88, value: "37" },
    { id: 89, value: "21" },
    { id: 90, value: "26" },
  ],
  [
    { id: 91, value: "70" },
    { id: 92, value: "72" },
    { id: 93, value: "25" },
    { id: 94, value: "88" },
    { id: 95, value: "86" },
    { id: 96, value: "04" },
  ],
  [
    { id: 97, value: "27" },
    { id: 98, value: "07" },
    { id: 99, value: "66" },
    { id: 100, value: "06" },
    { id: 101, value: "31" },
    { id: 102, value: "80" },
  ],
  [
    { id: 103, value: "33" },
    { id: 104, value: "89" },
    { id: 105, value: "95" },
    { id: 106, value: "89" },
    { id: 107, value: "56" },
    { id: 108, value: "66" },
  ],
  [
    { id: 109, value: "64" },
    { id: 110, value: "79" },
    { id: 111, value: "54" },
    { id: 112, value: "29" },
    { id: 113, value: "94" },
    { id: 114, value: "77" },
  ],
  [
    { id: 115, value: "82" },
    { id: 116, value: "29" },
    { id: 117, value: "49" },
    { id: 118, value: "65" },
    { id: 119, value: "08" },
    { id: 120, value: "37" },
  ],
  [
    { id: 121, value: "65" },
    { id: 122, value: "77" },
    { id: 123, value: "94" },
    { id: 124, value: "43" },
    { id: 125, value: "35" },
    { id: 126, value: "38" },
  ],
  [
    { id: 127, value: "59" },
    { id: 128, value: "02" },
    { id: 129, value: "86" },
    { id: 130, value: "16" },
    { id: 131, value: "10" },
    { id: 132, value: "98" },
  ],
  [
    { id: 133, value: "01" },
    { id: 134, value: "62" },
    { id: 135, value: "69" },
    { id: 136, value: "25" },
    { id: 137, value: "12" },
    { id: 138, value: "94" },
  ],
  [
    { id: 139, value: "86" },
    { id: 140, value: "44" },
    { id: 141, value: "15" },
    { id: 142, value: "39" },
    { id: 143, value: "60" },
    { id: 144, value: "78" },
  ],
  [
    { id: 145, value: "00" },
    { id: 146, value: "14" },
    { id: 147, value: "32" },
    { id: 148, value: "47" },
    { id: 149, value: "10" },
    { id: 150, value: "31" },
  ],
  [
    { id: 151, value: "40" },
    { id: 152, value: "66" },
    { id: 153, value: "34" },
    { id: 154, value: "16" },
    { id: 155, value: "88" },
    { id: 156, value: "49" },
  ],
  [
    { id: 157, value: "71" },
    { id: 158, value: "21" },
    { id: 159, value: "50" },
    { id: 160, value: "54" },
    { id: 161, value: "08" },
    { id: 162, value: "91" },
  ],
  [
    { id: 163, value: "50" },
    { id: 164, value: "96" },
    { id: 165, value: "41" },
    { id: 166, value: "38" },
    { id: 167, value: "67" },
    { id: 168, value: "83" },
  ],
  [
    { id: 169, value: "26" },
    { id: 170, value: "97" },
    { id: 171, value: "99" },
    { id: 172, value: "78" },
    { id: 173, value: "87" },
    { id: 174, value: "58" },
  ],
  [
    { id: 175, value: "17" },
    { id: 176, value: "65" },
    { id: 177, value: "57" },
    { id: 178, value: "89" },
    { id: 179, value: "20" },
    { id: 180, value: "28" },
  ],
  [
    { id: 181, value: "23" },
    { id: 182, value: "48" },
    { id: 183, value: "94" },
    { id: 184, value: "68" },
    { id: 185, value: "09" },
    { id: 186, value: "63" },
  ],
  [
    { id: 187, value: "26" },
    { id: 188, value: "30" },
    { id: 189, value: "94" },
    { id: 190, value: "11" },
    { id: 191, value: "79" },
    { id: 192, value: "40" },
  ],
  [
    { id: 193, value: "34" },
    { id: 194, value: "47" },
    { id: 195, value: "20" },
    { id: 196, value: "**" },
    { id: 197, value: "70" },
    { id: 198, value: "53" },
  ],
  [
    { id: 199, value: "14" },
    { id: 200, value: "40" },
    { id: 201, value: "18" },
    { id: 202, value: "01" },
    { id: 203, value: "98" },
    { id: 204, value: "93" },
  ],
  [
    { id: 205, value: "01" },
    { id: 206, value: "35" },
    { id: 207, value: "66" },
    { id: 208, value: "17" },
    { id: 209, value: "88" },
    { id: 210, value: "29" },
  ],
  [
    { id: 211, value: "42" },
    { id: 212, value: "95" },
    { id: 213, value: "85" },
    { id: 214, value: "82" },
    { id: 215, value: "34" },
    { id: 216, value: "**" },
  ],
  [
    { id: 217, value: "87" },
    { id: 218, value: "44" },
    { id: 219, value: "11" },
    { id: 220, value: "86" },
    { id: 221, value: "86" },
    { id: 222, value: "28" },
  ],
  [
    { id: 223, value: "78" },
    { id: 224, value: "78" },
    { id: 225, value: "82" },
    { id: 226, value: "21" },
    { id: 227, value: "44" },
    { id: 228, value: "50" },
  ],
  [
    { id: 229, value: "06" },
    { id: 230, value: "63" },
    { id: 231, value: "11" },
    { id: 232, value: "55" },
    { id: 233, value: "15" },
    { id: 234, value: "06" },
  ],
  [
    { id: 235, value: "29" },
    { id: 236, value: "27" },
    { id: 237, value: "71" },
    { id: 238, value: "11" },
    { id: 239, value: "27" },
    { id: 240, value: "75" },
  ],
  [
    { id: 241, value: "23" },
    { id: 242, value: "94" },
    { id: 243, value: "19" },
    { id: 244, value: "98" },
    { id: 245, value: "53" },
    { id: 246, value: "04" },
  ],
  [
    { id: 247, value: "21" },
    { id: 248, value: "22" },
    { id: 249, value: "26" },
    { id: 250, value: "69" },
    { id: 251, value: "39" },
    { id: 252, value: "79" },
  ],
  [
    { id: 253, value: "29" },
    { id: 254, value: "03" },
    { id: 255, value: "31" },
    { id: 256, value: "54" },
    { id: 257, value: "15" },
    { id: 258, value: "44" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "22" },
    { id: 268, value: "75" },
    { id: 269, value: "37" },
    { id: 270, value: "39" },
  ],
  [
    { id: 271, value: "51" },
    { id: 272, value: "58" },
    { id: 273, value: "79" },
    { id: 274, value: "38" },
    { id: 275, value: "33" },
    { id: 276, value: "36" },
  ],
  [
    { id: 277, value: "83" },
    { id: 278, value: "30" },
    { id: 279, value: "50" },
    { id: 280, value: "93" },
    { id: 281, value: "53" },
    { id: 282, value: "19" },
  ],
  [
    { id: 283, value: "10" },
    { id: 284, value: "81" },
    { id: 285, value: "09" },
    { id: 286, value: "16" },
    { id: 287, value: "32" },
    { id: 288, value: "36" },
  ],
  [
    { id: 289, value: "61" },
    { id: 290, value: "72" },
    { id: 291, value: "11" },
    { id: 292, value: "75" },
    { id: 293, value: "00" },
    { id: 294, value: "73" },
  ],
  [
    { id: 295, value: "82" },
    { id: 296, value: "65" },
    { id: 297, value: "76" },
    { id: 298, value: "90" },
    { id: 299, value: "24" },
    { id: 300, value: "05" },
  ],
  [
    { id: 301, value: "07" },
    { id: 302, value: "86" },
    { id: 303, value: "32" },
    { id: 304, value: "18" },
    { id: 305, value: "56" },
    { id: 306, value: "14" },
  ],
  [
    { id: 307, value: "34" },
    { id: 308, value: "20" },
    { id: 309, value: "89" },
    { id: 310, value: "51" },
    { id: 311, value: "27" },
    { id: 312, value: "28" },
  ],
  [
    { id: 313, value: "88" },
    { id: 314, value: "06" },
    { id: 315, value: "53" },
    { id: 316, value: "59" },
    { id: 317, value: "21" },
    { id: 318, value: "59" },
  ],
  [
    { id: 319, value: "32" },
    { id: 320, value: "95" },
    { id: 321, value: "67" },
    { id: 322, value: "06" },
    { id: 323, value: "45" },
    { id: 324, value: "52" },
  ],
  [
    { id: 325, value: "39" },
    { id: 326, value: "68" },
    { id: 327, value: "68" },
    { id: 328, value: "83" },
    { id: 329, value: "56" },
    { id: 330, value: "37" },
  ],
  [
    { id: 331, value: "99" },
    { id: 332, value: "04" },
    { id: 333, value: "90" },
    { id: 334, value: "38" },
    { id: 335, value: "10" },
    { id: 336, value: "60" },
    { id: 337, value: "**" },
  ],
  [
    { id: 338, value: "22" },
    { id: 339, value: "59" },
    { id: 340, value: "88" },
    { id: 341, value: "67" },
    { id: 342, value: "99" },
    { id: 343, value: "91" },
    { id: 344, value: "**" },
  ],
  [
    { id: 345, value: "85" },
    { id: 346, value: "64" },
    { id: 347, value: "41" },
    { id: 348, value: "48" },
    { id: 349, value: "21" },
    { id: 350, value: "60" },
    { id: 351, value: "**" },
  ],
  [
    { id: 352, value: "49" },
    { id: 353, value: "23" },
    { id: 354, value: "20" },
    { id: 355, value: "38" },
    { id: 356, value: "64" },
    { id: 357, value: "13" },
    { id: 358, value: "**" },
  ],
  [
    { id: 359, value: "95" },
    { id: 360, value: "42" },
    { id: 361, value: "86" },
    { id: 362, value: "37" },
    { id: 363, value: "23" },
    { id: 364, value: "04" },
    { id: 365, value: "**" },
  ],
  [
    { id: 366, value: "47" },
    { id: 367, value: "75" },
    { id: 368, value: "50" },
    { id: 369, value: "59" },
    { id: 370, value: "07" },
    { id: 371, value: "78" },
    { id: 372, value: "**" },
  ],
  [
    { id: 373, value: "37" },
    { id: 374, value: "78" },
    { id: 375, value: "96" },
    { id: 376, value: "52" },
    { id: 377, value: "02" },
    { id: 378, value: "81" },
    { id: 379, value: "**" },
  ],
  [
    { id: 380, value: "44" },
    { id: 381, value: "13" },
    { id: 382, value: "29" },
    { id: 383, value: "42" },
    { id: 384, value: "97" },
    { id: 385, value: "47" },
    { id: 386, value: "**" },
  ],
  [
    { id: 387, value: "36" },
    { id: 388, value: "12" },
    { id: 389, value: "95" },
    { id: 390, value: "28" },
    { id: 391, value: "79" },
    { id: 392, value: "66" },
    { id: 393, value: "**" },
  ],
  [
    { id: 394, value: "28" },
    { id: 395, value: "37" },
    { id: 396, value: "38" },
    { id: 397, value: "71" },
    { id: 398, value: "34" },
    { id: 399, value: "03" },
    { id: 400, value: "**" },
  ],
  [
    { id: 401, value: "45" },
    { id: 402, value: "36" },
    { id: 403, value: "19" },
    { id: 404, value: "26" },
    { id: 405, value: "54" },
    { id: 406, value: "34" },
    { id: 407, value: "**" },
  ],
  [
    { id: 408, value: "51" },
    { id: 409, value: "36" },
    { id: 410, value: "61" },
    { id: 411, value: "40" },
    { id: 412, value: "42" },
    { id: 413, value: "66" },
    { id: 414, value: "**" },
  ],
  [
    { id: 415, value: "97" },
    { id: 416, value: "92" },
    { id: 417, value: "44" },
    { id: 418, value: "38" },
    { id: 419, value: "91" },
    { id: 420, value: "72" },
    { id: 421, value: "**" },
  ],
  [
    { id: 422, value: "26" },
    { id: 423, value: "41" },
    { id: 424, value: "17" },
    { id: 425, value: "20" },
    { id: 426, value: "85" },
    { id: 427, value: "90" },
    { id: 428, value: "**" },
  ],
  [
    { id: 429, value: "33" },
    { id: 430, value: "86" },
    { id: 431, value: "25" },
    { id: 432, value: "03" },
    { id: 433, value: "74" },
    { id: 434, value: "29" },
    { id: 435, value: "**" },
  ],
  [
    { id: 436, value: "99" },
    { id: 437, value: "78" },
    { id: 438, value: "26" },
    { id: 439, value: "48" },
    { id: 440, value: "30" },
    { id: 441, value: "48" },
    { id: 442, value: "**" },
  ],
  [
    { id: 443, value: "96" },
    { id: 444, value: "89" },
    { id: 445, value: "73" },
    { id: 446, value: "31" },
    { id: 447, value: "08" },
    { id: 448, value: "34" },
    { id: 449, value: "**" },
  ],
  [
    { id: 450, value: "77" },
    { id: 451, value: "12" },
    { id: 452, value: "70" },
    { id: 453, value: "70" },
    { id: 454, value: "60" },
    { id: 455, value: "67" },
    { id: 456, value: "**" },
  ],
  [
    { id: 457, value: "17" },
    { id: 458, value: "54" },
    { id: 459, value: "96" },
    { id: 460, value: "99" },
    { id: 461, value: "03" },
    { id: 462, value: "28" },
    { id: 463, value: "**" },
  ],
  [
    { id: 464, value: "15" },
    { id: 465, value: "82" },
    { id: 466, value: "43" },
    { id: 467, value: "59" },
    { id: 468, value: "86" },
    { id: 469, value: "63" },
    { id: 470, value: "**" },
  ],
  [
    { id: 471, value: "14" },
    { id: 472, value: "97" },
    { id: 473, value: "12" },
    { id: 474, value: "04" },
    { id: 475, value: "44" },
    { id: 476, value: "64" },
    { id: 477, value: "**" },
  ],
  [
    { id: 478, value: "12" },
    { id: 479, value: "21" },
    { id: 480, value: "15" },
    { id: 481, value: "87" },
    { id: 482, value: "67" },
    { id: 483, value: "35" },
    { id: 484, value: "**" },
  ],
  [
    { id: 485, value: "83" },
    { id: 486, value: "21" },
    { id: 487, value: "06" },
    { id: 488, value: "33" },
    { id: 489, value: "10" },
    { id: 490, value: "86" },
    { id: 491, value: "**" },
  ],
  [
    { id: 492, value: "74" },
    { id: 493, value: "89" },
    { id: 494, value: "62" },
    { id: 495, value: "46" },
    { id: 496, value: "30" },
    { id: 497, value: "32" },
    { id: 498, value: "**" },
  ],
  [
    { id: 499, value: "04" },
    { id: 500, value: "29" },
    { id: 501, value: "45" },
    { id: 502, value: "72" },
    { id: 503, value: "16" },
    { id: 504, value: "40" },
    { id: 505, value: "**" },
  ],
  [
    { id: 506, value: "55" },
    { id: 507, value: "21" },
    { id: 508, value: "61" },
    { id: 509, value: "89" },
    { id: 510, value: "68" },
    { id: 511, value: "99" },
    { id: 512, value: "**" },
  ],
  [
    { id: 513, value: "19" },
    { id: 514, value: "54" },
    { id: 515, value: "70" },
    { id: 516, value: "13" },
    { id: 517, value: "22" },
    { id: 518, value: "06" },
    { id: 519, value: "**" },
  ],
  [
    { id: 520, value: "10" },
    { id: 521, value: "17" },
    { id: 522, value: "11" },
    { id: 523, value: "08" },
    { id: 524, value: "70" },
    { id: 525, value: "82" },
    { id: 526, value: "**" },
  ],
  [
    { id: 527, value: "70" },
    { id: 528, value: "33" },
    { id: 529, value: "82" },
    { id: 530, value: "54" },
    { id: 531, value: "65" },
    { id: 532, value: "94" },
    { id: 533, value: "**" },
  ],
  [
    { id: 534, value: "91" },
    { id: 535, value: "97" },
    { id: 536, value: "97" },
    { id: 537, value: "73" },
    { id: 538, value: "33" },
    { id: 539, value: "49" },
    { id: 540, value: "**" },
  ],
  [
    { id: 541, value: "87" },
    { id: 542, value: "25" },
    { id: 543, value: "49" },
    { id: 544, value: "34" },
    { id: 545, value: "89" },
    { id: 546, value: "80" },
    { id: 547, value: "**" },
  ],
  [
    { id: 548, value: "88" },
    { id: 549, value: "71" },
    { id: 550, value: "**" },
    { id: 551, value: "34" },
    { id: 552, value: "32" },
    { id: 553, value: "35" },
    { id: 554, value: "**" },
  ],
  [
    { id: 555, value: "04" },
    { id: 556, value: "43" },
    { id: 557, value: "85" },
    { id: 558, value: "66" },
    { id: 559, value: "36" },
    { id: 560, value: "11" },
    { id: 561, value: "**" },
  ],
  [
    { id: 562, value: "98" },
    { id: 563, value: "59" },
    { id: 564, value: "16" },
    { id: 565, value: "96" },
    { id: 566, value: "38" },
    { id: 567, value: "55" },
    { id: 568, value: "**" },
  ],
  [
    { id: 569, value: "86" },
    { id: 570, value: "75" },
    { id: 571, value: "96" },
    { id: 572, value: "35" },
    { id: 573, value: "15" },
    { id: 574, value: "35" },
    { id: 575, value: "**" },
  ],
  [
    { id: 576, value: "41" },
    { id: 577, value: "89" },
    { id: 578, value: "20" },
    { id: 579, value: "15" },
    { id: 580, value: "12" },
    { id: 581, value: "47" },
    { id: 582, value: "**" },
  ],
  [
    { id: 583, value: "19" },
    { id: 584, value: "66" },
    { id: 585, value: "30" },
    { id: 586, value: "82" },
    { id: 587, value: "20" },
    { id: 588, value: "89" },
    { id: 589, value: "**" },
  ],
  [
    { id: 590, value: "43" },
    { id: 591, value: "09" },
    { id: 592, value: "34" },
    { id: 593, value: "19" },
    { id: 594, value: "75" },
    { id: 595, value: "50" },
    { id: 596, value: "**" },
  ],
  [
    { id: 597, value: "13" },
    { id: 598, value: "36" },
    { id: 599, value: "01" },
    { id: 600, value: "96" },
    { id: 601, value: "79" },
    { id: 602, value: "**" },
    { id: 603, value: "**" },
  ],
  [
    { id: 604, value: "57" },
    { id: 605, value: "35" },
    { id: 606, value: "58" },
    { id: 607, value: "91" },
    { id: 608, value: "75" },
    { id: 609, value: "33" },
    { id: 610, value: "**" },
  ],
  [
    { id: 611, value: "91" },
    { id: 612, value: "40" },
    { id: 613, value: "45" },
    { id: 614, value: "47" },
    { id: 615, value: "21" },
    { id: 616, value: "47" },
    { id: 617, value: "**" },
  ],
  [
    { id: 618, value: "86" },
    { id: 619, value: "46" },
    { id: 620, value: "47" },
    { id: 621, value: "36" },
    { id: 622, value: "06" },
    { id: 623, value: "86" },
    { id: 624, value: "**" },
  ],
  [
    { id: 625, value: "85" },
    { id: 626, value: "60" },
    { id: 627, value: "17" },
    { id: 628, value: "58" },
    { id: 629, value: "07" },
    { id: 630, value: "21" },
    { id: 631, value: "**" },
  ],
  [
    { id: 632, value: "18" },
    { id: 633, value: "59" },
    { id: 634, value: "95" },
    { id: 635, value: "90" },
    { id: 636, value: "97" },
    { id: 637, value: "48" },
    { id: 638, value: "**" },
  ],
  [
    { id: 639, value: "42" },
    { id: 640, value: "51" },
    { id: 641, value: "13" },
    { id: 642, value: "98" },
    { id: 643, value: "48" },
    { id: 644, value: "05" },
    { id: 645, value: "**" },
  ],
  [
    { id: 646, value: "45" },
    { id: 647, value: "53" },
    { id: 648, value: "43" },
    { id: 649, value: "59" },
    { id: 650, value: "97" },
    { id: 651, value: "34" },
    { id: 652, value: "**" },
  ],
  [
    { id: 653, value: "12" },
    { id: 654, value: "29" },
    { id: 655, value: "90" },
    { id: 656, value: "72" },
    { id: 657, value: "13" },
    { id: 658, value: "28" },
    { id: 659, value: "**" },
  ],
  [
    { id: 660, value: "08" },
    { id: 661, value: "70" },
    { id: 662, value: "55" },
    { id: 663, value: "57" },
    { id: 664, value: "52" },
    { id: 665, value: "35" },
    { id: 666, value: "**" },
  ],
  [
    { id: 667, value: "15" },
    { id: 668, value: "42" },
    { id: 669, value: "72" },
    { id: 670, value: "83" },
    { id: 671, value: "33" },
    { id: 672, value: "66" },
    { id: 673, value: "**" },
  ],
  [
    { id: 674, value: "48" },
    { id: 675, value: "68" },
    { id: 676, value: "00" },
    { id: 677, value: "64" },
    { id: 678, value: "46" },
    { id: 679, value: "41" },
    { id: 680, value: "**" },
  ],
  [
    { id: 681, value: "75" },
    { id: 682, value: "21" },
    { id: 683, value: "18" },
    { id: 684, value: "36" },
    { id: 685, value: "05" },
    { id: 686, value: "38" },
    { id: 687, value: "**" },
  ],
  [
    { id: 688, value: "31" },
    { id: 689, value: "46" },
    { id: 690, value: "29" },
    { id: 691, value: "29" },
    { id: 692, value: "70" },
    { id: 693, value: "17" },
    { id: 694, value: "**" },
  ],
  [
    { id: 695, value: "**" },
    { id: 696, value: "16" },
    { id: 697, value: "13" },
    { id: 698, value: "08" },
    { id: 699, value: "49" },
    { id: 700, value: "28" },
    { id: 701, value: "**" },
  ],
  [
    { id: 702, value: "21" },
    { id: 703, value: "87" },
    { id: 704, value: "30" },
    { id: 705, value: "66" },
    { id: 706, value: "95" },
    { id: 707, value: "13" },
    { id: 708, value: "**" },
  ],
  [
    { id: 709, value: "08" },
    { id: 710, value: "53" },
    { id: 711, value: "53" },
    { id: 712, value: "96" },
    { id: 713, value: "89" },
    { id: 714, value: "58" },
    { id: 715, value: "**" },
  ],
  [
    { id: 716, value: "77" },
    { id: 717, value: "19" },
    { id: 718, value: "02" },
    { id: 719, value: "89" },
    { id: 720, value: "98" },
    { id: 721, value: "94" },
    { id: 722, value: "**" },
  ],
  [
    { id: 723, value: "60" },
    { id: 724, value: "28" },
    { id: 725, value: "04" },
    { id: 726, value: "69" },
    { id: 727, value: "06" },
    { id: 728, value: "19" },
    { id: 729, value: "**" },
  ],
  [
    { id: 730, value: "05" },
    { id: 731, value: "91" },
    { id: 732, value: "**" },
    { id: 733, value: "42" },
    { id: 734, value: "21" },
    { id: 735, value: "96" },
    { id: 736, value: "**" },
  ],
  [
    { id: 737, value: "92" },
    { id: 738, value: "45" },
    { id: 739, value: "95" },
    { id: 740, value: "94" },
    { id: 741, value: "82" },
    { id: 742, value: "52" },
    { id: 743, value: "**" },
  ],
  [
    { id: 744, value: "92" },
    { id: 745, value: "50" },
    { id: 746, value: "98" },
    { id: 747, value: "44" },
    { id: 748, value: "97" },
    { id: 749, value: "06" },
    { id: 750, value: "**" },
  ],
];

// kalyan

export const Kalyan = [
  [
    { id: 1, value: "41" },
    { id: 2, value: "60" },
    { id: 3, value: "95" },
    { id: 4, value: "63" },
    { id: 5, value: "25" },
    { id: 6, value: "15" },
  ],
  [
    { id: 7, value: "73" },
    { id: 8, value: "42" },
    { id: 9, value: "29" },
    { id: 10, value: "63" },
    { id: 11, value: "38" },
    { id: 12, value: "12" },
  ],
  [
    { id: 13, value: "75" },
    { id: 14, value: "75" },
    { id: 15, value: "27" },
    { id: 16, value: "05" },
    { id: 17, value: "25" },
    { id: 18, value: "37" },
  ],
  [
    { id: 19, value: "30" },
    { id: 20, value: "37" },
    { id: 21, value: "51" },
    { id: 22, value: "14" },
    { id: 23, value: "**" },
    { id: 24, value: "20" },
  ],
  [
    { id: 25, value: "91" },
    { id: 26, value: "72" },
    { id: 27, value: "30" },
    { id: 28, value: "45" },
    { id: 29, value: "04" },
    { id: 30, value: "48" },
  ],
  [
    { id: 31, value: "16" },
    { id: 32, value: "62" },
    { id: 33, value: "45" },
    { id: 34, value: "72" },
    { id: 35, value: "87" },
    { id: 36, value: "98" },
  ],
  [
    { id: 37, value: "01" },
    { id: 38, value: "97" },
    { id: 39, value: "06" },
    { id: 40, value: "07" },
    { id: 41, value: "52" },
    { id: 42, value: "25" },
  ],
  [
    { id: 43, value: "44" },
    { id: 44, value: "04" },
    { id: 45, value: "52" },
    { id: 46, value: "40" },
    { id: 47, value: "03" },
    { id: 48, value: "89" },
  ],
  [
    { id: 49, value: "32" },
    { id: 50, value: "08" },
    { id: 51, value: "58" },
    { id: 52, value: "56" },
    { id: 53, value: "47" },
    { id: 54, value: "96" },
  ],
  [
    { id: 55, value: "93" },
    { id: 56, value: "76" },
    { id: 57, value: "37" },
    { id: 58, value: "72" },
    { id: 59, value: "03" },
    { id: 60, value: "03" },
  ],
  [
    { id: 61, value: "39" },
    { id: 62, value: "27" },
    { id: 63, value: "39" },
    { id: 64, value: "08" },
    { id: 65, value: "28" },
    { id: 66, value: "96" },
  ],
  [
    { id: 67, value: "59" },
    { id: 68, value: "60" },
    { id: 69, value: "27" },
    { id: 70, value: "33" },
    { id: 71, value: "66" },
    { id: 72, value: "40" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "97" },
    { id: 75, value: "55" },
    { id: 76, value: "39" },
    { id: 77, value: "08" },
    { id: 78, value: "91" },
  ],
  [
    { id: 79, value: "96" },
    { id: 80, value: "64" },
    { id: 81, value: "97" },
    { id: 82, value: "41" },
    { id: 83, value: "49" },
    { id: 84, value: "36" },
  ],
  [
    { id: 85, value: "44" },
    { id: 86, value: "32" },
    { id: 87, value: "88" },
    { id: 88, value: "83" },
    { id: 89, value: "64" },
    { id: 90, value: "67" },
  ],
  [
    { id: 91, value: "46" },
    { id: 92, value: "97" },
    { id: 93, value: "52" },
    { id: 94, value: "81" },
    { id: 95, value: "02" },
    { id: 96, value: "04" },
  ],
  [
    { id: 97, value: "03" },
    { id: 98, value: "49" },
    { id: 99, value: "42" },
    { id: 100, value: "78" },
    { id: 101, value: "67" },
    { id: 102, value: "02" },
  ],
  [
    { id: 103, value: "33" },
    { id: 104, value: "92" },
    { id: 105, value: "58" },
    { id: 106, value: "60" },
    { id: 107, value: "08" },
    { id: 108, value: "24" },
  ],
  [
    { id: 109, value: "27" },
    { id: 110, value: "21" },
    { id: 111, value: "83" },
    { id: 112, value: "79" },
    { id: 113, value: "01" },
    { id: 114, value: "44" },
  ],
  [
    { id: 115, value: "98" },
    { id: 116, value: "40" },
    { id: 117, value: "45" },
    { id: 118, value: "96" },
    { id: 119, value: "53" },
    { id: 120, value: "30" },
  ],
  [
    { id: 121, value: "26" },
    { id: 122, value: "66" },
    { id: 123, value: "70" },
    { id: 124, value: "02" },
    { id: 125, value: "16" },
    { id: 126, value: "42" },
  ],
  [
    { id: 127, value: "00" },
    { id: 128, value: "63" },
    { id: 129, value: "94" },
    { id: 130, value: "44" },
    { id: 131, value: "46" },
    { id: 132, value: "34" },
  ],
  [
    { id: 133, value: "27" },
    { id: 134, value: "63" },
    { id: 135, value: "50" },
    { id: 136, value: "53" },
    { id: 137, value: "72" },
    { id: 138, value: "62" },
  ],
  [
    { id: 139, value: "29" },
    { id: 140, value: "75" },
    { id: 141, value: "90" },
    { id: 142, value: "82" },
    { id: 143, value: "70" },
    { id: 144, value: "65" },
  ],
  [
    { id: 145, value: "15" },
    { id: 146, value: "25" },
    { id: 147, value: "75" },
    { id: 148, value: "26" },
    { id: 149, value: "31" },
    { id: 150, value: "98" },
  ],
  [
    { id: 151, value: "45" },
    { id: 152, value: "26" },
    { id: 153, value: "64" },
    { id: 154, value: "47" },
    { id: 155, value: "66" },
    { id: 156, value: "15" },
  ],
  [
    { id: 157, value: "77" },
    { id: 158, value: "66" },
    { id: 159, value: "24" },
    { id: 160, value: "64" },
    { id: 161, value: "13" },
    { id: 162, value: "84" },
  ],
  [
    { id: 163, value: "26" },
    { id: 164, value: "91" },
    { id: 165, value: "29" },
    { id: 166, value: "88" },
    { id: 167, value: "04" },
    { id: 168, value: "55" },
  ],
  [
    { id: 169, value: "95" },
    { id: 170, value: "37" },
    { id: 171, value: "02" },
    { id: 172, value: "99" },
    { id: 173, value: "70" },
    { id: 174, value: "82" },
  ],
  [
    { id: 175, value: "55" },
    { id: 176, value: "13" },
    { id: 177, value: "34" },
    { id: 178, value: "31" },
    { id: 179, value: "39" },
    { id: 180, value: "89" },
  ],
  [
    { id: 181, value: "94" },
    { id: 182, value: "23" },
    { id: 183, value: "27" },
    { id: 184, value: "13" },
    { id: 185, value: "81" },
    { id: 186, value: "49" },
  ],
  [
    { id: 187, value: "07" },
    { id: 188, value: "67" },
    { id: 189, value: "46" },
    { id: 190, value: "49" },
    { id: 191, value: "64" },
    { id: 192, value: "87" },
  ],
  [
    { id: 193, value: "16" },
    { id: 194, value: "99" },
    { id: 195, value: "40" },
    { id: 196, value: "**" },
    { id: 197, value: "33" },
    { id: 198, value: "82" },
  ],
  [
    { id: 199, value: "04" },
    { id: 200, value: "45" },
    { id: 201, value: "24" },
    { id: 202, value: "16" },
    { id: 203, value: "89" },
    { id: 204, value: "28" },
  ],
  [
    { id: 205, value: "28" },
    { id: 206, value: "25" },
    { id: 207, value: "16" },
    { id: 208, value: "12" },
    { id: 209, value: "20" },
    { id: 210, value: "65" },
  ],
  [
    { id: 211, value: "46" },
    { id: 212, value: "85" },
    { id: 213, value: "90" },
    { id: 214, value: "72" },
    { id: 215, value: "72" },
    { id: 216, value: "93" },
  ],
  [
    { id: 217, value: "69" },
    { id: 218, value: "76" },
    { id: 219, value: "12" },
    { id: 220, value: "45" },
    { id: 221, value: "30" },
    { id: 222, value: "14" },
  ],
  [
    { id: 223, value: "08" },
    { id: 224, value: "85" },
    { id: 225, value: "87" },
    { id: 226, value: "40" },
    { id: 227, value: "13" },
    { id: 228, value: "14" },
  ],
  [
    { id: 229, value: "54" },
    { id: 230, value: "82" },
    { id: 231, value: "34" },
    { id: 232, value: "70" },
    { id: 233, value: "57" },
    { id: 234, value: "03" },
  ],
  [
    { id: 235, value: "85" },
    { id: 236, value: "64" },
    { id: 237, value: "47" },
    { id: 238, value: "87" },
    { id: 239, value: "85" },
    { id: 240, value: "97" },
  ],
  [
    { id: 241, value: "58" },
    { id: 242, value: "06" },
    { id: 243, value: "51" },
    { id: 244, value: "13" },
    { id: 245, value: "74" },
    { id: 246, value: "39" },
  ],
  [
    { id: 247, value: "91" },
    { id: 248, value: "35" },
    { id: 249, value: "82" },
    { id: 250, value: "53" },
    { id: 251, value: "56" },
    { id: 252, value: "07" },
  ],
  [
    { id: 253, value: "62" },
    { id: 254, value: "10" },
    { id: 255, value: "49" },
    { id: 256, value: "51" },
    { id: 257, value: "19" },
    { id: 258, value: "56" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "80" },
    { id: 268, value: "52" },
    { id: 269, value: "84" },
    { id: 270, value: "87" },
  ],
  [
    { id: 271, value: "51" },
    { id: 272, value: "91" },
    { id: 273, value: "41" },
    { id: 274, value: "57" },
    { id: 275, value: "19" },
    { id: 276, value: "95" },
  ],
  [
    { id: 277, value: "05" },
    { id: 278, value: "90" },
    { id: 279, value: "74" },
    { id: 280, value: "06" },
    { id: 281, value: "19" },
    { id: 282, value: "63" },
  ],
  [
    { id: 283, value: "90" },
    { id: 284, value: "34" },
    { id: 285, value: "82" },
    { id: 286, value: "09" },
    { id: 287, value: "28" },
    { id: 288, value: "19" },
  ],
  [
    { id: 289, value: "72" },
    { id: 290, value: "34" },
    { id: 291, value: "21" },
    { id: 292, value: "32" },
    { id: 293, value: "21" },
    { id: 294, value: "42" },
  ],
  [
    { id: 295, value: "58" },
    { id: 296, value: "84" },
    { id: 297, value: "00" },
    { id: 298, value: "67" },
    { id: 299, value: "06" },
    { id: 300, value: "98" },
  ],
  [
    { id: 301, value: "03" },
    { id: 302, value: "82" },
    { id: 303, value: "29" },
    { id: 304, value: "90" },
    { id: 305, value: "14" },
    { id: 306, value: "66" },
  ],
  [
    { id: 307, value: "02" },
    { id: 308, value: "40" },
    { id: 309, value: "92" },
    { id: 310, value: "85" },
    { id: 311, value: "00" },
    { id: 312, value: "88" },
  ],
  [
    { id: 313, value: "39" },
    { id: 314, value: "94" },
    { id: 315, value: "33" },
    { id: 316, value: "58" },
    { id: 317, value: "11" },
    { id: 318, value: "63" },
  ],
  [
    { id: 319, value: "91" },
    { id: 320, value: "69" },
    { id: 321, value: "60" },
    { id: 322, value: "71" },
    { id: 323, value: "85" },
    { id: 324, value: "20" },
  ],
  [
    { id: 325, value: "95" },
    { id: 326, value: "28" },
    { id: 327, value: "11" },
    { id: 328, value: "29" },
    { id: 329, value: "28" },
    { id: 330, value: "18" },
  ],
  [
    { id: 331, value: "47" },
    { id: 332, value: "83" },
    { id: 333, value: "45" },
    { id: 334, value: "80" },
    { id: 335, value: "33" },
    { id: 336, value: "18" },
  ],
  [
    { id: 337, value: "06" },
    { id: 338, value: "65" },
    { id: 339, value: "12" },
    { id: 340, value: "55" },
    { id: 341, value: "31" },
    { id: 342, value: "64" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "94" },
    { id: 345, value: "61" },
    { id: 346, value: "59" },
    { id: 347, value: "80" },
    { id: 348, value: "33" },
    { id: 349, value: "18" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "96" },
    { id: 352, value: "25" },
    { id: 353, value: "78" },
    { id: 354, value: "59" },
    { id: 355, value: "30" },
    { id: 356, value: "95" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "08" },
    { id: 359, value: "55" },
    { id: 360, value: "04" },
    { id: 361, value: "14" },
    { id: 362, value: "55" },
    { id: 363, value: "51" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "71" },
    { id: 366, value: "27" },
    { id: 367, value: "21" },
    { id: 368, value: "23" },
    { id: 369, value: "95" },
    { id: 370, value: "29" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "21" },
    { id: 373, value: "19" },
    { id: 374, value: "33" },
    { id: 375, value: "17" },
    { id: 376, value: "76" },
    { id: 377, value: "84" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "57" },
    { id: 380, value: "65" },
    { id: 381, value: "06" },
    { id: 382, value: "97" },
    { id: 383, value: "93" },
    { id: 384, value: "53" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "21" },
    { id: 387, value: "01" },
    { id: 388, value: "80" },
    { id: 389, value: "39" },
    { id: 390, value: "20" },
    { id: 391, value: "01" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "49" },
    { id: 394, value: "89" },
    { id: 395, value: "83" },
    { id: 396, value: "29" },
    { id: 397, value: "61" },
    { id: 398, value: "44" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "82" },
    { id: 401, value: "01" },
    { id: 402, value: "14" },
    { id: 403, value: "33" },
    { id: 404, value: "70" },
    { id: 405, value: "13" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "33" },
    { id: 408, value: "00" },
    { id: 409, value: "10" },
    { id: 410, value: "79" },
    { id: 411, value: "41" },
    { id: 412, value: "96" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "12" },
    { id: 415, value: "04" },
    { id: 416, value: "66" },
    { id: 417, value: "61" },
    { id: 418, value: "62" },
    { id: 419, value: "02" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "91" },
    { id: 422, value: "31" },
    { id: 423, value: "44" },
    { id: 424, value: "63" },
    { id: 425, value: "23" },
    { id: 426, value: "93" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "40" },
    { id: 429, value: "96" },
    { id: 430, value: "62" },
    { id: 431, value: "80" },
    { id: 432, value: "15" },
    { id: 433, value: "76" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "35" },
    { id: 436, value: "91" },
    { id: 437, value: "44" },
    { id: 438, value: "08" },
    { id: 439, value: "34" },
    { id: 440, value: "46" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "43" },
    { id: 443, value: "14" },
    { id: 444, value: "25" },
    { id: 445, value: "69" },
    { id: 446, value: "05" },
    { id: 447, value: "00" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "98" },
    { id: 450, value: "04" },
    { id: 451, value: "03" },
    { id: 452, value: "62" },
    { id: 453, value: "47" },
    { id: 454, value: "45" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "82" },
    { id: 457, value: "00" },
    { id: 458, value: "74" },
    { id: 459, value: "83" },
    { id: 460, value: "08" },
    { id: 461, value: "57" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "99" },
    { id: 464, value: "00" },
    { id: 465, value: "47" },
    { id: 466, value: "21" },
    { id: 467, value: "72" },
    { id: 468, value: "26" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "30" },
    { id: 471, value: "61" },
    { id: 472, value: "05" },
    { id: 473, value: "75" },
    { id: 474, value: "65" },
    { id: 475, value: "38" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "34" },
    { id: 478, value: "62" },
    { id: 479, value: "21" },
    { id: 480, value: "02" },
    { id: 481, value: "23" },
    { id: 482, value: "24" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "11" },
    { id: 485, value: "89" },
    { id: 486, value: "40" },
    { id: 487, value: "76" },
    { id: 488, value: "44" },
    { id: 489, value: "75" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "07" },
    { id: 492, value: "42" },
    { id: 493, value: "48" },
    { id: 494, value: "33" },
    { id: 495, value: "72" },
    { id: 496, value: "34" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "53" },
    { id: 499, value: "81" },
    { id: 500, value: "81" },
    { id: 501, value: "48" },
    { id: 502, value: "31" },
    { id: 503, value: "64" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "06" },
    { id: 506, value: "14" },
    { id: 507, value: "02" },
    { id: 508, value: "15" },
    { id: 509, value: "89" },
    { id: 510, value: "75" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "81" },
    { id: 513, value: "88" },
    { id: 514, value: "88" },
    { id: 515, value: "41" },
    { id: 516, value: "48" },
    { id: 517, value: "77" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "44" },
    { id: 520, value: "85" },
    { id: 521, value: "28" },
    { id: 522, value: "72" },
    { id: 523, value: "36" },
    { id: 524, value: "13" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "68" },
    { id: 527, value: "10" },
    { id: 528, value: "05" },
    { id: 529, value: "71" },
    { id: 530, value: "82" },
    { id: 531, value: "61" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "05" },
    { id: 534, value: "08" },
    { id: 535, value: "76" },
    { id: 536, value: "67" },
    { id: 537, value: "03" },
    { id: 538, value: "58" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "06" },
    { id: 541, value: "11" },
    { id: 542, value: "09" },
    { id: 543, value: "09" },
    { id: 544, value: "68" },
    { id: 545, value: "69" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "83" },
    { id: 548, value: "91" },
    { id: 549, value: "75" },
    { id: 550, value: "42" },
    { id: 551, value: "22" },
    { id: 552, value: "72" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "54" },
    { id: 555, value: "75" },
    { id: 556, value: "14" },
    { id: 557, value: "39" },
    { id: 558, value: "68" },
    { id: 559, value: "43" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "68" },
    { id: 562, value: "73" },
    { id: 563, value: "20" },
    { id: 564, value: "05" },
    { id: 565, value: "40" },
    { id: 566, value: "38" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "25" },
    { id: 569, value: "75" },
    { id: 570, value: "61" },
    { id: 571, value: "43" },
    { id: 572, value: "17" },
    { id: 573, value: "24" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "14" },
    { id: 576, value: "63" },
    { id: 577, value: "87" },
    { id: 578, value: "01" },
    { id: 579, value: "51" },
    { id: 580, value: "58" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "99" },
    { id: 583, value: "42" },
    { id: 584, value: "44" },
    { id: 585, value: "16" },
    { id: 586, value: "56" },
    { id: 587, value: "38" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "52" },
    { id: 590, value: "58" },
    { id: 591, value: "49" },
    { id: 592, value: "69" },
    { id: 593, value: "79" },
    { id: 594, value: "71" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "71" },
    { id: 597, value: "79" },
    { id: 598, value: "73" },
    { id: 599, value: "87" },
    { id: 600, value: "80" },
    { id: 601, value: "19" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "12" },
    { id: 604, value: "96" },
    { id: 605, value: "79" },
    { id: 606, value: "36" },
    { id: 607, value: "84" },
    { id: 608, value: "97" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "40" },
    { id: 611, value: "85" },
    { id: 612, value: "95" },
    { id: 613, value: "31" },
    { id: 614, value: "15" },
    { id: 615, value: "**" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "59" },
    { id: 618, value: "44" },
    { id: 619, value: "59" },
    { id: 620, value: "42" },
    { id: 621, value: "90" },
    { id: 622, value: "08" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "55" },
    { id: 625, value: "02" },
    { id: 626, value: "23" },
    { id: 627, value: "00" },
    { id: 628, value: "05" },
    { id: 629, value: "27" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "91" },
    { id: 632, value: "16" },
    { id: 633, value: "84" },
    { id: 634, value: "20" },
    { id: 635, value: "84" },
    { id: 636, value: "47" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "52" },
    { id: 639, value: "96" },
    { id: 640, value: "53" },
    { id: 641, value: "11" },
    { id: 642, value: "70" },
    { id: 643, value: "82" },
    { id: 644, value: "**" },
  ],
  [
    { id: 645, value: "91" },
    { id: 646, value: "97" },
    { id: 647, value: "67" },
    { id: 648, value: "79" },
    { id: 649, value: "09" },
    { id: 650, value: "87" },
    { id: 651, value: "**" },
  ],
  [
    { id: 652, value: "78" },
    { id: 653, value: "52" },
    { id: 654, value: "12" },
    { id: 655, value: "72" },
    { id: 656, value: "64" },
    { id: 657, value: "17" },
    { id: 658, value: "**" },
  ],
  [
    { id: 659, value: "16" },
    { id: 660, value: "43" },
    { id: 661, value: "78" },
    { id: 662, value: "91" },
    { id: 663, value: "27" },
    { id: 664, value: "30" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "64" },
    { id: 667, value: "30" },
    { id: 668, value: "97" },
    { id: 669, value: "55" },
    { id: 670, value: "97" },
    { id: 671, value: "39" },
    { id: 672, value: "**" },
  ],
  [
    { id: 673, value: "33" },
    { id: 674, value: "38" },
    { id: 675, value: "53" },
    { id: 676, value: "32" },
    { id: 677, value: "84" },
    { id: 678, value: "82" },
    { id: 679, value: "**" },
  ],
  [
    { id: 680, value: "60" },
    { id: 681, value: "57" },
    { id: 682, value: "36" },
    { id: 683, value: "94" },
    { id: 684, value: "52" },
    { id: 685, value: "68" },
    { id: 686, value: "**" },
  ],
  [
    { id: 687, value: "04" },
    { id: 688, value: "46" },
    { id: 689, value: "65" },
    { id: 690, value: "04" },
    { id: 691, value: "04" },
    { id: 692, value: "74" },
    { id: 693, value: "**" },
  ],
  [
    { id: 694, value: "77" },
    { id: 695, value: "51" },
    { id: 696, value: "04" },
    { id: 697, value: "34" },
    { id: 698, value: "55" },
    { id: 699, value: "42" },
    { id: 700, value: "**" },
  ],
  [
    { id: 701, value: "02" },
    { id: 702, value: "39" },
    { id: 703, value: "06" },
    { id: 704, value: "67" },
    { id: 705, value: "69" },
    { id: 706, value: "54" },
    { id: 707, value: "**" },
  ],
  [
    { id: 708, value: "**" },
    { id: 709, value: "76" },
    { id: 710, value: "59" },
    { id: 711, value: "35" },
    { id: 712, value: "12" },
    { id: 713, value: "70" },
    { id: 714, value: "**" },
  ],
  [
    { id: 715, value: "91" },
    { id: 716, value: "78" },
    { id: 717, value: "82" },
    { id: 718, value: "20" },
    { id: 719, value: "54" },
    { id: 720, value: "65" },
    { id: 721, value: "**" },
  ],
  [
    { id: 722, value: "77" },
    { id: 723, value: "00" },
    { id: 724, value: "36" },
    { id: 725, value: "25" },
    { id: 726, value: "88" },
    { id: 727, value: "27" },
    { id: 728, value: "**" },
  ],
  [
    { id: 729, value: "94" },
    { id: 730, value: "31" },
    { id: 731, value: "55" },
    { id: 732, value: "49" },
    { id: 733, value: "18" },
    { id: 734, value: "15" },
    { id: 735, value: "**" },
  ],
  [
    { id: 736, value: "97" },
    { id: 737, value: "49" },
    { id: 738, value: "71" },
    { id: 739, value: "17" },
    { id: 740, value: "12" },
    { id: 741, value: "33" },
    { id: 742, value: "**" },
  ],
  [
    { id: 743, value: "13" },
    { id: 744, value: "94" },
    { id: 745, value: "**" },
    { id: 746, value: "90" },
    { id: 747, value: "56" },
    { id: 748, value: "63" },
    { id: 749, value: "**" },
  ],
  [
    { id: 750, value: "70" },
    { id: 751, value: "21" },
    { id: 752, value: "30" },
    { id: 753, value: "88" },
    { id: 754, value: "15" },
    { id: 755, value: "54" },
    { id: 756, value: "**" },
  ],
  [
    { id: 757, value: "58" },
    { id: 758, value: "13" },
    { id: 759, value: "72" },
    { id: 760, value: "25" },
    { id: 761, value: "06" },
    { id: 762, value: "82" },
    { id: 763, value: "**" },
  ],
];
export const KalyanNight = [
  [
    { id: 1, value: "93" },
    { id: 2, value: "42" },
    { id: 3, value: "98" },
    { id: 4, value: "76" },
    { id: 5, value: "42" },
  ],
  [
    { id: 6, value: "19" },
    { id: 7, value: "47" },
    { id: 8, value: "47" },
    { id: 9, value: "75" },
    { id: 10, value: "36" },
  ],
  [
    { id: 11, value: "36" },
    { id: 12, value: "29" },
    { id: 13, value: "79" },
    { id: 14, value: "97" },
    { id: 15, value: "51" },
  ],
  [
    { id: 16, value: "79" },
    { id: 17, value: "68" },
    { id: 18, value: "35" },
    { id: 19, value: "32" },
    { id: 20, value: "**" },
  ],
  [
    { id: 21, value: "70" },
    { id: 22, value: "70" },
    { id: 23, value: "34" },
    { id: 24, value: "30" },
    { id: 25, value: "42" },
  ],
  [
    { id: 26, value: "95" },
    { id: 27, value: "85" },
    { id: 28, value: "62" },
    { id: 29, value: "80" },
    { id: 30, value: "91" },
  ],
  [
    { id: 31, value: "28" },
    { id: 32, value: "31" },
    { id: 33, value: "63" },
    { id: 34, value: "51" },
    { id: 35, value: "54" },
  ],
  [
    { id: 36, value: "28" },
    { id: 37, value: "35" },
    { id: 38, value: "24" },
    { id: 39, value: "83" },
    { id: 40, value: "52" },
  ],
  [
    { id: 41, value: "90" },
    { id: 42, value: "28" },
    { id: 43, value: "87" },
    { id: 44, value: "66" },
    { id: 45, value: "28" },
  ],
  [
    { id: 46, value: "44" },
    { id: 47, value: "06" },
    { id: 48, value: "96" },
    { id: 49, value: "33" },
    { id: 50, value: "52" },
  ],
  [
    { id: 51, value: "77" },
    { id: 52, value: "80" },
    { id: 53, value: "21" },
    { id: 54, value: "67" },
    { id: 55, value: "25" },
  ],
  [
    { id: 56, value: "74" },
    { id: 57, value: "05" },
    { id: 58, value: "59" },
    { id: 59, value: "33" },
    { id: 60, value: "63" },
  ],
  [
    { id: 61, value: "**" },
    { id: 62, value: "44" },
    { id: 63, value: "31" },
    { id: 64, value: "32" },
    { id: 65, value: "29" },
  ],
  [
    { id: 66, value: "64" },
    { id: 67, value: "33" },
    { id: 68, value: "15" },
    { id: 69, value: "03" },
    { id: 70, value: "45" },
  ],
  [
    { id: 71, value: "01" },
    { id: 72, value: "01" },
    { id: 73, value: "07" },
    { id: 74, value: "65" },
    { id: 75, value: "16" },
  ],
  [
    { id: 76, value: "29" },
    { id: 77, value: "16" },
    { id: 78, value: "96" },
    { id: 79, value: "71" },
    { id: 80, value: "75" },
  ],
  [
    { id: 81, value: "64" },
    { id: 82, value: "12" },
    { id: 83, value: "42" },
    { id: 84, value: "66" },
    { id: 85, value: "61" },
  ],
  [
    { id: 86, value: "16" },
    { id: 87, value: "62" },
    { id: 88, value: "26" },
    { id: 89, value: "32" },
    { id: 90, value: "50" },
  ],
  [
    { id: 91, value: "49" },
    { id: 92, value: "22" },
    { id: 93, value: "46" },
    { id: 94, value: "42" },
    { id: 95, value: "55" },
  ],
  [
    { id: 96, value: "64" },
    { id: 97, value: "07" },
    { id: 98, value: "05" },
    { id: 99, value: "24" },
    { id: 100, value: "20" },
  ],
  [
    { id: 101, value: "75" },
    { id: 102, value: "51" },
    { id: 103, value: "95" },
    { id: 104, value: "77" },
    { id: 105, value: "60" },
  ],
  [
    { id: 106, value: "71" },
    { id: 107, value: "33" },
    { id: 108, value: "07" },
    { id: 109, value: "59" },
    { id: 110, value: "68" },
  ],
  [
    { id: 111, value: "30" },
    { id: 112, value: "59" },
    { id: 113, value: "34" },
    { id: 114, value: "60" },
    { id: 115, value: "02" },
  ],
  [
    { id: 116, value: "78" },
    { id: 117, value: "67" },
    { id: 118, value: "70" },
    { id: 119, value: "60" },
    { id: 120, value: "23" },
  ],
  [
    { id: 121, value: "07" },
    { id: 122, value: "76" },
    { id: 123, value: "36" },
    { id: 124, value: "61" },
    { id: 125, value: "68" },
  ],
  [
    { id: 126, value: "81" },
    { id: 127, value: "84" },
    { id: 128, value: "84" },
    { id: 129, value: "91" },
    { id: 130, value: "18" },
  ],
  [
    { id: 131, value: "74" },
    { id: 132, value: "43" },
    { id: 133, value: "79" },
    { id: 134, value: "47" },
    { id: 135, value: "05" },
  ],
  [
    { id: 136, value: "00" },
    { id: 137, value: "60" },
    { id: 138, value: "12" },
    { id: 139, value: "31" },
    { id: 140, value: "12" },
  ],
  [
    { id: 141, value: "57" },
    { id: 142, value: "77" },
    { id: 143, value: "15" },
    { id: 144, value: "97" },
    { id: 145, value: "77" },
  ],
  [
    { id: 146, value: "78" },
    { id: 147, value: "37" },
    { id: 148, value: "84" },
    { id: 149, value: "13" },
    { id: 150, value: "13" },
  ],
  [
    { id: 151, value: "39" },
    { id: 152, value: "32" },
    { id: 153, value: "69" },
    { id: 154, value: "90" },
    { id: 155, value: "36" },
  ],
  [
    { id: 156, value: "46" },
    { id: 157, value: "16" },
    { id: 158, value: "02" },
    { id: 159, value: "70" },
    { id: 160, value: "97" },
  ],
  [
    { id: 161, value: "34" },
    { id: 162, value: "85" },
    { id: 163, value: "61" },
    { id: 164, value: "**" },
    { id: 165, value: "52" },
  ],
  [
    { id: 166, value: "81" },
    { id: 167, value: "14" },
    { id: 168, value: "52" },
    { id: 169, value: "41" },
    { id: 170, value: "38" },
  ],
  [
    { id: 171, value: "21" },
    { id: 172, value: "61" },
    { id: 173, value: "82" },
    { id: 174, value: "31" },
    { id: 175, value: "01" },
  ],
  [
    { id: 176, value: "13" },
    { id: 177, value: "08" },
    { id: 178, value: "45" },
    { id: 179, value: "40" },
    { id: 180, value: "47" },
  ],
  [
    { id: 181, value: "64" },
    { id: 182, value: "42" },
    { id: 183, value: "45" },
    { id: 184, value: "81" },
    { id: 185, value: "98" },
  ],
  [
    { id: 186, value: "88" },
    { id: 187, value: "27" },
    { id: 188, value: "72" },
    { id: 189, value: "58" },
    { id: 190, value: "97" },
  ],
  [
    { id: 191, value: "88" },
    { id: 192, value: "84" },
    { id: 193, value: "73" },
    { id: 194, value: "14" },
    { id: 195, value: "64" },
  ],
  [
    { id: 196, value: "89" },
    { id: 197, value: "66" },
    { id: 198, value: "89" },
    { id: 199, value: "55" },
    { id: 200, value: "85" },
  ],
  [
    { id: 201, value: "55" },
    { id: 202, value: "73" },
    { id: 203, value: "58" },
    { id: 204, value: "06" },
    { id: 205, value: "14" },
  ],
  [
    { id: 206, value: "53" },
    { id: 207, value: "45" },
    { id: 208, value: "92" },
    { id: 209, value: "55" },
    { id: 210, value: "12" },
  ],
  [
    { id: 211, value: "65" },
    { id: 212, value: "96" },
    { id: 213, value: "42" },
    { id: 214, value: "76" },
    { id: 215, value: "70" },
  ],
  [
    { id: 216, value: "**" },
    { id: 217, value: "**" },
    { id: 218, value: "**" },
    { id: 219, value: "**" },
    { id: 220, value: "**" },
  ],
  [
    { id: 221, value: "**" },
    { id: 222, value: "**" },
    { id: 223, value: "54" },
    { id: 224, value: "31" },
    { id: 225, value: "37" },
  ],
  [
    { id: 226, value: "54" },
    { id: 227, value: "61" },
    { id: 228, value: "60" },
    { id: 229, value: "27" },
    { id: 230, value: "63" },
  ],
  [
    { id: 231, value: "40" },
    { id: 232, value: "88" },
    { id: 233, value: "61" },
    { id: 234, value: "58" },
    { id: 235, value: "87" },
  ],
  [
    { id: 236, value: "66" },
    { id: 237, value: "15" },
    { id: 238, value: "95" },
    { id: 239, value: "48" },
    { id: 240, value: "17" },
  ],
  [
    { id: 241, value: "78" },
    { id: 242, value: "62" },
    { id: 243, value: "08" },
    { id: 244, value: "51" },
    { id: 245, value: "00" },
  ],
  [
    { id: 246, value: "20" },
    { id: 247, value: "96" },
    { id: 248, value: "96" },
    { id: 249, value: "31" },
    { id: 250, value: "06" },
  ],
  [
    { id: 251, value: "60" },
    { id: 252, value: "19" },
    { id: 253, value: "35" },
    { id: 254, value: "33" },
    { id: 255, value: "35" },
  ],
  [
    { id: 256, value: "31" },
    { id: 257, value: "89" },
    { id: 258, value: "14" },
    { id: 259, value: "14" },
    { id: 260, value: "12" },
  ],
  [
    { id: 261, value: "84" },
    { id: 262, value: "97" },
    { id: 263, value: "93" },
    { id: 264, value: "64" },
    { id: 265, value: "18" },
  ],
  [
    { id: 266, value: "87" },
    { id: 267, value: "17" },
    { id: 268, value: "97" },
    { id: 269, value: "39" },
    { id: 270, value: "01" },
  ],
  [
    { id: 271, value: "95" },
    { id: 272, value: "54" },
    { id: 273, value: "57" },
    { id: 274, value: "72" },
    { id: 275, value: "78" },
  ],
  [
    { id: 276, value: "92" },
    { id: 277, value: "36" },
    { id: 278, value: "14" },
    { id: 279, value: "59" },
    { id: 280, value: "78" },
  ],
  [
    { id: 281, value: "04" },
    { id: 282, value: "08" },
    { id: 283, value: "41" },
    { id: 284, value: "58" },
    { id: 285, value: "78" },
    { id: 286, value: "**" },
    { id: 287, value: "**" },
  ],
  [
    { id: 288, value: "27" },
    { id: 289, value: "39" },
    { id: 290, value: "34" },
    { id: 291, value: "48" },
    { id: 292, value: "29" },
    { id: 293, value: "**" },
    { id: 294, value: "**" },
  ],
  [
    { id: 295, value: "03" },
    { id: 296, value: "30" },
    { id: 297, value: "47" },
    { id: 298, value: "57" },
    { id: 299, value: "28" },
    { id: 300, value: "**" },
    { id: 301, value: "**" },
  ],
  [
    { id: 302, value: "40" },
    { id: 303, value: "40" },
    { id: 304, value: "17" },
    { id: 305, value: "41" },
    { id: 306, value: "96" },
    { id: 307, value: "**" },
    { id: 308, value: "**" },
  ],
  [
    { id: 309, value: "02" },
    { id: 310, value: "38" },
    { id: 311, value: "36" },
    { id: 312, value: "84" },
    { id: 313, value: "52" },
    { id: 314, value: "**" },
    { id: 315, value: "**" },
  ],
  [
    { id: 316, value: "13" },
    { id: 317, value: "39" },
    { id: 318, value: "56" },
    { id: 319, value: "54" },
    { id: 320, value: "31" },
    { id: 321, value: "**" },
    { id: 322, value: "**" },
  ],
  [
    { id: 323, value: "50" },
    { id: 324, value: "60" },
    { id: 325, value: "13" },
    { id: 326, value: "40" },
    { id: 327, value: "57" },
    { id: 328, value: "**" },
    { id: 329, value: "**" },
  ],
  [
    { id: 330, value: "02" },
    { id: 331, value: "98" },
    { id: 332, value: "57" },
    { id: 333, value: "41" },
    { id: 334, value: "37" },
    { id: 335, value: "**" },
    { id: 336, value: "**" },
  ],
  [
    { id: 337, value: "32" },
    { id: 338, value: "32" },
    { id: 339, value: "03" },
    { id: 340, value: "90" },
    { id: 341, value: "29" },
    { id: 342, value: "**" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "71" },
    { id: 345, value: "46" },
    { id: 346, value: "98" },
    { id: 347, value: "20" },
    { id: 348, value: "32" },
    { id: 349, value: "**" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "92" },
    { id: 352, value: "89" },
    { id: 353, value: "63" },
    { id: 354, value: "67" },
    { id: 355, value: "44" },
    { id: 356, value: "**" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "04" },
    { id: 359, value: "55" },
    { id: 360, value: "55" },
    { id: 361, value: "88" },
    { id: 362, value: "25" },
    { id: 363, value: "**" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "37" },
    { id: 366, value: "66" },
    { id: 367, value: "26" },
    { id: 368, value: "34" },
    { id: 369, value: "29" },
    { id: 370, value: "**" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "13" },
    { id: 373, value: "61" },
    { id: 374, value: "51" },
    { id: 375, value: "99" },
    { id: 376, value: "60" },
    { id: 377, value: "**" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "90" },
    { id: 380, value: "33" },
    { id: 381, value: "24" },
    { id: 382, value: "83" },
    { id: 383, value: "16" },
    { id: 384, value: "**" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "66" },
    { id: 387, value: "44" },
    { id: 388, value: "26" },
    { id: 389, value: "81" },
    { id: 390, value: "79" },
    { id: 391, value: "**" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "98" },
    { id: 394, value: "23" },
    { id: 395, value: "69" },
    { id: 396, value: "22" },
    { id: 397, value: "82" },
    { id: 398, value: "**" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "02" },
    { id: 401, value: "05" },
    { id: 402, value: "22" },
    { id: 403, value: "48" },
    { id: 404, value: "45" },
    { id: 405, value: "**" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "43" },
    { id: 408, value: "14" },
    { id: 409, value: "67" },
    { id: 410, value: "63" },
    { id: 411, value: "21" },
    { id: 412, value: "**" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "92" },
    { id: 415, value: "41" },
    { id: 416, value: "26" },
    { id: 417, value: "21" },
    { id: 418, value: "42" },
    { id: 419, value: "**" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "87" },
    { id: 422, value: "39" },
    { id: 423, value: "90" },
    { id: 424, value: "57" },
    { id: 425, value: "09" },
    { id: 426, value: "**" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "98" },
    { id: 429, value: "31" },
    { id: 430, value: "06" },
    { id: 431, value: "39" },
    { id: 432, value: "86" },
    { id: 433, value: "**" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "15" },
    { id: 436, value: "42" },
    { id: 437, value: "15" },
    { id: 438, value: "32" },
    { id: 439, value: "88" },
    { id: 440, value: "**" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "75" },
    { id: 443, value: "38" },
    { id: 444, value: "87" },
    { id: 445, value: "96" },
    { id: 446, value: "17" },
    { id: 447, value: "**" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "87" },
    { id: 450, value: "78" },
    { id: 451, value: "33" },
    { id: 452, value: "08" },
    { id: 453, value: "28" },
    { id: 454, value: "**" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "28" },
    { id: 457, value: "14" },
    { id: 458, value: "39" },
    { id: 459, value: "24" },
    { id: 460, value: "60" },
    { id: 461, value: "**" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "82" },
    { id: 464, value: "54" },
    { id: 465, value: "08" },
    { id: 466, value: "95" },
    { id: 467, value: "95" },
    { id: 468, value: "**" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "58" },
    { id: 471, value: "69" },
    { id: 472, value: "44" },
    { id: 473, value: "91" },
    { id: 474, value: "86" },
    { id: 475, value: "**" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "84" },
    { id: 478, value: "21" },
    { id: 479, value: "92" },
    { id: 480, value: "07" },
    { id: 481, value: "79" },
    { id: 482, value: "**" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "50" },
    { id: 485, value: "33" },
    { id: 486, value: "09" },
    { id: 487, value: "77" },
    { id: 488, value: "**" },
    { id: 489, value: "**" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "99" },
    { id: 492, value: "70" },
    { id: 493, value: "15" },
    { id: 494, value: "06" },
    { id: 495, value: "17" },
    { id: 496, value: "**" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "77" },
    { id: 499, value: "65" },
    { id: 500, value: "57" },
    { id: 501, value: "09" },
    { id: 502, value: "50" },
    { id: 503, value: "**" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "81" },
    { id: 506, value: "16" },
    { id: 507, value: "52" },
    { id: 508, value: "64" },
    { id: 509, value: "79" },
    { id: 510, value: "**" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "01" },
    { id: 513, value: "05" },
    { id: 514, value: "03" },
    { id: 515, value: "07" },
    { id: 516, value: "22" },
    { id: 517, value: "**" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "16" },
    { id: 520, value: "48" },
    { id: 521, value: "09" },
    { id: 522, value: "44" },
    { id: 523, value: "70" },
    { id: 524, value: "**" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "67" },
    { id: 527, value: "50" },
    { id: 528, value: "26" },
    { id: 529, value: "33" },
    { id: 530, value: "51" },
    { id: 531, value: "**" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "19" },
    { id: 534, value: "74" },
    { id: 535, value: "93" },
    { id: 536, value: "75" },
    { id: 537, value: "78" },
    { id: 538, value: "**" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "12" },
    { id: 541, value: "16" },
    { id: 542, value: "67" },
    { id: 543, value: "02" },
    { id: 544, value: "30" },
    { id: 545, value: "**" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "66" },
    { id: 548, value: "63" },
    { id: 549, value: "38" },
    { id: 550, value: "05" },
    { id: 551, value: "26" },
    { id: 552, value: "**" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "33" },
    { id: 555, value: "05" },
    { id: 556, value: "25" },
    { id: 557, value: "26" },
    { id: 558, value: "40" },
    { id: 559, value: "**" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "71" },
    { id: 562, value: "23" },
    { id: 563, value: "88" },
    { id: 564, value: "57" },
    { id: 565, value: "59" },
    { id: 566, value: "**" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "86" },
    { id: 569, value: "99" },
    { id: 570, value: "67" },
    { id: 571, value: "59" },
    { id: 572, value: "07" },
    { id: 573, value: "**" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "49" },
    { id: 576, value: "29" },
    { id: 577, value: "40" },
    { id: 578, value: "03" },
    { id: 579, value: "17" },
    { id: 580, value: "**" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "47" },
    { id: 583, value: "18" },
    { id: 584, value: "00" },
    { id: 585, value: "03" },
    { id: 586, value: "86" },
    { id: 587, value: "**" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "38" },
    { id: 590, value: "69" },
    { id: 591, value: "31" },
    { id: 592, value: "82" },
    { id: 593, value: "27" },
    { id: 594, value: "**" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "97" },
    { id: 597, value: "19" },
    { id: 598, value: "11" },
    { id: 599, value: "19" },
    { id: 600, value: "27" },
    { id: 601, value: "**" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "61" },
    { id: 604, value: "27" },
    { id: 605, value: "03" },
    { id: 606, value: "63" },
    { id: 607, value: "07" },
    { id: 608, value: "**" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "86" },
    { id: 611, value: "69" },
    { id: 612, value: "92" },
    { id: 613, value: "71" },
    { id: 614, value: "97" },
    { id: 615, value: "**" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "31" },
    { id: 618, value: "75" },
    { id: 619, value: "08" },
    { id: 620, value: "39" },
    { id: 621, value: "03" },
    { id: 622, value: "**" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "37" },
    { id: 625, value: "95" },
    { id: 626, value: "81" },
    { id: 627, value: "01" },
    { id: 628, value: "08" },
    { id: 629, value: "**" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "06" },
    { id: 632, value: "73" },
    { id: 633, value: "60" },
    { id: 634, value: "65" },
    { id: 635, value: "71" },
    { id: 636, value: "**" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "73" },
    { id: 639, value: "02" },
    { id: 640, value: "49" },
    { id: 641, value: "82" },
    { id: 642, value: "91" },
    { id: 643, value: "**" },
    { id: 644, value: "**" },
  ],
  [
    { id: 645, value: "**" },
    { id: 646, value: "31" },
    { id: 647, value: "53" },
    { id: 648, value: "15" },
    { id: 649, value: "26" },
    { id: 650, value: "**" },
    { id: 651, value: "**" },
  ],
  [
    { id: 652, value: "88" },
    { id: 653, value: "89" },
    { id: 654, value: "40" },
    { id: 655, value: "66" },
    { id: 656, value: "62" },
    { id: 657, value: "**" },
    { id: 658, value: "**" },
  ],
  [
    { id: 659, value: "79" },
    { id: 660, value: "47" },
    { id: 661, value: "95" },
    { id: 662, value: "42" },
    { id: 663, value: "51" },
    { id: 664, value: "**" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "33" },
    { id: 667, value: "18" },
    { id: 668, value: "93" },
    { id: 669, value: "46" },
    { id: 670, value: "41" },
    { id: 671, value: "**" },
    { id: 672, value: "**" },
  ],
  [
    { id: 673, value: "19" },
    { id: 674, value: "75" },
    { id: 675, value: "35" },
    { id: 676, value: "33" },
    { id: 677, value: "39" },
    { id: 678, value: "**" },
    { id: 679, value: "**" },
  ],
  [
    { id: 680, value: "14" },
    { id: 681, value: "50" },
    { id: 682, value: "**" },
    { id: 683, value: "24" },
    { id: 684, value: "44" },
    { id: 685, value: "**" },
    { id: 686, value: "**" },
  ],
  [
    { id: 687, value: "24" },
    { id: 688, value: "22" },
    { id: 689, value: "53" },
    { id: 690, value: "52" },
    { id: 691, value: "58" },
    { id: 692, value: "**" },
    { id: 693, value: "**" },
  ],
  [
    { id: 694, value: "99" },
    { id: 695, value: "87" },
    { id: 696, value: "18" },
    { id: 697, value: "16" },
    { id: 698, value: "45" },
    { id: 699, value: "**" },
    { id: 700, value: "**" },
  ],
];
// sridevinight

export const ShreeDeviNight = [
  [
    { id: 1, value: "87" },
    { id: 2, value: "70" },
    { id: 3, value: "86" },
    { id: 4, value: "70" },
    { id: 5, value: "26" },
    { id: 6, value: "93" },
    { id: 7, value: "56" },
  ],
  [
    { id: 8, value: "61" },
    { id: 9, value: "04" },
    { id: 10, value: "22" },
    { id: 11, value: "01" },
    { id: 12, value: "18" },
    { id: 13, value: "40" },
    { id: 14, value: "41" },
  ],
  [
    { id: 15, value: "19" },
    { id: 16, value: "94" },
    { id: 17, value: "93" },
    { id: 18, value: "82" },
    { id: 19, value: "68" },
    { id: 20, value: "11" },
    { id: 21, value: "71" },
  ],
  [
    { id: 22, value: "47" },
    { id: 23, value: "85" },
    { id: 24, value: "65" },
    { id: 25, value: "98" },
    { id: 26, value: "**" },
    { id: 27, value: "21" },
    { id: 28, value: "39" },
  ],
  [
    { id: 29, value: "19" },
    { id: 30, value: "23" },
    { id: 31, value: "87" },
    { id: 32, value: "82" },
    { id: 33, value: "40" },
    { id: 34, value: "59" },
    { id: 35, value: "64" },
  ],
  [
    { id: 36, value: "44" },
    { id: 37, value: "88" },
    { id: 38, value: "60" },
    { id: 39, value: "08" },
    { id: 40, value: "83" },
    { id: 41, value: "22" },
    { id: 42, value: "48" },
  ],
  [
    { id: 43, value: "22" },
    { id: 44, value: "88" },
    { id: 45, value: "45" },
    { id: 46, value: "60" },
    { id: 47, value: "77" },
    { id: 48, value: "92" },
    { id: 49, value: "90" },
  ],
  [
    { id: 50, value: "48" },
    { id: 51, value: "60" },
    { id: 52, value: "51" },
    { id: 53, value: "65" },
    { id: 54, value: "79" },
    { id: 55, value: "33" },
    { id: 56, value: "26" },
  ],
  [
    { id: 57, value: "27" },
    { id: 58, value: "17" },
    { id: 59, value: "80" },
    { id: 60, value: "58" },
    { id: 61, value: "58" },
    { id: 62, value: "92" },
    { id: 63, value: "15" },
  ],
  [
    { id: 64, value: "69" },
    { id: 65, value: "00" },
    { id: 66, value: "08" },
    { id: 67, value: "19" },
    { id: 68, value: "79" },
    { id: 69, value: "15" },
    { id: 70, value: "39" },
  ],
  [
    { id: 71, value: "07" },
    { id: 72, value: "28" },
    { id: 73, value: "09" },
    { id: 74, value: "16" },
    { id: 75, value: "74" },
    { id: 76, value: "16" },
    { id: 77, value: "28" },
  ],
  [
    { id: 78, value: "55" },
    { id: 79, value: "48" },
    { id: 80, value: "15" },
    { id: 81, value: "81" },
    { id: 82, value: "09" },
    { id: 83, value: "05" },
    { id: 84, value: "61" },
  ],
  [
    { id: 85, value: "**" },
    { id: 86, value: "51" },
    { id: 87, value: "27" },
    { id: 88, value: "74" },
    { id: 89, value: "49" },
    { id: 90, value: "39" },
    { id: 91, value: "78" },
  ],
  [
    { id: 92, value: "07" },
    { id: 93, value: "00" },
    { id: 94, value: "97" },
    { id: 95, value: "48" },
    { id: 96, value: "95" },
    { id: 97, value: "43" },
    { id: 98, value: "12" },
  ],
  [
    { id: 99, value: "07" },
    { id: 100, value: "44" },
    { id: 101, value: "56" },
    { id: 102, value: "80" },
    { id: 103, value: "90" },
    { id: 104, value: "81" },
    { id: 105, value: "35" },
  ],
  [
    { id: 106, value: "97" },
    { id: 107, value: "21" },
    { id: 108, value: "94" },
    { id: 109, value: "14" },
    { id: 110, value: "36" },
    { id: 111, value: "41" },
    { id: 112, value: "83" },
  ],
  [
    { id: 113, value: "24" },
    { id: 114, value: "73" },
    { id: 115, value: "78" },
    { id: 116, value: "86" },
    { id: 117, value: "55" },
    { id: 118, value: "14" },
    { id: 119, value: "60" },
  ],
  [
    { id: 120, value: "55" },
    { id: 121, value: "21" },
    { id: 122, value: "20" },
    { id: 123, value: "85" },
    { id: 124, value: "35" },
    { id: 125, value: "14" },
    { id: 126, value: "13" },
  ],
  [
    { id: 127, value: "64" },
    { id: 128, value: "57" },
    { id: 129, value: "23" },
    { id: 130, value: "51" },
    { id: 131, value: "22" },
    { id: 132, value: "17" },
    { id: 133, value: "84" },
  ],
  [
    { id: 134, value: "61" },
    { id: 135, value: "16" },
    { id: 136, value: "80" },
    { id: 137, value: "44" },
    { id: 138, value: "07" },
    { id: 139, value: "01" },
    { id: 140, value: "93" },
  ],
  [
    { id: 141, value: "98" },
    { id: 142, value: "77" },
    { id: 143, value: "72" },
    { id: 144, value: "41" },
    { id: 145, value: "90" },
    { id: 146, value: "07" },
    { id: 147, value: "47" },
  ],
  [
    { id: 148, value: "89" },
    { id: 149, value: "41" },
    { id: 150, value: "02" },
    { id: 151, value: "45" },
    { id: 152, value: "88" },
    { id: 153, value: "35" },
    { id: 154, value: "40" },
  ],
  [
    { id: 155, value: "45" },
    { id: 156, value: "62" },
    { id: 157, value: "60" },
    { id: 158, value: "35" },
    { id: 159, value: "62" },
    { id: 160, value: "00" },
    { id: 161, value: "72" },
  ],
  [
    { id: 162, value: "98" },
    { id: 163, value: "82" },
    { id: 164, value: "92" },
    { id: 165, value: "96" },
    { id: 166, value: "13" },
    { id: 167, value: "13" },
    { id: 168, value: "64" },
  ],
  [
    { id: 169, value: "77" },
    { id: 170, value: "44" },
    { id: 171, value: "94" },
    { id: 172, value: "85" },
    { id: 173, value: "01" },
    { id: 174, value: "62" },
    { id: 175, value: "87" },
  ],
  [
    { id: 176, value: "03" },
    { id: 177, value: "03" },
    { id: 178, value: "44" },
    { id: 179, value: "24" },
    { id: 180, value: "69" },
    { id: 181, value: "64" },
    { id: 182, value: "39" },
  ],
  [
    { id: 183, value: "78" },
    { id: 184, value: "21" },
    { id: 185, value: "04" },
    { id: 186, value: "36" },
    { id: 187, value: "39" },
    { id: 188, value: "00" },
    { id: 189, value: "60" },
  ],
  [
    { id: 190, value: "01" },
    { id: 191, value: "29" },
    { id: 192, value: "61" },
    { id: 193, value: "31" },
    { id: 194, value: "31" },
    { id: 195, value: "79" },
    { id: 196, value: "76" },
  ],
  [
    { id: 197, value: "53" },
    { id: 198, value: "22" },
    { id: 199, value: "78" },
    { id: 200, value: "30" },
    { id: 201, value: "61" },
    { id: 202, value: "90" },
    { id: 203, value: "30" },
  ],
  [
    { id: 204, value: "61" },
    { id: 205, value: "35" },
    { id: 206, value: "78" },
    { id: 207, value: "37" },
    { id: 208, value: "59" },
    { id: 209, value: "41" },
    { id: 210, value: "23" },
  ],
  [
    { id: 211, value: "51" },
    { id: 212, value: "59" },
    { id: 213, value: "44" },
    { id: 214, value: "57" },
    { id: 215, value: "03" },
    { id: 216, value: "24" },
    { id: 217, value: "83" },
  ],
  [
    { id: 218, value: "62" },
    { id: 219, value: "01" },
    { id: 220, value: "67" },
    { id: 221, value: "23" },
    { id: 222, value: "21" },
    { id: 223, value: "48" },
    { id: 224, value: "41" },
  ],
  [
    { id: 225, value: "90" },
    { id: 226, value: "08" },
    { id: 227, value: "89" },
    { id: 228, value: "**" },
    { id: 229, value: "13" },
    { id: 230, value: "27" },
    { id: 231, value: "88" },
  ],
  [
    { id: 232, value: "05" },
    { id: 233, value: "65" },
    { id: 234, value: "96" },
    { id: 235, value: "41" },
    { id: 236, value: "83" },
    { id: 237, value: "70" },
    { id: 238, value: "95" },
  ],
  [
    { id: 239, value: "74" },
    { id: 240, value: "15" },
    { id: 241, value: "31" },
    { id: 242, value: "59" },
    { id: 243, value: "58" },
    { id: 244, value: "98" },
    { id: 245, value: "15" },
  ],
  [
    { id: 246, value: "80" },
    { id: 247, value: "31" },
    { id: 248, value: "93" },
    { id: 249, value: "12" },
    { id: 250, value: "96" },
    { id: 251, value: "24" },
    { id: 252, value: "95" },
  ],
  [
    { id: 253, value: "22" },
    { id: 254, value: "70" },
    { id: 255, value: "88" },
    { id: 256, value: "11" },
    { id: 257, value: "25" },
    { id: 258, value: "05" },
    { id: 259, value: "72" },
  ],
  [
    { id: 260, value: "84" },
    { id: 261, value: "03" },
    { id: 262, value: "70" },
    { id: 263, value: "06" },
    { id: 264, value: "22" },
    { id: 265, value: "59" },
    { id: 266, value: "71" },
  ],
  [
    { id: 267, value: "81" },
    { id: 268, value: "88" },
    { id: 269, value: "63" },
    { id: 270, value: "04" },
    { id: 271, value: "88" },
    { id: 272, value: "09" },
    { id: 273, value: "50" },
  ],
  [
    { id: 274, value: "26" },
    { id: 275, value: "41" },
    { id: 276, value: "89" },
    { id: 277, value: "38" },
    { id: 278, value: "75" },
    { id: 279, value: "42" },
    { id: 280, value: "48" },
  ],
  [
    { id: 281, value: "42" },
    { id: 282, value: "92" },
    { id: 283, value: "95" },
    { id: 284, value: "70" },
    { id: 285, value: "60" },
    { id: 286, value: "18" },
    { id: 287, value: "63" },
  ],
  [
    { id: 288, value: "15" },
    { id: 289, value: "21" },
    { id: 290, value: "37" },
    { id: 291, value: "00" },
    { id: 292, value: "33" },
    { id: 293, value: "67" },
    { id: 294, value: "27" },
  ],
  [
    { id: 295, value: "92" },
    { id: 296, value: "83" },
    { id: 297, value: "32" },
    { id: 298, value: "15" },
    { id: 299, value: "16" },
    { id: 300, value: "95" },
    { id: 301, value: "96" },
  ],
  [
    { id: 302, value: "40" },
    { id: 303, value: "78" },
    { id: 304, value: "84" },
    { id: 305, value: "03" },
    { id: 306, value: "84" },
    { id: 307, value: "54" },
    { id: 308, value: "15" },
  ],
  [
    { id: 309, value: "78" },
    { id: 310, value: "24" },
    { id: 311, value: "47" },
    { id: 312, value: "71" },
    { id: 313, value: "30" },
    { id: 314, value: "95" },
    { id: 315, value: "30" },
  ],
  [
    { id: 316, value: "34" },
    { id: 317, value: "24" },
    { id: 318, value: "80" },
    { id: 319, value: "42" },
    { id: 320, value: "72" },
    { id: 321, value: "11" },
    { id: 322, value: "34" },
  ],
  [
    { id: 323, value: "58" },
    { id: 324, value: "98" },
    { id: 325, value: "52" },
    { id: 326, value: "62" },
    { id: 327, value: "14" },
    { id: 328, value: "10" },
    { id: 329, value: "34" },
  ],
  [
    { id: 330, value: "32" },
    { id: 331, value: "39" },
    { id: 332, value: "10" },
    { id: 333, value: "85" },
    { id: 334, value: "81" },
    { id: 335, value: "86" },
    { id: 336, value: "26" },
  ],
  [
    { id: 337, value: "40" },
    { id: 338, value: "07" },
    { id: 339, value: "16" },
    { id: 340, value: "92" },
    { id: 341, value: "70" },
    { id: 342, value: "80" },
    { id: 343, value: "93" },
  ],
  [
    { id: 344, value: "65" },
    { id: 345, value: "37" },
    { id: 346, value: "16" },
    { id: 347, value: "77" },
    { id: 348, value: "22" },
    { id: 349, value: "02" },
    { id: 350, value: "75" },
  ],
  [
    { id: 351, value: "06" },
    { id: 352, value: "65" },
    { id: 353, value: "65" },
    { id: 354, value: "68" },
    { id: 355, value: "43" },
    { id: 356, value: "41" },
    { id: 357, value: "93" },
  ],
  [
    { id: 358, value: "22" },
    { id: 359, value: "31" },
    { id: 360, value: "47" },
    { id: 361, value: "98" },
    { id: 362, value: "73" },
    { id: 363, value: "69" },
    { id: 364, value: "72" },
  ],
  [
    { id: 365, value: "78" },
    { id: 366, value: "50" },
    { id: 367, value: "46" },
    { id: 368, value: "92" },
    { id: 369, value: "51" },
    { id: 370, value: "10" },
    { id: 371, value: "09" },
  ],
  [
    { id: 372, value: "72" },
    { id: 373, value: "70" },
    { id: 374, value: "07" },
    { id: 375, value: "94" },
    { id: 376, value: "66" },
    { id: 377, value: "41" },
    { id: 378, value: "52" },
  ],
  [
    { id: 379, value: "49" },
    { id: 380, value: "76" },
    { id: 381, value: "40" },
    { id: 382, value: "21" },
    { id: 383, value: "67" },
    { id: 384, value: "02" },
    { id: 385, value: "65" },
  ],
  [
    { id: 386, value: "61" },
    { id: 387, value: "97" },
    { id: 388, value: "42" },
    { id: 389, value: "51" },
    { id: 390, value: "02" },
    { id: 391, value: "83" },
    { id: 392, value: "40" },
  ],
  [
    { id: 393, value: "00" },
    { id: 394, value: "53" },
    { id: 395, value: "14" },
    { id: 396, value: "55" },
    { id: 397, value: "22" },
    { id: 398, value: "79" },
    { id: 399, value: "55" },
  ],
  [
    { id: 400, value: "65" },
    { id: 401, value: "21" },
    { id: 402, value: "28" },
    { id: 403, value: "90" },
    { id: 404, value: "79" },
    { id: 405, value: "34" },
    { id: 406, value: "72" },
  ],
  [
    { id: 407, value: "04" },
    { id: 408, value: "61" },
    { id: 409, value: "96" },
    { id: 410, value: "57" },
    { id: 411, value: "33" },
    { id: 412, value: "55" },
    { id: 413, value: "74" },
  ],
  [
    { id: 414, value: "55" },
    { id: 415, value: "79" },
    { id: 416, value: "22" },
    { id: 417, value: "96" },
    { id: 418, value: "96" },
    { id: 419, value: "30" },
    { id: 420, value: "72" },
  ],
  [
    { id: 421, value: "22" },
    { id: 422, value: "49" },
    { id: 423, value: "98" },
    { id: 424, value: "98" },
    { id: 425, value: "93" },
    { id: 426, value: "05" },
    { id: 427, value: "12" },
  ],
  [
    { id: 428, value: "61" },
    { id: 429, value: "00" },
    { id: 430, value: "74" },
    { id: 431, value: "52" },
    { id: 432, value: "39" },
    { id: 433, value: "97" },
    { id: 434, value: "39" },
  ],
  [
    { id: 435, value: "97" },
    { id: 436, value: "87" },
    { id: 437, value: "01" },
    { id: 438, value: "94" },
    { id: 439, value: "79" },
    { id: 440, value: "44" },
    { id: 441, value: "02" },
  ],
  [
    { id: 442, value: "40" },
    { id: 443, value: "34" },
    { id: 444, value: "01" },
    { id: 445, value: "70" },
    { id: 446, value: "08" },
    { id: 447, value: "74" },
    { id: 448, value: "64" },
  ],
  [
    { id: 449, value: "14" },
    { id: 450, value: "69" },
    { id: 451, value: "37" },
    { id: 452, value: "11" },
    { id: 453, value: "31" },
    { id: 454, value: "77" },
    { id: 455, value: "39" },
  ],
  [
    { id: 456, value: "08" },
    { id: 457, value: "55" },
    { id: 458, value: "12" },
    { id: 459, value: "46" },
    { id: 460, value: "42" },
    { id: 461, value: "79" },
    { id: 462, value: "45" },
  ],
  [
    { id: 463, value: "26" },
    { id: 464, value: "02" },
    { id: 465, value: "13" },
    { id: 466, value: "63" },
    { id: 467, value: "01" },
    { id: 468, value: "15" },
    { id: 469, value: "35" },
  ],
  [
    { id: 470, value: "00" },
    { id: 471, value: "67" },
    { id: 472, value: "50" },
    { id: 473, value: "60" },
    { id: 474, value: "78" },
    { id: 475, value: "11" },
    { id: 476, value: "39" },
  ],
  [
    { id: 477, value: "77" },
    { id: 478, value: "33" },
    { id: 479, value: "95" },
    { id: 480, value: "45" },
    { id: 481, value: "75" },
    { id: 482, value: "34" },
    { id: 483, value: "92" },
  ],
  [
    { id: 484, value: "43" },
    { id: 485, value: "10" },
    { id: 486, value: "49" },
    { id: 487, value: "78" },
    { id: 488, value: "27" },
    { id: 489, value: "48" },
    { id: 490, value: "35" },
  ],
  [
    { id: 491, value: "46" },
    { id: 492, value: "27" },
    { id: 493, value: "13" },
    { id: 494, value: "28" },
    { id: 495, value: "23" },
    { id: 496, value: "35" },
    { id: 497, value: "78" },
  ],
  [
    { id: 498, value: "34" },
    { id: 499, value: "81" },
    { id: 500, value: "23" },
    { id: 501, value: "07" },
    { id: 502, value: "51" },
    { id: 503, value: "79" },
    { id: 504, value: "06" },
  ],
  [
    { id: 505, value: "04" },
    { id: 506, value: "32" },
    { id: 507, value: "47" },
    { id: 508, value: "83" },
    { id: 509, value: "63" },
    { id: 510, value: "49" },
    { id: 511, value: "87" },
  ],
  [
    { id: 512, value: "43" },
    { id: 513, value: "86" },
    { id: 514, value: "43" },
    { id: 515, value: "68" },
    { id: 516, value: "44" },
    { id: 517, value: "41" },
    { id: 518, value: "56" },
  ],
  [
    { id: 519, value: "13" },
    { id: 520, value: "40" },
    { id: 521, value: "55" },
    { id: 522, value: "53" },
    { id: 523, value: "06" },
    { id: 524, value: "06" },
    { id: 525, value: "88" },
  ],
  [
    { id: 526, value: "55" },
    { id: 527, value: "55" },
    { id: 528, value: "63" },
    { id: 529, value: "39" },
    { id: 530, value: "11" },
    { id: 531, value: "89" },
    { id: 532, value: "39" },
  ],
  [
    { id: 533, value: "31" },
    { id: 534, value: "19" },
    { id: 535, value: "90" },
    { id: 536, value: "06" },
    { id: 537, value: "41" },
    { id: 538, value: "96" },
    { id: 539, value: "54" },
  ],
  [
    { id: 540, value: "58" },
    { id: 541, value: "44" },
    { id: 542, value: "18" },
    { id: 543, value: "26" },
    { id: 544, value: "32" },
    { id: 545, value: "09" },
    { id: 546, value: "26" },
  ],
  [
    { id: 547, value: "11" },
    { id: 548, value: "40" },
    { id: 549, value: "59" },
    { id: 550, value: "20" },
    { id: 551, value: "38" },
    { id: 552, value: "31" },
    { id: 553, value: "82" },
  ],
  [
    { id: 554, value: "50" },
    { id: 555, value: "02" },
    { id: 556, value: "54" },
    { id: 557, value: "98" },
    { id: 558, value: "04" },
    { id: 559, value: "15" },
    { id: 560, value: "56" },
  ],
  [
    { id: 561, value: "72" },
    { id: 562, value: "29" },
    { id: 563, value: "42" },
    { id: 564, value: "75" },
    { id: 565, value: "38" },
    { id: 566, value: "35" },
    { id: 567, value: "42" },
  ],
  [
    { id: 568, value: "32" },
    { id: 569, value: "96" },
    { id: 570, value: "95" },
    { id: 571, value: "17" },
    { id: 572, value: "95" },
    { id: 573, value: "18" },
    { id: 574, value: "75" },
  ],
  [
    { id: 575, value: "11" },
    { id: 576, value: "72" },
    { id: 577, value: "97" },
    { id: 578, value: "80" },
    { id: 579, value: "85" },
    { id: 580, value: "66" },
    { id: 581, value: "09" },
  ],
  [
    { id: 582, value: "77" },
    { id: 583, value: "90" },
    { id: 584, value: "17" },
    { id: 585, value: "10" },
    { id: 586, value: "39" },
    { id: 587, value: "51" },
    { id: 588, value: "59" },
  ],
  [
    { id: 589, value: "78" },
    { id: 590, value: "40" },
    { id: 591, value: "42" },
    { id: 592, value: "72" },
    { id: 593, value: "**" },
    { id: 594, value: "69" },
    { id: 595, value: "18" },
  ],
  [
    { id: 596, value: "64" },
    { id: 597, value: "93" },
    { id: 598, value: "68" },
    { id: 599, value: "22" },
    { id: 600, value: "18" },
    { id: 601, value: "33" },
    { id: 602, value: "86" },
  ],
  [
    { id: 603, value: "96" },
    { id: 604, value: "41" },
    { id: 605, value: "64" },
    { id: 606, value: "54" },
    { id: 607, value: "82" },
    { id: 608, value: "94" },
    { id: 609, value: "26" },
  ],
  [
    { id: 610, value: "56" },
    { id: 611, value: "71" },
    { id: 612, value: "42" },
    { id: 613, value: "19" },
    { id: 614, value: "69" },
    { id: 615, value: "88" },
    { id: 616, value: "81" },
  ],
  [
    { id: 617, value: "03" },
    { id: 618, value: "77" },
    { id: 619, value: "75" },
    { id: 620, value: "82" },
    { id: 621, value: "67" },
    { id: 622, value: "52" },
    { id: 623, value: "94" },
  ],
  [
    { id: 624, value: "30" },
    { id: 625, value: "79" },
    { id: 626, value: "56" },
    { id: 627, value: "43" },
    { id: 628, value: "56" },
    { id: 629, value: "70" },
    { id: 630, value: "18" },
  ],
  [
    { id: 631, value: "45" },
    { id: 632, value: "43" },
    { id: 633, value: "25" },
    { id: 634, value: "44" },
    { id: 635, value: "23" },
    { id: 636, value: "35" },
    { id: 637, value: "34" },
  ],
  [
    { id: 638, value: "11" },
    { id: 639, value: "23" },
    { id: 640, value: "83" },
    { id: 641, value: "09" },
    { id: 642, value: "61" },
    { id: 643, value: "60" },
    { id: 644, value: "01" },
  ],
  [
    { id: 645, value: "82" },
    { id: 646, value: "51" },
    { id: 647, value: "60" },
    { id: 648, value: "52" },
    { id: 649, value: "31" },
    { id: 650, value: "87" },
    { id: 651, value: "31" },
  ],
  [
    { id: 652, value: "00" },
    { id: 653, value: "11" },
    { id: 654, value: "07" },
    { id: 655, value: "54" },
    { id: 656, value: "82" },
    { id: 657, value: "**" },
    { id: 658, value: "77" },
  ],
  [
    { id: 659, value: "04" },
    { id: 660, value: "04" },
    { id: 661, value: "78" },
    { id: 662, value: "12" },
    { id: 663, value: "80" },
    { id: 664, value: "37" },
    { id: 665, value: "61" },
  ],
  [
    { id: 666, value: "70" },
    { id: 667, value: "63" },
    { id: 668, value: "20" },
    { id: 669, value: "55" },
    { id: 670, value: "52" },
    { id: 671, value: "70" },
    { id: 672, value: "73" },
  ],
  [
    { id: 673, value: "63" },
    { id: 674, value: "62" },
    { id: 675, value: "47" },
    { id: 676, value: "48" },
    { id: 677, value: "26" },
    { id: 678, value: "82" },
    { id: 679, value: "82" },
  ],
  [
    { id: 680, value: "86" },
    { id: 681, value: "40" },
    { id: 682, value: "26" },
    { id: 683, value: "41" },
    { id: 684, value: "60" },
    { id: 685, value: "23" },
    { id: 686, value: "51" },
  ],
  [
    { id: 687, value: "12" },
    { id: 688, value: "13" },
    { id: 689, value: "59" },
    { id: 690, value: "89" },
    { id: 691, value: "78" },
    { id: 692, value: "29" },
    { id: 693, value: "65" },
  ],
  [
    { id: 694, value: "28" },
    { id: 695, value: "28" },
    { id: 696, value: "14" },
    { id: 697, value: "10" },
    { id: 698, value: "36" },
    { id: 699, value: "50" },
    { id: 700, value: "42" },
  ],
  [
    { id: 701, value: "03" },
    { id: 702, value: "78" },
    { id: 703, value: "51" },
    { id: 704, value: "29" },
    { id: 705, value: "73" },
    { id: 706, value: "43" },
    { id: 707, value: "67" },
  ],
  [
    { id: 708, value: "17" },
    { id: 709, value: "50" },
    { id: 710, value: "22" },
    { id: 711, value: "62" },
    { id: 712, value: "93" },
    { id: 713, value: "09" },
    { id: 714, value: "06" },
  ],
  [
    { id: 715, value: "33" },
    { id: 716, value: "71" },
    { id: 717, value: "76" },
    { id: 718, value: "17" },
    { id: 719, value: "96" },
    { id: 720, value: "22" },
    { id: 721, value: "42" },
  ],
  [
    { id: 722, value: "71" },
    { id: 723, value: "04" },
    { id: 724, value: "90" },
    { id: 725, value: "57" },
    { id: 726, value: "58" },
    { id: 727, value: "33" },
    { id: 728, value: "93" },
  ],
  [
    { id: 729, value: "55" },
    { id: 730, value: "60" },
    { id: 731, value: "00" },
    { id: 732, value: "87" },
    { id: 733, value: "07" },
    { id: 734, value: "89" },
    { id: 735, value: "15" },
  ],
  [
    { id: 736, value: "81" },
    { id: 737, value: "84" },
    { id: 738, value: "36" },
    { id: 739, value: "23" },
    { id: 740, value: "85" },
    { id: 741, value: "94" },
    { id: 742, value: "22" },
  ],
  [
    { id: 743, value: "25" },
    { id: 744, value: "07" },
    { id: 745, value: "07" },
    { id: 746, value: "61" },
    { id: 747, value: "35" },
    { id: 748, value: "01" },
    { id: 749, value: "95" },
  ],
  [
    { id: 750, value: "00" },
    { id: 751, value: "96" },
    { id: 752, value: "73" },
    { id: 753, value: "64" },
    { id: 754, value: "48" },
    { id: 755, value: "66" },
    { id: 756, value: "79" },
  ],
  [
    { id: 757, value: "**" },
    { id: 758, value: "00" },
    { id: 759, value: "35" },
    { id: 760, value: "33" },
    { id: 761, value: "31" },
    { id: 762, value: "14" },
    { id: 763, value: "59" },
  ],
  [
    { id: 764, value: "24" },
    { id: 765, value: "71" },
    { id: 766, value: "59" },
    { id: 767, value: "98" },
    { id: 768, value: "27" },
    { id: 769, value: "21" },
    { id: 770, value: "61" },
  ],
  [
    { id: 771, value: "66" },
    { id: 772, value: "15" },
    { id: 773, value: "62" },
    { id: 774, value: "57" },
    { id: 775, value: "94" },
    { id: 776, value: "64" },
    { id: 777, value: "27" },
  ],
  [
    { id: 778, value: "10" },
    { id: 779, value: "90" },
    { id: 780, value: "45" },
    { id: 781, value: "09" },
    { id: 782, value: "92" },
    { id: 783, value: "57" },
    { id: 784, value: "43" },
  ],
  [
    { id: 785, value: "02" },
    { id: 786, value: "20" },
    { id: 787, value: "37" },
    { id: 788, value: "43" },
    { id: 789, value: "62" },
    { id: 790, value: "08" },
    { id: 791, value: "06" },
  ],
  [
    { id: 792, value: "87" },
    { id: 793, value: "14" },
    { id: 794, value: "**" },
    { id: 795, value: "90" },
    { id: 796, value: "61" },
    { id: 797, value: "88" },
    { id: 798, value: "58" },
  ],
  [
    { id: 799, value: "33" },
    { id: 800, value: "74" },
    { id: 801, value: "07" },
    { id: 802, value: "82" },
    { id: 803, value: "75" },
    { id: 804, value: "92" },
    { id: 805, value: "24" },
  ],
  [
    { id: 806, value: "58" },
    { id: 807, value: "41" },
    { id: 808, value: "01" },
    { id: 809, value: "45" },
    { id: 810, value: "59" },
    { id: 811, value: "65" },
    { id: 812, value: "46" },
  ],
];

// MILAN NIGHT

export const MilanNight = [
  [
    { id: 1, value: "50" },
    { id: 2, value: "88" },
    { id: 3, value: "80" },
    { id: 4, value: "96" },
    { id: 5, value: "69" },
    { id: 6, value: "79" },
  ],
  [
    { id: 7, value: "61" },
    { id: 8, value: "02" },
    { id: 9, value: "50" },
    { id: 10, value: "68" },
    { id: 11, value: "02" },
    { id: 12, value: "27" },
  ],
  [
    { id: 13, value: "77" },
    { id: 14, value: "08" },
    { id: 15, value: "88" },
    { id: 16, value: "01" },
    { id: 17, value: "77" },
    { id: 18, value: "18" },
  ],
  [
    { id: 19, value: "91" },
    { id: 20, value: "61" },
    { id: 21, value: "28" },
    { id: 22, value: "64" },
    { id: 23, value: "**" },
    { id: 24, value: "44" },
  ],
  [
    { id: 25, value: "12" },
    { id: 26, value: "50" },
    { id: 27, value: "05" },
    { id: 28, value: "99" },
    { id: 29, value: "05" },
    { id: 30, value: "04" },
  ],
  [
    { id: 31, value: "70" },
    { id: 32, value: "95" },
    { id: 33, value: "87" },
    { id: 34, value: "81" },
    { id: 35, value: "41" },
    { id: 36, value: "58" },
  ],
  [
    { id: 37, value: "40" },
    { id: 38, value: "66" },
    { id: 39, value: "44" },
    { id: 40, value: "52" },
    { id: 41, value: "05" },
    { id: 42, value: "62" },
  ],
  [
    { id: 43, value: "97" },
    { id: 44, value: "20" },
    { id: 45, value: "40" },
    { id: 46, value: "08" },
    { id: 47, value: "67" },
    { id: 48, value: "36" },
  ],
  [
    { id: 49, value: "01" },
    { id: 50, value: "05" },
    { id: 51, value: "46" },
    { id: 52, value: "94" },
    { id: 53, value: "27" },
    { id: 54, value: "92" },
  ],
  [
    { id: 55, value: "17" },
    { id: 56, value: "70" },
    { id: 57, value: "63" },
    { id: 58, value: "47" },
    { id: 59, value: "95" },
    { id: 60, value: "24" },
  ],
  [
    { id: 61, value: "13" },
    { id: 62, value: "98" },
    { id: 63, value: "01" },
    { id: 64, value: "78" },
    { id: 65, value: "53" },
    { id: 66, value: "19" },
  ],
  [
    { id: 67, value: "44" },
    { id: 68, value: "01" },
    { id: 69, value: "12" },
    { id: 70, value: "16" },
    { id: 71, value: "34" },
    { id: 72, value: "66" },
  ],
  [
    { id: 73, value: "**" },
    { id: 74, value: "37" },
    { id: 75, value: "84" },
    { id: 76, value: "30" },
    { id: 77, value: "57" },
    { id: 78, value: "46" },
  ],
  [
    { id: 79, value: "67" },
    { id: 80, value: "62" },
    { id: 81, value: "39" },
    { id: 82, value: "04" },
    { id: 83, value: "32" },
    { id: 84, value: "88" },
  ],
  [
    { id: 85, value: "91" },
    { id: 86, value: "78" },
    { id: 87, value: "51" },
    { id: 88, value: "04" },
    { id: 89, value: "06" },
    { id: 90, value: "35" },
  ],
  [
    { id: 91, value: "41" },
    { id: 92, value: "03" },
    { id: 93, value: "73" },
    { id: 94, value: "39" },
    { id: 95, value: "39" },
    { id: 96, value: "10" },
  ],
  [
    { id: 97, value: "90" },
    { id: 98, value: "71" },
    { id: 99, value: "69" },
    { id: 100, value: "31" },
    { id: 101, value: "65" },
    { id: 102, value: "13" },
  ],
  [
    { id: 103, value: "78" },
    { id: 104, value: "19" },
    { id: 105, value: "39" },
    { id: 106, value: "29" },
    { id: 107, value: "02" },
    { id: 108, value: "09" },
  ],
  [
    { id: 109, value: "82" },
    { id: 110, value: "40" },
    { id: 111, value: "17" },
    { id: 112, value: "43" },
    { id: 113, value: "89" },
    { id: 114, value: "91" },
  ],
  [
    { id: 115, value: "35" },
    { id: 116, value: "43" },
    { id: 117, value: "46" },
    { id: 118, value: "42" },
    { id: 119, value: "84" },
    { id: 120, value: "47" },
  ],
  [
    { id: 121, value: "40" },
    { id: 122, value: "25" },
    { id: 123, value: "86" },
    { id: 124, value: "57" },
    { id: 125, value: "43" },
    { id: 126, value: "57" },
  ],
  [
    { id: 127, value: "19" },
    { id: 128, value: "89" },
    { id: 129, value: "35" },
    { id: 130, value: "32" },
    { id: 131, value: "76" },
    { id: 132, value: "59" },
  ],
  [
    { id: 133, value: "85" },
    { id: 134, value: "63" },
    { id: 135, value: "43" },
    { id: 136, value: "30" },
    { id: 137, value: "15" },
    { id: 138, value: "79" },
  ],
  [
    { id: 139, value: "67" },
    { id: 140, value: "95" },
    { id: 141, value: "15" },
    { id: 142, value: "72" },
    { id: 143, value: "89" },
    { id: 144, value: "48" },
  ],
  [
    { id: 145, value: "01" },
    { id: 146, value: "00" },
    { id: 147, value: "22" },
    { id: 148, value: "88" },
    { id: 149, value: "13" },
    { id: 150, value: "42" },
  ],
  [
    { id: 151, value: "00" },
    { id: 152, value: "86" },
    { id: 153, value: "31" },
    { id: 154, value: "33" },
    { id: 155, value: "95" },
    { id: 156, value: "23" },
  ],
  [
    { id: 157, value: "25" },
    { id: 158, value: "68" },
    { id: 159, value: "14" },
    { id: 160, value: "28" },
    { id: 161, value: "88" },
    { id: 162, value: "96" },
  ],
  [
    { id: 163, value: "62" },
    { id: 164, value: "62" },
    { id: 165, value: "72" },
    { id: 166, value: "76" },
    { id: 167, value: "54" },
    { id: 168, value: "68" },
  ],
  [
    { id: 169, value: "48" },
    { id: 170, value: "43" },
    { id: 171, value: "36" },
    { id: 172, value: "40" },
    { id: 173, value: "72" },
    { id: 174, value: "08" },
  ],
  [
    { id: 175, value: "88" },
    { id: 176, value: "06" },
    { id: 177, value: "11" },
    { id: 178, value: "41" },
    { id: 179, value: "90" },
    { id: 180, value: "55" },
  ],
  [
    { id: 181, value: "39" },
    { id: 182, value: "12" },
    { id: 183, value: "70" },
    { id: 184, value: "39" },
    { id: 185, value: "73" },
    { id: 186, value: "73" },
  ],
  [
    { id: 187, value: "77" },
    { id: 188, value: "09" },
    { id: 189, value: "66" },
    { id: 190, value: "13" },
    { id: 191, value: "21" },
    { id: 192, value: "07" },
  ],
  [
    { id: 193, value: "84" },
    { id: 194, value: "20" },
    { id: 195, value: "89" },
    { id: 196, value: "**" },
    { id: 197, value: "41" },
    { id: 198, value: "70" },
  ],
  [
    { id: 199, value: "38" },
    { id: 200, value: "77" },
    { id: 201, value: "84" },
    { id: 202, value: "03" },
    { id: 203, value: "28" },
    { id: 204, value: "86" },
  ],
  [
    { id: 205, value: "04" },
    { id: 206, value: "91" },
    { id: 207, value: "15" },
    { id: 208, value: "52" },
    { id: 209, value: "68" },
    { id: 210, value: "45" },
  ],
  [
    { id: 211, value: "29" },
    { id: 212, value: "10" },
    { id: 213, value: "48" },
    { id: 214, value: "88" },
    { id: 215, value: "51" },
    { id: 216, value: "**" },
  ],
  [
    { id: 217, value: "61" },
    { id: 218, value: "74" },
    { id: 219, value: "49" },
    { id: 220, value: "87" },
    { id: 221, value: "49" },
    { id: 222, value: "71" },
  ],
  [
    { id: 223, value: "64" },
    { id: 224, value: "65" },
    { id: 225, value: "57" },
    { id: 226, value: "11" },
    { id: 227, value: "28" },
    { id: 228, value: "71" },
  ],
  [
    { id: 229, value: "55" },
    { id: 230, value: "42" },
    { id: 231, value: "23" },
    { id: 232, value: "74" },
    { id: 233, value: "42" },
    { id: 234, value: "79" },
  ],
  [
    { id: 235, value: "66" },
    { id: 236, value: "23" },
    { id: 237, value: "19" },
    { id: 238, value: "80" },
    { id: 239, value: "34" },
    { id: 240, value: "05" },
  ],
  [
    { id: 241, value: "43" },
    { id: 242, value: "61" },
    { id: 243, value: "61" },
    { id: 244, value: "46" },
    { id: 245, value: "88" },
    { id: 246, value: "75" },
  ],
  [
    { id: 247, value: "79" },
    { id: 248, value: "35" },
    { id: 249, value: "29" },
    { id: 250, value: "21" },
    { id: 251, value: "04" },
    { id: 252, value: "31" },
  ],
  [
    { id: 253, value: "49" },
    { id: 254, value: "62" },
    { id: 255, value: "02" },
    { id: 256, value: "60" },
    { id: 257, value: "90" },
    { id: 258, value: "09" },
  ],
  [
    { id: 259, value: "**" },
    { id: 260, value: "**" },
    { id: 261, value: "**" },
    { id: 262, value: "**" },
    { id: 263, value: "**" },
    { id: 264, value: "**" },
  ],
  [
    { id: 265, value: "**" },
    { id: 266, value: "**" },
    { id: 267, value: "07" },
    { id: 268, value: "16" },
    { id: 269, value: "73" },
    { id: 270, value: "48" },
  ],
  [
    { id: 271, value: "73" },
    { id: 272, value: "22" },
    { id: 273, value: "45" },
    { id: 274, value: "60" },
    { id: 275, value: "89" },
    { id: 276, value: "77" },
  ],
  [
    { id: 277, value: "86" },
    { id: 278, value: "92" },
    { id: 279, value: "59" },
    { id: 280, value: "94" },
    { id: 281, value: "93" },
    { id: 282, value: "35" },
  ],
  [
    { id: 283, value: "92" },
    { id: 284, value: "62" },
    { id: 285, value: "89" },
    { id: 286, value: "82" },
    { id: 287, value: "18" },
    { id: 288, value: "32" },
  ],
  [
    { id: 289, value: "53" },
    { id: 290, value: "12" },
    { id: 291, value: "03" },
    { id: 292, value: "41" },
    { id: 293, value: "54" },
    { id: 294, value: "04" },
  ],
  [
    { id: 295, value: "53" },
    { id: 296, value: "01" },
    { id: 297, value: "68" },
    { id: 298, value: "01" },
    { id: 299, value: "66" },
    { id: 300, value: "22" },
  ],
  [
    { id: 301, value: "31" },
    { id: 302, value: "55" },
    { id: 303, value: "93" },
    { id: 304, value: "84" },
    { id: 305, value: "27" },
    { id: 306, value: "87" },
  ],
  [
    { id: 307, value: "58" },
    { id: 308, value: "85" },
    { id: 309, value: "82" },
    { id: 310, value: "27" },
    { id: 311, value: "55" },
    { id: 312, value: "46" },
  ],
  [
    { id: 313, value: "28" },
    { id: 314, value: "69" },
    { id: 315, value: "98" },
    { id: 316, value: "19" },
    { id: 317, value: "46" },
    { id: 318, value: "68" },
  ],
  [
    { id: 319, value: "81" },
    { id: 320, value: "03" },
    { id: 321, value: "24" },
    { id: 322, value: "67" },
    { id: 323, value: "19" },
    { id: 324, value: "38" },
  ],
  [
    { id: 325, value: "26" },
    { id: 326, value: "72" },
    { id: 327, value: "08" },
    { id: 328, value: "07" },
    { id: 329, value: "88" },
    { id: 330, value: "56" },
  ],
  [
    { id: 331, value: "16" },
    { id: 332, value: "19" },
    { id: 333, value: "70" },
    { id: 334, value: "66" },
    { id: 335, value: "54" },
    { id: 336, value: "53" },
  ],
  [
    { id: 337, value: "70" },
    { id: 338, value: "26" },
    { id: 339, value: "03" },
    { id: 340, value: "67" },
    { id: 341, value: "54" },
    { id: 342, value: "53" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "08" },
    { id: 345, value: "54" },
    { id: 346, value: "74" },
    { id: 347, value: "43" },
    { id: 348, value: "88" },
    { id: 349, value: "73" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "53" },
    { id: 352, value: "28" },
    { id: 353, value: "24" },
    { id: 354, value: "35" },
    { id: 355, value: "04" },
    { id: 356, value: "09" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "02" },
    { id: 359, value: "08" },
    { id: 360, value: "55" },
    { id: 361, value: "29" },
    { id: 362, value: "98" },
    { id: 363, value: "45" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "89" },
    { id: 366, value: "37" },
    { id: 367, value: "82" },
    { id: 368, value: "36" },
    { id: 369, value: "62" },
    { id: 370, value: "52" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "05" },
    { id: 373, value: "63" },
    { id: 374, value: "65" },
    { id: 375, value: "73" },
    { id: 376, value: "94" },
    { id: 377, value: "03" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "95" },
    { id: 380, value: "70" },
    { id: 381, value: "67" },
    { id: 382, value: "09" },
    { id: 383, value: "26" },
    { id: 384, value: "89" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "78" },
    { id: 387, value: "78" },
    { id: 388, value: "93" },
    { id: 389, value: "69" },
    { id: 390, value: "73" },
    { id: 391, value: "31" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "77" },
    { id: 394, value: "51" },
    { id: 395, value: "82" },
    { id: 396, value: "89" },
    { id: 397, value: "55" },
    { id: 398, value: "85" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "02" },
    { id: 401, value: "90" },
    { id: 402, value: "46" },
    { id: 403, value: "21" },
    { id: 404, value: "23" },
    { id: 405, value: "88" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "37" },
    { id: 408, value: "51" },
    { id: 409, value: "33" },
    { id: 410, value: "37" },
    { id: 411, value: "23" },
    { id: 412, value: "84" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "09" },
    { id: 415, value: "65" },
    { id: 416, value: "61" },
    { id: 417, value: "25" },
    { id: 418, value: "64" },
    { id: 419, value: "45" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "80" },
    { id: 422, value: "93" },
    { id: 423, value: "76" },
    { id: 424, value: "87" },
    { id: 425, value: "07" },
    { id: 426, value: "62" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "05" },
    { id: 429, value: "28" },
    { id: 430, value: "44" },
    { id: 431, value: "27" },
    { id: 432, value: "05" },
    { id: 433, value: "94" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "45" },
    { id: 436, value: "05" },
    { id: 437, value: "47" },
    { id: 438, value: "51" },
    { id: 439, value: "05" },
    { id: 440, value: "96" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "64" },
    { id: 443, value: "57" },
    { id: 444, value: "59" },
    { id: 445, value: "56" },
    { id: 446, value: "86" },
    { id: 447, value: "44" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "79" },
    { id: 450, value: "06" },
    { id: 451, value: "74" },
    { id: 452, value: "82" },
    { id: 453, value: "12" },
    { id: 454, value: "32" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "29" },
    { id: 457, value: "56" },
    { id: 458, value: "50" },
    { id: 459, value: "95" },
    { id: 460, value: "81" },
    { id: 461, value: "77" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "18" },
    { id: 464, value: "17" },
    { id: 465, value: "92" },
    { id: 466, value: "06" },
    { id: 467, value: "87" },
    { id: 468, value: "13" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "87" },
    { id: 471, value: "06" },
    { id: 472, value: "69" },
    { id: 473, value: "86" },
    { id: 474, value: "64" },
    { id: 475, value: "71" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "60" },
    { id: 478, value: "37" },
    { id: 479, value: "05" },
    { id: 480, value: "03" },
    { id: 481, value: "55" },
    { id: 482, value: "02" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "22" },
    { id: 485, value: "13" },
    { id: 486, value: "29" },
    { id: 487, value: "01" },
    { id: 488, value: "59" },
    { id: 489, value: "56" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "70" },
    { id: 492, value: "09" },
    { id: 493, value: "87" },
    { id: 494, value: "40" },
    { id: 495, value: "18" },
    { id: 496, value: "10" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "19" },
    { id: 499, value: "98" },
    { id: 500, value: "42" },
    { id: 501, value: "09" },
    { id: 502, value: "18" },
    { id: 503, value: "68" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "25" },
    { id: 506, value: "24" },
    { id: 507, value: "46" },
    { id: 508, value: "57" },
    { id: 509, value: "17" },
    { id: 510, value: "85" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "81" },
    { id: 513, value: "24" },
    { id: 514, value: "75" },
    { id: 515, value: "58" },
    { id: 516, value: "10" },
    { id: 517, value: "56" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "70" },
    { id: 520, value: "52" },
    { id: 521, value: "91" },
    { id: 522, value: "38" },
    { id: 523, value: "52" },
    { id: 524, value: "42" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "01" },
    { id: 527, value: "69" },
    { id: 528, value: "04" },
    { id: 529, value: "71" },
    { id: 530, value: "21" },
    { id: 531, value: "80" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "92" },
    { id: 534, value: "68" },
    { id: 535, value: "93" },
    { id: 536, value: "11" },
    { id: 537, value: "31" },
    { id: 538, value: "08" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "59" },
    { id: 541, value: "11" },
    { id: 542, value: "08" },
    { id: 543, value: "18" },
    { id: 544, value: "98" },
    { id: 545, value: "**" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "93" },
    { id: 548, value: "25" },
    { id: 549, value: "03" },
    { id: 550, value: "35" },
    { id: 551, value: "17" },
    { id: 552, value: "74" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "66" },
    { id: 555, value: "50" },
    { id: 556, value: "**" },
    { id: 557, value: "21" },
    { id: 558, value: "87" },
    { id: 559, value: "79" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "64" },
    { id: 562, value: "74" },
    { id: 563, value: "20" },
    { id: 564, value: "60" },
    { id: 565, value: "45" },
    { id: 566, value: "**" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "10" },
    { id: 569, value: "28" },
    { id: 570, value: "18" },
    { id: 571, value: "71" },
    { id: 572, value: "86" },
    { id: 573, value: "19" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "49" },
    { id: 576, value: "07" },
    { id: 577, value: "71" },
    { id: 578, value: "96" },
    { id: 579, value: "64" },
    { id: 580, value: "37" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "67" },
    { id: 583, value: "44" },
    { id: 584, value: "32" },
    { id: 585, value: "40" },
    { id: 586, value: "43" },
    { id: 587, value: "44" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "24" },
    { id: 590, value: "27" },
    { id: 591, value: "49" },
    { id: 592, value: "09" },
    { id: 593, value: "22" },
    { id: 594, value: "32" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "25" },
    { id: 597, value: "89" },
    { id: 598, value: "38" },
    { id: 599, value: "69" },
    { id: 600, value: "11" },
    { id: 601, value: "05" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "03" },
    { id: 604, value: "43" },
    { id: 605, value: "54" },
    { id: 606, value: "56" },
    { id: 607, value: "32" },
    { id: 608, value: "**" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "72" },
    { id: 611, value: "68" },
    { id: 612, value: "25" },
    { id: 613, value: "42" },
    { id: 614, value: "93" },
    { id: 615, value: "59" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "50" },
    { id: 618, value: "92" },
    { id: 619, value: "80" },
    { id: 620, value: "67" },
    { id: 621, value: "43" },
    { id: 622, value: "16" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "28" },
    { id: 625, value: "65" },
    { id: 626, value: "37" },
    { id: 627, value: "22" },
    { id: 628, value: "34" },
    { id: 629, value: "84" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "60" },
    { id: 632, value: "55" },
    { id: 633, value: "53" },
    { id: 634, value: "40" },
    { id: 635, value: "04" },
    { id: 636, value: "97" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "80" },
    { id: 639, value: "70" },
    { id: 640, value: "01" },
    { id: 641, value: "17" },
    { id: 642, value: "60" },
    { id: 643, value: "25" },
    { id: 644, value: "**" },
  ],
  [
    { id: 645, value: "60" },
    { id: 646, value: "13" },
    { id: 647, value: "69" },
    { id: 648, value: "63" },
    { id: 649, value: "56" },
    { id: 650, value: "88" },
    { id: 651, value: "**" },
  ],
  [
    { id: 652, value: "69" },
    { id: 653, value: "66" },
    { id: 654, value: "31" },
    { id: 655, value: "31" },
    { id: 656, value: "02" },
    { id: 657, value: "69" },
    { id: 658, value: "**" },
  ],
  [
    { id: 659, value: "20" },
    { id: 660, value: "30" },
    { id: 661, value: "08" },
    { id: 662, value: "38" },
    { id: 663, value: "57" },
    { id: 664, value: "40" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "46" },
    { id: 667, value: "93" },
    { id: 668, value: "97" },
    { id: 669, value: "97" },
    { id: 670, value: "17" },
    { id: 671, value: "75" },
    { id: 672, value: "**" },
  ],
  [
    { id: 673, value: "44" },
    { id: 674, value: "06" },
    { id: 675, value: "73" },
    { id: 676, value: "29" },
    { id: 677, value: "11" },
    { id: 678, value: "98" },
    { id: 679, value: "**" },
  ],
  [
    { id: 680, value: "39" },
    { id: 681, value: "52" },
    { id: 682, value: "98" },
    { id: 683, value: "63" },
    { id: 684, value: "51" },
    { id: 685, value: "24" },
    { id: 686, value: "**" },
  ],
  [
    { id: 687, value: "71" },
    { id: 688, value: "94" },
    { id: 689, value: "22" },
    { id: 690, value: "16" },
    { id: 691, value: "22" },
    { id: 692, value: "01" },
    { id: 693, value: "**" },
  ],
  [
    { id: 694, value: "66" },
    { id: 695, value: "77" },
    { id: 696, value: "08" },
    { id: 697, value: "94" },
    { id: 698, value: "93" },
    { id: 699, value: "21" },
    { id: 700, value: "**" },
  ],
  [
    { id: 701, value: "**" },
    { id: 702, value: "27" },
    { id: 703, value: "69" },
    { id: 704, value: "31" },
    { id: 705, value: "93" },
    { id: 706, value: "37" },
    { id: 707, value: "**" },
  ],
  [
    { id: 708, value: "30" },
    { id: 709, value: "38" },
    { id: 710, value: "00" },
    { id: 711, value: "66" },
    { id: 712, value: "73" },
    { id: 713, value: "60" },
    { id: 714, value: "**" },
  ],
  [
    { id: 715, value: "97" },
    { id: 716, value: "72" },
    { id: 717, value: "24" },
    { id: 718, value: "70" },
    { id: 719, value: "10" },
    { id: 720, value: "26" },
    { id: 721, value: "**" },
  ],
  [
    { id: 722, value: "33" },
    { id: 723, value: "45" },
    { id: 724, value: "41" },
    { id: 725, value: "13" },
    { id: 726, value: "53" },
    { id: 727, value: "94" },
    { id: 728, value: "**" },
  ],
  [
    { id: 729, value: "19" },
    { id: 730, value: "06" },
    { id: 731, value: "39" },
    { id: 732, value: "02" },
    { id: 733, value: "47" },
    { id: 734, value: "47" },
    { id: 735, value: "**" },
  ],
  [
    { id: 736, value: "69" },
    { id: 737, value: "11" },
    { id: 738, value: "**" },
    { id: 739, value: "25" },
    { id: 740, value: "21" },
    { id: 741, value: "95" },
    { id: 742, value: "**" },
  ],
  [
    { id: 743, value: "37" },
    { id: 744, value: "06" },
    { id: 745, value: "77" },
    { id: 746, value: "16" },
    { id: 747, value: "92" },
    { id: 748, value: "77" },
    { id: 749, value: "**" },
  ],
  [
    { id: 750, value: "77" },
    { id: 751, value: "43" },
    { id: 752, value: "64" },
    { id: 753, value: "78" },
    { id: 754, value: "40" },
    { id: 755, value: "**" },
    { id: 756, value: "**" },
  ],
];

// rajdhaninight

export const RajdhaniNight = [
  [
    { id: 1, value: "22" },
    { id: 2, value: "86" },
    { id: 3, value: "85" },
    { id: 4, value: "18" },
    { id: 5, value: "22" },
  ],
  [
    { id: 6, value: "47" },
    { id: 7, value: "41" },
    { id: 8, value: "17" },
    { id: 9, value: "09" },
    { id: 10, value: "25" },
  ],
  [
    { id: 11, value: "90" },
    { id: 12, value: "12" },
    { id: 13, value: "01" },
    { id: 14, value: "21" },
    { id: 15, value: "52" },
  ],
  [
    { id: 16, value: "33" },
    { id: 17, value: "64" },
    { id: 18, value: "31" },
    { id: 19, value: "68" },
    { id: 20, value: "**" },
  ],
  [
    { id: 21, value: "38" },
    { id: 22, value: "95" },
    { id: 23, value: "24" },
    { id: 24, value: "90" },
    { id: 25, value: "60" },
  ],
  [
    { id: 26, value: "77" },
    { id: 27, value: "22" },
    { id: 28, value: "83" },
    { id: 29, value: "28" },
    { id: 30, value: "72" },
  ],
  [
    { id: 31, value: "03" },
    { id: 32, value: "60" },
    { id: 33, value: "36" },
    { id: 34, value: "07" },
    { id: 35, value: "45" },
  ],
  [
    { id: 36, value: "60" },
    { id: 37, value: "11" },
    { id: 38, value: "60" },
    { id: 39, value: "91" },
    { id: 40, value: "77" },
  ],
  [
    { id: 41, value: "38" },
    { id: 42, value: "84" },
    { id: 43, value: "36" },
    { id: 44, value: "79" },
    { id: 45, value: "91" },
  ],
  [
    { id: 46, value: "79" },
    { id: 47, value: "23" },
    { id: 48, value: "86" },
    { id: 49, value: "74" },
    { id: 50, value: "86" },
  ],
  [
    { id: 51, value: "68" },
    { id: 52, value: "25" },
    { id: 53, value: "85" },
    { id: 54, value: "79" },
    { id: 55, value: "17" },
  ],
  [
    { id: 56, value: "76" },
    { id: 57, value: "13" },
    { id: 58, value: "34" },
    { id: 59, value: "56" },
    { id: 60, value: "51" },
  ],
  [
    { id: 61, value: "**" },
    { id: 62, value: "18" },
    { id: 63, value: "31" },
    { id: 64, value: "83" },
    { id: 65, value: "55" },
  ],
  [
    { id: 66, value: "48" },
    { id: 67, value: "14" },
    { id: 68, value: "91" },
    { id: 69, value: "77" },
    { id: 70, value: "09" },
  ],
  [
    { id: 71, value: "43" },
    { id: 72, value: "41" },
    { id: 73, value: "54" },
    { id: 74, value: "02" },
    { id: 75, value: "63" },
  ],
  [
    { id: 76, value: "16" },
    { id: 77, value: "40" },
    { id: 78, value: "32" },
    { id: 79, value: "80" },
    { id: 80, value: "13" },
  ],
  [
    { id: 81, value: "28" },
    { id: 82, value: "18" },
    { id: 83, value: "29" },
    { id: 84, value: "48" },
    { id: 85, value: "05" },
  ],
  [
    { id: 86, value: "21" },
    { id: 87, value: "49" },
    { id: 88, value: "14" },
    { id: 89, value: "56" },
    { id: 90, value: "52" },
  ],
  [
    { id: 91, value: "05" },
    { id: 92, value: "46" },
    { id: 93, value: "96" },
    { id: 94, value: "18" },
    { id: 95, value: "64" },
  ],
  [
    { id: 96, value: "42" },
    { id: 97, value: "50" },
    { id: 98, value: "80" },
    { id: 99, value: "08" },
    { id: 100, value: "20" },
  ],
  [
    { id: 101, value: "40" },
    { id: 102, value: "21" },
    { id: 103, value: "25" },
    { id: 104, value: "27" },
    { id: 105, value: "63" },
  ],
  [
    { id: 106, value: "08" },
    { id: 107, value: "51" },
    { id: 108, value: "87" },
    { id: 109, value: "57" },
    { id: 110, value: "81" },
  ],
  [
    { id: 111, value: "72" },
    { id: 112, value: "20" },
    { id: 113, value: "53" },
    { id: 114, value: "41" },
    { id: 115, value: "55" },
  ],
  [
    { id: 116, value: "41" },
    { id: 117, value: "58" },
    { id: 118, value: "97" },
    { id: 119, value: "66" },
    { id: 120, value: "47" },
  ],
  [
    { id: 121, value: "99" },
    { id: 122, value: "85" },
    { id: 123, value: "01" },
    { id: 124, value: "08" },
    { id: 125, value: "39" },
  ],
  [
    { id: 126, value: "25" },
    { id: 127, value: "93" },
    { id: 128, value: "57" },
    { id: 129, value: "13" },
    { id: 130, value: "23" },
  ],
  [
    { id: 131, value: "37" },
    { id: 132, value: "67" },
    { id: 133, value: "11" },
    { id: 134, value: "61" },
    { id: 135, value: "78" },
  ],
  [
    { id: 136, value: "12" },
    { id: 137, value: "98" },
    { id: 138, value: "77" },
    { id: 139, value: "23" },
    { id: 140, value: "33" },
  ],
  [
    { id: 141, value: "77" },
    { id: 142, value: "38" },
    { id: 143, value: "49" },
    { id: 144, value: "27" },
    { id: 145, value: "17" },
  ],
  [
    { id: 146, value: "81" },
    { id: 147, value: "82" },
    { id: 148, value: "51" },
    { id: 149, value: "45" },
    { id: 150, value: "98" },
  ],
  [
    { id: 151, value: "39" },
    { id: 152, value: "34" },
    { id: 153, value: "58" },
    { id: 154, value: "12" },
    { id: 155, value: "31" },
  ],
  [
    { id: 156, value: "91" },
    { id: 157, value: "12" },
    { id: 158, value: "08" },
    { id: 159, value: "45" },
    { id: 160, value: "67" },
  ],
  [
    { id: 161, value: "67" },
    { id: 162, value: "27" },
    { id: 163, value: "03" },
    { id: 164, value: "**" },
    { id: 165, value: "16" },
  ],
  [
    { id: 166, value: "06" },
    { id: 167, value: "71" },
    { id: 168, value: "06" },
    { id: 169, value: "01" },
    { id: 170, value: "39" },
  ],
  [
    { id: 171, value: "82" },
    { id: 172, value: "53" },
    { id: 173, value: "80" },
    { id: 174, value: "33" },
    { id: 175, value: "75" },
  ],
  [
    { id: 176, value: "05" },
    { id: 177, value: "98" },
    { id: 178, value: "77" },
    { id: 179, value: "68" },
    { id: 180, value: "42" },
  ],
  [
    { id: 181, value: "83" },
    { id: 182, value: "84" },
    { id: 183, value: "07" },
    { id: 184, value: "48" },
    { id: 185, value: "04" },
  ],
  [
    { id: 186, value: "80" },
    { id: 187, value: "41" },
    { id: 188, value: "46" },
    { id: 189, value: "67" },
    { id: 190, value: "08" },
  ],
  [
    { id: 191, value: "79" },
    { id: 192, value: "57" },
    { id: 193, value: "90" },
    { id: 194, value: "00" },
    { id: 195, value: "49" },
  ],
  [
    { id: 196, value: "42" },
    { id: 197, value: "13" },
    { id: 198, value: "56" },
    { id: 199, value: "08" },
    { id: 200, value: "47" },
  ],
  [
    { id: 201, value: "39" },
    { id: 202, value: "70" },
    { id: 203, value: "84" },
    { id: 204, value: "10" },
    { id: 205, value: "67" },
  ],
  [
    { id: 206, value: "11" },
    { id: 207, value: "04" },
    { id: 208, value: "45" },
    { id: 209, value: "01" },
    { id: 210, value: "33" },
  ],
  [
    { id: 211, value: "43" },
    { id: 212, value: "42" },
    { id: 213, value: "21" },
    { id: 214, value: "29" },
    { id: 215, value: "18" },
  ],
  [
    { id: 216, value: "**" },
    { id: 217, value: "**" },
    { id: 218, value: "**" },
    { id: 219, value: "**" },
    { id: 220, value: "**" },
  ],
  [
    { id: 221, value: "**" },
    { id: 222, value: "**" },
    { id: 223, value: "11" },
    { id: 224, value: "95" },
    { id: 225, value: "94" },
  ],
  [
    { id: 226, value: "58" },
    { id: 227, value: "44" },
    { id: 228, value: "72" },
    { id: 229, value: "30" },
    { id: 230, value: "31" },
  ],
  [
    { id: 231, value: "99" },
    { id: 232, value: "02" },
    { id: 233, value: "79" },
    { id: 234, value: "27" },
    { id: 235, value: "60" },
  ],
  [
    { id: 236, value: "50" },
    { id: 237, value: "45" },
    { id: 238, value: "44" },
    { id: 239, value: "75" },
    { id: 240, value: "49" },
  ],
  [
    { id: 241, value: "50" },
    { id: 242, value: "22" },
    { id: 243, value: "16" },
    { id: 244, value: "82" },
    { id: 245, value: "36" },
  ],
  [
    { id: 246, value: "03" },
    { id: 247, value: "52" },
    { id: 248, value: "58" },
    { id: 249, value: "30" },
    { id: 250, value: "08" },
  ],
  [
    { id: 251, value: "52" },
    { id: 252, value: "31" },
    { id: 253, value: "89" },
    { id: 254, value: "77" },
    { id: 255, value: "76" },
  ],
  [
    { id: 256, value: "83" },
    { id: 257, value: "54" },
    { id: 258, value: "89" },
    { id: 259, value: "92" },
    { id: 260, value: "24" },
  ],
  [
    { id: 261, value: "22" },
    { id: 262, value: "40" },
    { id: 263, value: "60" },
    { id: 264, value: "13" },
    { id: 265, value: "54" },
  ],
  [
    { id: 266, value: "16" },
    { id: 267, value: "00" },
    { id: 268, value: "62" },
    { id: 269, value: "04" },
    { id: 270, value: "19" },
  ],
  [
    { id: 271, value: "58" },
    { id: 272, value: "32" },
    { id: 273, value: "53" },
    { id: 274, value: "68" },
    { id: 275, value: "27" },
  ],
  [
    { id: 276, value: "23" },
    { id: 277, value: "11" },
    { id: 278, value: "16" },
    { id: 279, value: "98" },
    { id: 280, value: "34" },
  ],
  [
    { id: 281, value: "72" },
    { id: 282, value: "38" },
    { id: 283, value: "24" },
    { id: 284, value: "90" },
    { id: 285, value: "34" },
    { id: 286, value: "**" },
    { id: 287, value: "**" },
  ],
  [
    { id: 288, value: "47" },
    { id: 289, value: "17" },
    { id: 290, value: "15" },
    { id: 291, value: "19" },
    { id: 292, value: "57" },
    { id: 293, value: "**" },
    { id: 294, value: "**" },
  ],
  [
    { id: 295, value: "55" },
    { id: 296, value: "79" },
    { id: 297, value: "15" },
    { id: 298, value: "43" },
    { id: 299, value: "08" },
    { id: 300, value: "**" },
    { id: 301, value: "**" },
  ],
  [
    { id: 302, value: "57" },
    { id: 303, value: "93" },
    { id: 304, value: "15" },
    { id: 305, value: "27" },
    { id: 306, value: "64" },
    { id: 307, value: "**" },
    { id: 308, value: "**" },
  ],
  [
    { id: 309, value: "76" },
    { id: 310, value: "70" },
    { id: 311, value: "74" },
    { id: 312, value: "87" },
    { id: 313, value: "45" },
    { id: 314, value: "**" },
    { id: 315, value: "**" },
  ],
  [
    { id: 316, value: "58" },
    { id: 317, value: "85" },
    { id: 318, value: "06" },
    { id: 319, value: "04" },
    { id: 320, value: "97" },
    { id: 321, value: "**" },
    { id: 322, value: "**" },
  ],
  [
    { id: 323, value: "79" },
    { id: 324, value: "11" },
    { id: 325, value: "21" },
    { id: 326, value: "76" },
    { id: 327, value: "00" },
    { id: 328, value: "**" },
    { id: 329, value: "**" },
  ],
  [
    { id: 330, value: "52" },
    { id: 331, value: "48" },
    { id: 332, value: "25" },
    { id: 333, value: "41" },
    { id: 334, value: "70" },
    { id: 335, value: "**" },
    { id: 336, value: "**" },
  ],
  [
    { id: 337, value: "28" },
    { id: 338, value: "44" },
    { id: 339, value: "55" },
    { id: 340, value: "96" },
    { id: 341, value: "94" },
    { id: 342, value: "**" },
    { id: 343, value: "**" },
  ],
  [
    { id: 344, value: "57" },
    { id: 345, value: "36" },
    { id: 346, value: "21" },
    { id: 347, value: "28" },
    { id: 348, value: "17" },
    { id: 349, value: "**" },
    { id: 350, value: "**" },
  ],
  [
    { id: 351, value: "40" },
    { id: 352, value: "70" },
    { id: 353, value: "02" },
    { id: 354, value: "68" },
    { id: 355, value: "53" },
    { id: 356, value: "**" },
    { id: 357, value: "**" },
  ],
  [
    { id: 358, value: "27" },
    { id: 359, value: "62" },
    { id: 360, value: "81" },
    { id: 361, value: "17" },
    { id: 362, value: "83" },
    { id: 363, value: "**" },
    { id: 364, value: "**" },
  ],
  [
    { id: 365, value: "72" },
    { id: 366, value: "71" },
    { id: 367, value: "82" },
    { id: 368, value: "39" },
    { id: 369, value: "46" },
    { id: 370, value: "**" },
    { id: 371, value: "**" },
  ],
  [
    { id: 372, value: "54" },
    { id: 373, value: "86" },
    { id: 374, value: "77" },
    { id: 375, value: "74" },
    { id: 376, value: "44" },
    { id: 377, value: "**" },
    { id: 378, value: "**" },
  ],
  [
    { id: 379, value: "37" },
    { id: 380, value: "62" },
    { id: 381, value: "38" },
    { id: 382, value: "22" },
    { id: 383, value: "13" },
    { id: 384, value: "**" },
    { id: 385, value: "**" },
  ],
  [
    { id: 386, value: "91" },
    { id: 387, value: "51" },
    { id: 388, value: "34" },
    { id: 389, value: "48" },
    { id: 390, value: "10" },
    { id: 391, value: "**" },
    { id: 392, value: "**" },
  ],
  [
    { id: 393, value: "48" },
    { id: 394, value: "84" },
    { id: 395, value: "98" },
    { id: 396, value: "35" },
    { id: 397, value: "71" },
    { id: 398, value: "**" },
    { id: 399, value: "**" },
  ],
  [
    { id: 400, value: "04" },
    { id: 401, value: "29" },
    { id: 402, value: "63" },
    { id: 403, value: "96" },
    { id: 404, value: "03" },
    { id: 405, value: "**" },
    { id: 406, value: "**" },
  ],
  [
    { id: 407, value: "08" },
    { id: 408, value: "74" },
    { id: 409, value: "82" },
    { id: 410, value: "40" },
    { id: 411, value: "37" },
    { id: 412, value: "**" },
    { id: 413, value: "**" },
  ],
  [
    { id: 414, value: "76" },
    { id: 415, value: "14" },
    { id: 416, value: "10" },
    { id: 417, value: "13" },
    { id: 418, value: "21" },
    { id: 419, value: "**" },
    { id: 420, value: "**" },
  ],
  [
    { id: 421, value: "89" },
    { id: 422, value: "87" },
    { id: 423, value: "16" },
    { id: 424, value: "47" },
    { id: 425, value: "46" },
    { id: 426, value: "**" },
    { id: 427, value: "**" },
  ],
  [
    { id: 428, value: "07" },
    { id: 429, value: "10" },
    { id: 430, value: "52" },
    { id: 431, value: "60" },
    { id: 432, value: "13" },
    { id: 433, value: "**" },
    { id: 434, value: "**" },
  ],
  [
    { id: 435, value: "41" },
    { id: 436, value: "45" },
    { id: 437, value: "18" },
    { id: 438, value: "29" },
    { id: 439, value: "04" },
    { id: 440, value: "**" },
    { id: 441, value: "**" },
  ],
  [
    { id: 442, value: "98" },
    { id: 443, value: "43" },
    { id: 444, value: "25" },
    { id: 445, value: "10" },
    { id: 446, value: "87" },
    { id: 447, value: "**" },
    { id: 448, value: "**" },
  ],
  [
    { id: 449, value: "73" },
    { id: 450, value: "59" },
    { id: 451, value: "19" },
    { id: 452, value: "46" },
    { id: 453, value: "86" },
    { id: 454, value: "**" },
    { id: 455, value: "**" },
  ],
  [
    { id: 456, value: "28" },
    { id: 457, value: "83" },
    { id: 458, value: "76" },
    { id: 459, value: "23" },
    { id: 460, value: "71" },
    { id: 461, value: "**" },
    { id: 462, value: "**" },
  ],
  [
    { id: 463, value: "77" },
    { id: 464, value: "40" },
    { id: 465, value: "16" },
    { id: 466, value: "83" },
    { id: 467, value: "00" },
    { id: 468, value: "**" },
    { id: 469, value: "**" },
  ],
  [
    { id: 470, value: "48" },
    { id: 471, value: "31" },
    { id: 472, value: "34" },
    { id: 473, value: "41" },
    { id: 474, value: "14" },
    { id: 475, value: "**" },
    { id: 476, value: "**" },
  ],
  [
    { id: 477, value: "20" },
    { id: 478, value: "04" },
    { id: 479, value: "09" },
    { id: 480, value: "16" },
    { id: 481, value: "45" },
    { id: 482, value: "**" },
    { id: 483, value: "**" },
  ],
  [
    { id: 484, value: "60" },
    { id: 485, value: "55" },
    { id: 486, value: "73" },
    { id: 487, value: "58" },
    { id: 488, value: "**" },
    { id: 489, value: "**" },
    { id: 490, value: "**" },
  ],
  [
    { id: 491, value: "92" },
    { id: 492, value: "13" },
    { id: 493, value: "64" },
    { id: 494, value: "15" },
    { id: 495, value: "07" },
    { id: 496, value: "**" },
    { id: 497, value: "**" },
  ],
  [
    { id: 498, value: "89" },
    { id: 499, value: "50" },
    { id: 500, value: "12" },
    { id: 501, value: "74" },
    { id: 502, value: "91" },
    { id: 503, value: "**" },
    { id: 504, value: "**" },
  ],
  [
    { id: 505, value: "65" },
    { id: 506, value: "20" },
    { id: 507, value: "69" },
    { id: 508, value: "20" },
    { id: 509, value: "65" },
    { id: 510, value: "**" },
    { id: 511, value: "**" },
  ],
  [
    { id: 512, value: "26" },
    { id: 513, value: "59" },
    { id: 514, value: "02" },
    { id: 515, value: "25" },
    { id: 516, value: "07" },
    { id: 517, value: "**" },
    { id: 518, value: "**" },
  ],
  [
    { id: 519, value: "51" },
    { id: 520, value: "47" },
    { id: 521, value: "76" },
    { id: 522, value: "98" },
    { id: 523, value: "20" },
    { id: 524, value: "**" },
    { id: 525, value: "**" },
  ],
  [
    { id: 526, value: "50" },
    { id: 527, value: "58" },
    { id: 528, value: "42" },
    { id: 529, value: "81" },
    { id: 530, value: "52" },
    { id: 531, value: "**" },
    { id: 532, value: "**" },
  ],
  [
    { id: 533, value: "57" },
    { id: 534, value: "83" },
    { id: 535, value: "62" },
    { id: 536, value: "05" },
    { id: 537, value: "39" },
    { id: 538, value: "**" },
    { id: 539, value: "**" },
  ],
  [
    { id: 540, value: "71" },
    { id: 541, value: "71" },
    { id: 542, value: "61" },
    { id: 543, value: "09" },
    { id: 544, value: "58" },
    { id: 545, value: "**" },
    { id: 546, value: "**" },
  ],
  [
    { id: 547, value: "38" },
    { id: 548, value: "20" },
    { id: 549, value: "64" },
    { id: 550, value: "54" },
    { id: 551, value: "85" },
    { id: 552, value: "**" },
    { id: 553, value: "**" },
  ],
  [
    { id: 554, value: "06" },
    { id: 555, value: "64" },
    { id: 556, value: "36" },
    { id: 557, value: "32" },
    { id: 558, value: "48" },
    { id: 559, value: "**" },
    { id: 560, value: "**" },
  ],
  [
    { id: 561, value: "04" },
    { id: 562, value: "63" },
    { id: 563, value: "52" },
    { id: 564, value: "00" },
    { id: 565, value: "32" },
    { id: 566, value: "**" },
    { id: 567, value: "**" },
  ],
  [
    { id: 568, value: "40" },
    { id: 569, value: "92" },
    { id: 570, value: "89" },
    { id: 571, value: "81" },
    { id: 572, value: "10" },
    { id: 573, value: "**" },
    { id: 574, value: "**" },
  ],
  [
    { id: 575, value: "29" },
    { id: 576, value: "05" },
    { id: 577, value: "03" },
    { id: 578, value: "87" },
    { id: 579, value: "43" },
    { id: 580, value: "**" },
    { id: 581, value: "**" },
  ],
  [
    { id: 582, value: "19" },
    { id: 583, value: "35" },
    { id: 584, value: "38" },
    { id: 585, value: "36" },
    { id: 586, value: "81" },
    { id: 587, value: "**" },
    { id: 588, value: "**" },
  ],
  [
    { id: 589, value: "20" },
    { id: 590, value: "00" },
    { id: 591, value: "17" },
    { id: 592, value: "57" },
    { id: 593, value: "45" },
    { id: 594, value: "**" },
    { id: 595, value: "**" },
  ],
  [
    { id: 596, value: "42" },
    { id: 597, value: "92" },
    { id: 598, value: "43" },
    { id: 599, value: "57" },
    { id: 600, value: "22" },
    { id: 601, value: "**" },
    { id: 602, value: "**" },
  ],
  [
    { id: 603, value: "37" },
    { id: 604, value: "86" },
    { id: 605, value: "27" },
    { id: 606, value: "80" },
    { id: 607, value: "85" },
    { id: 608, value: "**" },
    { id: 609, value: "**" },
  ],
  [
    { id: 610, value: "41" },
    { id: 611, value: "76" },
    { id: 612, value: "67" },
    { id: 613, value: "47" },
    { id: 614, value: "27" },
    { id: 615, value: "**" },
    { id: 616, value: "**" },
  ],
  [
    { id: 617, value: "63" },
    { id: 618, value: "75" },
    { id: 619, value: "71" },
    { id: 620, value: "05" },
    { id: 621, value: "64" },
    { id: 622, value: "**" },
    { id: 623, value: "**" },
  ],
  [
    { id: 624, value: "86" },
    { id: 625, value: "73" },
    { id: 626, value: "34" },
    { id: 627, value: "46" },
    { id: 628, value: "67" },
    { id: 629, value: "**" },
    { id: 630, value: "**" },
  ],
  [
    { id: 631, value: "33" },
    { id: 632, value: "09" },
    { id: 633, value: "08" },
    { id: 634, value: "84" },
    { id: 635, value: "62" },
    { id: 636, value: "**" },
    { id: 637, value: "**" },
  ],
  [
    { id: 638, value: "35" },
    { id: 639, value: "86" },
    { id: 640, value: "20" },
    { id: 641, value: "96" },
    { id: 642, value: "59" },
    { id: 643, value: "**" },
    { id: 644, value: "**" },
  ],
  [
    { id: 645, value: "**" },
    { id: 646, value: "30" },
    { id: 647, value: "23" },
    { id: 648, value: "83" },
    { id: 649, value: "52" },
    { id: 650, value: "**" },
    { id: 651, value: "**" },
  ],
  [
    { id: 652, value: "28" },
    { id: 653, value: "55" },
    { id: 654, value: "20" },
    { id: 655, value: "73" },
    { id: 656, value: "87" },
    { id: 657, value: "**" },
    { id: 658, value: "**" },
  ],
  [
    { id: 659, value: "82" },
    { id: 660, value: "93" },
    { id: 661, value: "22" },
    { id: 662, value: "34" },
    { id: 663, value: "30" },
    { id: 664, value: "**" },
    { id: 665, value: "**" },
  ],
  [
    { id: 666, value: "46" },
    { id: 667, value: "29" },
    { id: 668, value: "38" },
    { id: 669, value: "92" },
    { id: 670, value: "65" },
    { id: 671, value: "**" },
    { id: 672, value: "**" },
  ],
  [
    { id: 673, value: "76" },
    { id: 674, value: "39" },
    { id: 675, value: "48" },
    { id: 676, value: "53" },
    { id: 677, value: "09" },
    { id: 678, value: "**" },
    { id: 679, value: "**" },
  ],
  [
    { id: 680, value: "47" },
    { id: 681, value: "03" },
    { id: 682, value: "**" },
    { id: 683, value: "48" },
    { id: 684, value: "65" },
    { id: 685, value: "**" },
    { id: 686, value: "**" },
  ],
  [
    { id: 687, value: "16" },
    { id: 688, value: "56" },
    { id: 689, value: "05" },
    { id: 690, value: "43" },
    { id: 691, value: "09" },
    { id: 692, value: "**" },
    { id: 693, value: "**" },
  ],
  [
    { id: 694, value: "56" },
    { id: 695, value: "21" },
    { id: 696, value: "02" },
    { id: 697, value: "02" },
    { id: 698, value: "38" },
    { id: 699, value: "**" },
    { id: 700, value: "**" },
  ],
];

// MAIN BAZAR

export const MainBazar = [
  [
    { id: 1, value: "81" },
    { id: 2, value: "85" },
    { id: 3, value: "25" },
    { id: 4, value: "82" },
    { id: 5, value: "34" },
  ],
  [
    { id: 6, value: "85" },
    { id: 7, value: "21" },
    { id: 8, value: "02" },
    { id: 9, value: "90" },
    { id: 10, value: "23" },
  ],
  [
    { id: 11, value: "45" },
    { id: 12, value: "11" },
    { id: 13, value: "78" },
    { id: 14, value: "25" },
    { id: 15, value: "74" },
  ],
  [
    { id: 16, value: "89" },
    { id: 17, value: "47" },
    { id: 18, value: "04" },
    { id: 19, value: "16" },
    { id: 20, value: "**" },
  ],
  [
    { id: 21, value: "58" },
    { id: 22, value: "70" },
    { id: 23, value: "55" },
    { id: 24, value: "87" },
    { id: 25, value: "72" },
  ],
  [
    { id: 26, value: "28" },
    { id: 27, value: "99" },
    { id: 28, value: "72" },
    { id: 29, value: "01" },
    { id: 30, value: "65" },
  ],
  [
    { id: 31, value: "04" },
    { id: 32, value: "77" },
    { id: 33, value: "55" },
    { id: 34, value: "52" },
    { id: 35, value: "77" },
  ],
  [
    { id: 36, value: "70" },
    { id: 37, value: "96" },
    { id: 38, value: "54" },
    { id: 39, value: "94" },
    { id: 40, value: "14" },
  ],
  [
    { id: 41, value: "50" },
    { id: 42, value: "04" },
    { id: 43, value: "68" },
    { id: 44, value: "03" },
    { id: 45, value: "55" },
  ],
  [
    { id: 46, value: "31" },
    { id: 47, value: "88" },
    { id: 48, value: "20" },
    { id: 49, value: "11" },
    { id: 50, value: "82" },
  ],
  [
    { id: 51, value: "15" },
    { id: 52, value: "15" },
    { id: 53, value: "71" },
    { id: 54, value: "90" },
    { id: 55, value: "41" },
  ],
  [
    { id: 56, value: "98" },
    { id: 57, value: "42" },
    { id: 58, value: "63" },
    { id: 59, value: "71" },
    { id: 60, value: "02" },
  ],
  [
    { id: 61, value: "**" },
    { id: 62, value: "12" },
    { id: 63, value: "71" },
    { id: 64, value: "84" },
    { id: 65, value: "08" },
  ],
  [
    { id: 66, value: "67" },
    { id: 67, value: "54" },
    { id: 68, value: "71" },
    { id: 69, value: "03" },
    { id: 70, value: "22" },
  ],
  [
    { id: 71, value: "61" },
    { id: 72, value: "97" },
    { id: 73, value: "38" },
    { id: 74, value: "01" },
    { id: 75, value: "79" },
  ],
  [
    { id: 76, value: "63" },
    { id: 77, value: "90" },
    { id: 78, value: "85" },
    { id: 79, value: "64" },
    { id: 80, value: "58" },
  ],
  [
    { id: 81, value: "55" },
    { id: 82, value: "44" },
    { id: 83, value: "11" },
    { id: 84, value: "87" },
    { id: 85, value: "14" },
  ],
  [
    { id: 86, value: "11" },
    { id: 87, value: "66" },
    { id: 88, value: "40" },
    { id: 89, value: "44" },
    { id: 90, value: "40" },
  ],
  [
    { id: 91, value: "67" },
    { id: 92, value: "20" },
    { id: 93, value: "32" },
    { id: 94, value: "86" },
    { id: 95, value: "67" },
  ],
  [
    { id: 96, value: "03" },
    { id: 97, value: "98" },
    { id: 98, value: "80" },
    { id: 99, value: "20" },
    { id: 100, value: "29" },
  ],
  [
    { id: 101, value: "54" },
    { id: 102, value: "81" },
    { id: 103, value: "04" },
    { id: 104, value: "97" },
    { id: 105, value: "46" },
  ],
  [
    { id: 106, value: "39" },
    { id: 107, value: "36" },
    { id: 108, value: "58" },
    { id: 109, value: "32" },
    { id: 110, value: "74" },
  ],
  [
    { id: 111, value: "19" },
    { id: 112, value: "67" },
    { id: 113, value: "68" },
    { id: 114, value: "32" },
    { id: 115, value: "65" },
  ],
  [
    { id: 116, value: "46" },
    { id: 117, value: "25" },
    { id: 118, value: "91" },
    { id: 119, value: "51" },
    { id: 120, value: "22" },
  ],
  [
    { id: 121, value: "35" },
    { id: 122, value: "13" },
    { id: 123, value: "11" },
    { id: 124, value: "18" },
    { id: 125, value: "65" },
  ],
  [
    { id: 126, value: "48" },
    { id: 127, value: "93" },
    { id: 128, value: "52" },
    { id: 129, value: "97" },
    { id: 130, value: "97" },
  ],
  [
    { id: 131, value: "32" },
    { id: 132, value: "50" },
    { id: 133, value: "47" },
    { id: 134, value: "89" },
    { id: 135, value: "12" },
  ],
  [
    { id: 136, value: "09" },
    { id: 137, value: "96" },
    { id: 138, value: "25" },
    { id: 139, value: "13" },
    { id: 140, value: "81" },
  ],
  [
    { id: 141, value: "82" },
    { id: 142, value: "67" },
    { id: 143, value: "95" },
    { id: 144, value: "68" },
    { id: 145, value: "44" },
  ],
  [
    { id: 146, value: "40" },
    { id: 147, value: "45" },
    { id: 148, value: "40" },
    { id: 149, value: "82" },
    { id: 150, value: "13" },
  ],
  [
    { id: 151, value: "94" },
    { id: 152, value: "43" },
    { id: 153, value: "42" },
    { id: 154, value: "23" },
    { id: 155, value: "12" },
  ],
  [
    { id: 156, value: "14" },
    { id: 157, value: "30" },
    { id: 158, value: "06" },
    { id: 159, value: "35" },
    { id: 160, value: "52" },
  ],
  [
    { id: 161, value: "04" },
    { id: 162, value: "11" },
    { id: 163, value: "07" },
    { id: 164, value: "**" },
    { id: 165, value: "84" },
  ],
  [
    { id: 166, value: "91" },
    { id: 167, value: "57" },
    { id: 168, value: "81" },
    { id: 169, value: "30" },
    { id: 170, value: "58" },
  ],
  [
    { id: 171, value: "93" },
    { id: 172, value: "72" },
    { id: 173, value: "60" },
    { id: 174, value: "59" },
    { id: 175, value: "06" },
  ],
  [
    { id: 176, value: "56" },
    { id: 177, value: "11" },
    { id: 178, value: "13" },
    { id: 179, value: "09" },
    { id: 180, value: "20" },
  ],
  [
    { id: 181, value: "88" },
    { id: 182, value: "58" },
    { id: 183, value: "77" },
    { id: 184, value: "23" },
    { id: 185, value: "13" },
  ],
  [
    { id: 186, value: "40" },
    { id: 187, value: "26" },
    { id: 188, value: "73" },
    { id: 189, value: "16" },
    { id: 190, value: "48" },
  ],
  [
    { id: 191, value: "59" },
    { id: 192, value: "37" },
    { id: 193, value: "38" },
    { id: 194, value: "82" },
    { id: 195, value: "87" },
  ],
  [
    { id: 196, value: "43" },
    { id: 197, value: "49" },
    { id: 198, value: "67" },
    { id: 199, value: "47" },
    { id: 200, value: "62" },
  ],
  [
    { id: 201, value: "05" },
    { id: 202, value: "75" },
    { id: 203, value: "15" },
    { id: 204, value: "48" },
    { id: 205, value: "58" },
  ],
  [
    { id: 206, value: "80" },
    { id: 207, value: "39" },
    { id: 208, value: "66" },
    { id: 209, value: "96" },
    { id: 210, value: "12" },
  ],
  [
    { id: 211, value: "89" },
    { id: 212, value: "20" },
    { id: 213, value: "73" },
    { id: 214, value: "41" },
    { id: 215, value: "99" },
  ],
  [
    { id: 216, value: "**" },
    { id: 217, value: "**" },
    { id: 218, value: "**" },
    { id: 219, value: "**" },
    { id: 220, value: "**" },
  ],
  [
    { id: 221, value: "**" },
    { id: 222, value: "**" },
    { id: 223, value: "72" },
    { id: 224, value: "06" },
    { id: 225, value: "70" },
  ],
  [
    { id: 226, value: "95" },
    { id: 227, value: "23" },
    { id: 228, value: "08" },
    { id: 229, value: "62" },
    { id: 230, value: "36" },
  ],
  [
    { id: 231, value: "23" },
    { id: 232, value: "36" },
    { id: 233, value: "23" },
    { id: 234, value: "59" },
    { id: 235, value: "67" },
  ],
  [
    { id: 236, value: "21" },
    { id: 237, value: "05" },
    { id: 238, value: "34" },
    { id: 239, value: "54" },
    { id: 240, value: "36" },
  ],
  [
    { id: 241, value: "38" },
    { id: 242, value: "98" },
    { id: 243, value: "27" },
    { id: 244, value: "27" },
    { id: 245, value: "52" },
  ],
  [
    { id: 246, value: "60" },
    { id: 247, value: "85" },
    { id: 248, value: "24" },
    { id: 249, value: "67" },
    { id: 250, value: "72" },
  ],
  [
    { id: 251, value: "16" },
    { id: 252, value: "00" },
    { id: 253, value: "81" },
    { id: 254, value: "83" },
    { id: 255, value: "16" },
  ],
  [
    { id: 256, value: "38" },
    { id: 257, value: "86" },
    { id: 258, value: "53" },
    { id: 259, value: "45" },
    { id: 260, value: "24" },
  ],
  [
    { id: 261, value: "06" },
    { id: 262, value: "69" },
    { id: 263, value: "80" },
    { id: 264, value: "36" },
    { id: 265, value: "81" },
  ],
  [
    { id: 266, value: "55" },
    { id: 267, value: "16" },
    { id: 268, value: "14" },
    { id: 269, value: "12" },
    { id: 270, value: "20" },
  ],
  [
    { id: 271, value: "12" },
    { id: 272, value: "51" },
    { id: 273, value: "21" },
    { id: 274, value: "10" },
    { id: 275, value: "49" },
  ],
  [
    { id: 276, value: "91" },
    { id: 277, value: "20" },
    { id: 278, value: "57" },
    { id: 279, value: "92" },
    { id: 280, value: "20" },
    { id: 281, value: "**" },
    { id: 282, value: "**" },
  ],
  [
    { id: 283, value: "66" },
    { id: 284, value: "96" },
    { id: 285, value: "28" },
    { id: 286, value: "33" },
    { id: 287, value: "33" },
    { id: 288, value: "**" },
    { id: 289, value: "**" },
  ],
  [
    { id: 290, value: "68" },
    { id: 291, value: "26" },
    { id: 292, value: "96" },
    { id: 293, value: "64" },
    { id: 294, value: "78" },
    { id: 295, value: "**" },
    { id: 296, value: "**" },
  ],
  [
    { id: 297, value: "70" },
    { id: 298, value: "46" },
    { id: 299, value: "46" },
    { id: 300, value: "35" },
    { id: 301, value: "10" },
    { id: 302, value: "**" },
    { id: 303, value: "**" },
  ],
  [
    { id: 304, value: "29" },
    { id: 305, value: "50" },
    { id: 306, value: "05" },
    { id: 307, value: "59" },
    { id: 308, value: "76" },
    { id: 309, value: "**" },
    { id: 310, value: "**" },
  ],
  [
    { id: 311, value: "99" },
    { id: 312, value: "14" },
    { id: 313, value: "97" },
    { id: 314, value: "29" },
    { id: 315, value: "65" },
    { id: 316, value: "**" },
    { id: 317, value: "**" },
  ],
  [
    { id: 318, value: "80" },
    { id: 319, value: "99" },
    { id: 320, value: "33" },
    { id: 321, value: "57" },
    { id: 322, value: "27" },
    { id: 323, value: "**" },
    { id: 324, value: "**" },
  ],
  [
    { id: 325, value: "96" },
    { id: 326, value: "16" },
    { id: 327, value: "35" },
    { id: 328, value: "37" },
    { id: 329, value: "50" },
    { id: 330, value: "**" },
    { id: 331, value: "**" },
  ],
  [
    { id: 332, value: "89" },
    { id: 333, value: "16" },
    { id: 334, value: "03" },
    { id: 335, value: "44" },
    { id: 336, value: "76" },
    { id: 337, value: "**" },
    { id: 338, value: "**" },
  ],
  [
    { id: 339, value: "69" },
    { id: 340, value: "67" },
    { id: 341, value: "93" },
    { id: 342, value: "60" },
    { id: 343, value: "39" },
    { id: 344, value: "**" },
    { id: 345, value: "**" },
  ],
  [
    { id: 346, value: "50" },
    { id: 347, value: "07" },
    { id: 348, value: "16" },
    { id: 349, value: "27" },
    { id: 350, value: "82" },
    { id: 351, value: "**" },
    { id: 352, value: "**" },
  ],
  [
    { id: 353, value: "53" },
    { id: 354, value: "70" },
    { id: 355, value: "50" },
    { id: 356, value: "68" },
    { id: 357, value: "23" },
    { id: 358, value: "**" },
    { id: 359, value: "**" },
  ],
  [
    { id: 360, value: "38" },
    { id: 361, value: "45" },
    { id: 362, value: "13" },
    { id: 363, value: "03" },
    { id: 364, value: "47" },
    { id: 365, value: "**" },
    { id: 366, value: "**" },
  ],
  [
    { id: 367, value: "09" },
    { id: 368, value: "90" },
    { id: 369, value: "79" },
    { id: 370, value: "90" },
    { id: 371, value: "00" },
    { id: 372, value: "**" },
    { id: 373, value: "**" },
  ],
  [
    { id: 374, value: "95" },
    { id: 375, value: "76" },
    { id: 376, value: "63" },
    { id: 377, value: "13" },
    { id: 378, value: "21" },
    { id: 379, value: "**" },
    { id: 380, value: "**" },
  ],
  [
    { id: 381, value: "57" },
    { id: 382, value: "75" },
    { id: 383, value: "74" },
    { id: 384, value: "05" },
    { id: 385, value: "98" },
    { id: 386, value: "**" },
    { id: 387, value: "**" },
  ],
  [
    { id: 388, value: "94" },
    { id: 389, value: "83" },
    { id: 390, value: "71" },
    { id: 391, value: "09" },
    { id: 392, value: "61" },
    { id: 393, value: "**" },
    { id: 394, value: "**" },
  ],
  [
    { id: 395, value: "34" },
    { id: 396, value: "79" },
    { id: 397, value: "67" },
    { id: 398, value: "29" },
    { id: 399, value: "74" },
    { id: 400, value: "**" },
    { id: 401, value: "**" },
  ],
  [
    { id: 402, value: "84" },
    { id: 403, value: "33" },
    { id: 404, value: "74" },
    { id: 405, value: "08" },
    { id: 406, value: "03" },
    { id: 407, value: "**" },
    { id: 408, value: "**" },
  ],
  [
    { id: 409, value: "36" },
    { id: 410, value: "42" },
    { id: 411, value: "84" },
    { id: 412, value: "73" },
    { id: 413, value: "64" },
    { id: 414, value: "**" },
    { id: 415, value: "**" },
  ],
  [
    { id: 416, value: "26" },
    { id: 417, value: "00" },
    { id: 418, value: "54" },
    { id: 419, value: "32" },
    { id: 420, value: "37" },
    { id: 421, value: "**" },
    { id: 422, value: "**" },
  ],
  [
    { id: 423, value: "33" },
    { id: 424, value: "19" },
    { id: 425, value: "13" },
    { id: 426, value: "75" },
    { id: 427, value: "09" },
    { id: 428, value: "**" },
    { id: 429, value: "**" },
  ],
  [
    { id: 430, value: "20" },
    { id: 431, value: "95" },
    { id: 432, value: "57" },
    { id: 433, value: "19" },
    { id: 434, value: "53" },
    { id: 435, value: "**" },
    { id: 436, value: "**" },
  ],
  [
    { id: 437, value: "07" },
    { id: 438, value: "93" },
    { id: 439, value: "87" },
    { id: 440, value: "61" },
    { id: 441, value: "29" },
    { id: 442, value: "**" },
    { id: 443, value: "**" },
  ],
  [
    { id: 444, value: "83" },
    { id: 445, value: "46" },
    { id: 446, value: "62" },
    { id: 447, value: "32" },
    { id: 448, value: "49" },
    { id: 449, value: "**" },
    { id: 450, value: "**" },
  ],
  [
    { id: 451, value: "14" },
    { id: 452, value: "21" },
    { id: 453, value: "79" },
    { id: 454, value: "69" },
    { id: 455, value: "13" },
    { id: 456, value: "**" },
    { id: 457, value: "**" },
  ],
  [
    { id: 458, value: "52" },
    { id: 459, value: "45" },
    { id: 460, value: "59" },
    { id: 461, value: "78" },
    { id: 462, value: "87" },
    { id: 463, value: "**" },
    { id: 464, value: "**" },
  ],
  [
    { id: 465, value: "13" },
    { id: 466, value: "73" },
    { id: 467, value: "25" },
    { id: 468, value: "36" },
    { id: 469, value: "15" },
    { id: 470, value: "**" },
    { id: 471, value: "**" },
  ],
  [
    { id: 472, value: "97" },
    { id: 473, value: "60" },
    { id: 474, value: "40" },
    { id: 475, value: "94" },
    { id: 476, value: "46" },
    { id: 477, value: "**" },
    { id: 478, value: "**" },
  ],
  [
    { id: 479, value: "77" },
    { id: 480, value: "55" },
    { id: 481, value: "96" },
    { id: 482, value: "04" },
    { id: 483, value: "**" },
    { id: 484, value: "**" },
    { id: 485, value: "**" },
  ],
  [
    { id: 486, value: "76" },
    { id: 487, value: "71" },
    { id: 488, value: "14" },
    { id: 489, value: "50" },
    { id: 490, value: "76" },
    { id: 491, value: "**" },
    { id: 492, value: "**" },
  ],
  [
    { id: 493, value: "51" },
    { id: 494, value: "83" },
    { id: 495, value: "57" },
    { id: 496, value: "51" },
    { id: 497, value: "87" },
    { id: 498, value: "**" },
    { id: 499, value: "**" },
  ],
  [
    { id: 500, value: "54" },
    { id: 501, value: "44" },
    { id: 502, value: "37" },
    { id: 503, value: "23" },
    { id: 504, value: "30" },
    { id: 505, value: "**" },
    { id: 506, value: "**" },
  ],
  [
    { id: 507, value: "47" },
    { id: 508, value: "42" },
    { id: 509, value: "86" },
    { id: 510, value: "91" },
    { id: 511, value: "51" },
    { id: 512, value: "**" },
    { id: 513, value: "**" },
  ],
  [
    { id: 514, value: "09" },
    { id: 515, value: "93" },
    { id: 516, value: "15" },
    { id: 517, value: "59" },
    { id: 518, value: "19" },
    { id: 519, value: "**" },
    { id: 520, value: "**" },
  ],
  [
    { id: 521, value: "83" },
    { id: 522, value: "31" },
    { id: 523, value: "93" },
    { id: 524, value: "03" },
    { id: 525, value: "17" },
    { id: 526, value: "**" },
    { id: 527, value: "**" },
  ],
  [
    { id: 528, value: "04" },
    { id: 529, value: "62" },
    { id: 530, value: "14" },
    { id: 531, value: "66" },
    { id: 532, value: "52" },
    { id: 533, value: "**" },
    { id: 534, value: "**" },
  ],
  [
    { id: 535, value: "19" },
    { id: 536, value: "68" },
    { id: 537, value: "88" },
    { id: 538, value: "66" },
    { id: 539, value: "74" },
    { id: 540, value: "**" },
    { id: 541, value: "**" },
  ],
  [
    { id: 542, value: "00" },
    { id: 543, value: "94" },
    { id: 544, value: "47" },
    { id: 545, value: "88" },
    { id: 546, value: "49" },
    { id: 547, value: "**" },
    { id: 548, value: "**" },
  ],
  [
    { id: 549, value: "85" },
    { id: 550, value: "59" },
    { id: 551, value: "66" },
    { id: 552, value: "12" },
    { id: 553, value: "47" },
    { id: 554, value: "**" },
    { id: 555, value: "**" },
  ],
  [
    { id: 556, value: "11" },
    { id: 557, value: "86" },
    { id: 558, value: "94" },
    { id: 559, value: "72" },
    { id: 560, value: "79" },
    { id: 561, value: "**" },
    { id: 562, value: "**" },
  ],
  [
    { id: 563, value: "04" },
    { id: 564, value: "37" },
    { id: 565, value: "36" },
    { id: 566, value: "25" },
    { id: 567, value: "25" },
    { id: 568, value: "**" },
    { id: 569, value: "**" },
  ],
  [
    { id: 570, value: "44" },
    { id: 571, value: "20" },
    { id: 572, value: "66" },
    { id: 573, value: "72" },
    { id: 574, value: "76" },
    { id: 575, value: "**" },
    { id: 576, value: "**" },
  ],
  [
    { id: 577, value: "92" },
    { id: 578, value: "84" },
    { id: 579, value: "81" },
    { id: 580, value: "65" },
    { id: 581, value: "46" },
    { id: 582, value: "**" },
    { id: 583, value: "**" },
  ],
  [
    { id: 584, value: "82" },
    { id: 585, value: "14" },
    { id: 586, value: "65" },
    { id: 587, value: "70" },
    { id: 588, value: "59" },
    { id: 589, value: "**" },
    { id: 590, value: "**" },
  ],
  [
    { id: 591, value: "07" },
    { id: 592, value: "05" },
    { id: 593, value: "05" },
    { id: 594, value: "78" },
    { id: 595, value: "28" },
    { id: 596, value: "**" },
    { id: 597, value: "**" },
  ],
  [
    { id: 598, value: "77" },
    { id: 599, value: "79" },
    { id: 600, value: "34" },
    { id: 601, value: "03" },
    { id: 602, value: "90" },
    { id: 603, value: "**" },
    { id: 604, value: "**" },
  ],
  [
    { id: 605, value: "71" },
    { id: 606, value: "81" },
    { id: 607, value: "15" },
    { id: 608, value: "39" },
    { id: 609, value: "06" },
    { id: 610, value: "**" },
    { id: 611, value: "**" },
  ],
  [
    { id: 612, value: "67" },
    { id: 613, value: "34" },
    { id: 614, value: "54" },
    { id: 615, value: "63" },
    { id: 616, value: "65" },
    { id: 617, value: "**" },
    { id: 618, value: "**" },
  ],
  [
    { id: 619, value: "01" },
    { id: 620, value: "04" },
    { id: 621, value: "21" },
    { id: 622, value: "47" },
    { id: 623, value: "48" },
    { id: 624, value: "**" },
    { id: 625, value: "**" },
  ],
  [
    { id: 626, value: "63" },
    { id: 627, value: "37" },
    { id: 628, value: "20" },
    { id: 629, value: "45" },
    { id: 630, value: "02" },
    { id: 631, value: "**" },
    { id: 632, value: "**" },
  ],
  [
    { id: 633, value: "71" },
    { id: 634, value: "56" },
    { id: 635, value: "80" },
    { id: 636, value: "12" },
    { id: 637, value: "45" },
    { id: 638, value: "**" },
    { id: 639, value: "**" },
  ],
  [
    { id: 640, value: "**" },
    { id: 641, value: "30" },
    { id: 642, value: "53" },
    { id: 643, value: "47" },
    { id: 644, value: "57" },
    { id: 645, value: "**" },
    { id: 646, value: "**" },
  ],
  [
    { id: 647, value: "97" },
    { id: 648, value: "21" },
    { id: 649, value: "61" },
    { id: 650, value: "67" },
    { id: 651, value: "80" },
    { id: 652, value: "**" },
    { id: 653, value: "**" },
  ],
  [
    { id: 654, value: "99" },
    { id: 655, value: "80" },
    { id: 656, value: "96" },
    { id: 657, value: "86" },
    { id: 658, value: "80" },
    { id: 659, value: "**" },
    { id: 660, value: "**" },
  ],
  [
    { id: 661, value: "85" },
    { id: 662, value: "85" },
    { id: 663, value: "54" },
    { id: 664, value: "68" },
    { id: 665, value: "39" },
    { id: 666, value: "**" },
    { id: 667, value: "**" },
  ],
  [
    { id: 668, value: "32" },
    { id: 669, value: "82" },
    { id: 670, value: "32" },
    { id: 671, value: "64" },
    { id: 672, value: "76" },
    { id: 673, value: "**" },
    { id: 674, value: "**" },
  ],
  [
    { id: 675, value: "99" },
    { id: 676, value: "43" },
    { id: 677, value: "**" },
    { id: 678, value: "49" },
    { id: 679, value: "59" },
    { id: 680, value: "**" },
    { id: 681, value: "**" },
  ],
  [
    { id: 682, value: "94" },
    { id: 683, value: "20" },
    { id: 684, value: "23" },
    { id: 685, value: "79" },
    { id: 686, value: "72" },
    { id: 687, value: "**" },
    { id: 688, value: "**" },
  ],
  [
    { id: 689, value: "11" },
    { id: 690, value: "25" },
    { id: 691, value: "60" },
    { id: 692, value: "43" },
    { id: 693, value: "55" },
    { id: 694, value: "**" },
    { id: 695, value: "**" },
  ],
];

// maya morning

export const MayaMorning = [
  [
    { id: 1, value: "16" },
    { id: 2, value: "27" },
    { id: 3, value: "09" },
    { id: 4, value: "36" },
    { id: 5, value: "92" },
    { id: 6, value: "87" },
    { id: 7, value: "41" },
  ],
  [
    { id: 8, value: "74" },
    { id: 9, value: "98" },
    { id: 10, value: "69" },
    { id: 11, value: "12" },
    { id: 12, value: "17" },
    { id: 13, value: "51" },
    { id: 14, value: "03" },
  ],
  [
    { id: 15, value: "88" },
    { id: 16, value: "24" },
    { id: 17, value: "28" },
    { id: 18, value: "13" },
    { id: 19, value: "44" },
    { id: 20, value: "05" },
    { id: 21, value: "90" },
  ],
  [
    { id: 1, value: "88" },
    { id: 2, value: "24" },
    { id: 3, value: "28" },
    { id: 4, value: "13" },
    { id: 5, value: "44" },
    { id: 6, value: "05" },
    { id: 7, value: "90" },
  ],
  [
    { id: 8, value: "13" },
    { id: 9, value: "11" },
    { id: 10, value: "65" },
    { id: 11, value: "20" },
    { id: 12, value: "24" },
    { id: 13, value: "12" },
    { id: 14, value: "88" },
  ],
  [
    { id: 15, value: "72" },
    { id: 16, value: "05" },
    { id: 17, value: "84" },
    { id: 18, value: "62" },
    { id: 19, value: "05" },
    { id: 20, value: "32" },
    { id: 21, value: "45" },
  ],
  [
    { id: 1, value: "24" },
    { id: 2, value: "59" },
    { id: 3, value: "54" },
    { id: 4, value: "26" },
    { id: 5, value: "12" },
    { id: 6, value: "80" },
    { id: 7, value: "63" },
  ],
  [
    { id: 8, value: "35" },
    { id: 9, value: "49" },
    { id: 10, value: "29" },
    { id: 11, value: "85" },
    { id: 12, value: "08" },
    { id: 13, value: "86" },
    { id: 14, value: "38" },
  ],
  [
    { id: 15, value: "19" },
    { id: 16, value: "67" },
    { id: 17, value: "65" },
    { id: 18, value: "52" },
    { id: 19, value: "72" },
    { id: 20, value: "07" },
    { id: 20, value: "94" },
  ],
  [
    { id: 1, value: "71" },
    { id: 2, value: "49" },
    { id: 3, value: "68" },
    { id: 4, value: "55" },
    { id: 5, value: "11" },
    { id: 6, value: "20" },
    { id: 7, value: "90" },
  ],
  [
    { id: 1, value: "71" },
    { id: 2, value: "49" },
    { id: 3, value: "68" },
    { id: 4, value: "55" },
    { id: 5, value: "11" },
    { id: 6, value: "20" },
    { id: 7, value: "90" },
  ],
  [
    { id: 1, value: "28" },
    { id: 2, value: "89" },
    { id: 3, value: "20" },
    { id: 4, value: "28" },
    { id: 5, value: "49" },
    { id: 6, value: "93" },
    { id: 7, value: "76" },
  ],
  [
    { id: 1, value: "66" },
    { id: 2, value: "89" },
    { id: 3, value: "00" },
    { id: 4, value: "39" },
    { id: 5, value: "05" },
    { id: 6, value: "87" },
    { id: 7, value: "28" },
  ],
  [
    { id: 1, value: "52" },
    { id: 2, value: "48" },
    { id: 3, value: "00" },
    { id: 4, value: "46" },
    { id: 5, value: "40" },
    { id: 6, value: "18" },
    { id: 7, value: "23" },
  ],
  [
    { id: 1, value: "03" },
    { id: 2, value: "79" },
    { id: 3, value: "27" },
    { id: 4, value: "13" },
    { id: 5, value: "15" },
    { id: 6, value: "89" },
    { id: 7, value: "42" },
  ],
  [
    { id: 1, value: "91" },
    { id: 2, value: "25" },
    { id: 3, value: "28" },
    { id: 4, value: "60" },
    { id: 5, value: "55" },
    { id: 6, value: "43" },
    { id: 7, value: "40" },
  ],
  [
    { id: 43, value: "41" },
    { id: 44, value: "91" },
    { id: 45, value: "33" },
    { id: 46, value: "91" },
    { id: 47, value: "96" },
    { id: 48, value: "66" },
    { id: 49, value: "93" },
  ],
  [
    { id: 50, value: "98" },
    { id: 51, value: "90" },
    { id: 52, value: "53" },
    { id: 53, value: "66" },
    { id: 54, value: "08" },
    { id: 55, value: "29" },
    { id: 56, value: "99" },
  ],
  [
    { id: 57, value: "73" },
    { id: 58, value: "91" },
    { id: 59, value: "68" },
    { id: 60, value: "01" },
    { id: 61, value: "71" },
    { id: 62, value: "87" },
    { id: 63, value: "91" },
  ],
  [
    { id: 64, value: "46" },
    { id: 65, value: "11" },
    { id: 66, value: "72" },
    { id: 67, value: "27" },
    { id: 68, value: "26" },
    { id: 69, value: "42" },
    { id: 70, value: "74" },
  ],

  [
    { id: 1, value: "98" },
    { id: 2, value: "06" },
    { id: 3, value: "24" },
    { id: 4, value: "83" },
    { id: 5, value: "57" },
    { id: 6, value: "87" },
    { id: 7, value: "68" },
  ],
  [
    { id: 1, value: "84" },
    { id: 2, value: "50" },
    { id: 3, value: "46" },
    { id: 4, value: "53" },
    { id: 5, value: "97" },
    { id: 6, value: "60" },
    { id: 7, value: "09" },
  ],
  [
    { id: 1, value: "20" },
    { id: 2, value: "80" },
    { id: 3, value: "09" },
    { id: 4, value: "65" },
    { id: 5, value: "48" },
    { id: 6, value: "10" },
    { id: 7, value: "83" },
  ],
  [
    { id: 1, value: "98" },
    { id: 2, value: "06" },
    { id: 3, value: "24" },
    { id: 4, value: "83" },
    { id: 5, value: "57" },
    { id: 6, value: "87" },
    { id: 7, value: "80" },
  ],
  [
    { id: 1, value: "84" },
    { id: 2, value: "50" },
    { id: 3, value: "46" },
    { id: 4, value: "53" },
    { id: 5, value: "97" },
    { id: 6, value: "60" },
    { id: 7, value: "66" },
  ],
  [
    { id: 1, value: "20" },
    { id: 2, value: "80" },
    { id: 3, value: "09" },
    { id: 4, value: "65" },
    { id: 5, value: "48" },
    { id: 6, value: "10" },
    { id: 7, value: "80" },
  ],
  [
    { id: 1, value: "89" },
    { id: 2, value: "76" },
    { id: 3, value: "94" },
    { id: 4, value: "57" },
    { id: 5, value: "34" },
    { id: 6, value: "12" },
    { id: 7, value: "83" },
  ],
  [
    { id: 1, value: "90" },
    { id: 2, value: "45" },
    { id: 3, value: "72" },
    { id: 4, value: "68" },
    { id: 5, value: "33" },
    { id: 6, value: "18" },
    { id: 7, value: "66" },
  ],
  [
    { id: 1, value: "44" },
    { id: 2, value: "85" },
    { id: 3, value: "13" },
    { id: 4, value: "90" },
    { id: 5, value: "40" },
    { id: 6, value: "55" },
    { id: 7, value: "90" },
  ],

  [
    { id: 1, value: "22" },
    { id: 2, value: "67" },
    { id: 3, value: "48" },
    { id: 4, value: "77" },
    { id: 5, value: "23" },
    { id: 6, value: "39" },
    { id: 7, value: "90" },
  ],
  [
    { id: 1, value: "88" },
    { id: 2, value: "12" },
    { id: 3, value: "77" },
    { id: 4, value: "33" },
    { id: 5, value: "64" },
    { id: 6, value: "90" },
    { id: 7, value: "53" },
  ],
  [
    { id: 1, value: "88" },
    { id: 2, value: "06" },
    { id: 3, value: "11" },
    { id: 4, value: "41" },
    { id: 5, value: "90" },
    { id: 6, value: "55" },
    { id: 7, value: "90" },
  ],
  [
    { id: 1, value: "66" },
    { id: 2, value: "47" },
    { id: 3, value: "93" },
    { id: 4, value: "15" },
    { id: 5, value: "34" },
    { id: 6, value: "58" },
    { id: 7, value: "06" },
  ],
  [
    { id: 1, value: "25" },
    { id: 2, value: "93" },
    { id: 3, value: "39" },
    { id: 4, value: "03" },
    { id: 5, value: "02" },
    { id: 6, value: "09" },
    { id: 7, value: "14" },
  ],
  [
    { id: 1, value: "89" },
    { id: 2, value: "64" },
    { id: 3, value: "30" },
    { id: 4, value: "75" },
    { id: 5, value: "52" },
    { id: 6, value: "11" },
    { id: 7, value: "64" },
  ],
  [
    { id: 1, value: "90" },
    { id: 2, value: "35" },
    { id: 3, value: "83" },
    { id: 4, value: "14" },
    { id: 5, value: "22" },
    { id: 6, value: "99" },
    { id: 7, value: "33" },
  ],
  [
    { id: 1, value: "67" },
    { id: 2, value: "43" },
    { id: 3, value: "56" },
    { id: 4, value: "27" },
    { id: 5, value: "90" },
    { id: 6, value: "29" },
    { id: 7, value: "67" },
  ],
  [
    { id: 1, value: "64" },
    { id: 2, value: "23" },
    { id: 3, value: "82" },
    { id: 4, value: "47" },
    { id: 5, value: "55" },
    { id: 6, value: "68" },
    { id: 7, value: "67" },
  ],
];

export const INDRAMORNING = [
  [
    { id: 1, value: "66" },
    { id: 2, value: "77" },
    { id: 3, value: "42" },
    { id: 4, value: "09" },
    { id: 5, value: "53" },
    { id: 6, value: "96" },
    { id: 7, value: "39" },
  ],
  [
    { id: 8, value: "23" },
    { id: 9, value: "66" },
    { id: 10, value: "03" },
    { id: 11, value: "30" },
    { id: 12, value: "50" },
    { id: 13, value: "71" },
    { id: 14, value: "54" },
  ],
  [
    { id: 15, value: "14" },
    { id: 16, value: "60" },
    { id: 17, value: "61" },
    { id: 18, value: "60" },
    { id: 19, value: "41" },
    { id: 20, value: "68" },
    { id: 21, value: "03" },
  ],
  [
    { id: 22, value: "49" },
    { id: 23, value: "27" },
    { id: 24, value: "05" },
    { id: 25, value: "17" },
    { id: 26, value: "32" },
    { id: 27, value: "42" },
    { id: 28, value: "14" },
  ],
  [
    { id: 29, value: "41" },
    { id: 30, value: "29" },
    { id: 31, value: "10" },
    { id: 32, value: "45" },
    { id: 33, value: "54" },
    { id: 34, value: "22" },
    { id: 35, value: "64" },
  ],
  [
    { id: 36, value: "33" },
    { id: 37, value: "00" },
    { id: 38, value: "59" },
    { id: 39, value: "41" },
    { id: 40, value: "58" },
    { id: 41, value: "15" },
    { id: 42, value: "80" },
  ],
  [
    { id: 43, value: "15" },
    { id: 44, value: "47" },
    { id: 45, value: "31" },
    { id: 46, value: "83" },
    { id: 47, value: "51" },
    { id: 48, value: "92" },
    { id: 49, value: "15" },
  ],
  [
    { id: 50, value: "92" },
    { id: 51, value: "31" },
    { id: 52, value: "42" },
    { id: 53, value: "32" },
    { id: 54, value: "42" },
    { id: 55, value: "10" },
    { id: 56, value: "95" },
  ],
  [
    { id: 57, value: "13" },
    { id: 58, value: "80" },
    { id: 59, value: "35" },
    { id: 60, value: "55" },
    { id: 61, value: "19" },
    { id: 62, value: "10" },
    { id: 63, value: "23" },
  ],
  [
    { id: 64, value: "04" },
    { id: 65, value: "89" },
    { id: 66, value: "49" },
    { id: 67, value: "02" },
    { id: 68, value: "83" },
    { id: 69, value: "21" },
    { id: 70, value: "43" },
  ],
  [
    { id: 71, value: "01" },
    { id: 72, value: "08" },
    { id: 73, value: "49" },
    { id: 74, value: "22" },
    { id: 75, value: "88" },
    { id: 76, value: "52" },
    { id: 77, value: "14" },
  ],
  [
    { id: 78, value: "52" },
    { id: 79, value: "11" },
    { id: 80, value: "65" },
    { id: 81, value: "78" },
    { id: 82, value: "30" },
    { id: 83, value: "70" },
    { id: 84, value: "14" },
  ],
  [
    { id: 1, value: "90" },
    { id: 2, value: "18" },
    { id: 3, value: "90" },
    { id: 4, value: "39" },
    { id: 5, value: "31" },
    { id: 6, value: "55" },
    { id: 7, value: "66" },
  ],
  [
    { id: 8, value: "67" },
    { id: 9, value: "31" },
    { id: 10, value: "90" },
    { id: 11, value: "94" },
    { id: 12, value: "79" },
    { id: 13, value: "46" },
    { id: 14, value: "82" },
  ],
  [
    { id: 15, value: "64" },
    { id: 16, value: "12" },
    { id: 17, value: "69" },
    { id: 18, value: "53" },
    { id: 19, value: "03" },
    { id: 20, value: "78" },
    { id: 21, value: "42" },
  ],
  [
    { id: 22, value: "27" },
    { id: 23, value: "83" },
    { id: 24, value: "70" },
    { id: 25, value: "05" },
    { id: 26, value: "98" },
    { id: 27, value: "82" },
    { id: 28, value: "99" },
  ],
  [
    { id: 29, value: "80" },
    { id: 30, value: "32" },
    { id: 31, value: "96" },
    { id: 32, value: "86" },
    { id: 33, value: "67" },
    { id: 34, value: "77" },
    { id: 35, value: "47" },
  ],
  [
    { id: 36, value: "79" },
    { id: 37, value: "09" },
    { id: 38, value: "29" },
    { id: 39, value: "74" },
    { id: 40, value: "39" },
    { id: 41, value: "56" },
    { id: 42, value: "95" },
  ],
  [
    { id: 43, value: "45" },
    { id: 44, value: "84" },
    { id: 45, value: "08" },
    { id: 46, value: "55" },
    { id: 47, value: "75" },
    { id: 48, value: "94" },
    { id: 49, value: "40" },
  ],
  [
    { id: 50, value: "23" },
    { id: 51, value: "07" },
    { id: 52, value: "24" },
    { id: 53, value: "48" },
    { id: 54, value: "51" },
    { id: 55, value: "99" },
    { id: 56, value: "63" },
  ],
  [
    { id: 57, value: "19" },
    { id: 58, value: "68" },
    { id: 59, value: "22" },
    { id: 60, value: "01" },
    { id: 61, value: "96" },
    { id: 62, value: "17" },
    { id: 63, value: "08" },
  ],

  [
    { id: 1, value: "61" },
    { id: 2, value: "10" },
    { id: 3, value: "83" },
    { id: 4, value: "91" },
    { id: 5, value: "35" },
    { id: 6, value: "79" },
    { id: 7, value: "27" },
  ],
  [
    { id: 8, value: "88" },
    { id: 9, value: "67" },
    { id: 10, value: "77" },
    { id: 11, value: "22" },
    { id: 12, value: "82" },
    { id: 13, value: "30" },
    { id: 14, value: "18" },
  ],
  [
    { id: 15, value: "58" },
    { id: 16, value: "25" },
    { id: 17, value: "82" },
    { id: 18, value: "75" },
    { id: 19, value: "08" },
    { id: 20, value: "62" },
    { id: 21, value: "20" },
  ],
  [
    { id: 22, value: "80" },
    { id: 23, value: "64" },
    { id: 24, value: "15" },
    { id: 25, value: "97" },
    { id: 26, value: "65" },
    { id: 27, value: "87" },
    { id: 28, value: "96" },
  ],
  [
    { id: 29, value: "61" },
    { id: 30, value: "99" },
    { id: 31, value: "39" },
    { id: 32, value: "81" },
    { id: 33, value: "25" },
    { id: 34, value: "77" },
    { id: 35, value: "52" },
  ],
  [
    { id: 36, value: "58" },
    { id: 37, value: "49" },
    { id: 38, value: "17" },
    { id: 39, value: "80" },
    { id: 40, value: "93" },
    { id: 41, value: "30" },
    { id: 42, value: "22" },
  ],
  [
    { id: 43, value: "99" },
    { id: 44, value: "21" },
    { id: 45, value: "67" },
    { id: 46, value: "07" },
    { id: 47, value: "51" },
    { id: 48, value: "74" },
    { id: 49, value: "13" },
  ],
  [
    { id: 50, value: "89" },
    { id: 51, value: "55" },
    { id: 52, value: "31" },
    { id: 53, value: "97" },
    { id: 54, value: "88" },
    { id: 55, value: "30" },
    { id: 56, value: "96" },
  ],
  [
    { id: 57, value: "73" },
    { id: 58, value: "93" },
    { id: 59, value: "67" },
    { id: 60, value: "50" },
    { id: 61, value: "15" },
    { id: 62, value: "32" },
    { id: 63, value: "19" },
  ],
  [
    { id: 1, value: "51" },
    { id: 2, value: "34" },
    { id: 3, value: "99" },
    { id: 4, value: "35" },
    { id: 5, value: "70" },
    { id: 6, value: "28" },
    { id: 7, value: "44" },
  ],
  [
    { id: 1, value: "27" },
    { id: 2, value: "05" },
    { id: 3, value: "45" },
    { id: 4, value: "84" },
    { id: 5, value: "75" },
    { id: 6, value: "17" },
    { id: 6, value: "54" },
  ],
  [
    { id: 1, value: "67" },
    { id: 2, value: "96" },
    { id: 3, value: "40" },
    { id: 4, value: "13" },
    { id: 5, value: "60" },
    { id: 6, value: "11" },
    { id: 7, value: "34" },
  ],
  [
    { id: 1, value: "30" },
    { id: 2, value: "21" },
    { id: 3, value: "88" },
    { id: 4, value: "41" },
    { id: 5, value: "78" },
    { id: 6, value: "37" },
    { id: 6, value: "37" },
  ],
  [
    { id: 1, value: "49" },
    { id: 2, value: "10" },
    { id: 3, value: "21" },
    { id: 4, value: "02" },
    { id: 5, value: "70" },
    { id: 6, value: "16" },
    { id: 7, value: "25" },
  ],
  [
    { id: 1, value: "66" },
    { id: 2, value: "41" },
    { id: 3, value: "99" },
    { id: 4, value: "15" },
    { id: 5, value: "59" },
    { id: 6, value: "89" },
    { id: 7, value: "20" },
  ],
  [
    { id: 1, value: "24" },
    { id: 2, value: "80" },
    { id: 3, value: "86" },
    { id: 4, value: "71" },
    { id: 5, value: "54" },
    { id: 6, value: "66" },
    { id: 7, value: "17" },
  ],
];
export const INDRADAY = [
  [
    { id: 1, value: "73" },
    { id: 2, value: "61" },
    { id: 3, value: "04" },
    { id: 4, value: "69" },
    { id: 5, value: "76" },
    { id: 6, value: "04" },
    { id: 7, value: "85" },
  ],
  [
    { id: 8, value: "77" },
    { id: 9, value: "96" },
    { id: 10, value: "73" },
    { id: 11, value: "42" },
    { id: 12, value: "43" },
    { id: 13, value: "35" },
    { id: 14, value: "96" },
  ],
  [
    { id: 15, value: "37" },
    { id: 16, value: "03" },
    { id: 17, value: "01" },
    { id: 18, value: "04" },
    { id: 19, value: "97" },
    { id: 20, value: "95" },
    { id: 21, value: "83" },
  ],
  [
    { id: 22, value: "54" },
    { id: 23, value: "58" },
    { id: 24, value: "14" },
    { id: 25, value: "07" },
    { id: 26, value: "51" },
    { id: 27, value: "07" },
    { id: 28, value: "46" },
  ],
  [
    { id: 29, value: "24" },
    { id: 30, value: "99" },
    { id: 31, value: "85" },
    { id: 32, value: "82" },
    { id: 33, value: "00" },
    { id: 34, value: "79" },
    { id: 35, value: "86" },
  ],
  [
    { id: 1, value: "51" },
    { id: 2, value: "57" },
    { id: 3, value: "62" },
    { id: 4, value: "62" },
    { id: 5, value: "94" },
    { id: 6, value: "58" },
    { id: 7, value: "97" },
  ],
  [
    { id: 8, value: "87" },
    { id: 9, value: "00" },
    { id: 10, value: "64" },
    { id: 11, value: "82" },
    { id: 12, value: "67" },
    { id: 13, value: "05" },
    { id: 14, value: "26" },
  ],
  [
    { id: 15, value: "06" },
    { id: 16, value: "02" },
    { id: 17, value: "27" },
    { id: 18, value: "96" },
    { id: 19, value: "**" },
    { id: 20, value: "22" },
    { id: 21, value: "40" },
  ],
  [
    { id: 22, value: "67" },
    { id: 23, value: "25" },
    { id: 24, value: "19" },
    { id: 25, value: "98" },
    { id: 26, value: "95" },
    { id: 27, value: "95" },
    { id: 28, value: "68" },
  ],
  [
    { id: 29, value: "19" },
    { id: 30, value: "46" },
    { id: 31, value: "68" },
    { id: 32, value: "59" },
    { id: 33, value: "87" },
    { id: 34, value: "32" },
    { id: 35, value: "24" },
  ],
  [
    { id: 36, value: "34" },
    { id: 37, value: "09" },
    { id: 38, value: "94" },
    { id: 39, value: "46" },
    { id: 40, value: "09" },
    { id: 41, value: "49" },
    { id: 42, value: "47" },
  ],
  [
    { id: 1, value: "01" },
    { id: 2, value: "51" },
    { id: 3, value: "47" },
    { id: 4, value: "19" },
    { id: 5, value: "48" },
    { id: 6, value: "57" },
    { id: 7, value: "97" },
  ],
  [
    { id: 8, value: "89" },
    { id: 9, value: "64" },
    { id: 10, value: "88" },
    { id: 11, value: "84" },
    { id: 12, value: "29" },
    { id: 13, value: "26" },
    { id: 14, value: "62" },
  ],
  [
    { id: 15, value: "54" },
    { id: 16, value: "60" },
    { id: 17, value: "14" },
    { id: 18, value: "94" },
    { id: 19, value: "94" },
    { id: 20, value: "59" },
    { id: 21, value: "87" },
  ],
  [
    { id: 22, value: "39" },
    { id: 23, value: "35" },
    { id: 24, value: "57" },
    { id: 25, value: "96" },
    { id: 26, value: "01" },
    { id: 27, value: "14" },
    { id: 28, value: "82" },
  ],
  [
    { id: 29, value: "55" },
    { id: 30, value: "45" },
    { id: 31, value: "25" },
    { id: 32, value: "49" },
    { id: 33, value: "58" },
    { id: 34, value: "22" },
    { id: 35, value: "19" },
  ],
  [
    { id: 36, value: "01" },
    { id: 37, value: "60" },
    { id: 38, value: "38" },
    { id: 39, value: "04" },
    { id: 40, value: "60" },
    { id: 41, value: "79" },
    { id: 42, value: "72" },
  ],
  [
    { id: 43, value: "47" },
    { id: 44, value: "09" },
    { id: 45, value: "08" },
    { id: 46, value: "09" },
    { id: 47, value: "49" },
    { id: 48, value: "06" },
    { id: 49, value: "94" },
  ],
  [
    { id: 1, value: "81" },
    { id: 2, value: "71" },
    { id: 3, value: "71" },
    { id: 4, value: "18" },
    { id: 5, value: "48" },
    { id: 6, value: "29" },
    { id: 7, value: "86" },
  ],
  [
    { id: 8, value: "13" },
    { id: 9, value: "97" },
    { id: 10, value: "17" },
    { id: 11, value: "56" },
    { id: 12, value: "84" },
    { id: 13, value: "16" },
    { id: 14, value: "64" },
  ],
  [
    { id: 15, value: "90" },
    { id: 16, value: "35" },
    { id: 17, value: "62" },
    { id: 18, value: "18" },
    { id: 19, value: "63" },
    { id: 20, value: "21" },
    { id: 21, value: "60" },
  ],
  [
    { id: 22, value: "82" },
    { id: 23, value: "69" },
    { id: 24, value: "79" },
    { id: 25, value: "01" },
    { id: 26, value: "85" },
    { id: 27, value: "98" },
    { id: 28, value: "05" },
  ],
  [
    { id: 29, value: "61" },
    { id: 30, value: "70" },
    { id: 31, value: "70" },
    { id: 32, value: "03" },
    { id: 33, value: "60" },
    { id: 34, value: "45" },
    { id: 35, value: "05" },
  ],
  [
    { id: 36, value: "61" },
    { id: 37, value: "70" },
    { id: 38, value: "60" },
    { id: 39, value: "82" },
    { id: 40, value: "35" },
    { id: 41, value: "71" },
    { id: 42, value: "48" },
  ],
  [
    { id: 1, value: "**" },
    { id: 1, value: "81" },
    { id: 2, value: "71" },
    { id: 3, value: "71" },
    { id: 4, value: "18" },
    { id: 5, value: "48" },
    { id: 6, value: "29" },
  ],
  [
    { id: 7, value: "86" },
    { id: 8, value: "13" },
    { id: 9, value: "97" },
    { id: 10, value: "17" },
    { id: 11, value: "56" },
    { id: 12, value: "84" },
    { id: 13, value: "16" },
  ],
  [
    { id: 14, value: "64" },
    { id: 15, value: "90" },
    { id: 16, value: "35" },
    { id: 17, value: "62" },
    { id: 18, value: "18" },
    { id: 19, value: "63" },
    { id: 20, value: "21" },
  ],
  [
    { id: 21, value: "60" },
    { id: 22, value: "82" },
    { id: 23, value: "69" },
    { id: 24, value: "79" },
    { id: 25, value: "01" },
    { id: 26, value: "85" },
    { id: 27, value: "98" },
  ],
  [
    { id: 28, value: "05" },
    { id: 29, value: "61" },
    { id: 30, value: "70" },
    { id: 31, value: "70" },
    { id: 32, value: "03" },
    { id: 33, value: "60" },
    { id: 34, value: "45" },
  ],
  [
    { id: 35, value: "05" },
    { id: 36, value: "61" },
    { id: 37, value: "70" },
    { id: 38, value: "60" },
    { id: 39, value: "82" },
    { id: 40, value: "35" },
    { id: 41, value: "71" },
  ],
  [
    { id: 1, value: "14" },
    { id: 2, value: "68" },
    { id: 3, value: "00" },
    { id: 4, value: "32" },
    { id: 5, value: "02" },
    { id: 6, value: "06" },
    { id: 7, value: "22" },
  ],
  [
    { id: 8, value: "43" },
    { id: 9, value: "36" },
    { id: 10, value: "64" },
    { id: 11, value: "79" },
    { id: 12, value: "79" },
    { id: 13, value: "91" },
    { id: 14, value: "77" },
  ],
  [
    { id: 15, value: "58" },
    { id: 16, value: "04" },
    { id: 17, value: "50" },
    { id: 18, value: "86" },
    { id: 19, value: "92" },
    { id: 20, value: "11" },
    { id: 21, value: "30" },
  ],
  [
    { id: 22, value: "28" },
    { id: 23, value: "19" },
    { id: 24, value: "53" },
    { id: 25, value: "46" },
    { id: 26, value: "47" },
    { id: 27, value: "76" },
    { id: 28, value: "12" },
  ],
  [
    { id: 29, value: "92" },
    { id: 30, value: "63" },
    { id: 31, value: "07" },
    { id: 32, value: "41" },
    { id: 33, value: "57" },
    { id: 34, value: "13" },
    { id: 35, value: "81" },
  ],
  [
    { id: 36, value: "79" },
    { id: 37, value: "54" },
    { id: 38, value: "80" },
    { id: 39, value: "13" },
    { id: 40, value: "37" },
    { id: 41, value: "59" },
    { id: 42, value: "08" },
  ],
  [
    { id: 1, value: "98" },
    { id: 2, value: "82" },
    { id: 3, value: "64" },
    { id: 4, value: "40" },
    { id: 5, value: "48" },
    { id: 6, value: "58" },
    { id: 7, value: "89" },
  ],
  [
    { id: 8, value: "15" },
    { id: 9, value: "51" },
    { id: 10, value: "71" },
    { id: 11, value: "88" },
    { id: 12, value: "59" },
    { id: 13, value: "44" },
    { id: 14, value: "17" },
  ],
  [
    { id: 15, value: "84" },
    { id: 16, value: "06" },
    { id: 17, value: "75" },
    { id: 18, value: "55" },
    { id: 19, value: "13" },
    { id: 20, value: "26" },
    { id: 21, value: "46" },
  ],
  [
    { id: 22, value: "35" },
    { id: 23, value: "05" },
    { id: 24, value: "97" },
    { id: 25, value: "21" },
    { id: 26, value: "30" },
    { id: 27, value: "57" },
    { id: 28, value: "84" },
  ],
  [
    { id: 29, value: "45" },
    { id: 30, value: "92" },
    { id: 31, value: "42" },
    { id: 32, value: "54" },
    { id: 33, value: "48" },
    { id: 34, value: "20" },
    { id: 35, value: "62" },
  ],
  [
    { id: 36, value: "15" },
    { id: 37, value: "28" },
    { id: 38, value: "39" },
    { id: 39, value: "17" },
    { id: 40, value: "46" },
    { id: 41, value: "94" },
    { id: 42, value: "67" },
  ],
  [
    { id: 43, value: "43" },
    { id: 44, value: "62" },
    { id: 45, value: "11" },
    { id: 46, value: "52" },
    { id: 47, value: "02" },
    { id: 48, value: "82" },
    { id: 48, value: "64" },
  ],
];
export const INDRANIGHT = [
  [
    { id: 1, value: "16" },
    { id: 2, value: "48" },
    { id: 3, value: "22" },
    { id: 4, value: "71" },
    { id: 5, value: "97" },
    { id: 6, value: "39" },
    { id: 7, value: "23" },
  ],
  [
    { id: 8, value: "39" },
    { id: 9, value: "88" },
    { id: 10, value: "82" },
    { id: 11, value: "76" },
    { id: 12, value: "82" },
    { id: 13, value: "78" },
    { id: 14, value: "59" },
  ],
  [
    { id: 15, value: "86" },
    { id: 16, value: "95" },
    { id: 17, value: "03" },
    { id: 18, value: "43" },
    { id: 19, value: "55" },
    { id: 20, value: "81" },
    { id: 21, value: "78" },
  ],
  [
    { id: 22, value: "65" },
    { id: 23, value: "22" },
    { id: 24, value: "70" },
    { id: 25, value: "45" },
    { id: 26, value: "08" },
    { id: 27, value: "82" },
    { id: 28, value: "71" },
  ],
  [
    { id: 29, value: "58" },
    { id: 30, value: "75" },
    { id: 31, value: "23" },
    { id: 32, value: "09" },
    { id: 33, value: "35" },
    { id: 34, value: "07" },
    { id: 35, value: "36" },
  ],
  [
    { id: 36, value: "65" },
    { id: 37, value: "68" },
    { id: 38, value: "08" },
    { id: 39, value: "73" },
    { id: 40, value: "28" },
    { id: 41, value: "60" },
    { id: 42, value: "36" },
  ],
  [
    { id: 43, value: "83" },
    { id: 44, value: "41" },
    { id: 45, value: "70" },
    { id: 46, value: "16" },
    { id: 47, value: "06" },
    { id: 48, value: "69" },
    { id: 49, value: "32" },
  ],
  [
    { id: 50, value: "52" },
    { id: 51, value: "62" },
    { id: 52, value: "49" },
    { id: 53, value: "07" },
    { id: 54, value: "03" },
    { id: 55, value: "67" },
    { id: 56, value: "18" },
  ],
  [
    { id: 57, value: "86" },
    { id: 58, value: "48" },
    { id: 59, value: "28" },
    { id: 60, value: "94" },
    { id: 61, value: "12" },
    { id: 62, value: "12" },
    { id: 63, value: "91" },
  ],
  [
    { id: 64, value: "86" },
    { id: 65, value: "08" },
    { id: 66, value: "11" },
    { id: 67, value: "11" },
    { id: 68, value: "17" },
    { id: 69, value: "55" },
    { id: 70, value: "37" },
  ],
  [
    { id: 1, value: "14" },
    { id: 2, value: "87" },
    { id: 3, value: "58" },
    { id: 4, value: "89" },
    { id: 5, value: "98" },
    { id: 6, value: "64" },
    { id: 5, value: "98" },
  ],
  [
    { id: 1, value: "89" },
    { id: 2, value: "45" },
    { id: 3, value: "74" },
    { id: 4, value: "83" },
    { id: 5, value: "50" },
    { id: 6, value: "62" },
    { id: 7, value: "11" },
  ],
  [
    { id: 1, value: "87" },
    { id: 2, value: "44" },
    { id: 3, value: "81" },
    { id: 4, value: "43" },
    { id: 5, value: "43" },
    { id: 6, value: "98" },
    { id: 7, value: "56" },
  ],
  [
    { id: 1, value: "78" },
    { id: 2, value: "91" },
    { id: 3, value: "19" },
    { id: 4, value: "08" },
    { id: 5, value: "26" },
    { id: 6, value: "73" },
    { id: 7, value: "20" },
  ],
  [
    { id: 1, value: "43" },
    { id: 2, value: "20" },
    { id: 3, value: "95" },
    { id: 4, value: "07" },
    { id: 5, value: "01" },
    { id: 6, value: "11" },
    { id: 7, value: "88" },
  ],
  [
    { id: 1, value: "49" },
    { id: 2, value: "90" },
    { id: 3, value: "83" },
    { id: 4, value: "16" },
    { id: 5, value: "24" },
    { id: 6, value: "04" },
    { id: 7, value: "30" },
  ],
  [
    { id: 1, value: "13" },
    { id: 2, value: "21" },
    { id: 3, value: "39" },
    { id: 4, value: "99" },
    { id: 5, value: "93" },
    { id: 6, value: "52" },
    { id: 7, value: "22" },
  ],
  [
    { id: 1, value: "46" },
    { id: 2, value: "60" },
    { id: 3, value: "01" },
    { id: 4, value: "20" },
    { id: 5, value: "74" },
    { id: 6, value: "84" },
    { id: 7, value: "67" },
  ],
  [
    { id: 1, value: "04" },
    { id: 2, value: "79" },
    { id: 3, value: "86" },
    { id: 4, value: "41" },
    { id: 5, value: "37" },
    { id: 6, value: "97" },
    { id: 7, value: "00" },
  ],
  [
    { id: 1, value: "81" },
    { id: 2, value: "26" },
    { id: 3, value: "73" },
    { id: 4, value: "31" },
    { id: 5, value: "96" },
    { id: 6, value: "43" },
    { id: 7, value: "18" },
  ],
  [
    { id: 1, value: "14" },
    { id: 2, value: "45" },
    { id: 3, value: "87" },
    { id: 4, value: "58" },
    { id: 5, value: "89" },
    { id: 6, value: "98" },
    { id: 7, value: "64" },
  ],
  [
    { id: 8, value: "89" },
    { id: 9, value: "45" },
    { id: 10, value: "74" },
    { id: 11, value: "83" },
    { id: 12, value: "50" },
    { id: 13, value: "62" },
    { id: 14, value: "11" },
  ],
  [
    { id: 15, value: "87" },
    { id: 16, value: "44" },
    { id: 17, value: "81" },
    { id: 18, value: "43" },
    { id: 19, value: "43" },
    { id: 20, value: "56" },
    { id: 21, value: "78" },
  ],
  [
    { id: 22, value: "26" },
    { id: 23, value: "19" },
    { id: 24, value: "08" },
    { id: 25, value: "26" },
    { id: 26, value: "73" },
    { id: 27, value: "20" },
    { id: 28, value: "20" },
  ],
  [
    { id: 1, value: "43" },
    { id: 2, value: "20" },
    { id: 3, value: "95" },
    { id: 4, value: "07" },
    { id: 5, value: "01" },
    { id: 6, value: "11" },
    { id: 7, value: "88" },
  ],
  [
    { id: 8, value: "49" },
    { id: 9, value: "90" },
    { id: 10, value: "83" },
    { id: 11, value: "16" },
    { id: 12, value: "24" },
    { id: 13, value: "04" },
    { id: 14, value: "30" },
  ],
  [
    { id: 15, value: "13" },
    { id: 16, value: "21" },
    { id: 17, value: "39" },
    { id: 18, value: "99" },
    { id: 19, value: "93" },
    { id: 20, value: "52" },
    { id: 21, value: "22" },
  ],
  [
    { id: 22, value: "46" },
    { id: 23, value: "60" },
    { id: 24, value: "01" },
    { id: 25, value: "20" },
    { id: 26, value: "74" },
    { id: 27, value: "84" },
    { id: 28, value: "67" },
  ],
  [
    { id: 29, value: "04" },
    { id: 30, value: "79" },
    { id: 31, value: "86" },
    { id: 32, value: "41" },
    { id: 33, value: "37" },
    { id: 34, value: "97" },
    { id: 35, value: "00" },
  ],
  [
    { id: 1, value: "81" },
    { id: 2, value: "26" },
    { id: 3, value: "73" },
    { id: 4, value: "31" },
    { id: 5, value: "96" },
    { id: 6, value: "43" },
    { id: 7, value: "18" },
  ],
  [
    { id: 8, value: "17" },
    { id: 9, value: "95" },
    { id: 10, value: "29" },
    { id: 11, value: "34" },
    { id: 12, value: "08" },
    { id: 13, value: "73" },
    { id: 14, value: "87" },
  ],
  [
    { id: 15, value: "24" },
    { id: 16, value: "86" },
    { id: 17, value: "31" },
    { id: 18, value: "04" },
    { id: 19, value: "61" },
    { id: 20, value: "52" },
    { id: 21, value: "12" },
  ],
  [
    { id: 22, value: "09" },
    { id: 23, value: "51" },
    { id: 24, value: "96" },
    { id: 25, value: "82" },
    { id: 26, value: "03" },
    { id: 27, value: "18" },
    { id: 28, value: "74" },
  ],
  [
    { id: 29, value: "17" },
    { id: 30, value: "92" },
    { id: 31, value: "20" },
    { id: 32, value: "66" },
    { id: 33, value: "19" },
    { id: 34, value: "83" },
    { id: 35, value: "30" },
  ],
  [
    { id: 1, value: "81" },
    { id: 2, value: "08" },
    { id: 3, value: "39" },
    { id: 4, value: "51" },
    { id: 5, value: "06" },
    { id: 6, value: "46" },
    { id: 7, value: "54" },
  ],
  [
    { id: 8, value: "30" },
    { id: 9, value: "26" },
    { id: 10, value: "02" },
    { id: 11, value: "71" },
    { id: 12, value: "84" },
    { id: 13, value: "07" },
    { id: 14, value: "91" },
  ],
  [
    { id: 15, value: "63" },
    { id: 16, value: "32" },
    { id: 17, value: "48" },
    { id: 18, value: "50" },
    { id: 19, value: "93" },
    { id: 20, value: "07" },
    { id: 21, value: "03" },
  ],
  [
    { id: 22, value: "71" },
    { id: 23, value: "98" },
    { id: 24, value: "42" },
    { id: 25, value: "81" },
    { id: 26, value: "63" },
    { id: 27, value: "57" },
    { id: 28, value: "91" },
  ],
  [
    { id: 29, value: "88" },
    { id: 30, value: "06" },
    { id: 31, value: "11" },
    { id: 32, value: "41" },
    { id: 33, value: "90" },
    { id: 34, value: "55" },
    { id: 35, value: "39" },
  ],
  [
    { id: 36, value: "81" },
    { id: 37, value: "08" },
    { id: 38, value: "39" },
    { id: 39, value: "51" },
    { id: 40, value: "06" },
    { id: 41, value: "46" },
    { id: 42, value: "54" },
  ],
  [
    { id: 1, value: "25" },
    { id: 2, value: "93" },
    { id: 3, value: "39" },
    { id: 4, value: "03" },
    { id: 5, value: "02" },
    { id: 6, value: "09" },
    { id: 7, value: "46" },
  ],
  [
    { id: 8, value: "32" },
    { id: 9, value: "99" },
    { id: 10, value: "16" },
    { id: 11, value: "25" },
    { id: 12, value: "10" },
    { id: 13, value: "77" },
    { id: 14, value: "83" },
  ],
  [
    { id: 15, value: "14" },
    { id: 16, value: "31" },
    { id: 17, value: "88" },
    { id: 18, value: "43" },
    { id: 19, value: "29" },
    { id: 20, value: "12" },
    { id: 21, value: "56" },
  ],
  [
    { id: 22, value: "70" },
    { id: 23, value: "19" },
    { id: 24, value: "32" },
    { id: 25, value: "84" },
    { id: 26, value: "49" },
    { id: 27, value: "93" },
    { id: 28, value: "10" },
  ],
  [
    { id: 29, value: "13" },
    { id: 30, value: "58" },
    { id: 31, value: "30" },
    { id: 32, value: "45" },
    { id: 33, value: "90" },
    { id: 34, value: "18" },
    { id: 35, value: "24" },
  ],
  [
    { id: 36, value: "62" },
    { id: 37, value: "40" },
    { id: 38, value: "88" },
    { id: 39, value: "15" },
    { id: 40, value: "67" },
    { id: 41, value: "21" },
    { id: 42, value: "73" },
  ],
];

export const MAYADAY = [
  [
    { id: 1, value: "93" },
    { id: 2, value: "50" },
    { id: 3, value: "27" },
    { id: 4, value: "65" },
    { id: 5, value: "53" },
    { id: 6, value: "62" },
    { id: 7, value: "54" },
  ],
  [
    { id: 8, value: "51" },
    { id: 9, value: "39" },
    { id: 10, value: "26" },
    { id: 11, value: "10" },
    { id: 12, value: "91" },
    { id: 13, value: "72" },
    { id: 14, value: "67" },
  ],
  [
    { id: 15, value: "54" },
    { id: 16, value: "28" },
    { id: 17, value: "79" },
    { id: 18, value: "29" },
    { id: 19, value: "51" },
    { id: 20, value: "57" },
    { id: 21, value: "62" },
  ],
  [
    { id: 1, value: "77" },
    { id: 2, value: "81" },
    { id: 3, value: "48" },
    { id: 4, value: "93" },
    { id: 5, value: "87" },
    { id: 6, value: "00" },
    { id: 7, value: "64" },
  ],
  [
    { id: 8, value: "14" },
    { id: 9, value: "30" },
    { id: 10, value: "94" },
    { id: 11, value: "14" },
    { id: 12, value: "85" },
    { id: 13, value: "95" },
    { id: 14, value: "90" },
  ],
  [
    { id: 8, value: "14" },
    { id: 9, value: "30" },
    { id: 10, value: "94" },
    { id: 11, value: "14" },
    { id: 12, value: "85" },
    { id: 13, value: "95" },
    { id: 14, value: "90" },
  ],
  [
    { id: 15, value: "50" },
    { id: 16, value: "87" },
    { id: 17, value: "23" },
    { id: 18, value: "04" },
    { id: 19, value: "95" },
    { id: 20, value: "06" },
    { id: 21, value: "93" },
  ],
  [
    { id: 22, value: "06" },
    { id: 23, value: "68" },
    { id: 24, value: "50" },
    { id: 25, value: "42" },
    { id: 26, value: "62" },
    { id: 27, value: "16" },
    { id: 28, value: "03" },
  ],
  [
    { id: 1, value: "31" },
    { id: 2, value: "26" },
    { id: 3, value: "78" },
    { id: 4, value: "49" },
    { id: 5, value: "91" },
    { id: 6, value: "20" },
    { id: 7, value: "29" },
  ],
  [
    { id: 8, value: "73" },
    { id: 9, value: "82" },
    { id: 10, value: "79" },
    { id: 11, value: "37" },
    { id: 12, value: "95" },
    { id: 13, value: "46" },
    { id: 14, value: "95" },
  ],
  [
    { id: 15, value: "90" },
    { id: 16, value: "40" },
    { id: 17, value: "74" },
    { id: 18, value: "28" },
    { id: 19, value: "93" },
    { id: 20, value: "07" },
    { id: 21, value: "69" },
  ],
  [
    { id: 22, value: "90" },
    { id: 23, value: "32" },
    { id: 24, value: "63" },
    { id: 25, value: "37" },
    { id: 26, value: "97" },
    { id: 27, value: "55" },
    { id: 28, value: "72" },
  ],
  [
    { id: 29, value: "23" },
    { id: 30, value: "97" },
    { id: 31, value: "92" },
    { id: 32, value: "28" },
    { id: 33, value: "53" },
    { id: 34, value: "03" },
    { id: 35, value: "15" },
  ],
  [
    { id: 1, value: "43" },
    { id: 2, value: "62" },
    { id: 3, value: "11" },
    { id: 4, value: "52" },
    { id: 5, value: "02" },
    { id: 6, value: "82" },
    { id: 7, value: "64" },
  ],
  [
    { id: 8, value: "66" },
    { id: 9, value: "98" },
    { id: 10, value: "14" },
    { id: 11, value: "40" },
    { id: 12, value: "65" },
    { id: 13, value: "45" },
    { id: 14, value: "98" },
  ],
  [
    { id: 15, value: "96" },
    { id: 16, value: "09" },
    { id: 17, value: "25" },
    { id: 18, value: "61" },
    { id: 19, value: "84" },
    { id: 20, value: "13" },
    { id: 21, value: "67" },
  ],
  [
    { id: 22, value: "11" },
    { id: 23, value: "37" },
    { id: 24, value: "09" },
    { id: 25, value: "88" },
    { id: 26, value: "54" },
    { id: 27, value: "06" },
    { id: 28, value: "93" },
  ],
  [
    { id: 1, value: "38" },
    { id: 2, value: "07" },
    { id: 3, value: "00" },
    { id: 4, value: "65" },
    { id: 5, value: "31" },
    { id: 6, value: "45" },
    { id: 7, value: "95" },
  ],
  [
    { id: 8, value: "04" },
    { id: 9, value: "86" },
    { id: 10, value: "50" },
    { id: 11, value: "80" },
    { id: 12, value: "93" },
    { id: 13, value: "44" },
    { id: 14, value: "86" },
  ],
  [
    { id: 15, value: "81" },
    { id: 16, value: "02" },
    { id: 17, value: "76" },
    { id: 18, value: "44" },
    { id: 19, value: "51" },
    { id: 20, value: "80" },
    { id: 21, value: "73" },
  ],
  [
    { id: 22, value: "39" },
    { id: 23, value: "61" },
    { id: 24, value: "02" },
    { id: 25, value: "10" },
    { id: 26, value: "39" },
    { id: 27, value: "90" },
    { id: 28, value: "26" },
  ],
  [
    { id: 29, value: "94" },
    { id: 30, value: "22" },
    { id: 31, value: "34" },
    { id: 32, value: "19" },
    { id: 33, value: "93" },
    { id: 34, value: "41" },
    { id: 35, value: "04" },
  ],
  [
    { id: 36, value: "66" },
    { id: 37, value: "56" },
    { id: 38, value: "74" },
    { id: 39, value: "75" },
    { id: 40, value: "19" },
    { id: 41, value: "89" },
    { id: 42, value: "89" },
  ],
  [
    { id: 1, value: "95" },
    { id: 2, value: "85" },
    { id: 3, value: "47" },
    { id: 4, value: "20" },
    { id: 5, value: "06" },
    { id: 6, value: "60" },
    { id: 7, value: "80" },
  ],
  [
    { id: 8, value: "47" },
    { id: 9, value: "31" },
    { id: 10, value: "81" },
    { id: 11, value: "65" },
    { id: 12, value: "92" },
    { id: 13, value: "81" },
    { id: 14, value: "71" },
  ],
  [
    { id: 15, value: "73" },
    { id: 16, value: "50" },
    { id: 17, value: "43" },
    { id: 18, value: "51" },
    { id: 19, value: "55" },
    { id: 20, value: "38" },
    { id: 21, value: "22" },
  ],
  [
    { id: 22, value: "83" },
    { id: 23, value: "18" },
    { id: 24, value: "25" },
    { id: 25, value: "30" },
    { id: 26, value: "70" },
    { id: 27, value: "14" },
    { id: 28, value: "31" },
  ],
  [
    { id: 29, value: "54" },
    { id: 30, value: "10" },
    { id: 31, value: "40" },
    { id: 32, value: "68" },
    { id: 33, value: "08" },
    { id: 34, value: "94" },
    { id: 35, value: "03" },
  ],
  [
    { id: 36, value: "03" },
    { id: 37, value: "08" },
    { id: 38, value: "48" },
    { id: 39, value: "22" },
    { id: 40, value: "84" },
    { id: 41, value: "62" },
    { id: 42, value: "79" },
  ],
  [
    { id: 1, value: "69" },
    { id: 2, value: "22" },
    { id: 3, value: "17" },
    { id: 4, value: "08" },
    { id: 5, value: "70" },
    { id: 6, value: "35" },
    { id: 7, value: "01" },
  ],
  [
    { id: 8, value: "87" },
    { id: 9, value: "96" },
    { id: 10, value: "43" },
    { id: 11, value: "39" },
    { id: 12, value: "87" },
    { id: 13, value: "51" },
    { id: 14, value: "99" },
  ],
  [
    { id: 15, value: "25" },
    { id: 16, value: "93" },
    { id: 17, value: "39" },
    { id: 18, value: "03" },
    { id: 19, value: "09" },
    { id: 20, value: "09" },
    { id: 21, value: "80" },
  ],
  [
    { id: 22, value: "33" },
    { id: 23, value: "77" },
    { id: 24, value: "55" },
    { id: 25, value: "42" },
    { id: 26, value: "89" },
    { id: 27, value: "11" },
    { id: 28, value: "23" },
  ],
  [
    { id: 29, value: "66" },
    { id: 30, value: "90" },
    { id: 31, value: "78" },
    { id: 32, value: "34" },
    { id: 33, value: "21" },
    { id: 34, value: "88" },
    { id: 35, value: "13" },
  ],
  [
    { id: 36, value: "72" },
    { id: 37, value: "55" },
    { id: 38, value: "16" },
    { id: 39, value: "44" },
    { id: 40, value: "33" },
    { id: 41, value: "61" },
    { id: 42, value: "29" },
  ],
  [
    { id: 43, value: "78" },
    { id: 44, value: "67" },
    { id: 45, value: "82" },
    { id: 46, value: "93" },
    { id: 47, value: "67" },
    { id: 48, value: "10" },
    { id: 49, value: "96" },
  ],
];

export const MAYANIGHT = [
  [
    { id: 1, value: "31" },
    { id: 2, value: "02" },
    { id: 3, value: "75" },
    { id: 4, value: "09" },
    { id: 5, value: "64" },
    { id: 6, value: "32" },
    { id: 7, value: "21" },
  ],
  [
    { id: 8, value: "74" },
    { id: 9, value: "11" },
    { id: 10, value: "94" },
    { id: 11, value: "31" },
    { id: 12, value: "43" },
    { id: 13, value: "26" },
    { id: 14, value: "89" },
  ],
  [
    { id: 15, value: "12" },
    { id: 16, value: "72" },
    { id: 17, value: "47" },
    { id: 18, value: "60" },
    { id: 19, value: "33" },
    { id: 20, value: "52" },
    { id: 21, value: "04" },
  ],
  [
    { id: 22, value: "14" },
    { id: 23, value: "70" },
    { id: 24, value: "68" },
    { id: 25, value: "21" },
    { id: 26, value: "86" },
    { id: 27, value: "90" },
    { id: 28, value: "73" },
  ],
  [
    { id: 29, value: "32" },
    { id: 30, value: "64" },
    { id: 31, value: "51" },
    { id: 32, value: "20" },
    { id: 33, value: "12" },
    { id: 34, value: "33" },
    { id: 35, value: "86" },
  ],
  [
    { id: 36, value: "05" },
    { id: 37, value: "21" },
    { id: 38, value: "36" },
    { id: 39, value: "54" },
    { id: 40, value: "59" },
    { id: 41, value: "66" },
    { id: 42, value: "43" },
  ],
  [
    { id: 1, value: "47" },
    { id: 2, value: "62" },
    { id: 3, value: "70" },
    { id: 4, value: "83" },
    { id: 5, value: "45" },
    { id: 6, value: "30" },
    { id: 7, value: "13" },
  ],
  [
    { id: 8, value: "42" },
    { id: 9, value: "08" },
    { id: 10, value: "23" },
    { id: 11, value: "99" },
    { id: 12, value: "82" },
    { id: 13, value: "97" },
    { id: 14, value: "91" },
  ],
  [
    { id: 15, value: "10" },
    { id: 16, value: "64" },
    { id: 17, value: "66" },
    { id: 18, value: "60" },
    { id: 19, value: "98" },
    { id: 20, value: "71" },
    { id: 21, value: "47" },
  ],
  [
    { id: 22, value: "62" },
    { id: 23, value: "36" },
    { id: 24, value: "91" },
    { id: 25, value: "37" },
    { id: 26, value: "43" },
    { id: 27, value: "83" },
    { id: 28, value: "25" },
  ],
  [
    { id: 29, value: "09" },
    { id: 30, value: "96" },
    { id: 31, value: "89" },
    { id: 32, value: "68" },
    { id: 33, value: "32" },
    { id: 34, value: "55" },
    { id: 35, value: "01" },
  ],
  [
    { id: 36, value: "25" },
    { id: 37, value: "51" },
    { id: 38, value: "31" },
    { id: 39, value: "63" },
    { id: 40, value: "51" },
    { id: 41, value: "20" },
    { id: 42, value: "47" },
  ],
  [
    { id: 43, value: "55" },
    { id: 44, value: "80" },
    { id: 45, value: "29" },
    { id: 46, value: "02" },
    { id: 47, value: "33" },
    { id: 48, value: "65" },
    { id: 49, value: "81" },
  ],
  [
    { id: 50, value: "59" },
    { id: 51, value: "40" },
    { id: 52, value: "24" },
    { id: 53, value: "92" },
    { id: 54, value: "52" },
    { id: 55, value: "86" },
    { id: 56, value: "02" },
  ],
  [
    { id: 57, value: "16" },
    { id: 58, value: "87" },
    { id: 59, value: "95" },
    { id: 60, value: "49" },
    { id: 61, value: "35" },
    { id: 62, value: "87" },
    { id: 63, value: "35" },
  ],
  [
    { id: 1, value: "22" },
    { id: 2, value: "08" },
    { id: 3, value: "44" },
    { id: 4, value: "65" },
    { id: 5, value: "79" },
    { id: 6, value: "36" },
    { id: 7, value: "42" },
  ],
  [
    { id: 8, value: "64" },
    { id: 9, value: "80" },
    { id: 10, value: "56" },
    { id: 11, value: "02" },
    { id: 12, value: "78" },
    { id: 13, value: "46" },
    { id: 14, value: "85" },
  ],
  [
    { id: 15, value: "15" },
    { id: 16, value: "84" },
    { id: 17, value: "77" },
    { id: 18, value: "21" },
    { id: 19, value: "04" },
    { id: 20, value: "19" },
    { id: 21, value: "94" },
  ],
  [
    { id: 22, value: "79" },
    { id: 23, value: "30" },
    { id: 24, value: "95" },
    { id: 25, value: "61" },
    { id: 26, value: "42" },
    { id: 27, value: "23" },
    { id: 28, value: "90" },
  ],
  [
    { id: 29, value: "01" },
    { id: 30, value: "41" },
    { id: 31, value: "38" },
    { id: 32, value: "25" },
    { id: 33, value: "49" },
    { id: 34, value: "52" },
    { id: 35, value: "06" },
  ],
  [
    { id: 36, value: "44" },
    { id: 37, value: "90" },
    { id: 38, value: "15" },
    { id: 39, value: "69" },
    { id: 40, value: "65" },
    { id: 41, value: "81" },
    { id: 42, value: "98" },
  ],
  [
    { id: 43, value: "61" },
    { id: 44, value: "97" },
    { id: 45, value: "03" },
    { id: 46, value: "28" },
    { id: 47, value: "43" },
    { id: 48, value: "53" },
    { id: 49, value: "57" },
  ],
  [
    { id: 50, value: "37" },
    { id: 51, value: "18" },
    { id: 52, value: "14" },
    { id: 53, value: "89" },
    { id: 54, value: "77" },
    { id: 55, value: "84" },
    { id: 56, value: "32" },
  ],
  [
    { id: 57, value: "52" },
    { id: 58, value: "93" },
    { id: 59, value: "49" },
    { id: 60, value: "25" },
    { id: 61, value: "33" },
    { id: 62, value: "79" },
    { id: 63, value: "38" },
  ],
  [
    { id: 1, value: "27" },
    { id: 2, value: "48" },
    { id: 3, value: "00" },
    { id: 4, value: "48" },
    { id: 5, value: "73" },
    { id: 6, value: "81" },
    { id: 7, value: "43" },
  ],
  [
    { id: 9, value: "81" },
    { id: 10, value: "52" },
    { id: 11, value: "49" },
    { id: 12, value: "96" },
    { id: 13, value: "07" },
    { id: 14, value: "59" },
    { id: 15, value: "80" },
  ],
  [
    { id: 16, value: "45" },
    { id: 17, value: "93" },
    { id: 18, value: "80" },
    { id: 19, value: "48" },
    { id: 20, value: "15" },
    { id: 21, value: "64" },
    { id: 22, value: "08" },
  ],
  [
    { id: 23, value: "93" },
    { id: 24, value: "50" },
    { id: 25, value: "27" },
    { id: 26, value: "65" },
    { id: 27, value: "53" },
    { id: 28, value: "62" },
    { id: 29, value: "54" },
  ],
  [
    { id: 30, value: "51" },
    { id: 31, value: "39" },
    { id: 32, value: "26" },
    { id: 33, value: "10" },
    { id: 34, value: "91" },
    { id: 35, value: "72" },
    { id: 36, value: "67" },
  ],
  [
    { id: 37, value: "60" },
    { id: 38, value: "98" },
    { id: 39, value: "88" },
    { id: 40, value: "25" },
    { id: 41, value: "90" },
    { id: 42, value: "56" },
    { id: 43, value: "74" },
  ],
  [
    { id: 44, value: "33" },
    { id: 45, value: "98" },
    { id: 46, value: "30" },
    { id: 47, value: "91" },
    { id: 48, value: "16" },
    { id: 49, value: "37" },
    { id: 50, value: "56" },
  ],
  [
    { id: 51, value: "25" },
    { id: 52, value: "31" },
    { id: 53, value: "63" },
    { id: 54, value: "24" },
    { id: 55, value: "03" },
    { id: 56, value: "36" },
    { id: 57, value: "38" },
  ],
  [
    { id: 58, value: "82" },
    { id: 59, value: "12" },
    { id: 60, value: "91" },
    { id: 61, value: "25" },
    { id: 62, value: "44" },
    { id: 63, value: "14" },
    { id: 64, value: "30" },
  ],
  [
    { id: 65, value: "44" },
    { id: 66, value: "80" },
    { id: 67, value: "47" },
    { id: 68, value: "52" },
    { id: 69, value: "44" },
    { id: 70, value: "80" },
    { id: 71, value: "38" },
  ],
  [
    { id: 72, value: "90" },
    { id: 73, value: "03" },
    { id: 74, value: "86" },
    { id: 75, value: "06" },
    { id: 76, value: "90" },
    { id: 77, value: "03" },
    { id: 78, value: "91" },
  ],
  [
    { id: 79, value: "30" },
    { id: 80, value: "61" },
    { id: 81, value: "62" },
    { id: 82, value: "46" },
    { id: 83, value: "70" },
    { id: 84, value: "54" },
    { id: 85, value: "55" },
  ],
  [
    { id: 86, value: "38" },
    { id: 87, value: "51" },
    { id: 88, value: "16" },
    { id: 89, value: "53" },
    { id: 90, value: "81" },
    { id: 91, value: "22" },
    { id: 92, value: "03" },
  ],
];

export const SUPREMEDAY = [
  [
    { id: 1, value: "00" },
    { id: 2, value: "68" },
    { id: 3, value: "46" },
    { id: 4, value: "01" },
    { id: 5, value: "66" },
    { id: 6, value: "97" },
    { id: 7, value: "28" },
  ],
  [
    { id: 8, value: "79" },
    { id: 9, value: "08" },
    { id: 10, value: "20" },
    { id: 11, value: "79" },
    { id: 12, value: "36" },
    { id: 13, value: "26" },
    { id: 14, value: "10" },
  ],
  [
    { id: 15, value: "46" },
    { id: 16, value: "38" },
    { id: 17, value: "97" },
    { id: 18, value: "20" },
    { id: 19, value: "85" },
    { id: 20, value: "70" },
    { id: 21, value: "06" },
  ],
  [
    { id: 22, value: "09" },
    { id: 23, value: "39" },
    { id: 24, value: "52" },
    { id: 25, value: "11" },
    { id: 26, value: "81" },
    { id: 27, value: "01" },
    { id: 28, value: "07" },
  ],
  [
    { id: 29, value: "91" },
    { id: 30, value: "32" },
    { id: 31, value: "35" },
    { id: 32, value: "81" },
    { id: 33, value: "45" },
    { id: 34, value: "79" },
    { id: 35, value: "45" },
  ],
  [
    { id: 36, value: "86" },
    { id: 37, value: "09" },
    { id: 38, value: "71" },
    { id: 39, value: "93" },
    { id: 40, value: "82" },
    { id: 41, value: "75" },
    { id: 42, value: "93" },
  ],
  [
    { id: 43, value: "59" },
    { id: 44, value: "55" },
    { id: 45, value: "33" },
    { id: 46, value: "08" },
    { id: 47, value: "06" },
    { id: 48, value: "15" },
    { id: 49, value: "81" },
  ],
  [
    { id: 50, value: "74" },
    { id: 51, value: "11" },
    { id: 52, value: "22" },
    { id: 53, value: "49" },
    { id: 54, value: "65" },
    { id: 55, value: "02" },
    { id: 56, value: "05" },
  ],
  [
    { id: 57, value: "41" },
    { id: 58, value: "35" },
    { id: 59, value: "86" },
    { id: 60, value: "76" },
    { id: 61, value: "92" },
    { id: 62, value: "15" },
    { id: 63, value: "86" },
  ],
  [
    { id: 64, value: "96" },
    { id: 65, value: "55" },
    { id: 66, value: "21" },
    { id: 67, value: "94" },
    { id: 68, value: "92" },
    { id: 69, value: "04" },
    { id: 70, value: "21" },
  ],
  [
    { id: 71, value: "35" },
    { id: 72, value: "76" },
    { id: 73, value: "64" },
    { id: 74, value: "35" },
    { id: 75, value: "45" },
    { id: 76, value: "33" },
    { id: 77, value: "84" },
  ],
  [
    { id: 78, value: "67" },
    { id: 79, value: "71" },
    { id: 80, value: "62" },
    { id: 81, value: "75" },
    { id: 82, value: "40" },
    { id: 83, value: "90" },
    { id: 84, value: "75" },
  ],
  [
    { id: 85, value: "48" },
    { id: 86, value: "23" },
    { id: 87, value: "34" },
    { id: 88, value: "62" },
    { id: 89, value: "09" },
    { id: 90, value: "89" },
    { id: 91, value: "43" },
  ],
  [
    { id: 92, value: "54" },
    { id: 93, value: "08" },
    { id: 94, value: "08" },
    { id: 95, value: "46" },
    { id: 96, value: "91" },
    { id: 97, value: "11" },
    { id: 98, value: "70" },
  ],
  [
    { id: 99, value: "25" },
    { id: 100, value: "64" },
    { id: 101, value: "02" },
    { id: 102, value: "39" },
    { id: 103, value: "31" },
    { id: 104, value: "15" },
    { id: 105, value: "13" },
  ],
  [
    { id: 106, value: "75" },
    { id: 107, value: "76" },
    { id: 108, value: "98" },
    { id: 109, value: "98" },
    { id: 110, value: "41" },
    { id: 111, value: "05" },
    { id: 112, value: "35" },
  ],
  [
    { id: 113, value: "55" },
    { id: 114, value: "71" },
    { id: 115, value: "48" },
    { id: 116, value: "16" },
    { id: 117, value: "66" },
    { id: 118, value: "05" },
    { id: 119, value: "61" },
  ],
  [
    { id: 120, value: "98" },
    { id: 121, value: "37" },
    { id: 122, value: "47" },
    { id: 123, value: "12" },
    { id: 124, value: "66" },
    { id: 125, value: "25" },
    { id: 126, value: "88" },
  ],
  [
    { id: 127, value: "01" },
    { id: 128, value: "38" },
    { id: 129, value: "12" },
    { id: 130, value: "11" },
    { id: 131, value: "90" },
    { id: 132, value: "90" },
    { id: 133, value: "97" },
  ],
  [
    { id: 134, value: "55" },
    { id: 135, value: "81" },
    { id: 136, value: "47" },
    { id: 137, value: "22" },
    { id: 138, value: "38" },
    { id: 139, value: "45" },
    { id: 140, value: "73" },
  ],
  [
    { id: 141, value: "59" },
    { id: 142, value: "78" },
    { id: 143, value: "06" },
    { id: 144, value: "15" },
    { id: 145, value: "10" },
    { id: 146, value: "22" },
    { id: 147, value: "10" },
  ],
  [
    { id: 148, value: "77" },
    { id: 149, value: "96" },
    { id: 150, value: "00" },
    { id: 151, value: "73" },
    { id: 152, value: "84" },
    { id: 153, value: "19" },
    { id: 154, value: "07" },
  ],
  [
    { id: 155, value: "03" },
    { id: 156, value: "72" },
    { id: 157, value: "11" },
    { id: 158, value: "77" },
    { id: 159, value: "89" },
    { id: 160, value: "44" },
    { id: 161, value: "79" },
  ],
  [
    { id: 162, value: "33" },
    { id: 163, value: "48" },
    { id: 164, value: "32" },
    { id: 165, value: "75" },
    { id: 166, value: "26" },
    { id: 167, value: "15" },
    { id: 168, value: "19" },
  ],
  [
    { id: 169, value: "85" },
    { id: 170, value: "20" },
    { id: 171, value: "94" },
    { id: 172, value: "88" },
    { id: 173, value: "69" },
    { id: 174, value: "78" },
    { id: 175, value: "88" },
  ],
  [
    { id: 176, value: "88" },
    { id: 177, value: "55" },
    { id: 178, value: "69" },
    { id: 179, value: "09" },
    { id: 180, value: "98" },
    { id: 181, value: "52" },
    { id: 182, value: "34" },
  ],
  [
    { id: 183, value: "98" },
    { id: 184, value: "26" },
    { id: 185, value: "26" },
    { id: 186, value: "71" },
    { id: 187, value: "00" },
    { id: 188, value: "95" },
    { id: 189, value: "02" },
  ],
  [
    { id: 190, value: "08" },
    { id: 191, value: "42" },
    { id: 192, value: "66" },
    { id: 193, value: "77" },
    { id: 194, value: "77" },
    { id: 195, value: "95" },
    { id: 196, value: "15" },
  ],
  [
    { id: 197, value: "03" },
    { id: 198, value: "69" },
    { id: 199, value: "54" },
    { id: 200, value: "07" },
    { id: 201, value: "62" },
    { id: 202, value: "81" },
    { id: 203, value: "45" },
  ],
  [
    { id: 204, value: "03" },
    { id: 205, value: "08" },
    { id: 206, value: "44" },
    { id: 207, value: "05" },
    { id: 208, value: "92" },
    { id: 209, value: "29" },
    { id: 210, value: "92" },
  ],
  [
    { id: 211, value: "78" },
    { id: 212, value: "46" },
    { id: 213, value: "12" },
    { id: 214, value: "64" },
    { id: 215, value: "45" },
    { id: 216, value: "09" },
    { id: 217, value: "37" },
  ],
  [
    { id: 218, value: "88" },
    { id: 219, value: "01" },
    { id: 220, value: "33" },
    { id: 221, value: "03" },
    { id: 222, value: "16" },
    { id: 223, value: "90" },
    { id: 224, value: "71" },
  ],
  [
    { id: 225, value: "41" },
    { id: 226, value: "05" },
    { id: 227, value: "83" },
    { id: 228, value: "71" },
    { id: 229, value: "09" },
    { id: 230, value: "59" },
    { id: 231, value: "84" },
  ],
  [
    { id: 232, value: "14" },
    { id: 233, value: "36" },
    { id: 234, value: "16" },
    { id: 235, value: "14" },
    { id: 236, value: "52" },
    { id: 237, value: "22" },
    { id: 238, value: "34" },
  ],
  [
    { id: 239, value: "11" },
    { id: 240, value: "36" },
    { id: 241, value: "60" },
    { id: 242, value: "06" },
    { id: 243, value: "08" },
    { id: 244, value: "79" },
    { id: 245, value: "83" },
  ],
  [
    { id: 246, value: "12" },
    { id: 247, value: "77" },
    { id: 248, value: "25" },
    { id: 249, value: "80" },
    { id: 250, value: "08" },
    { id: 251, value: "98" },
    { id: 252, value: "71" },
  ],
  [
    { id: 253, value: "97" },
    { id: 254, value: "16" },
    { id: 255, value: "65" },
    { id: 256, value: "10" },
    { id: 257, value: "25" },
    { id: 258, value: "76" },
    { id: 259, value: "70" },
  ],
  [
    { id: 260, value: "89" },
    { id: 261, value: "21" },
    { id: 262, value: "70" },
    { id: 263, value: "84" },
    { id: 264, value: "54" },
    { id: 265, value: "73" },
    { id: 266, value: "39" },
  ],
  [
    { id: 267, value: "94" },
    { id: 268, value: "47" },
    { id: 269, value: "79" },
    { id: 270, value: "25" },
    { id: 271, value: "06" },
    { id: 272, value: "33" },
    { id: 273, value: "90" },
  ],
  [
    { id: 274, value: "88" },
    { id: 275, value: "20" },
    { id: 276, value: "42" },
    { id: 277, value: "41" },
    { id: 278, value: "98" },
    { id: 279, value: "29" },
    { id: 280, value: "30" },
  ],
  [
    { id: 281, value: "34" },
    { id: 282, value: "00" },
    { id: 283, value: "79" },
    { id: 284, value: "22" },
    { id: 285, value: "89" },
    { id: 286, value: "08" },
    { id: 287, value: "77" },
  ],
  [
    { id: 288, value: "81" },
    { id: 289, value: "83" },
    { id: 290, value: "66" },
    { id: 291, value: "39" },
    { id: 292, value: "20" },
    { id: 293, value: "56" },
    { id: 294, value: "22" },
  ],
  [
    { id: 295, value: "79" },
    { id: 296, value: "68" },
    { id: 297, value: "00" },
    { id: 298, value: "36" },
    { id: 299, value: "81" },
    { id: 300, value: "07" },
    { id: 301, value: "14" },
  ],
  [
    { id: 302, value: "77" },
    { id: 303, value: "84" },
    { id: 304, value: "26" },
    { id: 305, value: "61" },
    { id: 306, value: "90" },
    { id: 307, value: "23" },
    { id: 308, value: "44" },
  ],
  [
    { id: 309, value: "54" },
    { id: 310, value: "01" },
    { id: 311, value: "36" },
    { id: 312, value: "18" },
    { id: 313, value: "74" },
    { id: 314, value: "80" },
    { id: 315, value: "10" },
  ],
  [
    { id: 316, value: "12" },
    { id: 317, value: "94" },
    { id: 318, value: "70" },
    { id: 319, value: "07" },
    { id: 320, value: "00" },
    { id: 321, value: "87" },
    { id: 322, value: "05" },
  ],
  [
    { id: 323, value: "50" },
    { id: 324, value: "49" },
    { id: 325, value: "72" },
    { id: 326, value: "35" },
    { id: 327, value: "74" },
    { id: 328, value: "84" },
    { id: 329, value: "89" },
  ],
  [
    { id: 330, value: "72" },
    { id: 331, value: "80" },
    { id: 332, value: "60" },
    { id: 333, value: "99" },
    { id: 334, value: "15" },
    { id: 335, value: "20" },
    { id: 336, value: "20" },
  ],
  [
    { id: 337, value: "55" },
    { id: 338, value: "23" },
    { id: 339, value: "88" },
    { id: 340, value: "11" },
    { id: 341, value: "80" },
    { id: 342, value: "51" },
    { id: 343, value: "08" },
  ],
  [
    { id: 344, value: "40" },
    { id: 345, value: "93" },
    { id: 346, value: "02" },
    { id: 347, value: "15" },
    { id: 348, value: "11" },
    { id: 349, value: "26" },
    { id: 350, value: "41" },
  ],
  [
    { id: 351, value: "86" },
    { id: 352, value: "40" },
    { id: 353, value: "95" },
    { id: 354, value: "96" },
    { id: 355, value: "19" },
    { id: 356, value: "31" },
    { id: 357, value: "50" },
  ],
  [
    { id: 358, value: "65" },
    { id: 359, value: "12" },
    { id: 360, value: "33" },
    { id: 361, value: "83" },
    { id: 362, value: "00" },
    { id: 363, value: "68" },
    { id: 364, value: "88" },
  ],
  [
    { id: 365, value: "38" },
    { id: 366, value: "70" },
    { id: 367, value: "97" },
    { id: 368, value: "92" },
    { id: 369, value: "31" },
    { id: 370, value: "48" },
    { id: 371, value: "41" },
  ],
  [
    { id: 372, value: "58" },
    { id: 373, value: "90" },
    { id: 374, value: "92" },
    { id: 375, value: "68" },
    { id: 376, value: "**" },
    { id: 377, value: "21" },
    { id: 378, value: "45" },
  ],
  [
    { id: 379, value: "44" },
    { id: 380, value: "25" },
    { id: 381, value: "87" },
    { id: 382, value: "10" },
    { id: 383, value: "60" },
    { id: 384, value: "22" },
    { id: 385, value: "78" },
  ],
  [
    { id: 386, value: "53" },
    { id: 387, value: "16" },
    { id: 388, value: "30" },
    { id: 389, value: "94" },
    { id: 390, value: "88" },
    { id: 391, value: "24" },
    { id: 392, value: "39" },
  ],
  [
    { id: 393, value: "96" },
    { id: 394, value: "13" },
    { id: 395, value: "82" },
    { id: 396, value: "28" },
    { id: 397, value: "97" },
    { id: 398, value: "22" },
    { id: 399, value: "22" },
  ],
  [
    { id: 400, value: "77" },
    { id: 401, value: "38" },
    { id: 402, value: "16" },
    { id: 403, value: "44" },
    { id: 404, value: "67" },
    { id: 405, value: "11" },
    { id: 406, value: "24" },
  ],
  [
    { id: 407, value: "70" },
    { id: 408, value: "45" },
    { id: 409, value: "31" },
    { id: 410, value: "69" },
    { id: 411, value: "17" },
    { id: 412, value: "60" },
    { id: 413, value: "98" },
  ],
  [
    { id: 414, value: "66" },
    { id: 415, value: "84" },
    { id: 416, value: "38" },
    { id: 417, value: "94" },
    { id: 418, value: "77" },
    { id: 419, value: "22" },
    { id: 420, value: "82" },
  ],
  [
    { id: 421, value: "59" },
    { id: 422, value: "40" },
    { id: 423, value: "56" },
    { id: 424, value: "65" },
    { id: 425, value: "71" },
    { id: 426, value: "71" },
    { id: 427, value: "87" },
  ],
  [
    { id: 428, value: "22" },
    { id: 429, value: "78" },
    { id: 430, value: "94" },
    { id: 431, value: "51" },
    { id: 432, value: "37" },
    { id: 433, value: "01" },
    { id: 434, value: "12" },
  ],
  [
    { id: 435, value: "05" },
    { id: 436, value: "65" },
    { id: 437, value: "17" },
    { id: 438, value: "25" },
    { id: 439, value: "94" },
    { id: 440, value: "**" },
    { id: 441, value: "20" },
  ],
  [
    { id: 442, value: "70" },
    { id: 443, value: "20" },
    { id: 444, value: "25" },
    { id: 445, value: "51" },
    { id: 446, value: "31" },
    { id: 447, value: "29" },
    { id: 448, value: "18" },
  ],
  [
    { id: 449, value: "24" },
    { id: 450, value: "03" },
    { id: 451, value: "99" },
    { id: 452, value: "15" },
    { id: 453, value: "88" },
    { id: 454, value: "46" },
    { id: 455, value: "44" },
  ],
  [
    { id: 456, value: "77" },
    { id: 457, value: "63" },
    { id: 458, value: "99" },
    { id: 459, value: "31" },
    { id: 460, value: "28" },
    { id: 461, value: "58" },
    { id: 462, value: "32" },
  ],
  [
    { id: 463, value: "08" },
    { id: 464, value: "22" },
    { id: 465, value: "34" },
    { id: 466, value: "18" },
    { id: 467, value: "55" },
    { id: 468, value: "70" },
    { id: 469, value: "17" },
  ],
  [
    { id: 470, value: "49" },
    { id: 471, value: "03" },
    { id: 472, value: "27" },
    { id: 473, value: "95" },
    { id: 474, value: "37" },
    { id: 475, value: "01" },
    { id: 476, value: "87" },
  ],
  [
    { id: 477, value: "16" },
    { id: 478, value: "83" },
    { id: 479, value: "77" },
    { id: 480, value: "39" },
    { id: 481, value: "98" },
    { id: 482, value: "50" },
    { id: 483, value: "93" },
  ],
  [
    { id: 484, value: "47" },
    { id: 485, value: "72" },
    { id: 486, value: "39" },
    { id: 487, value: "16" },
    { id: 488, value: "24" },
    { id: 489, value: "79" },
    { id: 490, value: "13" },
  ],
  [
    { id: 491, value: "49" },
    { id: 492, value: "27" },
    { id: 493, value: "01" },
    { id: 494, value: "53" },
    { id: 495, value: "71" },
    { id: 496, value: "97" },
    { id: 497, value: "10" },
  ],
  [
    { id: 498, value: "06" },
    { id: 499, value: "54" },
    { id: 500, value: "48" },
    { id: 501, value: "31" },
    { id: 502, value: "77" },
    { id: 503, value: "63" },
    { id: 504, value: "70" },
  ],
  [
    { id: 505, value: "29" },
    { id: 506, value: "34" },
    { id: 507, value: "58" },
    { id: 508, value: "07" },
    { id: 509, value: "44" },
    { id: 510, value: "65" },
    { id: 511, value: "54" },
  ],
  [
    { id: 512, value: "85" },
    { id: 513, value: "66" },
    { id: 514, value: "15" },
    { id: 515, value: "16" },
    { id: 516, value: "92" },
    { id: 517, value: "60" },
    { id: 518, value: "99" },
  ],
  [
    { id: 519, value: "46" },
    { id: 520, value: "95" },
    { id: 521, value: "59" },
    { id: 522, value: "15" },
    { id: 523, value: "87" },
    { id: 524, value: "20" },
    { id: 525, value: "30" },
  ],
  [
    { id: 526, value: "05" },
    { id: 527, value: "23" },
    { id: 528, value: "63" },
    { id: 529, value: "16" },
    { id: 530, value: "58" },
    { id: 531, value: "37" },
    { id: 532, value: "86" },
  ],
  [
    { id: 533, value: "92" },
    { id: 534, value: "96" },
    { id: 535, value: "10" },
    { id: 536, value: "69" },
    { id: 537, value: "41" },
    { id: 538, value: "91" },
    { id: 539, value: "44" },
  ],
  [
    { id: 540, value: "**" },
    { id: 541, value: "62" },
    { id: 542, value: "19" },
    { id: 543, value: "51" },
    { id: 544, value: "53" },
    { id: 545, value: "73" },
    { id: 546, value: "43" },
  ],
  [
    { id: 547, value: "37" },
    { id: 548, value: "03" },
    { id: 549, value: "26" },
    { id: 550, value: "76" },
    { id: 551, value: "13" },
    { id: 552, value: "16" },
    { id: 553, value: "94" },
  ],
  [
    { id: 554, value: "19" },
    { id: 555, value: "64" },
    { id: 556, value: "20" },
    { id: 557, value: "78" },
    { id: 558, value: "83" },
    { id: 559, value: "66" },
    { id: 560, value: "56" },
  ],
  [
    { id: 561, value: "12" },
    { id: 562, value: "98" },
    { id: 563, value: "54" },
    { id: 564, value: "36" },
    { id: 565, value: "80" },
    { id: 566, value: "00" },
    { id: 567, value: "44" },
  ],
  [
    { id: 568, value: "01" },
    { id: 569, value: "16" },
    { id: 570, value: "48" },
    { id: 571, value: "72" },
    { id: 572, value: "22" },
    { id: 573, value: "76" },
    { id: 574, value: "01" },
  ],
  [
    { id: 575, value: "38" },
    { id: 576, value: "26" },
    { id: 577, value: "**" },
    { id: 578, value: "05" },
    { id: 579, value: "10" },
    { id: 580, value: "50" },
    { id: 581, value: "70" },
  ],
  [
    { id: 582, value: "55" },
    { id: 583, value: "46" },
    { id: 584, value: "51" },
    { id: 585, value: "71" },
    { id: 586, value: "17" },
    { id: 587, value: "93" },
    { id: 588, value: "24" },
  ],
  [
    { id: 589, value: "85" },
    { id: 590, value: "07" },
    { id: 591, value: "82" },
    { id: 592, value: "90" },
    { id: 593, value: "99" },
    { id: 594, value: "73" },
    { id: 595, value: "91" },
  ],
];

export const SUPREMENIGHT = [
  [
    { id: 1, value: "16" },
    { id: 2, value: "61" },
    { id: 3, value: "93" },
    { id: 4, value: "88" },
    { id: 5, value: "07" },
    { id: 6, value: "73" },
    { id: 7, value: "98" },
  ],
  [
    { id: 8, value: "76" },
    { id: 9, value: "99" },
    { id: 10, value: "49" },
    { id: 11, value: "58" },
    { id: 12, value: "03" },
    { id: 13, value: "00" },
    { id: 14, value: "01" },
  ],
  [
    { id: 15, value: "34" },
    { id: 16, value: "11" },
    { id: 17, value: "36" },
    { id: 18, value: "69" },
    { id: 19, value: "97" },
    { id: 20, value: "48" },
    { id: 21, value: "53" },
  ],
  [
    { id: 22, value: "68" },
    { id: 23, value: "90" },
    { id: 24, value: "21" },
    { id: 25, value: "78" },
    { id: 26, value: "10" },
    { id: 27, value: "14" },
    { id: 28, value: "19" },
  ],
  [
    { id: 29, value: "77" },
    { id: 30, value: "07" },
    { id: 31, value: "28" },
    { id: 32, value: "32" },
    { id: 33, value: "88" },
    { id: 34, value: "91" },
    { id: 35, value: "60" },
  ],
  [
    { id: 36, value: "51" },
    { id: 37, value: "89" },
    { id: 38, value: "42" },
    { id: 39, value: "01" },
    { id: 40, value: "52" },
    { id: 41, value: "44" },
    { id: 42, value: "21" },
  ],
  [
    { id: 43, value: "33" },
    { id: 44, value: "42" },
    { id: 45, value: "10" },
    { id: 46, value: "73" },
    { id: 47, value: "93" },
    { id: 48, value: "55" },
    { id: 49, value: "00" },
  ],
  [
    { id: 50, value: "06" },
    { id: 51, value: "95" },
    { id: 52, value: "75" },
    { id: 53, value: "87" },
    { id: 54, value: "23" },
    { id: 55, value: "39" },
    { id: 56, value: "76" },
  ],
  [
    { id: 57, value: "05" },
    { id: 58, value: "41" },
    { id: 59, value: "92" },
    { id: 60, value: "46" },
    { id: 61, value: "41" },
    { id: 62, value: "73" },
    { id: 63, value: "08" },
  ],
  [
    { id: 64, value: "06" },
    { id: 65, value: "72" },
    { id: 66, value: "00" },
    { id: 67, value: "73" },
    { id: 68, value: "39" },
    { id: 69, value: "95" },
    { id: 70, value: "81" },
  ],
  [
    { id: 71, value: "99" },
    { id: 72, value: "76" },
    { id: 73, value: "56" },
    { id: 74, value: "41" },
    { id: 75, value: "41" },
    { id: 76, value: "02" },
    { id: 77, value: "35" },
  ],
  [
    { id: 78, value: "25" },
    { id: 79, value: "19" },
    { id: 80, value: "13" },
    { id: 81, value: "87" },
    { id: 82, value: "93" },
    { id: 83, value: "21" },
    { id: 84, value: "20" },
  ],
  [
    { id: 85, value: "17" },
    { id: 86, value: "46" },
    { id: 87, value: "65" },
    { id: 88, value: "10" },
    { id: 89, value: "37" },
    { id: 90, value: "98" },
    { id: 91, value: "53" },
  ],
  [
    { id: 92, value: "37" },
    { id: 93, value: "29" },
    { id: 94, value: "60" },
    { id: 95, value: "80" },
    { id: 96, value: "74" },
    { id: 97, value: "33" },
    { id: 98, value: "46" },
  ],
  [
    { id: 99, value: "51" },
    { id: 100, value: "07" },
    { id: 101, value: "47" },
    { id: 102, value: "68" },
    { id: 103, value: "68" },
    { id: 104, value: "75" },
    { id: 105, value: "24" },
  ],
  [
    { id: 106, value: "99" },
    { id: 107, value: "44" },
    { id: 108, value: "74" },
    { id: 109, value: "55" },
    { id: 110, value: "87" },
    { id: 111, value: "11" },
    { id: 112, value: "79" },
  ],
  [
    { id: 113, value: "66" },
    { id: 114, value: "05" },
    { id: 115, value: "81" },
    { id: 116, value: "46" },
    { id: 117, value: "26" },
    { id: 118, value: "45" },
    { id: 119, value: "49" },
  ],
  [
    { id: 120, value: "66" },
    { id: 121, value: "78" },
    { id: 122, value: "38" },
    { id: 123, value: "09" },
    { id: 124, value: "53" },
    { id: 125, value: "11" },
    { id: 126, value: "46" },
  ],
  [
    { id: 127, value: "27" },
    { id: 128, value: "90" },
    { id: 129, value: "06" },
    { id: 130, value: "54" },
    { id: 131, value: "83" },
    { id: 132, value: "40" },
    { id: 133, value: "62" },
  ],
  [
    { id: 134, value: "39" },
    { id: 135, value: "77" },
    { id: 136, value: "18" },
    { id: 137, value: "95" },
    { id: 138, value: "14" },
    { id: 139, value: "64" },
    { id: 140, value: "94" },
  ],
  [
    { id: 141, value: "20" },
    { id: 142, value: "12" },
    { id: 143, value: "65" },
    { id: 144, value: "73" },
    { id: 145, value: "48" },
    { id: 146, value: "97" },
    { id: 147, value: "01" },
  ],
  [
    { id: 148, value: "31" },
    { id: 149, value: "75" },
    { id: 150, value: "85" },
    { id: 151, value: "66" },
    { id: 152, value: "58" },
    { id: 153, value: "99" },
    { id: 154, value: "28" },
  ],
  [
    { id: 155, value: "79" },
    { id: 156, value: "12" },
    { id: 157, value: "95" },
    { id: 158, value: "33" },
    { id: 159, value: "48" },
    { id: 160, value: "20" },
    { id: 161, value: "47" },
  ],
  [
    { id: 162, value: "51" },
    { id: 163, value: "72" },
    { id: 164, value: "11" },
    { id: 165, value: "84" },
    { id: 166, value: "73" },
    { id: 167, value: "57" },
    { id: 168, value: "99" },
  ],
  [
    { id: 169, value: "34" },
    { id: 170, value: "89" },
    { id: 171, value: "20" },
    { id: 172, value: "65" },
    { id: 173, value: "44" },
    { id: 174, value: "63" },
    { id: 175, value: "17" },
  ],
  [
    { id: 176, value: "20" },
    { id: 177, value: "86" },
    { id: 178, value: "53" },
    { id: 179, value: "02" },
    { id: 180, value: "71" },
    { id: 181, value: "62" },
    { id: 182, value: "84" },
  ],
  [
    { id: 183, value: "22" },
    { id: 184, value: "90" },
    { id: 185, value: "15" },
    { id: 186, value: "75" },
    { id: 187, value: "64" },
    { id: 188, value: "88" },
    { id: 189, value: "84" },
  ],
  [
    { id: 190, value: "74" },
    { id: 191, value: "33" },
    { id: 192, value: "17" },
    { id: 193, value: "02" },
    { id: 194, value: "22" },
    { id: 195, value: "83" },
    { id: 196, value: "17" },
  ],
  [
    { id: 197, value: "55" },
    { id: 198, value: "85" },
    { id: 199, value: "90" },
    { id: 200, value: "30" },
    { id: 201, value: "33" },
    { id: 202, value: "41" },
    { id: 203, value: "90" },
  ],
  [
    { id: 204, value: "35" },
    { id: 205, value: "72" },
    { id: 206, value: "19" },
    { id: 207, value: "27" },
    { id: 208, value: "86" },
    { id: 209, value: "06" },
    { id: 210, value: "87" },
  ],
  [
    { id: 211, value: "59" },
    { id: 212, value: "44" },
    { id: 213, value: "11" },
    { id: 214, value: "69" },
    { id: 215, value: "34" },
    { id: 216, value: "13" },
    { id: 217, value: "63" },
  ],
  [
    { id: 218, value: "75" },
    { id: 219, value: "80" },
    { id: 220, value: "44" },
    { id: 221, value: "73" },
    { id: 222, value: "15" },
    { id: 223, value: "25" },
    { id: 224, value: "37" },
  ],
  [
    { id: 225, value: "63" },
    { id: 226, value: "18" },
    { id: 227, value: "50" },
    { id: 228, value: "66" },
    { id: 229, value: "01" },
    { id: 230, value: "36" },
    { id: 231, value: "52" },
  ],
  [
    { id: 232, value: "32" },
    { id: 233, value: "98" },
    { id: 234, value: "76" },
    { id: 235, value: "01" },
    { id: 236, value: "93" },
    { id: 237, value: "25" },
    { id: 238, value: "80" },
  ],
  [
    { id: 239, value: "76" },
    { id: 240, value: "14" },
    { id: 241, value: "98" },
    { id: 242, value: "48" },
    { id: 243, value: "22" },
    { id: 244, value: "91" },
    { id: 245, value: "80" },
  ],
  [
    { id: 246, value: "72" },
    { id: 247, value: "34" },
    { id: 248, value: "40" },
    { id: 249, value: "96" },
    { id: 250, value: "84" },
    { id: 251, value: "65" },
    { id: 252, value: "11" },
  ],
  [
    { id: 253, value: "17" },
    { id: 254, value: "93" },
    { id: 255, value: "23" },
    { id: 256, value: "05" },
    { id: 257, value: "44" },
    { id: 258, value: "39" },
    { id: 259, value: "56" },
  ],
  [
    { id: 260, value: "30" },
    { id: 261, value: "83" },
    { id: 262, value: "37" },
    { id: 263, value: "53" },
    { id: 264, value: "41" },
    { id: 265, value: "15" },
    { id: 266, value: "30" },
  ],
  [
    { id: 267, value: "03" },
    { id: 268, value: "12" },
    { id: 269, value: "10" },
    { id: 270, value: "49" },
    { id: 271, value: "68" },
    { id: 272, value: "72" },
    { id: 273, value: "69" },
  ],
  [
    { id: 274, value: "63" },
    { id: 275, value: "15" },
    { id: 276, value: "51" },
    { id: 277, value: "24" },
    { id: 278, value: "28" },
    { id: 279, value: "70" },
    { id: 280, value: "79" },
  ],
  [
    { id: 281, value: "00" },
    { id: 282, value: "61" },
    { id: 283, value: "83" },
    { id: 284, value: "49" },
    { id: 285, value: "99" },
    { id: 286, value: "10" },
    { id: 287, value: "92" },
  ],
  [
    { id: 288, value: "57" },
    { id: 289, value: "50" },
    { id: 290, value: "28" },
    { id: 291, value: "46" },
    { id: 292, value: "12" },
    { id: 293, value: "31" },
    { id: 294, value: "99" },
  ],
  [
    { id: 295, value: "81" },
    { id: 296, value: "86" },
    { id: 297, value: "34" },
    { id: 298, value: "48" },
    { id: 299, value: "60" },
    { id: 300, value: "04" },
    { id: 301, value: "30" },
  ],
  [
    { id: 302, value: "98" },
    { id: 303, value: "43" },
    { id: 304, value: "12" },
    { id: 305, value: "22" },
    { id: 306, value: "33" },
    { id: 307, value: "60" },
    { id: 308, value: "72" },
  ],
  [
    { id: 309, value: "63" },
    { id: 310, value: "25" },
    { id: 311, value: "58" },
    { id: 312, value: "47" },
    { id: 313, value: "80" },
    { id: 314, value: "68" },
    { id: 315, value: "96" },
  ],
  [
    { id: 316, value: "08" },
    { id: 317, value: "41" },
    { id: 318, value: "83" },
    { id: 319, value: "29" },
    { id: 320, value: "77" },
    { id: 321, value: "38" },
    { id: 322, value: "99" },
  ],
  [
    { id: 323, value: "11" },
    { id: 324, value: "54" },
    { id: 325, value: "05" },
    { id: 326, value: "87" },
    { id: 327, value: "60" },
    { id: 328, value: "38" },
    { id: 329, value: "20" },
  ],
  [
    { id: 330, value: "72" },
    { id: 331, value: "08" },
    { id: 332, value: "80" },
    { id: 333, value: "43" },
    { id: 334, value: "33" },
    { id: 335, value: "55" },
    { id: 336, value: "98" },
  ],
  [
    { id: 337, value: "90" },
    { id: 338, value: "17" },
    { id: 339, value: "38" },
    { id: 340, value: "74" },
    { id: 341, value: "**" },
    { id: 342, value: "66" },
    { id: 343, value: "87" },
  ],
  [
    { id: 344, value: "16" },
    { id: 345, value: "00" },
    { id: 346, value: "54" },
    { id: 347, value: "15" },
    { id: 348, value: "07" },
    { id: 349, value: "81" },
    { id: 350, value: "20" },
  ],
  [
    { id: 351, value: "55" },
    { id: 352, value: "39" },
    { id: 353, value: "22" },
    { id: 354, value: "05" },
    { id: 355, value: "13" },
    { id: 356, value: "88" },
    { id: 357, value: "20" },
  ],
  [
    { id: 358, value: "87" },
    { id: 359, value: "59" },
    { id: 360, value: "51" },
    { id: 361, value: "30" },
    { id: 362, value: "27" },
    { id: 363, value: "20" },
    { id: 364, value: "72" },
  ],
  [
    { id: 365, value: "23" },
    { id: 366, value: "96" },
    { id: 367, value: "91" },
    { id: 368, value: "70" },
    { id: 369, value: "56" },
    { id: 370, value: "82" },
    { id: 371, value: "37" },
  ],
  [
    { id: 372, value: "84" },
    { id: 373, value: "06" },
    { id: 374, value: "53" },
    { id: 375, value: "71" },
    { id: 376, value: "33" },
    { id: 377, value: "09" },
    { id: 378, value: "33" },
  ],
  [
    { id: 379, value: "74" },
    { id: 380, value: "05" },
    { id: 381, value: "29" },
    { id: 382, value: "47" },
    { id: 383, value: "01" },
    { id: 384, value: "32" },
    { id: 385, value: "24" },
  ],
  [
    { id: 386, value: "02" },
    { id: 387, value: "53" },
    { id: 388, value: "12" },
    { id: 389, value: "88" },
    { id: 390, value: "92" },
    { id: 391, value: "07" },
    { id: 392, value: "68" },
  ],
  [
    { id: 393, value: "76" },
    { id: 394, value: "80" },
    { id: 395, value: "55" },
    { id: 396, value: "94" },
    { id: 397, value: "66" },
    { id: 398, value: "44" },
    { id: 399, value: "13" },
  ],
  [
    { id: 400, value: "10" },
    { id: 401, value: "56" },
    { id: 402, value: "95" },
    { id: 403, value: "24" },
    { id: 404, value: "81" },
    { id: 405, value: "**" },
    { id: 406, value: "31" },
  ],
  [
    { id: 407, value: "07" },
    { id: 408, value: "17" },
    { id: 409, value: "81" },
    { id: 410, value: "35" },
    { id: 411, value: "58" },
    { id: 412, value: "73" },
    { id: 413, value: "00" },
  ],
  [
    { id: 414, value: "86" },
    { id: 415, value: "02" },
    { id: 416, value: "39" },
    { id: 417, value: "43" },
    { id: 418, value: "22" },
    { id: 419, value: "51" },
    { id: 420, value: "44" },
  ],
  [
    { id: 421, value: "69" },
    { id: 422, value: "12" },
    { id: 423, value: "07" },
    { id: 424, value: "54" },
    { id: 425, value: "45" },
    { id: 426, value: "29" },
    { id: 427, value: "26" },
  ],
  [
    { id: 428, value: "38" },
    { id: 429, value: "96" },
    { id: 430, value: "99" },
    { id: 431, value: "25" },
    { id: 432, value: "40" },
    { id: 433, value: "49" },
    { id: 434, value: "64" },
  ],
  [
    { id: 435, value: "06" },
    { id: 436, value: "49" },
    { id: 437, value: "15" },
    { id: 438, value: "51" },
    { id: 439, value: "62" },
    { id: 440, value: "76" },
    { id: 441, value: "29" },
  ],
  [
    { id: 442, value: "84" },
    { id: 443, value: "52" },
    { id: 444, value: "31" },
    { id: 445, value: "09" },
    { id: 446, value: "65" },
    { id: 447, value: "11" },
    { id: 448, value: "91" },
  ],
  [
    { id: 449, value: "83" },
    { id: 450, value: "32" },
    { id: 451, value: "95" },
    { id: 452, value: "07" },
    { id: 453, value: "63" },
    { id: 454, value: "64" },
    { id: 455, value: "89" },
  ],
  [
    { id: 456, value: "30" },
    { id: 457, value: "85" },
    { id: 458, value: "42" },
    { id: 459, value: "19" },
    { id: 460, value: "37" },
    { id: 461, value: "63" },
    { id: 462, value: "59" },
  ],
  [
    { id: 463, value: "98" },
    { id: 464, value: "21" },
    { id: 465, value: "78" },
    { id: 466, value: "31" },
    { id: 467, value: "68" },
    { id: 468, value: "03" },
    { id: 469, value: "22" },
  ],
  [
    { id: 470, value: "66" },
    { id: 471, value: "04" },
    { id: 472, value: "97" },
    { id: 473, value: "50" },
    { id: 474, value: "13" },
    { id: 475, value: "66" },
    { id: 476, value: "06" },
  ],
  [
    { id: 477, value: "32" },
    { id: 478, value: "89" },
    { id: 479, value: "56" },
    { id: 480, value: "04" },
    { id: 481, value: "64" },
    { id: 482, value: "55" },
    { id: 483, value: "04" },
  ],
  [
    { id: 484, value: "46" },
    { id: 485, value: "20" },
    { id: 486, value: "73" },
    { id: 487, value: "60" },
    { id: 488, value: "03" },
    { id: 489, value: "06" },
    { id: 490, value: "18" },
  ],
  [
    { id: 491, value: "76" },
    { id: 492, value: "05" },
    { id: 493, value: "08" },
    { id: 494, value: "13" },
    { id: 495, value: "80" },
    { id: 496, value: "32" },
    { id: 497, value: "96" },
  ],
  [
    { id: 498, value: "77" },
    { id: 499, value: "56" },
    { id: 500, value: "23" },
    { id: 501, value: "18" },
    { id: 502, value: "18" },
    { id: 503, value: "85" },
    { id: 504, value: "00" },
  ],
  [
    { id: 505, value: "**" },
    { id: 506, value: "95" },
    { id: 507, value: "63" },
    { id: 508, value: "21" },
    { id: 509, value: "87" },
    { id: 510, value: "14" },
    { id: 511, value: "42" },
  ],
  [
    { id: 512, value: "92" },
    { id: 513, value: "47" },
    { id: 514, value: "83" },
    { id: 515, value: "54" },
    { id: 516, value: "69" },
    { id: 517, value: "09" },
    { id: 518, value: "26" },
  ],
  [
    { id: 519, value: "95" },
    { id: 520, value: "36" },
    { id: 521, value: "80" },
    { id: 522, value: "09" },
    { id: 523, value: "21" },
    { id: 524, value: "85" },
    { id: 525, value: "70" },
  ],
  [
    { id: 526, value: "84" },
    { id: 527, value: "94" },
    { id: 528, value: "75" },
    { id: 529, value: "22" },
    { id: 530, value: "30" },
    { id: 531, value: "56" },
    { id: 532, value: "11" },
  ],
  [
    { id: 533, value: "26" },
    { id: 534, value: "52" },
    { id: 535, value: "33" },
    { id: 536, value: "74" },
    { id: 537, value: "88" },
    { id: 538, value: "17" },
    { id: 539, value: "03" },
  ],
  [
    { id: 540, value: "29" },
    { id: 541, value: "93" },
    { id: 542, value: "**" },
    { id: 543, value: "21" },
    { id: 544, value: "46" },
    { id: 545, value: "42" },
    { id: 546, value: "74" },
  ],
  [
    { id: 547, value: "05" },
    { id: 548, value: "20" },
    { id: 549, value: "77" },
    { id: 550, value: "21" },
    { id: 551, value: "44" },
    { id: 552, value: "87" },
    { id: 553, value: "43" },
  ],
  [
    { id: 554, value: "72" },
    { id: 555, value: "29" },
    { id: 556, value: "40" },
    { id: 557, value: "12" },
    { id: 558, value: "03" },
    { id: 559, value: "92" },
    { id: 560, value: "01" },
  ],
];

export const redJodi = [
  "11",
  "16",
  "61",
  "66",
  "22",
  "27",
  "77",
  "72",
  "38",
  "83",
  "88",
  "33",
  "50",
  "55",
  "00",
  "05",
  "49",
  "94",
  "99",
  "44",
];

export const redPana = [
  "000",
  "111",
  "222",
  "333",
  "444",
  "555",
  "666",
  "777",
  "888",
  "999",
];
